webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpTooltip_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87df5f92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpTooltip_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87df5f92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87df5f92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RangeYearSlider_vue__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59143b25_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RangeYearSlider_vue__ = __webpack_require__(348);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RangeYearSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59143b25_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RangeYearSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreloaderOverlay_vue__ = __webpack_require__(115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c099891_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreloaderOverlay_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c099891"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreloaderOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c099891_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreloaderOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoOverlay_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36d4141e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoOverlay_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36d4141e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoOverlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36d4141e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoOverlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleArrow_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_630cc030_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleArrow_vue__ = __webpack_require__(246);
function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-630cc030"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleArrow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_630cc030_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleArrow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectionMarker_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7193094a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectionMarker_vue__ = __webpack_require__(265);
function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7193094a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectionMarker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7193094a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectionMarker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighMediumLowExplainer_vue__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17811ff7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighMediumLowExplainer_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17811ff7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighMediumLowExplainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17811ff7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighMediumLowExplainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tourButton_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cb0a515_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tourButton_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tourButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cb0a515_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tourButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewModeTable_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112ceaf8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewModeTable_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(356)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-112ceaf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewModeTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112ceaf8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewModeTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3760e0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__(377);
function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3760e0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3760e0e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d85bc13_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d85bc13"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d85bc13_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleLabel_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb3f18a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleLabel_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4eb3f18a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb3f18a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137d5fa5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-137d5fa5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137d5fa5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DevelopmentsToWatch_vue_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb967d5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DevelopmentsToWatch_vue_vue__ = __webpack_require__(297);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DevelopmentsToWatch_vue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb967d5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DevelopmentsToWatch_vue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConcerningDevelopments_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64bca88f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConcerningDevelopments_vue__ = __webpack_require__(298);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConcerningDevelopments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64bca88f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConcerningDevelopments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarLine_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb892d1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarLine_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eb892d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb892d1_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BarLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeIcon_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a65a42c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeIcon_vue__ = __webpack_require__(470);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a65a42c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_misc_ToggleMap__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_navigation_PageSidebarNavigation_Nav__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_navigation_LevelNavigation__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_misc_HelpToolbar_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_misc_CovidToolbar_vue__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tutorials_Tutorials_vue__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_misc_MouseTooltip_vue__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_misc_Popup_vue__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_misc_ViewSelector__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_footer_layout_vue__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__event_bus_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// import tour from './components/tour/layout.vue'






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    CovidToolbar: __WEBPACK_IMPORTED_MODULE_7__components_shared_misc_CovidToolbar_vue__["a" /* default */],
    helptoolbar: __WEBPACK_IMPORTED_MODULE_6__components_shared_misc_HelpToolbar_vue__["a" /* default */],
    LevelNavigation: __WEBPACK_IMPORTED_MODULE_5__components_shared_navigation_LevelNavigation__["a" /* default */],
    PageSidebarNavigation: __WEBPACK_IMPORTED_MODULE_4__components_shared_navigation_PageSidebarNavigation_Nav__["a" /* default */],
    popup: __WEBPACK_IMPORTED_MODULE_10__components_shared_misc_Popup_vue__["a" /* default */],
    theFooter: __WEBPACK_IMPORTED_MODULE_12__components_shared_footer_layout_vue__["a" /* default */],
    tooltip: __WEBPACK_IMPORTED_MODULE_9__components_shared_misc_MouseTooltip_vue__["a" /* default */],
    ViewSelector: __WEBPACK_IMPORTED_MODULE_11__components_shared_misc_ViewSelector__["a" /* default */],
    ToggleMap: __WEBPACK_IMPORTED_MODULE_3__components_shared_misc_ToggleMap__["a" /* default */],
    // tour,
    tutorials: __WEBPACK_IMPORTED_MODULE_8__components_tutorials_Tutorials_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showIndicesNavigation: true
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'The Global State of Democracy initiative',
      meta: [{ name: 'description', content: 'The Global State of Democracy Indices (GSoD Indices) depict democratic trends at the country, regional and global levels across a broad range of different attributes of democracy in the period 1975–2021.' }, { property: 'og:title', content: 'The Global State of Democracy initiative' }, { property: 'og:site_name', content: 'The Global State of Democracy initiative' }, { property: 'og:type', content: 'website' }, { name: 'robots', content: 'index,follow' }]
    };
  },

  computed: {
    covid19FeatureIsonline: function covid19FeatureIsonline() {
      return this.$Strings('covid19_feature_enabled') === 'online' || "production" === 'development';
    },
    covid19IsEnabled: function covid19IsEnabled() {
      return this.$store.state.covid19.is_enabled;
    },
    vw: function vw() {
      return this.$store.state.windowSize.width;
    },
    vh: function vh() {
      return this.$store.state.windowSize.height;
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    },
    selectedRscs: function selectedRscs() {
      return this.$store.state.rsc.selected;
    },
    confidenceInterval: function confidenceInterval() {
      return this.$store.state.confidenceIntervals;
    },
    viewmode: function viewmode() {
      return this.$store.state.viewMode;
    }
  },
  watch: {
    '$store.state.covid19.is_enabled': function $storeStateCovid19Is_enabled() {
      if (this.$store.state.covid19.is_enabled) {
        this.$store.state.yearSliderCurrent = 2021;
      }
      this.$store.state.selections.covid19 = this.$store.state.covid19.is_enabled;
    },
    '$route': function $route() {
      this.updateShowIndicesNavigation();
      this.updateUserSelection();
      this.clearCovid19OnlyRsc();
      this.getApiData();
    },
    vw: function vw() {
      this.setContentSize();
    },
    vh: function vh() {
      this.setContentSize();
    },
    selectedAttributes: function selectedAttributes() {
      this.$store.state.selections.attr = this.selectedAttributes;
    },
    selectedRscs: function selectedRscs() {
      var rscs = [];
      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.selectedRscs, function (c) {
        rscs.push(c.id);
      });
      this.$store.state.selections.rsc = rscs;
    },
    confidenceInterval: function confidenceInterval() {
      this.$store.state.selections.ci = this.confidenceInterval;
    },
    viewmode: function viewmode() {
      this.$store.state.selections.view = this.viewmode;
    }
  },
  methods: {
    clearCovid19OnlyRsc: function clearCovid19OnlyRsc() {
      var rscCovidOnly = this.$store.state.selections.rsc;
      for (var i = 0; i < rscCovidOnly.length; i++) {
        var rscId = rscCovidOnly[i];
        if (this.$store.state.rsc.rscCovidProfileOnly.indexOf(parseInt(rscId)) !== -1) {
          var selected = this.$store.getters['rsc/getFromId'](rscId);
          this.$store.commit('rsc/unselect', selected);
        }
      }
    },
    filterCountries: function filterCountries(d) {
      for (var r in d.regions) {
        d.regions[r].name = __WEBPACK_IMPORTED_MODULE_14_vue__["a" /* default */].filter('fixedName')(d.regions[r].name);
        for (var s in d.regions[r].subregions) {
          d.regions[r].subregions[s].name = __WEBPACK_IMPORTED_MODULE_14_vue__["a" /* default */].filter('fixedName')(d.regions[r].subregions[s].name);
          for (var c in d.regions[r].subregions[s].countries) {
            d.regions[r].subregions[s].countries[c].name = __WEBPACK_IMPORTED_MODULE_14_vue__["a" /* default */].filter('fixedName')(d.regions[r].subregions[s].countries[c].name);
            if (d.regions[r].name === d.regions[r].subregions[s].name && d.regions[r].subregions[s].name === d.regions[r].subregions[s].countries[c].name) {
              delete d.regions[r].subregions[s].countries[c];
            }
          }
        }
      }
      return d;
    },
    getApiData: function getApiData() {
      var _this = this;

      if (this.$router.history.current.path.indexOf('/welcome') === -1) {
        this.$store.dispatch('startFetching', 'app');

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.loadCovid19Data(), this.loadCountries(), this.loadLabels()]).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (covid19, countries, labels) {
          _this.$store.state.covid19.all = covid19.data;
          _this.$store.state.rsc.all = _this.filterCountries(countries.data);
          _this.$store.state.attributes.labels = labels.data;
          _this.$store.dispatch('stopFetching', 'app');

          _this.updateUserSelection();
        })).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_13__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        });
      }
    },
    windowResize: function windowResize() {
      this.getWindowSize();
      __WEBPACK_IMPORTED_MODULE_13__event_bus_js__["a" /* EventBus */].$emit('window:resize');
    },


    /**
      * Checks the query strings first to see if
      * there is a selection
      * Then afterwards check for precious user selections
      * @param  {string} key The key of the value to look for
      * @return {mixed}
      */
    getUserSelectionValue: function getUserSelectionValue(key) {
      var selection = this.$store.state.selections[key];

      if (this.$router.history.current && this.$router.history.current.query && this.$router.history.current.query[key] !== undefined) {
        return JSON.parse(this.$router.history.current.query[key]);
      } else if (selection && (!Array.isArray(selection) || selection.length >= 1)) {
        return selection;
      }

      return undefined;
    },


    /**
      * Update selections based on values from the URL
      * @return {void}
      */
    updateUserSelection: function updateUserSelection() {
      var _this2 = this;

      var rsc = this.getUserSelectionValue('rsc');
      var attr = this.getUserSelectionValue('attr');
      var ci = this.getUserSelectionValue('ci');
      var view = this.getUserSelectionValue('view');
      var covid19 = this.getUserSelectionValue('covid19');

      this.$store.commit('resetSelectionColor');
      this.$store.commit('rsc/resetAllSelected');
      this.$store.commit('attributes/resetAllSelected');

      if (rsc) {
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(rsc, function (id) {
          var selected = _this2.$store.getters['rsc/getFromId'](id);
          if (selected) {
            _this2.$store.commit('rsc/select', selected);
          }
        });
      }

      if (attr) {
        if (attr.length >= 1) {
          this.$store.state.regime_enabled = false;
        }
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(attr, function (key) {
          var selected = _this2.$store.getters['attributes/getLabelFromKey'](key);
          if (selected) {
            _this2.$store.dispatch('attributes/toggleSelect', key);
          }
        });
      }

      var ciValue = true;
      if (ci !== undefined && (ci === 'false' || ci === false)) {
        ciValue = false;
      }
      this.$store.state.confidenceIntervals = ciValue;
      this.$store.state.viewMode = view === 'table' ? 'table' : 'chart';

      if (covid19 && covid19 === '1' && this.covid19FeatureIsonline) {
        this.$store.state.covid19.is_enabled = true;
      } else if (covid19 === '0' || !this.covid19FeatureIsonline) {
        this.$store.state.covid19.is_enabled = false;
      }
    },
    updateShowIndicesNavigation: function updateShowIndicesNavigation() {
      this.showIndicesNavigation = this.notFound ? false : this.$router.history.current.path.indexOf('/welcome') === -1;
      // this.showIndicesNavigation = (this.$router.history.current.path.substring(0, 8) === '/indices' && this.$router.history.current.path.indexOf('/welcome') === -1)
    },
    getWindowSize: function getWindowSize() {
      this.$store.state.windowSize.width = document.documentElement.clientWidth;
      this.$store.state.windowSize.height = document.documentElement.clientHeight;
    },
    getMousePosition: function getMousePosition(event) {
      __WEBPACK_IMPORTED_MODULE_13__event_bus_js__["a" /* EventBus */].$emit('mousemove');
      var xOffset = Math.max(document.documentElement.scrollLeft, document.body.scrollLeft);
      var yOffset = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
      this.$store.state.mousePosition = {
        x: event.clientX + xOffset,
        y: event.clientY + yOffset
      };
    },
    setAppHeight: function setAppHeight() {
      // let app = document.getElementById('app')
      // app.style.minHeight = (this.$store.state.windowSize.height - 50) + 'px' // 50 is the main nav bar
    },
    setContentSize: function setContentSize() {
      var header = document.getElementsByClassName('l-header')[0];
      var headerHeight = header && header.clientHeight ? header.clientHeight : 0;

      var mainNav = document.getElementsByClassName('l-mainwrap__main__navigation')[0];
      var mainNavHeight = mainNav && mainNav.clientHeight ? mainNav.clientHeight : 0;

      var side = document.getElementsByClassName('l-mainwrap__sidebar')[0];
      var sideWidth = side && side.clientWidth ? side.clientWidth : 0;

      var vw = this.vw;
      var vh = this.vh;

      this.$store.state.contentSize = { 'width': vw - sideWidth, 'height': vh - headerHeight - mainNavHeight };
    },
    loadCovid19Data: function loadCovid19Data() {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://covid19api.idea.int/api/" + 'covid19/countries?t=' + this.apiRefreshToken());
    },
    loadCountries: function loadCountries() {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'countries');
    },
    loadLabels: function loadLabels() {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'labels');
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.windowResize);
    document.removeEventListener('mousemove', this.getMousePosition, false);
    document.removeEventListener('mouseenter', this.getMousePosition, false);
  },
  created: function created() {
    document.addEventListener('mousemove', this.getMousePosition, false);
    document.addEventListener('mouseenter', this.getMousePosition, false);
    this.getApiData();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.updateShowIndicesNavigation();
    this.$nextTick(function () {
      window.addEventListener('resize', _this3.windowResize);
      _this3.setContentSize();
      _this3.getWindowSize();
      _this3.setAppHeight();
    });
  }
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ToggleMap',
  watch: {
    '$route': function $route() {
      this.covid19Watcher();
      this.reloadElement();
    }
  },
  mounted: function mounted() {
    this.showElement();
  },
  created: function created() {
    this.covid19Watcher();
  },
  destroyed: function destroyed() {
    this.removeElement();
  },

  methods: {
    covid19Watcher: function covid19Watcher() {
      if (this.$router.history.current.path.indexOf('/democracy-indices') !== -1) {
        this.$store.state.covid19.is_enabled = false;
      } else if (this.$router.history.current.path.indexOf('/covid19globalmonitor') !== -1) {
        this.$store.state.covid19.is_enabled = true;
      }
    },
    removeElement: function removeElement() {
      var menu = document.getElementById('main-menu');
      if (menu.getElementsByClassName('switch-to').length > 0) {
        var li = menu.getElementsByClassName('switch-to')[0];
        li.remove();
      }
    },
    reloadElement: function reloadElement() {
      this.removeElement();
      this.showElement();
    },
    showElement: function showElement() {
      var menu = document.getElementById('main-menu');
      var elli = document.createElement('li');
      elli.classList.add('switch-to');
      var link = document.createElement('a');
      var block = document.createElement('div');
      block.classList.add('content');
      var linkName = '';

      if (this.$router.history.current.path.indexOf('/covid19globalmonitor') !== -1 || this.$store.state.covid19.is_enabled === true) {
        link.classList.add('to-democraty');
        linkName = 'democracy-indices';
        block.innerHTML = 'Go To Democracy Indices';
      } else if (this.$router.history.current.path.indexOf('/democracy-indices') !== -1 || this.$store.state.covid19.is_enabled === false) {
        link.classList.add('to-covid');
        linkName = 'covid19globalmonitor';
        block.innerHTML = 'go to COVID-19';
      }
      link.href = linkName;
      link.append(block);
      elli.append(link);
      menu.appendChild(elli);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorldMap__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompareAttributes__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompareCountriesRegions__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CountryRegionProfile__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page-sidebar-nav',
  components: {
    WorldMap: __WEBPACK_IMPORTED_MODULE_0__WorldMap__["a" /* default */],
    CompareAttributes: __WEBPACK_IMPORTED_MODULE_1__CompareAttributes__["a" /* default */],
    CompareCountriesRegions: __WEBPACK_IMPORTED_MODULE_2__CompareCountriesRegions__["a" /* default */],
    CountryRegionProfile: __WEBPACK_IMPORTED_MODULE_3__CountryRegionProfile__["a" /* default */]
  },
  props: ['countriesRegime'],
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$on('sidebar-nav', function (page) {
      switch (page) {
        case 'CompareAttributes':
          _this.current = __WEBPACK_IMPORTED_MODULE_1__CompareAttributes__["a" /* default */];
          break;
        case 'WorldMap':
          _this.current = __WEBPACK_IMPORTED_MODULE_0__WorldMap__["a" /* default */];
          break;
        case 'CountryRegionProfile':
          _this.current = __WEBPACK_IMPORTED_MODULE_3__CountryRegionProfile__["a" /* default */];
          break;
        case 'CompareCountriesRegions':
          _this.current = __WEBPACK_IMPORTED_MODULE_2__CompareCountriesRegions__["a" /* default */];
          break;
        default:
          _this.current = false;
          break;
      }
    });
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$on('tooltip.close', function () {
      _this.close();
    });
  },
  destroyed: function destroyed() {
    // Remove event handlers
    __WEBPACK_IMPORTED_MODULE_4__event_bus_js__["a" /* EventBus */].$off('sidebar-nav');
  },
  data: function data() {
    return {
      current: __WEBPACK_IMPORTED_MODULE_1__CompareAttributes__["a" /* default */]
    };
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AttributesNavigation_Nav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttributesNavigation_CountriesRegime__ = __webpack_require__(270);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'worldmap-nav',
  components: {
    CountriesRegime: __WEBPACK_IMPORTED_MODULE_1__AttributesNavigation_CountriesRegime__["a" /* default */],
    'attribute-nav': __WEBPACK_IMPORTED_MODULE_0__AttributesNavigation_Nav__["a" /* default */]
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_ToggleLabel__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AttributeLabel__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Attribute__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_SelectionMarker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Regime__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_bus_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attribute-nav',
  components: { Regime: __WEBPACK_IMPORTED_MODULE_5__Regime__["a" /* default */], ToggleLabel: __WEBPACK_IMPORTED_MODULE_1__shared_ToggleLabel__["a" /* default */], Attribute: __WEBPACK_IMPORTED_MODULE_3__Attribute__["a" /* default */], AttributeLabel: __WEBPACK_IMPORTED_MODULE_2__AttributeLabel__["a" /* default */], SelectionMarker: __WEBPACK_IMPORTED_MODULE_4__shared_SelectionMarker__["a" /* default */] },
  props: {
    useRandomColors: {
      type: Boolean,
      default: false
    },
    closed: {
      type: Boolean,
      default: false
    },
    toggleable: {
      type: Boolean,
      default: false
    },
    selectMultiple: {
      type: Boolean,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentSection: false,
      open: false
    };
  },

  computed: {
    attributeHeaders: function attributeHeaders() {
      return this.$store.state.attributes.labels;
    },
    firstSelectedAttribute: function firstSelectedAttribute() {
      var firstKey = this.$store.getters['attributes/firstSelected'];
      if (!firstKey) return false;

      var name = this.$store.getters['attributes/labelInfo'](firstKey, 'name');
      return name;
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    }
  },
  watch: {
    closed: function closed() {
      this.open = !this.closed;
    },
    open: function open() {
      this.$emit('toggleClosed', !this.open);
    },
    selectedAttributes: function selectedAttributes() {
      // Make sure the section is open for the
      // last selected attribute
      var lastSelection = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.last(this.selectedAttributes);
      if (lastSelection) {
        var label = this.$store.getters['attributes/getLabelFromKey'](lastSelection);
        var section = label.section;

        // Fix to make the subsubattributes link to
        // 1. level attribute
        if (section === 'SA_02_02' || section === 'SA_02_03') {
          section = 'A_02';
        }

        if (label && section && section !== this.currentSection) {
          this.toggleSectionOpen(label.section);
        }
      }
    }
  },
  mounted: function mounted() {
    this.open = !this.closed;

    // Upon mounting the navigation component we check if
    // someone should already have made a selection
    // in which case we open up the section
    if (this.attributeHeaders && Array.isArray(this.attributeHeaders)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.attributeHeaders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var attr = _step.value;

          if (attr.section === '') {
            var sectionIsOrContainsSelected = this.$store.getters['attributes/isOrContainsSelected'](attr.id);
            if (sectionIsOrContainsSelected) {
              this.currentSection = attr.id;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },


  methods: {
    /**
     * Checks if an attribute is selected
     * @param  {string} key The attribute ID
     * @return {boolean}
     */
    attributeIsSelected: function attributeIsSelected(key) {
      var i = this.$store.state.attributes.selected.indexOf(key);
      var num = this.$store.state.attributes.selected.length;

      if (this.selectMultiple || num <= 1) {
        return i !== -1;
      } else {
        return i === 0;
      }
    },
    toggleSectionOpen: function toggleSectionOpen(key) {
      var sectionIsOrContainsSelected = this.$store.getters['attributes/isOrContainsSelected'](key);

      if (this.currentSection === key) {
        this.currentSection = false;
      } else {
        this.currentSection = key;
      }

      if (!sectionIsOrContainsSelected) {
        this.$store.commit('attributes/resetAllSelected');
        this.$store.commit('resetSelectionColor');
      }
    },
    toggleAttribute: function toggleAttribute(key, section) {
      var selectable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Yes';

      this.$store.commit('resetSelectionColor');

      // Make sure no more than 7 attributes are selected
      if (this.selectedAttributes.length >= 7 && !this.attributeIsSelected(key)) {
        // TODO: put in $Strings
        __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["a" /* EventBus */].$emit('popup.open', 'Maximum attributes selected', 'The maximum amount of attributes are selected. Please unselect attributes to compare others.');

        return false;
      }

      if (this.currentSection !== section) {
        this.toggleSectionOpen(section);
      }

      if (selectable === 'No') {
        __WEBPACK_IMPORTED_MODULE_7__event_bus_js__["a" /* EventBus */].$emit('popup.open', this.$Strings('attributeNotAvailable'), this.$Strings('attributeNotAvailableContent'));
        return false;
      }

      if (!this.selectMultiple) {
        this.$store.commit('attributes/resetAllSelected');
      }
      this.$store.dispatch('attributes/toggleSelect', key);

      if (this.closeOnSelect) {
        this.toggleOpen();
      }
    },
    toggleOpen: function toggleOpen() {
      this.open = !this.open;
    },
    getAttributeColor: function getAttributeColor(id) {
      if (!this.attributeIsSelected(id)) {
        return 'gray';
      }
      if (!this.useRandomColors) {
        var attr = this.$store.getters['attributes/getLabelFromKey'](id);
        if (attr && attr.color) {
          return attr.color;
        }
      }
      return this.$store.getters.getSelectionColor(id);
    },
    hasSubattributes: function hasSubattributes(attr) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.attributeHeaders), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var attr2 = _step2.value;

          if (attr2.section === attr.id) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }
});

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_ToggleArrow_vue__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'togglelabel',
  components: { ToggleArrow: __WEBPACK_IMPORTED_MODULE_0__shared_ToggleArrow_vue__["a" /* default */] },
  props: {
    toggleable: {
      type: Boolean,
      default: false
    },
    closed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    selected: {
      default: false
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      open: false
    };
  },

  watch: {
    closed: function closed() {
      this.open = !this.closed;
    }
  },
  mounted: function mounted() {
    this.open = !this.closed;
  },

  methods: {
    toggleOpen: function toggleOpen() {
      this.open = !this.open;
      this.callback(this.open);
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_js__);
//
//
//
//
//
//
//
//

// import _ from 'lodash'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toggle-arrow',
  props: {
    closed: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 6
    }
  },
  data: function data() {
    return {
      open: false,
      canvas: false
    };
  },
  mounted: function mounted() {
    this.open = !this.closed;
    this.canvas = __WEBPACK_IMPORTED_MODULE_0_svg_js___default()('toggler_' + this._uid);

    // Viewbox width is
    var svg = document.getElementById('toggler_' + this._uid);
    svg.style.height = parseFloat(this.width / 40 * 60) + 'px';
    svg.style.width = this.width + 'px';

    this.adjustRotation();
  },

  watch: {
    closed: function closed() {
      this.open = !this.closed;
    },
    open: function open() {
      this.adjustRotation();
    }
  },
  methods: {
    clicked: function clicked() {
      this.open = !this.open;
      this.$emit('toggle');
    },
    adjustRotation: function adjustRotation() {
      var rotation = !this.open ? -180 : 0;
      var polygon = this.canvas.select('polygon');
      polygon.rotate(rotation, 30, 20);
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeLabel_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53a5dc4f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeLabel_vue__ = __webpack_require__(261);
function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53a5dc4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53a5dc4f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_HelpTooltip_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_ToggleArrow_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_ChecksOnGovernmentIcon__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_ParticipatoryEngagementIcon__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_RepresentativeGovernmentIcon__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_FundamentalRightsIcon__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_ImpartialAdministrationIcon__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attribute-label',
  components: {
    HelpTooltip: __WEBPACK_IMPORTED_MODULE_0__misc_HelpTooltip_vue__["a" /* default */],
    ToggleArrow: __WEBPACK_IMPORTED_MODULE_1__shared_ToggleArrow_vue__["a" /* default */],
    ChecksOnGovernmentIcon: __WEBPACK_IMPORTED_MODULE_2__assets_ChecksOnGovernmentIcon__["a" /* default */],
    ParticipatoryEngagementIcon: __WEBPACK_IMPORTED_MODULE_3__assets_ParticipatoryEngagementIcon__["a" /* default */],
    RepresentativeGovernmentIcon: __WEBPACK_IMPORTED_MODULE_4__assets_RepresentativeGovernmentIcon__["a" /* default */],
    FundamentalRightsIcon: __WEBPACK_IMPORTED_MODULE_5__assets_FundamentalRightsIcon__["a" /* default */],
    ImpartialAdministrationIcon: __WEBPACK_IMPORTED_MODULE_6__assets_ImpartialAdministrationIcon__["a" /* default */]
  },
  props: {
    'title': {
      type: String,
      required: true
    },
    'identifier': {
      type: String,
      required: true
    },
    'color': {
      type: String,
      required: true
    },
    'tooltip': {
      default: false
    },
    'link': {
      default: false
    },
    'open': {
      type: Boolean,
      default: false
    },
    'selected': {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {
    getColor: function getColor() {
      if (this.selected) {
        return this.color;
      } else {
        return 'gray';
      }
    },
    iconComponent: function iconComponent() {
      if (this.identifier === 'A_01') return __WEBPACK_IMPORTED_MODULE_4__assets_RepresentativeGovernmentIcon__["a" /* default */];
      if (this.identifier === 'A_02') return __WEBPACK_IMPORTED_MODULE_5__assets_FundamentalRightsIcon__["a" /* default */];
      if (this.identifier === 'A_03') return __WEBPACK_IMPORTED_MODULE_2__assets_ChecksOnGovernmentIcon__["a" /* default */];
      if (this.identifier === 'A_04') return __WEBPACK_IMPORTED_MODULE_6__assets_ImpartialAdministrationIcon__["a" /* default */];
      if (this.identifier === 'A_05') return __WEBPACK_IMPORTED_MODULE_3__assets_ParticipatoryEngagementIcon__["a" /* default */];
    },
    classes: function classes() {
      var classes = {
        'isOpen': this.open === true,
        'isSelected': this.selected === true
      };
      classes['color--' + this.color] = true;

      return classes;
    }
  },
  methods: {
    toggleOpen: function toggleOpen() {
      this.$emit('toggleOpen', !this.open);
    },
    toggleSelect: function toggleSelect() {
      this.$emit('toggleSelect', !this.selected);
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'help-tooltip',
  props: {
    description: {},
    link: {
      default: false
    },
    followMouse: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
  },

  methods: {
    clickTooltip: function clickTooltip() {
      this.showTooltip();
    },
    showTooltip: function showTooltip() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
        style: 'single',
        label: this.description,
        followMouse: this.followMouse,
        link: this.link
      });
      return false;
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChecksOnGovernmentIcon_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f93a894_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChecksOnGovernmentIcon_vue__ = __webpack_require__(252);
function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f93a894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChecksOnGovernmentIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f93a894_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChecksOnGovernmentIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checks-on-government-icon',
  props: ['color']
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipatoryEngagementIcon_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6083ce86_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipatoryEngagementIcon_vue__ = __webpack_require__(254);
function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6083ce86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParticipatoryEngagementIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6083ce86_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParticipatoryEngagementIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'orange-icon',
  props: ['color']
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentativeGovernmentIcon_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249d4b5c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepresentativeGovernmentIcon_vue__ = __webpack_require__(256);
function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-249d4b5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepresentativeGovernmentIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249d4b5c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepresentativeGovernmentIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'purple-icon',
  props: ['color']
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundamentalRightsIcon_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3164b3c7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundamentalRightsIcon_vue__ = __webpack_require__(258);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3164b3c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FundamentalRightsIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3164b3c7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FundamentalRightsIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'red-icon',
  props: ['color']
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpartialAdministrationIcon_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6807ea84_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpartialAdministrationIcon_vue__ = __webpack_require__(260);
function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6807ea84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImpartialAdministrationIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6807ea84_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImpartialAdministrationIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'red-icon',
  props: ['color']
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attribute_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_698b9412_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attribute_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-698b9412"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attribute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_698b9412_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attribute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc_HelpTooltip_vue__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attribute',
  components: { helptooltip: __WEBPACK_IMPORTED_MODULE_0__misc_HelpTooltip_vue__["a" /* default */] },
  props: {
    attr: {
      type: Object,
      required: true
    },
    tooltip: {
      default: false
    },
    link: {
      default: false
    },
    color: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currentlySelected: false
    };
  },

  watch: {
    selected: function selected() {
      this.currentlySelected = this.selected;
    }
  },
  computed: {
    getColor: function getColor() {
      if (this.selected) {
        return this.color;
      } else {
        return 'gray';
      }
    }
  },
  created: function created() {
    this.currentlySelected = this.selected;
  },

  methods: {
    clicked: function clicked() {
      this.$emit('selected', this.currentlySelected);
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'search',
  props: {
    type: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Regime_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c75a10_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Regime_vue__ = __webpack_require__(268);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12c75a10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Regime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c75a10_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Regime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_RegimeIcon__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_SelectionMarker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_HelpTooltip__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from 'lodash'
// import {EventBus} from '@/event-bus.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attribute-nav',
  components: { RegimeIcon: __WEBPACK_IMPORTED_MODULE_0__icons_RegimeIcon__["a" /* default */], SelectionMarker: __WEBPACK_IMPORTED_MODULE_1__shared_SelectionMarker__["a" /* default */], helptooltip: __WEBPACK_IMPORTED_MODULE_2__misc_HelpTooltip__["a" /* default */] },
  watch: {
    '$store.state.attributes.selected': function $storeStateAttributesSelected() {
      // An attribute that has been selected
      // means that this filter is not
      if (this.$store.state.attributes.selected.length > 0) {
        this.$store.state.regime_enabled = 0;
      } else {
        this.$store.state.regime_enabled = 1;
      }
    }
  },
  computed: {
    isRegimeEnabled: function isRegimeEnabled() {
      return this.$store.state.regime_enabled && !this.selectedAttribute;
    },
    selectedAttribute: function selectedAttribute() {
      return this.$store.getters['attributes/firstSelected'];
    }
  },
  methods: {
    /**
     * This is not really a toggle as it is not allowed to untoggle this one
     * so we only turn it on if it has not already been selected
     *
     * @return  {void}
     */
    toggle: function toggle() {
      if (!this.$store.state.regime_enabled) {
        this.$store.state.regime_enabled = true;

        // We disable all other user selections
        this.$store.commit('resetSelectionColor');
        this.$store.commit('rsc/resetAllSelected');
        this.$store.commit('attributes/resetAllSelected');
      }
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegimeIcon_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782bddb9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegimeIcon_vue__ = __webpack_require__(267);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegimeIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782bddb9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegimeIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'RegimeIcon',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_RegimeIcon__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_ToggleLabel__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AttributeLabel__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Attribute__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_SelectionMarker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Regime__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'countries-regime',
  components: { Regime: __WEBPACK_IMPORTED_MODULE_7__Regime__["a" /* default */], ToggleLabel: __WEBPACK_IMPORTED_MODULE_3__shared_ToggleLabel__["a" /* default */], Attribute: __WEBPACK_IMPORTED_MODULE_5__Attribute__["a" /* default */], AttributeLabel: __WEBPACK_IMPORTED_MODULE_4__AttributeLabel__["a" /* default */], SelectionMarker: __WEBPACK_IMPORTED_MODULE_6__shared_SelectionMarker__["a" /* default */], RegimeIcon: __WEBPACK_IMPORTED_MODULE_2__icons_RegimeIcon__["a" /* default */] },
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken,
      cancel: function cancel() {},

      countriesRegime: {},
      currentSection: false,
      open: false,
      closed: false,
      covidQuery: ''
    };
  },

  computed: {
    countriesRegime: function countriesRegime() {
      return this.countriesRegime;
    }
  },
  watch: {
    covidQuery: function covidQuery() {
      return this.covidQuery;
    },
    closed: function closed() {
      this.open = !this.closed;
    },
    open: function open() {
      this.$emit('toggleClosed', !this.open);
    },
    '$store.state.covid19.is_enabled': function $storeStateCovid19Is_enabled() {
      if (this.$store.state.covid19.is_enabled) {
        this.covidQuery = '&covid19=1';
      } else {
        this.covidQuery = '';
      }
    }
  },
  mounted: function mounted() {
    if (this.$store.state.covid19.is_enabled) {
      this.covidQuery = '&covid19=1';
    } else {
      this.covidQuery = '';
    }
    this.open = true;
    this.loadData();
  },

  methods: {
    attributeIsSelected: function attributeIsSelected(i) {
      i++;
      return false;
    },
    toggleOpen: function toggleOpen() {
      this.$emit('toggleOpen', !this.open);
    },
    toggleSelect: function toggleSelect() {
      this.$emit('toggleSelect', !this.selected);
    },
    loadData: function loadData(callback) {
      var _this = this;

      this.$store.dispatch('startFetching', 'countriesRegime');
      this.cancel();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.fetchData()], {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (response) {
        _this.$store.dispatch('stopFetching', 'countriesRegime');
        if (response.data) {
          _this.getCountriesRegime(response.data);
        }
        if (callback !== undefined) callback();
      })).catch(function (error) {
        _this.$store.dispatch('stopFetching', 'countriesRegime');
        console.log(error);
      });
    },
    fetchData: function fetchData() {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'data?year1=' + this.$store.state.yearSliderCurrent + '&year2=' + this.$store.state.yearSliderCurrent);
    },
    getCountriesRegime: function getCountriesRegime(temp) {
      var y = {
        3: {
          name: '',
          class: 'bg--regime-dem-mid',
          countries: []
        },
        1: {
          name: '',
          class: 'bg--regime-orange',
          countries: []
        },
        2: {
          name: '',
          class: 'bg--regime-purple',
          countries: []
        }
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(temp), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var con = _step.value;

          var dem = this.$store.getters['rsc/getRegimeById'](con.dem);
          if (dem && dem.name) {
            y[con.dem].id = con.dem;
            y[con.dem].name = __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].filter('fixedName')(dem.name);
            y[con.dem].countries.push({
              id: con.ID_country_code,
              name: __WEBPACK_IMPORTED_MODULE_8_vue__["a" /* default */].filter('fixedName')(con.ID_country_name)
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      y[1].countries.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }return 0;
      });
      y[2].countries.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }return 0;
      });
      y[3].countries.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }return 0;
      });

      this.countriesRegime = y;
    },
    toggleSectionOpen: function toggleSectionOpen(key) {
      if (this.currentSection === key) {
        this.currentSection = false;
      } else {
        this.currentSection = key;
      }
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AttributesNavigation_Nav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CountriesNavigation_Nav__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compare-attributes-navigation',
  components: {
    'attribute-nav': __WEBPACK_IMPORTED_MODULE_0__AttributesNavigation_Nav__["a" /* default */],
    'countries-nav': __WEBPACK_IMPORTED_MODULE_1__CountriesNavigation_Nav__["a" /* default */]
  },
  data: function data() {
    return {
      currentNav: 'country'
    };
  },

  watch: {
    selectedCountries: function selectedCountries() {
      if (this.selectedCountries.length > 0) {
        this.currentNav = 'attribute';
      }
      this.setOpenNavigation();
    }
  },
  mounted: function mounted() {
    if (this.selectedCountries.length > 0) {
      this.currentNav = 'attribute';
    }
    this.setOpenNavigation();
  },

  computed: {
    countries: function countries() {
      return this.$store.state.rsc.all;
    },
    selectedCountries: function selectedCountries() {
      return this.$store.state.rsc.selected;
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    }
  },
  methods: {
    setOpenNavigation: function setOpenNavigation() {
      if (this.selectedCountries.length !== 0) {
        this.openAttributeNav();
      } else {
        this.openCountryNav();
      }
    },
    openCountryNav: function openCountryNav() {
      this.currentNav = 'country';
    },
    openAttributeNav: function openAttributeNav() {
      this.currentNav = 'attribute';
    },
    toggleCountryNavigation: function toggleCountryNavigation(closed) {
      if (closed) {
        this.openAttributeNav();
      } else {
        this.openCountryNav();
      }
    },
    toggleAttributeNavigation: function toggleAttributeNavigation(closed) {
      if (!closed) {
        this.openAttributeNav();
      } else {
        this.openCountryNav();
      }
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ToggleLabel__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CollapseLabel__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_SelectionMarker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compare-attributes-navigation',
  components: { SelectionMarker: __WEBPACK_IMPORTED_MODULE_4__shared_SelectionMarker__["a" /* default */], ToggleLabel: __WEBPACK_IMPORTED_MODULE_2__shared_ToggleLabel__["a" /* default */], CollapseLabel: __WEBPACK_IMPORTED_MODULE_3__CollapseLabel__["a" /* default */] },
  props: {
    countries: {
      type: Object,
      required: true
    },
    closed: {
      type: Boolean,
      default: false
    },
    toggleable: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    selectMultiple: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      searchActive: false,
      open: false,
      searchstring: '',
      openCountryRegions: []
    };
  },

  computed: {
    selectedCountries: function selectedCountries() {
      return this.$store.state.rsc.selected;
    },
    visibleRegions: function visibleRegions() {
      var _this = this;

      var result = {};
      var s = this.searchstring.toLowerCase();
      var countries = this.countries;

      if (countries.regions === undefined) {
        return result;
      } else {
        result = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(countries.regions));

        // _.each(countries.regions, (r, rI) => {
        //   result[rI] = { id: r.id, name: r.name, type: 'region', subregions: {} }
        //   _.each(r.subregions, (sr, srI) => {
        //     result[rI].subregions[srI] = { id: sr.id, name: sr.name, type: 'subregion', countries: {} }
        //     _.each(sr.countries, (c, cI) => {
        //       result[rI].subregions[srI].countries[cI] = { id: c.id, name: c.name, type: 'country' }
        //     })
        //   })
        // })
      }

      // If no search just return entire result set
      if (s === '') {
        if (this.searchActive) {
          this.searchActive = false;
          this.closeAllCountryRegion();
        }
        return result;
      }

      this.searchActive = true;

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(result, function (region, regionIndex) {
        var keepRegion = false;

        if (_this.stringMatchesString(region.name, s)) {
          keepRegion = true;
          _this.openCountryRegion(region.id, 'region');
        }

        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(region.subregions, function (subregion, subregionIndex) {
          var keepSubregion = false;

          if (_this.stringMatchesString(subregion.name, s)) {
            keepRegion = true;
            keepSubregion = true;
            _this.openCountryRegion(region.id, 'region');
            _this.openCountryRegion(subregion.id, 'subregion');
          }

          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(subregion.countries, function (country, countryIndex) {
            if (_this.stringMatchesString(country.name, s)) {
              keepRegion = true;
              keepSubregion = true;
              _this.openCountryRegion(region.id, 'region');
              _this.openCountryRegion(subregion.id, 'subregion');
            } else {
              delete result[regionIndex].subregions[subregionIndex].countries[countryIndex];
            }
          });

          if (!keepSubregion) {
            delete result[regionIndex].subregions[subregionIndex];
          }
        });

        if (!keepRegion) {
          delete result[regionIndex];
        }
      });

      return result;
    },
    selectedLabel: function selectedLabel() {
      if (this.selectMultiple) {
        return false;
      }
      var obj = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.first(this.selectedCountries);
      if (obj === undefined || obj.name === undefined) {
        return false;
      }
      return obj.name;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.open = !this.closed;

    var countries = this.countries;
    if (countries.regions !== undefined) {
      var result = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(countries.regions));
      var selected = this.selectedCountries;

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(result, function (region, regionIndex) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(selected, ['id', region.id])) {
          _this2.openCountryRegion(region.id, 'region');
        }

        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(region.subregions, function (subregion, subregionIndex) {
          if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(selected, ['id', subregion.id])) {
            _this2.openCountryRegion(subregion.id, 'subregion');
            _this2.openCountryRegion(region.id, 'region');
          }

          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(subregion.countries, function (country, countryIndex) {
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(selected, ['id', country.id])) {
              _this2.openCountryRegion(subregion.id, 'subregion');
              _this2.openCountryRegion(region.id, 'region');
            }
          });
        });
      });
    }
  },

  watch: {
    closed: function closed() {
      this.open = !this.closed;
    },
    open: function open() {
      this.$emit('toggleClosed', !this.open);
      // Set cursor in input if the countrylist is open
      if (this.open === true) {
        setTimeout(function () {
          var searchinput = document.getElementById('countries-nav__search__input');
          if (searchinput !== undefined && searchinput) {
            searchinput.focus();
          }
        }, 100);
      }
    }
  },
  methods: {
    rscIsVisible: function rscIsVisible(rscId) {
      var onlyForCovid19Profile = this.$store.state.rsc.rscCovidProfileOnly.indexOf(parseInt(rscId));
      if (onlyForCovid19Profile === -1) {
        return true;
      }

      return this.$router.history.current.path === '/indices/countries-regions-profile' && this.$store.state.covid19.is_enabled;
    },
    subregionExists: function subregionExists(regionId) {
      if (this.$store.state.rsc.regionsWithoutSubregions.indexOf(parseInt(regionId)) !== -1) {
        return false;
      }
      return true;
    },
    hasSubregions: function hasSubregions(region) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(region.subregions) > 0;
    },
    hasCountries: function hasCountries(subregion) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(subregion.countries) > 0;
    },


    /**
     * Sort the results alphabetically
     * @param  {Obj} regions Object with rsc data
     * @return {Obj}         The sorted object
     */
    sortByName: function sortByName(obj) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(obj, ['name']);
    },


    /**
     * Check if there is any results
     * @return {Boolean}
     */
    showNoSearchResultsText: function showNoSearchResultsText() {
      return this.open === true && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.visibleRegions);
    },


    /**
     * Open or close a country or region
     * @param  {string} key The key/ID
     * @return {void}
     */
    toggleCountryRegion: function toggleCountryRegion(key, type) {
      if (this.countryRegionIsOpen(key, type)) {
        this.closeCountryRegion(key, type);
      } else {
        this.openCountryRegion(key, type);
      }
    },


    /**
     * Open a country or region
     * @param  {string} key The key/ID
     * @return {void}
     */
    openCountryRegion: function openCountryRegion(key, type) {
      if (!this.countryRegionIsOpen(key, type)) {
        this.openCountryRegions.push(key + '__' + type);
      }
    },


    /**
     * Close country or region
     * @param  {string} key The key/ID
     * @return {void}
     */
    closeCountryRegion: function closeCountryRegion(key, type) {
      if (this.countryRegionIsOpen(key, type)) {
        var index = this.openCountryRegions.indexOf(key + '__' + type);
        this.openCountryRegions.splice(index, 1);
      }
    },


    /**
     * Closes all region and subregions
     * @return {void}
     */
    closeAllCountryRegion: function closeAllCountryRegion() {
      var _this3 = this;

      if (this.countries.regions === undefined) return false;

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.countries.regions, function (r, rId) {
        _this3.closeCountryRegion(r.id, 'region');
        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(r.subregions, function (sr, srId) {
          _this3.closeCountryRegion(sr.id, 'subregion');
        });
      });
    },


    /**
     * Check if a country or region is open
     * @param  {string} key The key/ID
     * @return {boolean}
     */
    countryRegionIsOpen: function countryRegionIsOpen(key, type) {
      return this.openCountryRegions.indexOf(key + '__' + type) !== -1;
    },


    /**
     * Checks if a country/region/subregion is currently selected
     * @param  {integer} id  The id
     * @param  {string} name The name
     * @param  {string} type The type
     * @return {boolean}
     */
    countryIsActive: function countryIsActive(id, name, type) {
      if (!id || !name || !type) {
        return false;
      }

      var i = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.$store.state.rsc.selected, function (rsc) {
        return rsc.id === id;
      });
      var num = this.$store.state.rsc.selected.length;

      if (this.selectMultiple || num <= 1) {
        return i !== -1;
      } else {
        return i === 0;
      }
    },
    stringMatchesString: function stringMatchesString(str1, str2) {
      var str1lc = str1.toLowerCase();
      var str2lc = str2.toLowerCase();
      return str1lc.search(str2lc) !== -1;
    },
    toggleCountry: function toggleCountry(id, name, type) {
      if (this.$store.state.rsc.notSelectableRegions.indexOf(id) !== -1) {
        this.toggleCountryRegion(id, type);
        return false;
      }

      this.$store.commit('resetSelectionColor');

      if (!this.selectMultiple) {
        this.$store.commit('rsc/resetAllSelected');
      }

      // Limit selection to 7
      if (this.selectedCountries.length >= 7 && !this.countryIsActive(id, name, type)) {
        __WEBPACK_IMPORTED_MODULE_5__event_bus_js__["a" /* EventBus */].$emit('popup.open', 'Maximum countries selected', 'The maximum amount of countries/regions are selected. Please unselect countries to compare others.');
        return false;
      }
      this.$store.dispatch('rsc/toggleSelect', {
        id: id,
        name: name,
        type: type
      });
      // this.$store.commit('selections/toggleRsc', {
      //   route: this.$route.path,
      //   key: id
      // })

      if (this.closeOnSelect) {
        this.closeCountryList();
      }
    },
    toggleCountryList: function toggleCountryList() {
      if (this.open === true) {
        this.closeCountryList();
      } else {
        this.openCountryList();
      }
    },
    openCountryList: function openCountryList() {
      this.searchstring = '';
      this.open = true;
    },
    closeCountryList: function closeCountryList() {
      this.searchstring = '';
      this.open = false;
    },
    getCountryColor: function getCountryColor(key) {
      return this.$store.getters.getSelectionColor(key);
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_ToggleArrow_vue__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'collapse-label',
  components: { ToggleArrow: __WEBPACK_IMPORTED_MODULE_0__shared_ToggleArrow_vue__["a" /* default */] },
  props: {
    title: {
      type: String,
      required: true
    },
    closed: {
      type: Boolean,
      default: false
    },
    canOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      open: false
    };
  },
  mounted: function mounted() {
    this.open = !this.closed;
  },

  watch: {
    closed: function closed() {
      this.open = !this.closed;
    }
  },
  methods: {
    toggleOpen: function toggleOpen() {
      this.open = !this.open;
      this.$emit('toggleOpen');
    },
    toggleClick: function toggleClick() {
      this.$emit('toggleClick');
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AttributesNavigation_Nav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CountriesNavigation_Nav__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compare-countries-regions-navigation',
  components: {
    'attribute-nav': __WEBPACK_IMPORTED_MODULE_0__AttributesNavigation_Nav__["a" /* default */],
    'countries-nav': __WEBPACK_IMPORTED_MODULE_1__CountriesNavigation_Nav__["a" /* default */]
  },
  data: function data() {
    return {
      currentNav: 'attribute'
    };
  },

  computed: {
    countries: function countries() {
      return this.$store.state.rsc.all;
    },
    selectedCountries: function selectedCountries() {
      return this.$store.state.rsc.selected;
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    }
  },
  watch: {
    selectedAttributes: function selectedAttributes() {
      if (this.selectedAttributes.length > 0) {
        this.currentNav = 'country';
      }
    }
  },
  mounted: function mounted() {
    if (this.selectedAttributes.length > 0) {
      this.currentNav = 'country';
    }
  },

  methods: {
    toggleCountryNavigation: function toggleCountryNavigation(closed) {
      if (closed) {
        this.currentNav = 'attribute';
      } else {
        this.currentNav = 'country';
      }
    },
    toggleAttributeNavigation: function toggleAttributeNavigation(closed) {
      if (closed) {
        this.currentNav = 'country';
      } else {
        this.currentNav = 'attribute';
      }
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CountriesNavigation_Nav__ = __webpack_require__(38);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'country-region-profile-navigation',
  components: {
    'countries-nav': __WEBPACK_IMPORTED_MODULE_0__CountriesNavigation_Nav__["a" /* default */]
  },
  computed: {
    countries: function countries() {
      return this.$store.state.rsc.all;
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'level-navigation',
  props: ['rout'],
  computed: {
    isFetching: function isFetching() {
      return this.$store.state.fetching.length > 0;
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'helptoolbar',
  computed: {},
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_2_axios___default.a.CancelToken,
      cancel: function cancel() {},

      description: false,
      popupContent: false,
      popupTitle: false
    };
  },

  watch: {
    '$route': function $route() {
      this.openToolbar();
    }
  },
  mounted: function mounted() {
    this.openToolbar();
  },

  methods: {
    openPopup: function openPopup() {
      __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('popup.open', this.popupTitle, this.popupContent);
    },
    loadData: function loadData() {
      var _this = this;

      this.cancel();

      var route = this.$route.path;
      var path = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.last(route.split('/'));

      if (!path) return;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/gsod-indices/api/" + 'helptoolbar/' + path, {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(function (response) {
        if (response.data && response.data[0]) {
          _this.description = response.data[0].description;
          _this.popupContent = response.data[0].popupContent ? response.data[0].popupContent : false;
          _this.popupTitle = response.data[0].popupTitle ? response.data[0].popupTitle : false;
        }
      }).catch(function (error) {
        if (!__WEBPACK_IMPORTED_MODULE_2_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        }
      });
    },
    openToolbar: function openToolbar() {
      this.resetText();
      if (!this.userHasSeenThis()) {
        this.loadData();
      }
    },
    closeToolbar: function closeToolbar() {
      this.setAsSeen();
      this.resetText();
    },
    resetText: function resetText() {
      this.description = false;
      this.popupContent = false;
      this.popupTitle = false;
    },
    isVisible: function isVisible() {
      return this.description !== false;
    },
    setAsSeen: function setAsSeen() {
      if (this.userHasSeenThis()) {
        return false;
      }
      var seen = this.$cookie.get('gsoid:helptoolbar');
      if (seen) {
        seen = JSON.parse(seen);
      }
      if (!seen || Object.prototype.toString.call(seen) !== '[object Array]') {
        seen = [];
      }
      seen.push({
        'route': this.$route.path,
        'seend': true
      });
      this.$cookie.set('gsoid:helptoolbar', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(seen), 30);
    },
    userHasSeenThis: function userHasSeenThis() {
      var seen = this.$cookie.get('gsoid:helptoolbar');
      if (seen) {
        seen = JSON.parse(seen);
      }
      return seen && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(seen, ['route', this.$route.path]);
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_DevelopmentsToWatch_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_ConcerningDevelopments_vue__ = __webpack_require__(41);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
// import {EventBus} from '@/event-bus.js'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'covidtoolbar',
  components: {
    ConcerningDevelopments: __WEBPACK_IMPORTED_MODULE_1__icons_ConcerningDevelopments_vue__["a" /* default */],
    DevelopmentsToWatch: __WEBPACK_IMPORTED_MODULE_0__icons_DevelopmentsToWatch_vue__["a" /* default */]
  },
  computed: {
    aboutUrl: function aboutUrl() {
      return "https://www.idea.int/gsod-indices/" + 'about-covid19';
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'developments-to-watch',
  'props': {
    'size': {
      type: Number,
      default: 47
    },
    'shadow': {
      type: Boolean,
      default: true
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
  },

  methods: {
    openTooltip: function openTooltip() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
        style: 'multiline',
        label: 'Developments to watch',
        value: ['<span class="text-sm">' + this.$Strings('covid19_watch_tooltip') + '</span>']
      });
    },
    closeTooltip: function closeTooltip() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'concerning-developments',
  'props': {
    'size': {
      type: Number,
      default: 47
    },
    'shadow': {
      type: Boolean,
      default: true
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
  },

  methods: {
    openTooltip: function openTooltip() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
        style: 'multiline',
        label: 'Concerning developments',
        value: ['<span class="text-sm">' + this.$Strings('covid19_concerning_tooltip') + '</span>']
      });
    },
    closeTooltip: function closeTooltip() {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tutorials',
  data: function data() {
    return {};
  },

  computed: {
    currentView: function currentView() {
      return this.$store.state.pagetutorial;
    },
    styleObject: function styleObject() {
      var levelnav = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.head(document.getElementsByClassName('l-mainwrap__main__navigation'));
      var height = levelnav !== undefined ? levelnav.offsetHeight : 0;
      return {
        top: height + 'px'
      };
    }
  },
  methods: {
    remove: function remove() {
      this.$store.state.pagetutorial = false;
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mouse-tooltip',
  data: function data() {
    return {
      data: {},
      visible: false,
      positionStyle: {},
      positionOffset: { x: 10, y: 10 }
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('tooltip.show', this.show);
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('tooltip.hide', this.hide);
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('mousemove', function () {
      if (_this.data.followMouse === undefined || _this.data.followMouse === true) {
        _this.setPosition();
      } else {
        _this.closeOnMouseLeave();
      }
    });
  },
  destroyed: function destroyed() {
    // Remove event handlers
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('tooltip.open');
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('tooltip.close');
  },

  computed: {
    mouseX: function mouseX() {
      return parseInt(this.$store.state.mousePosition.x);
    },
    mouseY: function mouseY() {
      return parseInt(this.$store.state.mousePosition.y);
    }
  },
  methods: {
    getElementPosition: function getElementPosition() {
      if (!document.getElementById('mousetooltip')) return { t: 0, l: 0, w: 0, h: 0 };

      var elem = document.getElementById('mousetooltip');

      var box = elem.getBoundingClientRect();

      var body = document.body;
      var docEl = document.documentElement;

      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

      var clientTop = docEl.clientTop || body.clientTop || 0;
      var clientLeft = docEl.clientLeft || body.clientLeft || 0;

      var top = box.top + scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;

      return {
        t: Math.round(top),
        l: Math.round(left),
        h: elem.offsetHeight,
        w: elem.offsetWidth
      };
    },
    closeOnMouseLeave: function closeOnMouseLeave() {
      var pos = this.getElementPosition();
      var offset = 25;

      if (!(this.mouseX > pos.l - offset && this.mouseX < pos.l + pos.w + offset && this.mouseY > pos.t - offset && this.mouseY < pos.t + pos.h + offset)) {
        this.hide();
      }
    },
    show: function show(data) {
      this.data = data;
      this.visible = true;
      this.setPosition();
    },
    hide: function hide() {
      this.visible = false;
    },
    setPosition: function setPosition() {
      var positionStyle = {
        top: 'auto',
        bottom: 'auto',
        left: 'auto',
        right: 'auto'
      };

      if (this.mouseX > window.innerWidth - 200) {
        positionStyle.right = parseInt(window.innerWidth - this.mouseX + this.positionOffset.x) + 'px';
      } else {
        positionStyle.left = parseInt(this.mouseX + this.positionOffset.x) + 'px';
      }

      if (this.mouseY > window.innnerHeight - 80) {
        positionStyle.bottom = parseInt(window.innnerHeight - this.mouseY + this.positionOffset.y) + 'px';
      } else {
        positionStyle.top = parseInt(this.mouseY + this.positionOffset.x) + 'px';
      }

      this.positionStyle = positionStyle;
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'popup',
  data: function data() {
    return {
      title: '',
      content: '',
      visible: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('popup.open', function (title, content) {
      _this.title = title;
      _this.content = content;
      _this.open();
    });
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on('popup.close', function () {
      _this.close();
    });
  },
  destroyed: function destroyed() {
    // Remove event handlers
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('popup.open');
    __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$off('popup.close');
  },

  methods: {
    open: function open() {
      this.visible = true;
    },
    close: function close() {
      this.visible = false;
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'view-selector',
  computed: {
    viewMode: function viewMode() {
      return this.$store.state.viewMode;
    }
  },
  watch: {
    '$store.state.covid19.is_enabled': function $storeStateCovid19Is_enabled() {
      if (this.$store.state.covid19.is_enabled) {
        this.$store.state.viewMode = 'chart';
      }
    }
  },
  methods: {
    setViewmode: function setViewmode(mode) {
      if (this.$store.state.fetching.length === 0) {
        this.$store.state.viewMode = mode;
      }
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gsodi-footer'
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_icons_ArrowRightIcon__ = __webpack_require__(320);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'welcome',
  components: {
    ArrowRightIcon: __WEBPACK_IMPORTED_MODULE_0__shared_icons_ArrowRightIcon__["a" /* default */]
  },
  mounted: function mounted() {
    var li = document.getElementsByClassName('switch-to');
    if (li.length > 0) {
      li[0].remove();
    }
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ArrowRightIcon'
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_pan_zoom__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_pan_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_pan_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_bus_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CountryRepository_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_misc_RegimeExplainer__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_misc_HighMediumLowExplainer__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_misc_PreloaderOverlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_misc_HelpTooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_sliders_RangeYearSlider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_misc_InfoOverlay__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tour_tourButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__covid19_FrameworkWheelMixins_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'worldmap',
  mixins: [__WEBPACK_IMPORTED_MODULE_15__covid19_FrameworkWheelMixins_js__["a" /* Covid19icons */]],
  props: ['covidEnable'],
  components: { RegimeExplainer: __WEBPACK_IMPORTED_MODULE_8__shared_misc_RegimeExplainer__["a" /* default */], TourButton: __WEBPACK_IMPORTED_MODULE_14__tour_tourButton__["a" /* default */], InfoOverlay: __WEBPACK_IMPORTED_MODULE_13__shared_misc_InfoOverlay__["a" /* default */], PreloaderOverlay: __WEBPACK_IMPORTED_MODULE_10__shared_misc_PreloaderOverlay__["a" /* default */], HelpTooltip: __WEBPACK_IMPORTED_MODULE_11__shared_misc_HelpTooltip__["a" /* default */], rangeYearSlider: __WEBPACK_IMPORTED_MODULE_12__shared_sliders_RangeYearSlider__["a" /* default */], HighMediumLowExplainer: __WEBPACK_IMPORTED_MODULE_9__shared_misc_HighMediumLowExplainer__["a" /* default */] },
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_3_axios___default.a.CancelToken,
      countryDragTimer: false, // Counts the time a user clicks on a country
      cancel: function cancel() {},

      canvas: false,
      countryGroup: false,
      countryRepository: new __WEBPACK_IMPORTED_MODULE_7__CountryRepository_js__["a" /* default */](),
      covid19group: false,
      currentGermanValue: {
        'German Democratic Republic': undefined,
        'Germany': undefined
      },
      currentZoom: 1,
      zoomScale: 1,
      data: [],
      mapSVGData: false,
      defaultZoom: 1,
      existingPattern: false,
      showConfidenceIntervals: true,
      showExplainer: false,
      tooltipDelay: 300,
      zoomSteps: [0.8, 1, 1.5, 3, 5],
      PanZoom: false,
      hoverDisabledCountries: ['N. Cyprus', 'Siachen Glacier', 'W. Sahara', 'Somaliland', 'Falkland Is.']
    };
  },
  mounted: function mounted() {
    this.$root.showMaps = true;
    this.$store.state.covid19.filter_available = true;
    this.$store.state.regime_nav_enabled = true;
    this.$store.state.covid19.is_enabled = this.covidEnable;
    this.$store.state.viewMode = 'chart';
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('sidebar-nav', 'WorldMap');
    this.initMap();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('hidemap');
    __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
    this.$root.showMaps = false;
    this.$store.state.covid19.filter_available = false;
    this.$store.state.regime_nav_enabled = false;
    this.cancel();
    if (this.PanZoom) {
      delete this.PanZoom;
    }
  },

  computed: {
    isRegimeEnabled: function isRegimeEnabled() {
      return this.$store.state.regime_enabled && !this.selectedAttribute;
    },
    viewmode: function viewmode() {
      return this.$store.state.viewMode;
    },
    mapHeight: function mapHeight() {
      var slider = document.getElementsByClassName('range-year-slider')[0];
      var sliderHeight = slider && slider.clientHeight ? slider.clientHeight : 0;
      return this.contentSize.height - sliderHeight - 100; // add 100 margin
    },
    contentSize: function contentSize() {
      return this.$store.state.contentSize;
    },
    windowSize: function windowSize() {
      return this.$store.state.windowSize;
    },
    year: function year() {
      return this.$store.state.yearSliderCurrent;
    },
    regions: function regions() {
      var all = this.$store.state.rsc.all;
      return all.regions;
    },
    selectedAttribute: function selectedAttribute() {
      return this.$store.getters['attributes/firstSelected'];
    },
    selectedAttributeName: function selectedAttributeName() {
      if (!this.selectedAttribute) return false;
      return this.$store.getters['attributes/labelInfo'](this.selectedAttribute, 'name');
    }
  },
  watch: {
    '$route': function $route() {
      this.$store.state.covid19.is_enabled = this.covidEnable;
    },
    '$store.state.covid19.is_enabled': function $storeStateCovid19Is_enabled() {
      this.assignDataToMap();
    },
    '$store.state.covid19.all': function $storeStateCovid19All() {
      this.loadData();
    },
    '$store.state.yearSliderCurrent': function $storeStateYearSliderCurrent() {
      this.loadData();
    },
    currentZoom: function currentZoom() {
      if (this.PanZoom) {
        this.PanZoom.zoom(this.currentZoom);
      }
    },
    selectedAttribute: function selectedAttribute() {
      this.assignDataToMap();
    },
    data: function data() {
      // Populate the repository
      this.countryRepository.reset();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var row = _step.value;

          var $el = this.canvas.select('[data-name="' + __WEBPACK_IMPORTED_MODULE_16_vue__["a" /* default */].filter('fixedName')(row.ID_country_name) + '"]');
          if ($el) {
            this.countryRepository.addCountry(row, $el, this.$store);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.assignDataToMap();

      if (!this.selectedAttribute || this.selectedAttribute === undefined) {
        this.$nextTick(this.openTour);
      }
    },
    viewmode: function viewmode() {
      if (this.viewmode === 'table') {
        this.$store.state.covid19.filter_available = false;
        var attr = this.selectedAttribute;
        var query = {};
        if (attr) {
          query.attr = ['["' + attr + '"]'];
        }
        this.$router.push({ name: 'world-map-table', query: query });
      } else {
        this.$store.state.covid19.filter_available = true;
      }
    }
  },
  methods: {
    openTour: function openTour(forceOpen) {
      __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tour:open', 'map', forceOpen, [{
        title: this.$Strings('tour_map1_title'),
        content: this.$Strings('tour_map1_description'),
        elementId: false
      }, {
        title: this.$Strings('tour_map2_title'),
        content: this.$Strings('tour_map2_description'),
        elementId: 'level-navigation'
      }, {
        title: this.$Strings('tour_map3_title'),
        content: this.$Strings('tour_map3_description'),
        elementId: 'attribute-nav'
      }, {
        title: this.$Strings('tour_map4_title'),
        content: this.$Strings('tour_map4_description'),
        elementId: 'range-year-slider'
      }, {
        title: this.$Strings('tour_map5_title'),
        content: this.$Strings('tour_map5_description'),
        elementId: 'view-selector'
      }]);
    },
    documentHasMap: function documentHasMap() {
      if (!this.mapSVGData || document.getElementById('worldmap')) {
        return true;
      }
    },
    initMap: function initMap() {
      var _this = this;

      if (!this.documentHasMap()) {
        return false;
      }

      this.canvas = __WEBPACK_IMPORTED_MODULE_4_svg_js___default()('worldmap');
      this.canvas.style({ width: '100%', height: '100%' });

      if (this.mapSVGData === false) {
        this.loadMap(function () {
          _this.canvas.svg(_this.mapSVGData);
          _this.canvas.viewbox(-200, -20, 1005, 482);

          // Set all countries to disabled
          _this.countryGroup = _this.canvas.group();
          _this.covid19group = _this.canvas.group();

          var countries = _this.canvas.select('[data-name]');
          countries.fill('#f1f3f7');

          // Add countries to group for easier access
          countries.each(function (i) {
            _this.countryGroup.add(countries.get(i));
          });

          _this.canvas.attr('id', 'worldmap-svg');

          // Enable zoom
          _this.enablePanZoom();

          // Remove areas without name from the map
          _this.canvas.select('path:not([data-name])').fill('transparent').style('pointer-events', 'none').addClass('not-used');

          _this.loadData();
        });
      } else {
        this.loadData();
      }
    },
    disablePanZoom: function disablePanZoom() {
      if (this.PanZoom) {
        this.PanZoom.destroy();
        this.PanZoom = false;
      }
    },
    enablePanZoom: function enablePanZoom() {
      var _this2 = this;

      this.disablePanZoom();
      this.PanZoom = __WEBPACK_IMPORTED_MODULE_5_svg_pan_zoom___default()('#worldmap-svg', {
        onPan: function onPan() {
          _this2.$forceUpdate();
        },
        onZoom: function onZoom(zoomScale) {
          _this2.zoomScale = zoomScale;
          _this2.$forceUpdate();
          _this2.assignDataToMap();
        }
      });
    },
    toggleInterval: function toggleInterval() {
      this.showConfidenceIntervals = !this.showConfidenceIntervals;
    },
    loadMap: function loadMap(callback) {
      var _this3 = this;

      this.$store.dispatch('startFetching', 'map');
      this.cancel();
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all([this.fetchMap()], {
        cancelToken: new this.CancelToken(function (c) {
          _this3.cancel = c;
        })
      }).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function (response) {
        _this3.$store.dispatch('stopFetching', 'map');
        _this3.mapSVGData = response.data.map;
        if (callback !== undefined) callback();
      })).catch(function (error) {
        _this3.$store.dispatch('stopFetching', 'map');
        if (!__WEBPACK_IMPORTED_MODULE_3_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this3.$Strings('json_error_title'), _this3.$Strings('json_error_body'));
        }
      });
    },
    loadData: function loadData(callback) {
      var _this4 = this;

      this.$store.dispatch('startFetching', 'mapData');
      this.cancel();
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.all([this.fetchData()], {
        cancelToken: new this.CancelToken(function (c) {
          _this4.cancel = c;
        })
      }).then(__WEBPACK_IMPORTED_MODULE_3_axios___default.a.spread(function (response) {
        _this4.$store.dispatch('stopFetching', 'mapData');
        _this4.data = response.data;
        if (callback !== undefined) callback();
      })).catch(function (error) {
        _this4.$store.dispatch('stopFetching', 'mapData');
        if (!__WEBPACK_IMPORTED_MODULE_3_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this4.$Strings('json_error_title'), _this4.$Strings('json_error_body'));
        }
      });
    },
    fetchData: function fetchData() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/gsod-indices/api/" + 'data?year1=' + this.$store.state.yearSliderCurrent + '&year2=' + this.$store.state.yearSliderCurrent);
    },
    fetchMap: function fetchMap() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/gsod-indices/api/" + 'map');
    },
    getColor: function getColor(name) {
      var color = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.colors, { name: name });
      return color.hex;
    },
    showCountryTooltip: function showCountryTooltip(country, attr) {
      if (country.name === 'Germany' || country.name === 'German Democratic Republic') {
        __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
          style: 'germany',
          values: this.currentGermanValue
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
          style: 'map',
          label: country.name,
          sublabel: country.regimeName(),
          value: country.attributeValue(attr)
        });
      }
    },
    showRegimeTooltip: function showRegimeTooltip(country) {
      var regimeName = country.regimeName();
      if (regimeName) {
        __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
          style: 'multiline',
          label: country.name,
          sublabel: regimeName
        });
      }
    },
    showCountryInfoTooltip: function showCountryInfoTooltip(country) {
      var countryInfo = this.getCountryInfo(country);
      __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
        style: 'country-info',
        label: country.name,
        value: countryInfo
      });
    },
    hideCountryTooltip: function hideCountryTooltip() {
      __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
    },
    resetCountries: function resetCountries() {
      if (!this.countryGroup) return false;
      this.resetCountryData();
    },
    resetCountryData: function resetCountryData(i) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.countryRepository.all()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var country = _step2.value;

          country.$el.stop().animate(1000, '>').fill(this.getColor('gray-light'));
          country.$el.off();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    addCovid19Icons: function addCovid19Icons() {
      var _this5 = this;

      var attr = this.selectedAttribute;
      var countries = this.countryRepository.all();
      this.$store.dispatch('startFetching', 'mapCovid19Icons');

      var _loop = function _loop(country) {
        var iconsize = 12 / _this5.zoomScale; // old value 17
        var type = attr ? country.countryAttributeType(attr) : country.incidentType();

        // There might no be any incidents
        // for a country in which case
        // we break the loop
        if (!type || type === '') return 'continue';

        // There might be more
        // than one area to
        // a country
        country.$el.each(function (i) {
          // Fix for New Zealans that has two areas
          if (country.name === 'New Zealand' && i === 1) {
            return false;
          }

          var icon = type === 'watch' ? _this5.getDevelopmentsToWatchIcon(_this5.canvas, iconsize) : _this5.getConcerningDevelopmentsIcon(_this5.canvas, iconsize);
          var pos = country.$el.get(i).rbox(_this5.countryGroup);
          var x = pos.cx;
          var y = pos.cy;
          var offset = _this5.$store.state.covid19.countrymapIconOffset[country.name];

          if (offset && offset[i]) {
            x += offset[i].x ? offset[i].x : 0;
            y += offset[i].y ? offset[i].y : 0;
          }

          if (country.id === '830' || country.id === '210' || country.id === '220') {
            x = pos.x;
            y = pos.y;

            if (country.id === '220') {
              x = pos.x + 12;
              y = pos.y + 11;
            }
            if (country.id === '210') {
              x = pos.x + 2;
              y = pos.y + 2;
            }
          }
          if (country.id === '385') {
            x = pos.x + 5;
            y = pos.y + (pos.height - 4);
          }
          if (country.id === '2') {
            x = pos.x + pos.width / 3 + 9;
            y = pos.y + 12;
            icon.center(x, y);
            _this5.covid19group.add(icon);
            _this5.addCovid19IconTooltip(icon, country, type);

            icon = type === 'watch' ? _this5.getDevelopmentsToWatchIcon(_this5.canvas, iconsize) : _this5.getConcerningDevelopmentsIcon(_this5.canvas, iconsize);

            x = pos.x2 - pos.width / 3 - 7;
            y = pos.y2 - pos.height / 3 + 2;
            icon.center(x, y);
            _this5.covid19group.add(icon);
            _this5.addCovid19IconTooltip(icon, country, type);

            return;
          }
          if (country.id === '20') {
            x = pos.x + pos.width / 3 - 6;
            y = pos.y + pos.height / 2 + 3;
          }
          if (country.id === '155' || country.id === '235' || country.id === '212') {
            x = pos.x + 6;
            y = pos.y + pos.height / 2 + 3;
          }

          if (country.id === '200') {
            x = pos.x + 6;
            y = pos.y + 10;
          }

          if (country.id === '560') {
            x += 1;
            y += 10;
          }
          icon.center(x, y);
          _this5.covid19group.add(icon);
          _this5.addCovid19IconTooltip(icon, country, type);
        });
      };

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(countries), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var country = _step3.value;

          var _ret = _loop(country);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.$store.dispatch('stopFetching', 'mapCovid19Icons');
    },
    resetCovid19Icons: function resetCovid19Icons() {
      if (this.covid19group) {
        this.covid19group.clear();
      }
    },
    addCovid19IconTooltip: function addCovid19IconTooltip(icon, country, type) {
      var _this6 = this;

      icon.on('mouseover', function () {
        _this6.changeCountryFill(country, '#064c65');
        icon.style('cursor', 'pointer');
        __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
          style: 'multiline',
          label: country.name,
          sublabel: country.regimeName(),
          value: [type === 'watch' ? 'Developments to watch' : 'Concerning developments', 'Click for detailed information']
        });
      });

      icon.on('mousedown', function () {
        _this6.clickStart();
      });
      icon.on('mouseup', function () {
        _this6.clickEnd(country);
      });

      icon.on('mouseout', function () {
        _this6.changeCountryFill(country, '');
        __WEBPACK_IMPORTED_MODULE_6__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
      });
    },
    setCountryData: function setCountryData() {
      var attr = this.selectedAttribute;

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.countryRepository.all()), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var country = _step4.value;

          if (['German Democratic Republic', 'Germany'].indexOf(country.name) !== -1 && this.hasBothGermanValues()) {
            country.$el.stop().animate(1000, '>').fill(this.pattern(country.attributeColor(attr)));
          } else {
            country.$el.stop().animate(1000, '>').fill(country.attributeHexColor(attr));
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.applyTooltips();
    },
    getCountryInfo: function getCountryInfo(country) {
      var infoMap = ['A_01', 'A_02', 'A_03', 'A_04', 'A_05'];
      var countryInfo = [];
      for (var key in infoMap) {
        var tkey = infoMap[key];
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(this.round(country.attributeValue(tkey)))) {
          countryInfo[key] = {
            'label': this.$store.getters['attributes/labelInfo'](tkey, 'name'),
            'value': this.round(country.attributeValue(tkey)).toFixed(2)
          };
        }
      }
      return countryInfo;
    },
    round: function round(num) {
      return Math.round(num * 100) / 100;
    },
    changeCountryFill: function changeCountryFill(country, color) {
      if (color === '') {
        var attr = this.selectedAttribute;
        if (attr) {
          color = country.attributeHexColor(attr);
        } else {
          color = country.regimeHexColor();
        }
      }
      country.$el.stop().style('cursor', 'pointer').animate(1000, '>').fill(color);
    },
    applyTooltips: function applyTooltips() {
      var _this7 = this;

      var _loop2 = function _loop2(country) {
        if (_this7.hoverDisabledCountries.indexOf(country.name) === -1) {
          country.$el.off();
          country.$el.on('mouseover', function () {
            // This would either be an
            // attribute tooltip or
            // a regime tooltip
            _this7.changeCountryFill(country, '#064c65');
            _this7.showCountryInfoTooltip(country);
          });
          country.$el.on('mousedown', function () {
            _this7.clickStart();
          });
          country.$el.on('mouseup', function () {
            _this7.clickEnd(country);
          });
          country.$el.on('mouseout', function () {
            _this7.hideCountryTooltip();
            _this7.changeCountryFill(country, '');
          });
        }
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.countryRepository.all()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var country = _step5.value;

          _loop2(country);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    clickStart: function clickStart() {
      this.countryDragTimer = new Date();
    },
    clickEnd: function clickEnd(country) {
      var end = new Date();
      var seconds = (end - this.countryDragTimer) / 1000.0;

      if (seconds < 0.25) {
        var covidEnabled = this.$store.state.covid19.is_enabled ? '&covid19=1' : '';
        var pathRedirect = '/countries-regions-profile?rsc=[' + country.id + ']' + covidEnabled;
        this.$router.push({ path: pathRedirect });
      }

      this.countryDragTimer = false;
    },
    assignRegimeColors: function assignRegimeColors() {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.countryRepository.all()), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var country = _step6.value;

          country.$el.stop().animate(1000, '>').fill(country.regimeHexColor());
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      this.applyTooltips();
    },
    assignDataToMap: function assignDataToMap() {
      if (!this.documentHasMap()) {
        return false;
      }

      this.$store.dispatch('startFetching', 'assignDataToMap');

      var year = this.$store.state.yearSliderCurrent;
      var attributeIsSelected = !!this.selectedAttribute;

      this.resetCovid19Icons();
      this.resetCountries();

      // Make sure all needed data is available
      // The user might need to select stuff - or data hasn't been
      // loaded yet
      if (!this.regions || !this.data || !year) {
        this.$store.dispatch('stopFetching', 'assignDataToMap');
        return false;
      }

      this.setGermanValues();

      // Check for covid19 incident information and
      // display it if available
      if (this.$store.state.covid19.is_enabled) {
        this.addCovid19Icons();
      }

      if (!attributeIsSelected) {
        this.assignRegimeColors();
      } else {
        this.setCountryData();
      }

      this.$store.dispatch('stopFetching', 'assignDataToMap');
    },
    createStripedPattern: function createStripedPattern(hex) {
      var size = 3;
      return this.canvas.pattern(size, size, function (add) {
        add.rect(size, size).addClass('bg').fill(hex);

        add.line(0, size).addClass('stroke').fill(hex).stroke({ color: '#ffffff', width: 2, opacity: 0.5 });

        add.rotate(45);
      });
    },
    pattern: function pattern(color) {
      if (!this.existingPattern) {
        this.existingPattern = this.createStripedPattern(this.getColor('gray-light'));
      }

      if (color !== undefined) {
        return this.createStripedPattern(this.getColor(color));
      }

      return this.existingPattern;
    },
    setGermanValues: function setGermanValues() {
      var year = this.$store.state.yearSliderCurrent;
      var attributeKey = this.selectedAttribute;

      var Germany = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.data, function (row) {
        return parseInt(row.ID_year) === parseInt(year) && row.ID_country_name === 'Germany';
      });
      this.currentGermanValue['Germany'] = Germany && Germany[attributeKey] ? Germany[attributeKey] : undefined;

      var GDR = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.data, function (row) {
        return parseInt(row.ID_year) === parseInt(year) && row.ID_country_name === 'German Democratic Republic';
      });
      this.currentGermanValue['German Democratic Republic'] = GDR && GDR[attributeKey] ? GDR[attributeKey] : undefined;
    },
    hasBothGermanValues: function hasBothGermanValues() {
      return this.currentGermanValue['Germany'] !== undefined && this.currentGermanValue['German Democratic Republic'] !== undefined;
    },
    canZoomIn: function canZoomIn() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(this.zoomSteps) !== this.currentZoom;
    },
    canZoomOut: function canZoomOut() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.first(this.zoomSteps) !== this.currentZoom;
    },
    canReset: function canReset() {
      if (this.PanZoom && this.PanZoom.getPan().x === 0 && this.currentZoom === 1) {
        return false;
      }
      return true;
    },
    zoomOut: function zoomOut() {
      if (this.canZoomOut()) {
        var index = this.zoomSteps.indexOf(this.currentZoom);
        this.currentZoom = this.zoomSteps[index - 1];
      }
    },
    zoomIn: function zoomIn() {
      if (this.canZoomIn()) {
        var index = this.zoomSteps.indexOf(this.currentZoom);
        this.currentZoom = this.zoomSteps[index + 1];
      }
    },
    zoomReset: function zoomReset() {
      if (this.canReset()) {
        this.currentZoom = 1;
        this.PanZoom.reset();
      }
    }
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'regime-explainer'
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'high-medium-low-explainer',
  props: {
    bg: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preloader-overlay',
  data: function data() {
    return {
      canvas: false,
      colors: ['purple', 'red', 'yellow', 'green'],
      lines: [],
      speed: 400,
      strokeWidth: 5,
      width: 60,
      height: 40,
      timer: false
    };
  },
  mounted: function mounted() {
    this.canvas = __WEBPACK_IMPORTED_MODULE_0_svg_js___default()('preloader_' + this._uid);
    this.draw();
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
    this.canvas.remove();
  },

  computed: {
    spaceBetween: function spaceBetween() {
      return (this.width - this.strokeWidth) / (this.colors.length - 1);
    },
    delayBetweenEach: function delayBetweenEach() {
      return this.speed / this.colors.length;
    }
  },
  methods: {
    draw: function draw() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.colors, function (color, index) {
        var xPos = _this.strokeWidth / 2 + _this.spaceBetween * index;
        var line = _this.canvas.line(xPos, _this.height, xPos, 0).stroke({ 'width': _this.strokeWidth, dasharray: '0,' + _this.height });
        line.addClass('svg-stroke--' + color);
        line.delay(_this.delayBetweenEach * index);

        _this.lines.push(line);
      });

      var currentIndex = 0;
      var animateUp = true;
      this.timer = setInterval(function () {
        if (currentIndex + 1 > _this.lines.length) {
          animateUp = !animateUp;
          currentIndex = 0;
        }
        if (animateUp) {
          _this.animateBarUp(currentIndex);
        } else {
          _this.animateBarDown(currentIndex);
        }
        currentIndex++;
      }, this.delayBetweenEach);
    },
    animateBarUp: function animateBarUp(index) {
      this.lines[index].stop().animate(this.speed).stroke({ dasharray: '0,' + this.height });
    },
    animateBarDown: function animateBarDown(index) {
      this.lines[index].stop().animate(this.speed).stroke({ dasharray: this.height + ',' + this.height });
    }
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'range-year-slider',
  components: { vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a },
  data: function data() {
    return {
      current: this.startSelection,
      minYear: this.years[0],
      maxYear: this.years[1]
    };
  },
  mounted: function mounted() {
    this.refresh();
    __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$on('slider.refresh', this.refresh);
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$off('slider.refresh', this.refresh);
  },

  watch: {
    current: function current() {
      if (this.isRangeSlider()) {
        this.$store.state.rangeYearSliderCurrent = this.current;
      } else {
        this.$store.state.yearSliderCurrent = this.current;
      }
    }
  },
  props: {
    years: {
      type: Array,
      // TODO: make these rely on $store.state.defaultYears
      default: function _default() {
        return [1975, 2021];
      }
    },
    startSelection: {
      // TODO: make these rely on $store.state.defaultYears
      default: function _default() {
        return [1975, 2021];
      }
    }
  },
  methods: {
    refresh: function refresh() {
      this.$refs.slider.refresh();
    },
    isRangeSlider: function isRangeSlider() {
      return this.startSelection instanceof Array;
    },
    isRangeSameYear: function isRangeSameYear() {
      return this.isRangeSlider() && this.current[0] === this.current[1];
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'info-overlay',
  props: {
    'description': {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tour-button',
  data: function data() {
    return {
      timer: false
    };
  },

  watch: {
    '$store.state.showTourTooltip': function $storeStateShowTourTooltip() {
      var _this = this;

      this.timer = setTimeout(function () {
        _this.$store.state.showTourTooltip = false;
      }, 3000);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Covid19icons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FrameworkWheelMixins; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(2);



var Covid19icons = {
  methods: {
    getConcerningDevelopmentsIcon: function getConcerningDevelopmentsIcon(canvas, size) {
      size = size === undefined ? 20 : size;
      var group = canvas.group();
      var circle = canvas.circle(size).fill('#F23411').stroke({ color: '#efefef', width: size / 20 }).move(0, 0);

      var text = canvas.text('!').font({
        fill: '#fff',
        anchor: 'middle',
        leading: 1,
        size: size / 4 * 3,
        family: 'Yrsa',
        weight: 500
      }).attr('alignment-baseline', 'middle').attr('dominant-baseline', 'middle');

      text.move(size / 2, size / 20);
      group.add(circle);
      group.add(text);
      group.addClass('concerningDevelopmentsIcon');

      return group;
    },
    getDevelopmentsToWatchIcon: function getDevelopmentsToWatchIcon(canvas, size) {
      size = size === undefined ? 20 : size;

      var group = canvas.group();
      var circle = canvas.circle(size).fill('#fff').stroke({ color: '#efefef', width: size / 10 }).move(0, 0);

      var circle1 = canvas.circle(size / 2.85).stroke({ color: '#004C64', width: size / 11.67 }).fill('none').move(size / 4, size / 4);

      var rect = canvas.rect(size / 3.333, size / 10).fill('#004c64').rotate(45).move(size / 4 * 3, size / 14.29);

      group.add(circle);
      group.add(circle1);
      group.add(rect);
      group.addClass('developmentsToWatchIcon');

      return group;
    }
  }
};

var FrameworkWheelMixins = {
  data: function data() {
    return {
      covidicons: [],
      covid19AttributeDegrees: [{ name: 'SA_01_01', deg: 9 }, // Start: 0. Size 18
      { name: 'SA_01_02', deg: 27 }, { name: 'SA_01_03', deg: 45 }, { name: 'SA_01_04', deg: 63 }, { name: 'SA_02_01', deg: 84 }, // Start: 72. Size 24
      { name: 'SA_02_02', deg: 108 }, { name: 'SA_02_03', deg: 132 }, { name: 'SA_03_01', deg: 156 }, //  Start 144. Size 24
      { name: 'SA_03_02', deg: 180 }, { name: 'SA_03_03', deg: 204 }, { name: 'SA_04_01', deg: 234 }, // Start 216. Size 36
      { name: 'SA_04_02', deg: 270 }, { name: 'SA_05_01', deg: 297 }, // Start 288. Size 18
      { name: 'SA_05_02', deg: 315 }, { name: 'SA_05_03', deg: 333 }, { name: 'SA_05_04', deg: 351 }]
    };
  },
  destroyed: function destroyed() {
    this.removeTooltips();
  },

  methods: {
    setCovid19AttributeIcons: function setCovid19AttributeIcons() {
      if (!this.$store.state.covid19.is_enabled || !this.firstCountry || !this.firstCountry.id || !this.canvas) {
        return false;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.covid19AttributeDegrees), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var attrDeg = _step.value;

          var attr = this.$store.getters['covid19/countryAttributeType'](this.firstCountry.id, attrDeg.name);

          if (attr) {
            var d = attrDeg.deg - 90; // the entire circle is rotate backwards 90deg
            var pos = this.getCovid19AttributeIconPosition(d);
            var x = pos.x - 10 + this.canvasSize[0] / 2;
            var y = pos.y - 10 + this.canvasSize[1] / 2;
            var icon = attr === 'watch' ? this.getDevelopmentsToWatchIcon(this.canvas) : this.getConcerningDevelopmentsIcon(this.canvas);

            icon.move(x, y);
            this.groups.push(icon);
            this.covidicons.push(icon);
            this.addTooltip(icon, attr);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    addTooltip: function addTooltip(icon, attr) {
      var _this = this;

      icon.on('mouseover', function () {
        var txt = void 0;
        if (attr === 'high') {
          txt = _this.$Strings('covid19_concerning_tooltip');
        } else {
          txt = _this.$Strings('covid19_watch_tooltip');
        }
        __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
          style: 'multiline',
          label: attr === 'watch' ? 'Developments to watch' : 'Concerning developments',
          value: ['<span class="text-sm">' + txt + '</span>']
        });
      });
      icon.on('mouseout', function () {
        __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
      });
    },
    removeTooltips: function removeTooltips() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.covidicons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var icon = _step2.value;

          icon.off();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    getCovid19AttributeIconPosition: function getCovid19AttributeIconPosition(deg) {
      var isSubattribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var c = this.canvasSize[1];
      var r = c / 2 - 84; // or 10 if it should go on edge
      var radian = deg * (Math.PI / 180);

      return {
        x: Math.cos(radian) * r,
        y: Math.sin(radian) * r
      };
    }
  }
};



/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_misc_PreloaderOverlay__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ViewModeTable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_misc_InfoOverlay__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'worldmap',
  props: {},
  components: { PreloaderOverlay: __WEBPACK_IMPORTED_MODULE_2__shared_misc_PreloaderOverlay__["a" /* default */], ViewModeTable: __WEBPACK_IMPORTED_MODULE_3__ViewModeTable__["a" /* default */], InfoOverlay: __WEBPACK_IMPORTED_MODULE_4__shared_misc_InfoOverlay__["a" /* default */] },
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken,
      cancel: function cancel() {},

      data: []
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_5__event_bus_js__["a" /* EventBus */].$emit('sidebar-nav', 'WorldMap');
    this.$store.state.viewMode = 'table';
    if (this.selectedAttribute) {
      this.loadData(function () {});
    }
  },

  computed: {
    viewmode: function viewmode() {
      return this.$store.state.viewMode;
    },
    year: function year() {
      return this.$store.state.yearSliderCurrent;
    },
    regions: function regions() {
      var all = this.$store.state.rsc.all;
      return all.regions;
    },
    selectedAttribute: function selectedAttribute() {
      return this.$store.getters['attributes/firstSelected'];
    },
    tableData: function tableData() {
      var result = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.data, function (row, i) {
        if (row.ID_region && row.ID_region !== '' && row.ID_subregion && row.ID_subregion !== '') {
          result[i] = row;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(result, ['ID_country_name']);
    }
  },
  watch: {
    selectedAttribute: function selectedAttribute() {
      if (this.data.length === 0) {
        this.loadData(function () {});
      }
    },
    year: function year() {
      this.loadData(function () {});
    },
    viewmode: function viewmode() {
      if (this.viewmode === 'chart') {
        this.changeViewMode();
      }
    }
  },
  methods: {
    changeViewMode: function changeViewMode() {
      var attr = this.selectedAttribute;
      var query = {};
      if (attr) {
        query.attr = ['["' + attr + '"]'];
      }
      this.$router.push({ name: 'democracy-indices', query: query });
    },
    toggleInterval: function toggleInterval() {
      this.showConfidenceIntervals = !this.showConfidenceIntervals;
    },
    loadData: function loadData(callback) {
      var _this = this;

      this.$store.dispatch('startFetching', 'maptable');
      this.cancel();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.fetchData()], {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (response) {
        _this.$store.dispatch('stopFetching', 'maptable');
        _this.data = response.data;
        if (callback !== undefined) callback();
      })).catch(function (error) {
        _this.$store.dispatch('stopFetching', 'maptable');
        if (!__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_5__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        }
      });
    },
    fetchData: function fetchData() {
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'data?year1=' + this.year + '&year2=' + this.year);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sliders_RangeYearSlider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_charts_TableChart_vue__ = __webpack_require__(357);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'





// import {EventBus} from '@/event-bus.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'viewmode-table',
  props: {
    'data': {},
    'dateRange': {},
    'sortingKey': {
      default: 'ID_country_name',
      required: false
    },
    showAttributes: {
      type: Array
    }
  },
  components: { TableChart: __WEBPACK_IMPORTED_MODULE_2__shared_charts_TableChart_vue__["a" /* default */], rangeYearSlider: __WEBPACK_IMPORTED_MODULE_1__shared_sliders_RangeYearSlider__["a" /* default */] },
  computed: {
    downloadUrl: function downloadUrl() {
      var countries = this.$store.state.rsc.selected;
      var attributes = this.showAttributes;
      var dateRange = this.$store.state.rangeYearSliderCurrent;

      if (!countries || !attributes) {
        return false;
      }

      return "/gsod-indices/csv_export/" + '?rsc=' + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(countries, 'id').join(',') + '&attr=' + attributes.join(',') + '&year1=' + dateRange[0] + '&year2=' + dateRange[1];
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navigation_shared_ToggleArrow_vue__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableChart',
  components: { ToggleArrow: __WEBPACK_IMPORTED_MODULE_1__navigation_shared_ToggleArrow_vue__["a" /* default */] },
  props: {
    data: {
      type: Array,
      required: true
    },
    showConfidenceInterval: {
      default: true,
      type: Boolean
    },
    sortingKey: {
      default: 'ID_country_name',
      type: String
    },
    showAttributes: {
      default: function _default() {
        return [];
      },

      type: Array
    }
  },
  computed: {
    headerNames: function headerNames() {
      var _this = this;

      var headers = ['ID_year', 'ID_country_name'];
      var attributes = this.showAttributes;

      if (!this.data[0]) return [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.data[0], function (data, key) {
        // Only take the headers matching the users
        // selected attributes
        if ((attributes.indexOf(key) !== -1 || _this.showAll) && !(key === 'ID_year' || key === 'ID_country_name')) {
          if (_this.headerExists(key)) {
            headers.push(key);
          }

          if (_this.showConfidenceInterval) {
            if (_this.headerExists(key + '_U')) {
              headers.push(key + '_U');
            }
            if (_this.headerExists(key + '_L')) {
              headers.push(key + '_L');
            }
          }
        }
      });
      return headers;
    },
    rows: function rows() {
      var _this2 = this;

      var result = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.data, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.size);
      var rows = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(result, function (row) {
        return row[_this2.currentSorting];
      });
      if (this.currentSortingOrder === 'desc') {
        return rows.reverse();
      } else {
        return rows;
      }
    }
  },
  data: function data() {
    return {
      currentSorting: this.sortingKey,
      currentSortingOrder: 'asc'
    };
  },

  methods: {
    isSortable: function isSortable(headerKey) {
      if (!headerKey) {
        return false;
      }
      if (['ID_country_name', 'ID_year'].indexOf(headerKey) !== -1) return true;
    },
    changeSorting: function changeSorting(headerKey) {
      if (this.isSortable(headerKey)) {
        if (this.currentSorting === headerKey) {
          this.currentSortingOrder = this.currentSortingOrder === 'asc' ? 'desc' : 'asc';
        } else {
          this.currentSorting = headerKey;
          this.currentSortingOrder = 'asc';
        }
      }
    },
    headerExists: function headerExists(key) {
      return !!this.getHeaderName(key);
    },
    getHeaderName: function getHeaderName(key) {
      var name = void 0;
      if (key === 'ID_year') return 'Year';
      if (key === 'ID_country_name') return 'Country name';

      if (key.slice(-2) === '_U') {
        name = this.$store.getters['attributes/labelInfo'](key.slice(0, key.length - 2), 'name');
        return name ? name + ' Confidence Interval Upper Limit' : false;
      }

      if (key.slice(-2) === '_L') {
        name = this.$store.getters['attributes/labelInfo'](key.slice(0, key.length - 2), 'name');
        return name ? name + ' Confidence Interval Lower Limit' : false;
      }

      return this.$store.getters['attributes/labelInfo'](key, 'name') + ' Score';
    },
    setSort: function setSort(selectedSort) {
      this.sortBy = selectedSort;
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_sliders_RangeYearSlider_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_charts_LineChart_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tutorials_CompareAttributesTutorial_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_misc_InfoOverlay_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_misc_PreloaderOverlay_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_misc_DownloadShare_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_misc_ConfidenceIntervals_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_charts_LinechartSelectedLabels_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tour_tourButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewModeTable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compare-attributes',
  components: { TourButton: __WEBPACK_IMPORTED_MODULE_10__tour_tourButton__["a" /* default */], ViewModeTable: __WEBPACK_IMPORTED_MODULE_11__ViewModeTable__["a" /* default */], PreloaderOverlay: __WEBPACK_IMPORTED_MODULE_6__shared_misc_PreloaderOverlay_vue__["a" /* default */], ConfidenceIntervals: __WEBPACK_IMPORTED_MODULE_8__shared_misc_ConfidenceIntervals_vue__["a" /* default */], DownloadShare: __WEBPACK_IMPORTED_MODULE_7__shared_misc_DownloadShare_vue__["a" /* default */], rangeYearSlider: __WEBPACK_IMPORTED_MODULE_2__shared_sliders_RangeYearSlider_vue__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_3__shared_charts_LineChart_vue__["a" /* default */], LinechartSelectedLabels: __WEBPACK_IMPORTED_MODULE_9__shared_charts_LinechartSelectedLabels_vue__["a" /* default */], tutorial: __WEBPACK_IMPORTED_MODULE_4__tutorials_CompareAttributesTutorial_vue__["a" /* default */], InfoOverlay: __WEBPACK_IMPORTED_MODULE_5__shared_misc_InfoOverlay_vue__["a" /* default */] },
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken,
      cancel: function cancel() {},

      chartData: []
    };
  },

  watch: {
    selectedCountry: function selectedCountry() {
      this.loadData();
    },
    selectedAttributes: function selectedAttributes() {
      // All attributes are loaded anyway
      // so no need to refresh
    },
    dateRange: function dateRange() {
      this.loadData();
    },
    viewmode: function viewmode() {
      this.loadData();
    }
  },

  methods: {
    openTour: function openTour(forceOpen) {
      __WEBPACK_IMPORTED_MODULE_12__event_bus_js__["a" /* EventBus */].$emit('tour:open', 'compare-attributes', forceOpen, [{
        title: this.$Strings('tour_attributes1_title'),
        content: this.$Strings('tour_attributes1_description'),
        elementId: false
      }, {
        title: this.$Strings('tour_attributes2_title'),
        content: this.$Strings('tour_attributes2_description'),
        elementId: 'countries-nav'
      }, {
        title: this.$Strings('tour_attributes3_title'),
        content: this.$Strings('tour_attributes3_description'),
        elementId: 'attribute-nav'
      }, {
        title: this.$Strings('tour_attributes4_title'),
        content: this.$Strings('tour_attributes4_description'),
        elementId: 'range-year-slider'
      }]);
    },

    /**
     * Loads the navigation data
     * @return {null}
     */
    loadData: function loadData() {
      var _this = this;

      if (!this.selectedCountry || !this.dateRange[0] || !this.dateRange[1]) {
        return false;
      }

      this.$store.dispatch('startFetching', 'compareAttributes');

      var year1 = this.dateRange[0];
      var year2 = this.dateRange[1];
      var crsId = this.selectedCountry.id;

      this.cancel();

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'data/?year1=' + year1 + '&year2=' + year2 + '&crsId=' + crsId, {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(function (response) {
        _this.$store.dispatch('stopFetching', 'compareAttributes');
        _this.chartData = response.data;
      }).catch(function (error) {
        _this.$store.dispatch('stopFetching', 'compareAttributes');
        if (!__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_12__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        }
      });
    },
    toggleInterval: function toggleInterval() {
      this.$store.state.confidenceIntervals = !this.$store.state.confidenceIntervals;
    }
  },
  mounted: function mounted() {
    this.loadData();
    __WEBPACK_IMPORTED_MODULE_12__event_bus_js__["a" /* EventBus */].$emit('sidebar-nav', 'CompareAttributes');

    if (this.selectedAttributes === undefined || this.selectedAttributes.length === 0 || !this.selectedCountry || this.selectedCountry === undefined) {
      this.$nextTick(this.openTour);
    }
  },
  destroyed: function destroyed() {},

  computed: {
    viewmode: function viewmode() {
      return this.$store.state.viewMode;
    },
    dateRange: function dateRange() {
      return this.$store.state.rangeYearSliderCurrent;
    },
    selectedCountry: function selectedCountry() {
      return this.$store.getters['rsc/firstSelected'];
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    },
    tableData: function tableData() {
      if (this.selectedAttributes.length === 0 || !this.selectedCountry) {
        return [];
      }
      return this.chartData;
    },
    formattedChartData: function formattedChartData() {
      var _this2 = this;

      var dataset = [];

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.selectedAttributes, function (attr) {
        var name = _this2.$store.getters['attributes/labelInfo'](attr, 'name');
        var color = _this2.$store.getters.getSelectionColor(attr);

        dataset[attr] = {
          name: name,
          color: color,
          yearData: {}
        };
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this2.chartData, function (row) {
          dataset[attr].yearData[row.ID_year] = {};
          dataset[attr].yearData[row.ID_year].point = row[attr];
          dataset[attr].yearData[row.ID_year].high = row[attr + '_U'];
          dataset[attr].yearData[row.ID_year].low = row[attr + '_L'];
        });
      });

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.values(dataset);
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389a9d8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__ = __webpack_require__(365);
function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_389a9d8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc_HelpTooltip__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * Data for the line chart is accepted in this format
 * [{
 *   name: 'the attribute name',
 *   color: 'yellow',
 *   yearData: {
 *     2005: { point: 0.5, high: 0.6, low: 0.45 },
 *     2006: { point: 0.2, high: 0.25, low: 0 }
 *   }
 * },
 * {
 *   name: 'another attribute name',
 *   color: 'red',
 *   yearData: {
 *     2005: { point: 0.5, high: 0.6, low: 0.45 },
 *     2006: { point: 0.2, high: 0.25, low: 0 }
 *   }
 * }]
 */

// import Vue from 'vue'







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineChart',
  components: { HelpTooltip: __WEBPACK_IMPORTED_MODULE_2__misc_HelpTooltip__["a" /* default */] },
  props: {
    data: {
      type: Array,
      required: true
    },
    visibleRange: {
      type: Array,
      default: [1980, 2005]
    },
    showConfidenceInterval: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    firstYear: function firstYear() {
      return this.visibleRange[0];
    },
    lastYear: function lastYear() {
      return this.visibleRange[1];
    }
  },
  data: function data() {
    return {
      canvas: false,
      canvasSize: [740, 285],
      labelFontsize: 11,
      hoverSize: 30,
      hoverGroup: [],
      gridGroup: false,
      groups: {},
      sideSpace: 40,
      bigStrokeWidth: 20,
      strokeWidth: 2,
      yLabels: ['0', '.1', '.2', '.3', '.4', '.5', '.6', '.7', '.8', '.9', '1'],
      tooltipCurrent: false,
      tooltipX: 0,
      tooltipY: 0
    };
  },

  watch: {
    data: function data() {
      this.redraw();
    },
    showConfidenceInterval: function showConfidenceInterval() {
      this.redraw();
    },
    visibleRange: function visibleRange() {
      this.redraw();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.drawCanvas();
    this.drawChart();

    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$on('window:resize', function () {
      _this.setChartSize();
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
  },

  methods: {

    /**
     * Redraws the chart
     */
    redraw: function redraw() {
      this.reset();
      this.drawChart();
    },


    /**
     * Draws the chart
     */
    drawChart: function drawChart() {
      var _this2 = this;

      if (!this.data) return false;

      // Initialize
      this.drawGrid();

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.data, function (val, index) {
        _this2.groups[index] = _this2.drawDataLine(val);
      });

      this.drawOpacityBoxes();
      this.groups.labels = this.drawLabels();

      // Add hover
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.data, function (val) {
        _this2.addHover(val);
      });

      this.addYAxisExplainer();
    },


    /**
     * Removes all elements from the chart
     */
    reset: function reset() {
      this.gridGroup.remove();
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.hoverGroup, function (group) {
        group.remove();
      });
      this.hoverGroup = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forIn(this.groups, function (group) {
        group.remove();
      });
      this.groups = {};
    },


    /**
     * Initialize the SVG convas
     */
    drawCanvas: function drawCanvas() {
      this.canvas = __WEBPACK_IMPORTED_MODULE_0_svg_js___default()('linechart__svg--' + this._uid);
      this.setChartSize();
    },


    /**
     * Set the chart size
     */
    setChartSize: function setChartSize() {
      this.canvas.attr('display', 'none');

      var containerEl = document.getElementsByClassName('linechart');
      var containerWidth = containerEl[0] ? containerEl[0].offsetWidth : 0;

      this.canvas.attr('display', 'block');

      var dimension = this.canvasSize[0] / this.canvasSize[1];
      var w = containerWidth + 40; // add 40 because the wrapper has -20px margin
      var h = w / dimension;

      this.canvas.size(w, h).viewbox(0, 0, this.canvasSize[0], this.canvasSize[1]).style({ height: h + 'px', width: w + 'px' });
    },


    /**
     * Draws the grid
     */
    drawGrid: function drawGrid() {
      var _this3 = this;

      var yearXMap = this.getYearXMap();
      var canvasHeight = this.getCalculatedCanvasHeight();
      var offset = this.getVerticalOffset();

      // Draw horizontal grid
      this.gridGroup = this.canvas.group();
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.yLabels, function (val) {
        var yPos = canvasHeight * parseFloat(val) + offset;
        var faded = parseFloat(val) * 10 % 2 === 0 ? '' : ' svg-stroke--faded';
        var line = _this3.drawLine(0, yPos, _this3.canvasSize[0], yPos, 'svg-stroke--gray-lightest' + faded);
        _this3.gridGroup.add(line);
      });

      // Draw vertical grid
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(yearXMap, function (xPos, year) {
        var strokeWidth = year % 5 === 0 ? 2 : 0.4;
        var line = _this3.drawLine(xPos, offset, xPos, canvasHeight + offset, 'svg-stroke--gray-lightest', strokeWidth);
        _this3.gridGroup.add(line);
      });
    },
    getDataYearPoint: function getDataYearPoint(year, row) {
      var offset = this.getVerticalOffset();
      var point = parseFloat(row.point);

      if (point === undefined || isNaN(point)) return false;

      var x = this.getYearXMap()[year];
      var y = this.getCalculatedCanvasHeight() * (1 - parseFloat(point)) + offset;

      return [x, y];
    },
    getDataYearConfHighPoint: function getDataYearConfHighPoint(year, row) {
      var canvasHeight = this.getCalculatedCanvasHeight();
      var offset = this.getVerticalOffset();
      var high = parseFloat(row.high);

      if (high === undefined || isNaN(high)) return false;
      if (high > 1) high = 1;

      var x = this.getYearXMap()[year];
      var y = canvasHeight * (1 - parseFloat(high)) + offset;

      return [x, y];
    },
    getDataYearConfLowPoint: function getDataYearConfLowPoint(year, row) {
      var canvasHeight = this.getCalculatedCanvasHeight();
      var offset = this.getVerticalOffset();
      var low = parseFloat(row.low);

      if (low === undefined || isNaN(low)) return false;
      if (low < 0) low = 0;

      var x = this.getYearXMap()[year];
      var y = canvasHeight * (1 - parseFloat(low)) + offset;

      return [x, y];
    },
    getYearCoordinates: function getYearCoordinates(data) {
      var _this4 = this;

      var years = {};
      var yearXMap = this.getYearXMap();

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data.yearData, function (val, year) {
        year = parseInt(year);
        years[year] = {};

        var xy = _this4.getDataYearPoint(year, val);
        var highXy = _this4.getDataYearConfHighPoint(year, val);
        var lowXy = _this4.getDataYearConfLowPoint(year, val);

        years[year].point = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(yearXMap, year) ? xy : false;
        years[year].high = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(yearXMap, year) ? highXy : false;
        years[year].low = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(yearXMap, year) ? lowXy : false;
      });

      return years;
    },
    getLineDataArray: function getLineDataArray(values, key) {
      var lines = [];
      var lineIndex = 0;
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(values, function (val, year) {
        if (val[key] !== false) {
          if (!lines[lineIndex]) {
            lines[lineIndex] = [];
          }

          lines[lineIndex].push(val[key]);
        } else {
          lineIndex++;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.compact(lines);
    },


    /**
     * Draws a data polyline based on data
     * @param  {object} data The line data
     * @return {Object}      A svg group
     */
    drawDataLine: function drawDataLine(data) {
      var _this5 = this;

      var group = this.canvas.group();
      var coordinateArrays = this.getYearCoordinates(data);
      var lines = this.getLineDataArray(coordinateArrays, 'point');

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(lines, function (lineData) {
        // Draw points
        var pointsLine = _this5.drawPolyline(lineData, 'svg-stroke--' + data.color, _this5.strokeWidth);
        group.add(pointsLine);
      });

      if (this.showConfidenceInterval) {
        var highLines = this.getLineDataArray(coordinateArrays, 'high');
        var lowLines = this.getLineDataArray(coordinateArrays, 'low');

        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(highLines, function (highData, index) {
          if (!lowLines[index]) return false;
          var lowData = lowLines[index].reverse();

          var confidenceData = highData.concat(lowData);

          // Draw points
          var condidenceLine = _this5.canvas.polygon(confidenceData).addClass('svg-fill--' + data.color + ' svg-fill--faded-2').stroke({ width: 0 });
          group.add(condidenceLine);
        });
      }

      return group;
    },


    /**
     * Adds hover functionality
     * @param  {object} data The line data
     */
    addHover: function addHover(data) {
      var _this6 = this;

      var yearXMap = this.getYearXMap();
      var canvasHeight = this.getCalculatedCanvasHeight();
      var offset = this.getVerticalOffset();

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(data.yearData, function (val, year) {
        // Previous point (offcanvas)
        year = parseInt(year);

        var x = yearXMap[year];
        var y = canvasHeight * (1 - parseFloat(val.point)) + offset;

        // if (!_.has(yearXMap, year) && _.has(yearXMap, year + 1)) {
        //   lineData.push(yearXMap[year + 1] - this.calculateSpaceBetweenLines())
        //   lineData.push(canvasHeight * val.point + offset)
        // }
        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(yearXMap, year)) {
          // Add hover to point
          var hoverCircle = _this6.canvas.circle(_this6.hoverSize).fill('transparent').move(x - _this6.hoverSize / 2, y - _this6.hoverSize / 2);
          _this6.hoverGroup.push(hoverCircle);
          hoverCircle.mouseover(function () {
            var mouseoverdata = [];

            // Check if other data lines are too close
            // If they are we show them in the mouse poup too
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this6.data, function (otherline) {
              if (Math.abs(otherline.yearData[year].point - val.point) < 0.13) {
                mouseoverdata.push({
                  label: otherline.name,
                  year: year,
                  value: _this6.getFixedValue(otherline.yearData[year].point)
                });
              }
            });

            __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
              style: 'linechart',
              data: {
                dataarr: mouseoverdata
              }
            });
          });
          hoverCircle.mouseout(function () {
            __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
          });
        }
      });
    },


    /**
     * Draws two opacity boxes
     * @return {[type]} [description]
     */
    drawOpacityBoxes: function drawOpacityBoxes() {
      var group = this.canvas.group();
      var canvasHeight = this.canvasSize[1];
      var rightBoxX = this.canvasSize[0] - this.sideSpace;

      var leftBox = this.canvas.rect(this.sideSpace, canvasHeight).move(0, 0).addClass('svg-fill--white svg-fill--faded');
      var rightBox = this.canvas.rect(this.sideSpace, canvasHeight).move(rightBoxX, 0).addClass('svg-fill--white svg-fill--faded');

      group.add(leftBox, rightBox);
      this.groups.opacityBoxes = group;
    },


    /**
     * Draws the data labels
     * @return {object} A SVG group containing the labels
     */
    drawLabels: function drawLabels() {
      var _this7 = this;

      var group = this.canvas.group();
      var canvasHeight = this.getCalculatedCanvasHeight();
      var offset = this.getVerticalOffset();
      var fontstack = window.getComputedStyle(document.body, null).getPropertyValue('font-family');

      // Year labels
      var xmap = this.getYearXMap();
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(xmap, function (xPos, year) {
        if (year % 5 === 0 || parseInt(year) === parseInt(_this7.firstYear) || parseInt(year) === parseInt(_this7.lastYear)) {
          var text = _this7.canvas.text(year);
          text.move(xPos, _this7.canvasSize[1] - _this7.labelFontsize).font({
            anchor: 'middle',
            size: _this7.labelFontsize,
            family: fontstack,
            weight: 100
          });
          text.addClass('svg-fill--gray');
          group.add(text);
        }
      });

      // Y Labels
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.yLabels, function (val) {
        var yPos = canvasHeight - canvasHeight * val + offset - _this7.labelFontsize / 2; // Subtract half fontsize
        var xPos = _this7.sideSpace - 3;
        var text = _this7.canvas.text(String(val));
        text.move(xPos, yPos).font({ anchor: 'end', size: _this7.labelFontsize, family: fontstack, weight: 100 });
        text.addClass('svg-fill--gray');
        group.add(text);
      });

      return group;
    },
    addYAxisExplainer: function addYAxisExplainer() {
      var _this8 = this;

      var offset = this.getVerticalOffset();
      var yPos = offset - this.labelFontsize / 2; // Subtract half fontsize
      var xPos = this.sideSpace - 25;

      var questionmark = this.canvas.select('.questionmark').first();
      questionmark.move(xPos, yPos);
      var circle = this.canvas.circle(12).attr({ 'fill': 'transparent' });
      circle.move(xPos, yPos);

      // re-add to move to top
      this.canvas.add(questionmark);
      this.canvas.add(circle);

      circle.mouseover(function () {
        __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', {
          style: 'single',
          label: _this8.$Strings('yAxisExplainer')
        });
      });
      circle.mouseout(function () {
        __WEBPACK_IMPORTED_MODULE_3__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
      });
    },


    /**
     * Returns the canvas vertical offset
     * @return {Integer}
     */
    getVerticalOffset: function getVerticalOffset() {
      return this.bigStrokeWidth + 5;
    },


    /**
     * Returns the calculated canvas height
     * @return {integer}
     */
    getCalculatedCanvasHeight: function getCalculatedCanvasHeight() {
      return this.canvasSize[1] - this.getVerticalOffset() * 2;
    },


    /**
     * Calculates the space between lines
     * @return {Float} The space in px between each line in the chart
     */
    calculateSpaceBetweenLines: function calculateSpaceBetweenLines() {
      var calculatedWidth = this.canvasSize[0] - this.sideSpace * 2;
      return calculatedWidth / (this.getAmountOfYears() - 1);
    },


    /**
     * Returns the amount of years shown in the graph
     * @return {Integer} The amount of years
     */
    getAmountOfYears: function getAmountOfYears() {
      return this.visibleRange[1] - this.visibleRange[0] + 1;
    },


    /**
     * Returns an object of the years and the corresponding x value
     * @return {Object} Mapped [year] => xPosition object
     */
    getYearXMap: function getYearXMap() {
      var spaceBetween = this.calculateSpaceBetweenLines();
      var result = {};

      if (this.getAmountOfYears() === 1) {
        result[this.visibleRange[0]] = this.sideSpace;
        return result;
      }

      for (var i = 0; i < this.getAmountOfYears(); i++) {
        var xPos = spaceBetween * i + this.sideSpace;
        var year = this.visibleRange[0] + i;
        result[year] = xPos;
      }

      return result;
    },


    /**
     * Draw a line in the chart
     * @param  {integer} xPos      The start x position
     * @param  {integer} yPos      The start y position
     * @param  {integer} xPos2     The end x position
     * @param  {integer} yPos2     The end y position
     * @param  {String} className  The classname
     * @return {Object} The line object
     */
    drawLine: function drawLine(xPos, yPos, xPos2, yPos2, className) {
      var strokeWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

      var line = this.canvas.line(xPos, yPos, xPos2, yPos2).stroke({ width: strokeWidth });
      line.addClass(className);
      return line;
    },


    /**
     * Draw a polyline in the chart
     * @param  {array} positionArray The position array
     * @param  {String} className  The classname
     * @return {Object} The line object
     */
    drawPolyline: function drawPolyline(positionArray, className) {
      var strokeWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var polyline = this.canvas.polyline(positionArray).stroke({ width: strokeWidth }).fill('none');
      polyline.addClass(className);
      return polyline;
    },


    /**
     * What to do when the mouse moves
     * @param  {object} event The JS Event object
     */
    onMouseMove: function onMouseMove(event) {
      var tooltip = document.getElementsByClassName('linechart__tooltip');
      var yPos = event.offsetY;
      if (tooltip.length > 0) {
        yPos = event.offsetY - tooltip[0].clientHeight - 7;
      }
      this.tooltipX = event.offsetX - 2;
      this.tooltipY = yPos;
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compare-attributes-tutorials',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadShare_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3a53fb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadShare_vue__ = __webpack_require__(374);
function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c3a53fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3a53fb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_submit_form__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_submit_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_submit_form__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'downloadshare',
  props: ['page'],
  data: function data() {
    return {
      showShareOptions: false
    };
  },

  computed: {
    confidenceIntervals: function confidenceIntervals() {
      return this.$store.state.confidenceIntervals;
    },
    dateRange: function dateRange() {
      return this.$store.state.rangeYearSliderCurrent;
    },
    selectedCountries: function selectedCountries() {
      return this.$store.state.rsc.selected;
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    },
    facebookLink: function facebookLink() {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.shareUrl);
    },
    twitterLink: function twitterLink() {
      return 'https://twitter.com/home?status=' + encodeURIComponent(this.shareUrl);
    },
    linkedInLink: function linkedInLink() {
      return 'https://www.linkedin.com/shareArticle?mini=true&title=The%20Global%20State%20of%20Democracy%20indices&url=' + encodeURIComponent(this.shareUrl);
    },
    shareUrl: function shareUrl() {
      var baseurl = location.protocol + '//' + location.host + location.pathname + '#' + this.$route.path + '?';
      var queryParams = [];

      if (this.selectedCountries) {
        var countriesArray = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedCountries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var country = _step.value;

            countriesArray.push(country.id);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        queryParams.push('rsc=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(countriesArray));
      }
      if (this.selectedAttributes) {
        queryParams.push('attr=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedAttributes));
      }
      if (this.dateRange) {
        queryParams.push('date=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.dateRange));
      }

      queryParams.push('ci=' + this.confidenceIntervals);

      return baseurl + queryParams.join('&');
    }
  },
  methods: {
    download: function download() {
      if (this.page === 'CompareAttributes') {
        this.downloadCompareAttributes();
      } else {
        this.downloadCompareSRC();
      }
    },

    /**
     * Triggers the download
     * @param  {obj} postdata The post data
     * @return {void}
     */
    postDownload: function postDownload(postdata) {
      __WEBPACK_IMPORTED_MODULE_2_submit_form___default()(this.$Strings('image_download_url'), {
        method: 'POST',
        target: '_blank',
        body: postdata
      });
    },


    /**
     * Download compare attributes chart image
     * @return {void}
     */
    downloadCompareAttributes: function downloadCompareAttributes() {
      var svgcharts = document.querySelectorAll('.linechart__svg');
      if (!(svgcharts.length > 0)) {
        alert('An error occured');
      }

      var title = this.$store.getters['rsc/firstSelected'].name;
      var svgchart = svgcharts[0].innerHTML;
      var years = this.$store.state.rangeYearSliderCurrent;
      var attributes = this.$store.state.attributes.selected;
      var labels = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(attributes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var attr = _step2.value;

          var id = this.$store.getters['attributes/labelInfo'](attr, 'id');
          var name = this.$store.getters['attributes/labelInfo'](attr, 'name');
          var color = this.$store.getters.getSelectionColor(attr);

          labels.push({
            id: id,
            name: name,
            color: color
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      this.postDownload({
        title: title,
        svg: svgchart,
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(labels),
        years: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(years)
      });
    },


    /**
    * Download compare src chart image
    * @return {void}
    */
    downloadCompareSRC: function downloadCompareSRC() {
      var svgcharts = document.querySelectorAll('.linechart__svg');
      if (!(svgcharts.length > 0)) {
        alert('An error occured');
      }

      var firstKey = this.$store.getters['attributes/firstSelected'];
      var title = this.$store.getters['attributes/labelInfo'](firstKey, 'name');
      var svgchart = svgcharts[0].innerHTML;
      var years = this.$store.state.rangeYearSliderCurrent;
      var rscs = this.$store.state.rsc.selected;
      var labels = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(rscs), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var rsc = _step3.value;

          labels.push({
            id: rsc.id,
            name: rsc.name,
            color: rsc.color
          });
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.postDownload({
        title: title,
        svg: svgchart,
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(labels),
        years: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(years)
      });
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfidenceIntervals_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245e211c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfidenceIntervals_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(375)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-245e211c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfidenceIntervals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245e211c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfidenceIntervals_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelpTooltip_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Checkbox_vue__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confidenceintervals',
  components: { HelpTooltip: __WEBPACK_IMPORTED_MODULE_0__HelpTooltip_vue__["a" /* default */], Checkbox: __WEBPACK_IMPORTED_MODULE_1__Checkbox_vue__["a" /* default */] },
  props: {
    showConfidenceIntervals: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleConfidenceInterval: function toggleConfidenceInterval() {
      this.$emit('toggleInterval', this.showConfidenceIntervals);
    }
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkbox',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    active: {
      type: Boolean,
      required: true
    },
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkboxClasses: function checkboxClasses() {
      var cls = {
        'checkbox--reverse': this.reverse
      };
      cls['checkbox--' + this.type] = true;
      return cls;
    }
  },
  methods: {
    toggle: function toggle() {
      this.$emit('toggle');
    }
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinechartSelectedLabels_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cce2982_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinechartSelectedLabels_vue__ = __webpack_require__(380);
function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cce2982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinechartSelectedLabels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cce2982_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinechartSelectedLabels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineChartSelectedLabels',
  props: ['data']
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_charts_LineChart_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_misc_InfoOverlay_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_misc_PreloaderOverlay_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_sliders_RangeYearSlider_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_misc_DownloadShare_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_misc_ConfidenceIntervals_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_charts_LinechartSelectedLabels_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tour_tourButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewModeTable__ = __webpack_require__(27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'compare-countries-regions',
  components: { TourButton: __WEBPACK_IMPORTED_MODULE_10__tour_tourButton__["a" /* default */], ViewModeTable: __WEBPACK_IMPORTED_MODULE_11__ViewModeTable__["a" /* default */], rangeYearSlider: __WEBPACK_IMPORTED_MODULE_6__shared_sliders_RangeYearSlider_vue__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_3__shared_charts_LineChart_vue__["a" /* default */], LinechartSelectedLabels: __WEBPACK_IMPORTED_MODULE_9__shared_charts_LinechartSelectedLabels_vue__["a" /* default */], InfoOverlay: __WEBPACK_IMPORTED_MODULE_4__shared_misc_InfoOverlay_vue__["a" /* default */], PreloaderOverlay: __WEBPACK_IMPORTED_MODULE_5__shared_misc_PreloaderOverlay_vue__["a" /* default */], DownloadShare: __WEBPACK_IMPORTED_MODULE_7__shared_misc_DownloadShare_vue__["a" /* default */], ConfidenceIntervals: __WEBPACK_IMPORTED_MODULE_8__shared_misc_ConfidenceIntervals_vue__["a" /* default */] },
  mounted: function mounted() {
    this.loadData();

    __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('sidebar-nav', 'CompareCountriesRegions');

    if (!this.selectedCountries || this.selectedCountries.length === 0) {
      this.$nextTick(this.openTour);
    }
  },
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken,
      cancel: function cancel() {},

      chartData: []
    };
  },

  watch: {
    selectedCountries: function selectedCountries() {
      this.updateUrl();
      this.loadData();
    },
    selectedAttributes: function selectedAttributes() {
      // All attributes are loaded anyway
      // so no need to refresh
    },
    dateRange: function dateRange() {
      this.updateUrl();
      this.loadData();
    }
  },
  methods: {
    openTour: function openTour(forceOpen) {
      __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('tour:open', 'compare-country-region', forceOpen, [{
        title: this.$Strings('tour_countryregion1_title'),
        content: this.$Strings('tour_countryregion1_description'),
        elementId: false
      }, {
        title: this.$Strings('tour_countryregion2_title'),
        content: this.$Strings('tour_countryregion2_description'),
        elementId: 'level-navigation'
      }, {
        title: this.$Strings('tour_countryregion3_title'),
        content: this.$Strings('tour_countryregion3_description'),
        elementId: 'attribute-nav'
      }, {
        title: this.$Strings('tour_countryregion4_title'),
        content: this.$Strings('tour_countryregion4_description'),
        elementId: 'range-year-slider'
      }]);
    },

    /**
     * Loads the navigation data
     * @return {null}
     */
    loadData: function loadData() {
      var _this = this;

      var year1 = this.dateRange[0];
      var year2 = this.dateRange[1];
      var countryIds = [];

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.selectedCountries, function (c) {
        countryIds.push(c.id);
      });

      var cIds = countryIds.join(',');

      if (!year1 || !year2 || cIds.length === 0) {
        return false;
      }

      this.cancel();

      this.$store.dispatch('startFetching', 'compareCountryRegions');

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'data/?year1=' + year1 + '&year2=' + year2 + '&crsId=' + cIds, {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(function (response) {
        _this.chartData = response.data;
        _this.$store.dispatch('stopFetching', 'compareCountryRegions');
      }).catch(function (error) {
        _this.$store.dispatch('stopFetching', 'compareCountryRegions');
        if (!__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        }
      });
    },
    updateUrl: function updateUrl() {
      // TOOD: make this
      // let query = {
      //   c: this.selectedCountries,
      //   a: this.selectedAttributes,
      //   d: this.dateRange,
      //   ci: this.confidence_intervals
      // }
      // this.$router.push({ query: query })
    },
    toggleInterval: function toggleInterval() {
      this.$store.state.confidenceIntervals = !this.$store.state.confidenceIntervals;
    }
  },
  computed: {
    selectedLabelsData: function selectedLabelsData() {
      var _this2 = this;

      var selected = this.$store.state.rsc.selected;
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(selected, function (result, key) {
        selected[key].color = _this2.$store.getters.getSelectionColor(result.id);
      });
      return selected;
    },
    tableData: function tableData() {
      if (this.selectedAttributes.length === 0 || this.selectedCountries.length === 0) {
        return [];
      }
      return this.chartData;
    },
    viewmode: function viewmode() {
      return this.$store.state.viewMode;
    },
    convertedChartData: function convertedChartData() {
      var _this3 = this;

      var dataset = {};
      var countries = {};
      var attribute = this.firstSelectedAttribute;

      // Don't give data if there isn't selected an attribute yet
      if (!attribute) return [];

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.selectedCountries, function (country) {
        countries[country.id] = country;
      });

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.chartData, function (row) {
        if (countries[row.ID_country_code] === undefined) {
          return;
        }

        if (dataset[row.ID_country_code] === undefined) {
          dataset[row.ID_country_code] = {
            name: countries[row.ID_country_code].name,
            color: _this3.$store.getters.getSelectionColor(row.ID_country_code),
            yearData: {}
          };
        }
        dataset[row.ID_country_code].yearData[row.ID_year] = {};
        dataset[row.ID_country_code].yearData[row.ID_year].point = row[attribute];
        dataset[row.ID_country_code].yearData[row.ID_year].high = row[attribute + '_U'];
        dataset[row.ID_country_code].yearData[row.ID_year].low = row[attribute + '_L'];
      });

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.values(dataset);
    },
    dateRange: function dateRange() {
      return this.$store.state.rangeYearSliderCurrent;
    },
    selectedCountries: function selectedCountries() {
      return this.$store.state.rsc.selected;
    },
    selectedAttributes: function selectedAttributes() {
      return this.$store.state.attributes.selected;
    },
    firstSelectedAttribute: function firstSelectedAttribute() {
      return this.$store.getters['attributes/firstSelected'];
    },
    firstSelectedAttributeName: function firstSelectedAttributeName() {
      var firstKey = this.$store.getters['attributes/firstSelected'];
      var name = this.$store.getters['attributes/labelInfo'](firstKey, 'name');
      return name;
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CountriesRegionsProfile_SingleCountry_vue__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__covid19_Covid19Profile_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CountriesRegionsProfile_MultipleCountries_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_misc_PreloaderOverlay_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_misc_InfoOverlay_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ViewModeTable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tour_tourButton__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'countries-regions-profile',
  components: {
    MultipleCountries: __WEBPACK_IMPORTED_MODULE_4__CountriesRegionsProfile_MultipleCountries_vue__["a" /* default */],
    SingleCountry: __WEBPACK_IMPORTED_MODULE_2__CountriesRegionsProfile_SingleCountry_vue__["a" /* default */],
    TourButton: __WEBPACK_IMPORTED_MODULE_8__tour_tourButton__["a" /* default */],
    ViewModeTable: __WEBPACK_IMPORTED_MODULE_7__ViewModeTable__["a" /* default */],
    PreloaderOverlay: __WEBPACK_IMPORTED_MODULE_5__shared_misc_PreloaderOverlay_vue__["a" /* default */],
    InfoOverlay: __WEBPACK_IMPORTED_MODULE_6__shared_misc_InfoOverlay_vue__["a" /* default */],
    Covid19Profile: __WEBPACK_IMPORTED_MODULE_3__covid19_Covid19Profile_vue__["a" /* default */]
  },
  created: function created() {
    if (this.$route.query.covid19 === '1') {
      this.$store.state.covid19.is_enabled = true;
    } else {
      this.$store.state.covid19.is_enabled = false;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_9__event_bus_js__["a" /* EventBus */].$emit('sidebar-nav', 'CountryRegionProfile');
    this.calculateSubattributeData();
    this.calculateSubcomponentData();
    this.fetchData();

    this.$nextTick(this.openTour);
    this.setCovid19FilterVisibility();
  },
  destroyed: function destroyed() {
    this.$store.state.covid19.filter_available = false;
  },
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken,
      cancel: function cancel() {},

      chartData: [],
      organizations: ['ASEAN', 'AU', 'EU', 'OAS', 'OECD'],
      subcomponentData: [],
      subattributeData: [],
      mainAttributeKeys: ['A_01', 'A_02', 'A_03', 'A_04'],
      subAttributeKeys: ['SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04', 'SA_02_01', 'SA_02_02', 'SA_02_03', 'SA_03_01', 'SA_03_02', 'SA_03_03', 'SA_04_01', 'SA_04_02', 'SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04'],
      subComponentKeys: ['SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c']
    };
  },

  computed: {
    /**
     * AttributeData
     */
    attributeData: function attributeData() {
      var _this = this;

      var result = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.countries, function (country) {
        var row = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this.chartData, ['ID_country_name', country.name]);
        var resultRow = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this.mainAttributeKeys, function (columnKey) {
          if (row) {
            resultRow.push(_this.getRowData(row, columnKey));
          } else {
            resultRow.push(_this.getEmptyRowData(country.name, columnKey));
          }
        });
        result.push(resultRow);
      });
      return result;
    },


    /**
     * Returns the world data
     */
    worldData: function worldData() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.chartData, ['ID_country_code', '999']);
    },


    /**
     * Gets the attributes for the table viewmode
     * @return {obj} Collection of results
     */
    tableData: function tableData() {
      return this.chartData;
    },


    /**
     * The download PDF profil URL
     * @return {string}
     */
    downloadProfileUrl: function downloadProfileUrl() {
      var country = this.firstCountry;
      if (country) {
        var type = this.organizations.indexOf(country.name) === -1 ? country.type : 'organization';
        var slug = country.name.toLowerCase().replace(new RegExp(' ', 'g'), '-').replace(/[^a-zA-Z0-9._-]+/g, '');
        return "/gsod-indices/sites/default/files/profile-pdfs/2021/" + type + '/' + slug + '.pdf';
      }
    },
    viewmode: function viewmode() {
      return this.$store.state.viewMode;
    },
    year: function year() {
      return this.$store.state.yearSliderCurrent;
    },
    countries: function countries() {
      return this.$store.state.rsc.selected;
    },
    mainAttributes: function mainAttributes() {
      var _this2 = this;

      var result = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.mainAttributeKeys, function (columnKey) {
        var attr = _this2.$store.getters['attributes/getLabelFromKey'](columnKey);
        if (attr) {
          result.push(attr);
        }
      });
      return result;
    },
    firstCountry: function firstCountry() {
      return this.$store.getters['rsc/firstSelected'];
    }
  },
  watch: {
    firstCountry: function firstCountry() {
      __WEBPACK_IMPORTED_MODULE_9__event_bus_js__["a" /* EventBus */].$emit('slider.refresh');
    },
    subcomponentData: function subcomponentData() {
      __WEBPACK_IMPORTED_MODULE_9__event_bus_js__["a" /* EventBus */].$emit('slider.refresh');
    },
    subattributeData: function subattributeData() {
      __WEBPACK_IMPORTED_MODULE_9__event_bus_js__["a" /* EventBus */].$emit('slider.refresh');
    },
    year: function year() {
      this.fetchData();
    },
    countries: function countries() {
      this.setCovid19FilterVisibility();
      this.fetchData();
    }
  },
  methods: {
    setCovid19FilterVisibility: function setCovid19FilterVisibility() {
      this.$store.state.covid19.filter_available = true;
    },
    currentCountryDataset: function currentCountryDataset() {
      if (this.chartData && this.firstCountry && this.firstCountry.id) {
        var id = '' + this.firstCountry.id + '';
        var result = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.chartData, ['ID_country_code', id]);
        return result || {};
      }
      return {};
    },
    openTour: function openTour(forceOpen) {
      var tourpages = [];
      tourpages.push({
        title: this.$Strings('tour_profile1_title'),
        content: this.$Strings('tour_profile1_description'),
        elementId: false
      });

      tourpages.push({
        title: this.$Strings('tour_profile2_title'),
        content: this.$Strings('tour_profile2_description'),
        elementId: 'countries-nav'
      });

      // Remove tour information page on covid19 pages
      if (!this.$store.state.covid19.is_enabled) {
        tourpages.push({
          title: this.$Strings('tour_profile3_title'),
          content: this.$Strings('tour_profile3_description'),
          elementId: 'range-year-slider',
          style: {
            marginTop: '180px'
          }
        });

        tourpages.push({
          title: this.$Strings('tour_profile4_title'),
          content: this.$Strings('tour_profile4_description'),
          elementId: 'global-performance-btn'
        });
        tourpages.push({
          title: this.$Strings('tour_profile5_title'),
          content: this.$Strings('tour_profile5_description'),
          elementId: 'key-attributes-btn'
        });
        tourpages.push({
          title: this.$Strings('tour_profile6_title'),
          content: this.$Strings('tour_profile6_description'),
          elementId: 'download-btn'
        });
      }

      __WEBPACK_IMPORTED_MODULE_9__event_bus_js__["a" /* EventBus */].$emit('tour:open', 'compare-region-profile', forceOpen, tourpages);
    },

    /**
     * Execute print
     * @return {string}
     */
    downloadDisplayedDataUrl: function downloadDisplayedDataUrl() {
      window.print();
    },
    calculateSubcomponentData: function calculateSubcomponentData() {
      var _this3 = this;

      var result = [];
      var countries = this.countries;

      // Set dummy content
      // for no countries
      if (countries.length === 0) {
        countries = [{
          name: 'No country'
        }];
      }

      // There might be situations where
      // Countries has been selected - but no data
      // is retrieved from the selected year
      // ex German Democratic Republic in 2000
      // So we check how many rows are expected
      // and return a result indicating that
      // there is no data to be found
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(countries, function (country) {
        var row = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this3.chartData, ['ID_country_name', country.name]);
        var resultRow = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this3.subComponentKeys, function (columnKey) {
          if (row) {
            resultRow.push(_this3.getRowData(row, columnKey));
          } else {
            resultRow.push(_this3.getEmptyRowData(country.name, columnKey));
          }
        });
        result.push(resultRow);
      });

      this.subcomponentData = result;
    },
    calculateSubattributeData: function calculateSubattributeData() {
      var _this4 = this;

      var result = [];
      var countries = this.countries;

      // Set dummy content
      // for no countries
      if (countries.length === 0) {
        countries = [{
          name: 'No country'
        }];
      }

      // There might be situations where
      // Countries has been selected - but no data
      // is retrieved from the selected year
      // ex German Democratic Republic in 2000
      // So we check how many rows are expected
      // and return a result indicating that
      // there is no data to be found
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(countries, function (country) {
        var row = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(_this4.chartData, ['ID_country_name', country.name]);
        var resultRow = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this4.subAttributeKeys, function (columnKey) {
          if (row) {
            resultRow.push(_this4.getRowData(row, columnKey));
          } else {
            resultRow.push(_this4.getEmptyRowData(country.name, columnKey));
          }
        });
        result.push(resultRow);
      });

      this.subattributeData = result;
    },
    gotoGlobalPerformance: function gotoGlobalPerformance() {
      var selected = this.firstCountry;
      var region = this.$store.getters['rsc/getCountryRegion'](selected.id);
      var subregion = this.$store.getters['rsc/getCountrySubregion'](selected.id);
      var world = this.$store.getters['rsc/getGlobal'];

      this.$store.commit('rsc/resetAllSelected');

      this.$store.state.rsc.selected.push(selected);

      if (this.$store.state.rsc.regionsWithoutSubregions.indexOf(region.id) === -1 && subregion) {
        this.$store.state.rsc.selected.push(subregion);
      }

      if (this.$store.state.rsc.notSelectableRegions.indexOf(region.id) === -1 && region) {
        this.$store.state.rsc.selected.push(region);
      }

      if (selected.name !== 'World' && world) {
        this.$store.state.rsc.selected.push(world);
      }
    },
    gotoKeyAttributesOverTime: function gotoKeyAttributesOverTime() {
      var selected = this.firstCountry;
      var region = this.$store.getters['rsc/getCountryRegion'](selected.id);
      var subregion = this.$store.getters['rsc/getCountrySubregion'](selected.id);
      var world = this.$store.getters['rsc/getGlobal'];

      var countryselection = '[' + selected.id;

      if (this.$store.state.rsc.regionsWithoutSubregions.indexOf(region.id) === -1 && subregion) {
        countryselection += ',' + subregion.id;
      }

      if (this.$store.state.rsc.notSelectableRegions.indexOf(region.id) === -1 && region) {
        countryselection += ',' + region.id;
      }

      if (selected.name !== 'World' && world) {
        countryselection += ',' + world.id;
      }

      countryselection += ']';

      if (selected) {
        this.$router.push({ name: 'compare-countries-regions', query: { rsc: [countryselection], attr: ['["A_01"]'] } });
      }
    },
    getEmptyRowData: function getEmptyRowData(countryname, columnKey) {
      var rowData = { range: [] };
      rowData.columnKey = false;
      rowData.range[0] = false;
      rowData.range[1] = false;
      rowData.value = false;
      rowData.country = countryname;
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name');
      rowData.color = 'gray-lighter';
      rowData.description = false;
      return rowData;
    },
    getRowData: function getRowData(row, columnKey) {
      var rowData = { range: [] };
      rowData.columnKey = columnKey;
      rowData.range[0] = row[columnKey + '_L'] ? row[columnKey + '_L'] : false;
      rowData.range[1] = row[columnKey + '_U'] ? row[columnKey + '_U'] : false;
      rowData.value = row[columnKey] || false;
      rowData.country = row['ID_country_name'];
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name');
      rowData.color = this.$store.getters['attributes/labelInfo'](columnKey, 'color');
      rowData.description = this.$store.getters['attributes/labelInfo'](columnKey, 'description');
      return rowData;
    },
    getAttributeValue: function getAttributeValue(columnKey, value) {
      var row = this.currentCountryDataset();
      var data = !row ? this.getEmptyRowData('', columnKey) : this.getRowData(row, columnKey);
      return data[value] ? data[value] : undefined;
    },


    /**
     * Load the profile data
     */
    loadProfileData: function loadProfileData() {
      var countryIdArray = [999];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.countries, function (country) {
        countryIdArray.push(country.id);
      });

      var countryIds = countryIdArray.join(', ');

      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/gsod-indices/api/" + 'data/?year1=' + this.year + '&year2=' + this.year + '&crsId=' + countryIds);
    },


    /**
     * Grab the data needed for this page
     */
    fetchData: function fetchData() {
      var _this5 = this;

      if (this.countries.length === 0 || !this.year) {
        this.chartData = [];
        this.calculateSubattributeData();
        this.calculateSubcomponentData();
        return false;
      }

      this.cancel();

      this.$store.dispatch('startFetching', 'countryRegionsProfile');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.all([this.loadProfileData()], {
        cancelToken: new this.CancelToken(function (c) {
          _this5.cancel = c;
        })
      }).then(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.spread(function (chartData) {
        _this5.$store.dispatch('stopFetching', 'countryRegionsProfile');
        _this5.chartData = chartData.data;
        _this5.calculateSubattributeData();
        _this5.calculateSubcomponentData();
      })).catch(function (error) {
        _this5.$store.dispatch('stopFetching', 'countryRegionsProfile');
        if (!__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_9__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this5.$Strings('json_error_title'), _this5.$Strings('json_error_body'));
          console.log(error);
        }
      });
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_charts_BarLine_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_misc_Checkbox_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_charts_CircleChart_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_charts_FrameworkWheel_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_misc_HelpTooltip_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_misc_HighMediumLowExplainer_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_sliders_RangeYearSlider_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_icons_PrintIcon_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_icons_ShareIcon_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_icons_DownloadIcon_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
// import axios from 'axios'














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'single-country',
  components: {
    BarLine: __WEBPACK_IMPORTED_MODULE_0__shared_charts_BarLine_vue__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_1__shared_misc_Checkbox_vue__["a" /* default */],
    CircleChart: __WEBPACK_IMPORTED_MODULE_2__shared_charts_CircleChart_vue__["a" /* default */],
    FrameworkWheel: __WEBPACK_IMPORTED_MODULE_3__shared_charts_FrameworkWheel_vue__["a" /* default */],
    HelpTooltip: __WEBPACK_IMPORTED_MODULE_4__shared_misc_HelpTooltip_vue__["a" /* default */],
    RangeYearSlider: __WEBPACK_IMPORTED_MODULE_6__shared_sliders_RangeYearSlider_vue__["a" /* default */],
    PrintIcon: __WEBPACK_IMPORTED_MODULE_8__shared_icons_PrintIcon_vue__["a" /* default */],
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_10__shared_icons_DownloadIcon_vue__["a" /* default */],
    ShareIcon: __WEBPACK_IMPORTED_MODULE_9__shared_icons_ShareIcon_vue__["a" /* default */],
    HighMediumLowExplainer: __WEBPACK_IMPORTED_MODULE_5__shared_misc_HighMediumLowExplainer_vue__["a" /* default */]
  },
  props: ['currentCountryDataset', 'firstCountry', 'subattributeData', 'subcomponentData', 'worldData'],
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_7_axios___default.a.CancelToken,
      countryData: false,
      sourcelinkNum: 0
    };
  },

  computed: {
    profileUrl: function profileUrl() {
      if (this.firstCountry && this.firstCountry.name) {
        return "https://www.idea.int/gsod-indices/" + 'profile/' + (this.$store.state.covid19.is_enabled ? 'covid19/' : '') + this.firstCountry.name.toLowerCase().replace(/[^a-zA-Z0-9._-]+/g, '-');
      }
      return '';
    },
    maplink: function maplink() {
      return "https://www.idea.int/gsod-indices/" + '#/indices/world-map?covid19=1';
    },
    VDemLogo: function VDemLogo() {
      return "https://www.idea.int/gsod-indices/" + 'themes/custom/gsodi/img/vdem-logo.png';
    },
    downloadUrl: function downloadUrl() {
      return "https://www.idea.int/gsod-indices/" + 'gsodi-pdf/download';
    },
    downloadAttr: function downloadAttr() {
      return 'rsc=[' + this.firstCountry.id + ']&covid19=1';
    }
  },
  watch: {
    'firstCountry': function firstCountry() {
      this.countryData = false;
      this.fetchCountryInfo();
    },
    'countryData': function countryData() {
      this.$store.state.covid19.last_updated = this.countryData['last_updated'];
    }
  },
  mounted: function mounted() {
    this.fetchCountryInfo();
  },
  destroyed: function destroyed() {
    this.$store.state.covid19.last_updated = false;
  },

  methods: {
    getEmptyRowData: function getEmptyRowData(countryname, columnKey) {
      var rowData = { range: [] };
      rowData.columnKey = false;
      rowData.range[0] = false;
      rowData.range[1] = false;
      rowData.value = false;
      rowData.country = countryname;
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name');
      rowData.color = 'gray-lighter';
      rowData.description = false;
      return rowData;
    },
    fetchCountryInfo: function fetchCountryInfo() {
      var _this = this;

      if (!this.firstCountry || !this.firstCountry.id) {
        return false;
      }

      this.$store.dispatch('startFetching', 'covid19profile');
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get("https://covid19api.idea.int/api/" + 'covid19/country/' + this.firstCountry.id + '?t=' + this.apiRefreshToken(), {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(function (response) {
        _this.$store.dispatch('stopFetching', 'covid19profile');
        if (response.data.country_code) {
          _this.countryData = response.data;
        }
      }).catch(function (error) {
        _this.$store.dispatch('stopFetching', 'covid19profile');
        if (!__WEBPACK_IMPORTED_MODULE_7_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_11__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        }
      });
    },
    printImage: function printImage() {
      window.print();
    },
    getRowData: function getRowData(row, columnKey) {
      var rowData = { range: [] };
      rowData.columnKey = columnKey;
      rowData.range[0] = row[columnKey + '_L'] ? row[columnKey + '_L'] : false;
      rowData.range[1] = row[columnKey + '_U'] ? row[columnKey + '_U'] : false;
      rowData.value = row[columnKey] || false;
      rowData.country = row['ID_country_name'];
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name');
      rowData.color = this.$store.getters['attributes/labelInfo'](columnKey, 'color');
      rowData.description = this.$store.getters['attributes/labelInfo'](columnKey, 'description');
      return rowData;
    },
    getAttributeValue: function getAttributeValue(columnKey, value) {
      var row = this.currentCountryDataset();
      var data = !row ? this.getEmptyRowData('', columnKey) : this.getRowData(row, columnKey);
      return data[value] ? data[value] : undefined;
    },
    getWorldDataValue: function getWorldDataValue(columnKey) {
      var worldrow = this.worldData;
      if (!columnKey || !worldrow) return undefined;
      var result = this.getRowData(worldrow, columnKey);
      return result && result.value ? parseFloat(result.value) : undefined;
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc_HelpTooltip_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'barchart',
  components: { HelpTooltip: __WEBPACK_IMPORTED_MODULE_1__misc_HelpTooltip_vue__["a" /* default */] },
  props: {
    color: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    annotationValue: {
      type: Number
    },
    label: {
      type: String
    },
    tooltip: {
      default: false
    },
    confInt: {},
    showValues: {
      type: Boolean,
      default: false
    },
    showRange: {
      type: Boolean,
      default: false
    },
    showInLineValue: {
      type: Boolean,
      default: false
    },
    strokeWidth: {
      default: 14
    },
    canvasSize: {
      default: function _default() {
        return [20, 225];
      }
    }
  },
  data: function data() {
    return {
      animationSpeed: 150,
      canvas: false
    };
  },

  watch: {
    confInt: function confInt() {
      this.reset();
      this.draw();
    },
    value: function value() {
      this.reset();
      this.draw();
    },
    annotationValue: function annotationValue() {
      this.reset();
      this.draw();
    },
    confidenceIntervals: function confidenceIntervals() {
      this.reset();
      this.draw();
    },
    showRange: function showRange() {
      this.reset();
      this.draw();
    }
  },
  mounted: function mounted() {
    this.drawCanvas();
    this.draw();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
  },

  methods: {
    valueExists: function valueExists() {
      return this.value || this.value === 0 || this.value === 0.00;
    },
    reset: function reset() {
      this.removeMouseHover(this.canvas);
      if (this.canvas) {
        this.canvas.remove();
      }
      this.drawCanvas();
    },
    drawCanvas: function drawCanvas() {
      var visibleWidth = 0;
      if (this.showValues && !this.showInLineValue) {
        visibleWidth = 20;
      } else if (!this.showValues && this.showInLineValue) {
        visibleWidth = 40;
      } else {
        visibleWidth = 10;
      }
      this.canvas = __WEBPACK_IMPORTED_MODULE_0_svg_js___default()('barline_svg--' + this._uid);
      this.canvas.viewbox(0, 0, this.canvasSize[0], this.canvasSize[1]);
      this.canvas.style({ width: visibleWidth + 'px', margin: '0 auto', display: 'block' });
      this.addMouseHover(this.canvas);
    },
    draw: function draw() {
      var cw = this.canvasSize[0];
      var ch = this.canvasSize[1];

      var x = cw / 2;
      var y = ch - ch * this.value;
      var startX = (cw - this.strokeWidth) / 2;

      this.drawLine(x, 0, x, ch, 'svg-stroke--gray-lighter', this.strokeWidth, false);

      if (this.valueExists()) {
        // let lwidth = this.annotationValue ? this.strokeWidth * 0.75 : this.strokeWidth
        var lwidth = this.strokeWidth;
        var lx = startX + lwidth / 2;
        this.drawLine(lx, ch, lx, y, 'svg-stroke--' + this.color, lwidth);
      }

      if (this.showRange) {
        this.drawCI();
      }

      if (this.annotationValue) {
        var ay = ch - ch * this.annotationValue;
        var awidth = 2;
        this.drawLine(0, ay, cw, ay, 'svg-stroke--annotation', awidth);

        /*
        let ay = ch - (ch * this.annotationValue)
        let awidth = (this.strokeWidth * 0.3)
        let ax = cw - startX - (awidth / 2)
        this.drawLine(ax, ay, ax, ch, 'svg-stroke--annotation', awidth)
        */
      }
    },
    drawCI: function drawCI() {
      var cw = this.canvasSize[0];
      var ch = this.canvasSize[1];
      var x = cw / 2;

      var confY1 = ch - ch * this.confInt[0];
      var confY2 = ch - ch * this.confInt[1];

      this.drawLine(x, confY1, x, confY2, 'svg-stroke--' + this.color + ' svg-stroke--faded', cw);
    },
    addMouseHover: function addMouseHover(elem) {
      var mouseOverObj = {};

      if (this.value || this.value === 0 || this.value === 0.00) {
        mouseOverObj = {
          style: 'map',
          label: this.label,
          value: this.getFixedValue(this.value)
        };
      } else {
        mouseOverObj = {
          style: 'single',
          label: this.$Strings('barLineNoValue').replace('%label', this.label)
        };
      }

      // Mouse over actions
      elem.mouseover(function () {
        __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('tooltip.show', mouseOverObj);
      });
      elem.mouseout(function () {
        __WEBPACK_IMPORTED_MODULE_2__event_bus_js__["a" /* EventBus */].$emit('tooltip.hide');
      });
    },
    removeMouseHover: function removeMouseHover(elem) {
      elem.off();
    },


    /**
     * Draw a line in the chart
     * @param  {integer} xPos      The start x position
     * @param  {integer} yPos      The start y position
     * @param  {integer} xPos2     The end x position
     * @param  {integer} yPos2     The end y position
     * @param  {String} className  The classname
     * @param  {boolean/integer} animate  The speed of animation if any
     * @return {Object} The line object
     */
    drawLine: function drawLine(xPos, yPos, xPos2, yPos2, className) {
      var strokeWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : this.strokeWidth;
      var animationSpeed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this.animationSpeed;

      var lineLength = yPos - yPos2;

      var line = this.canvas.line(xPos, yPos, xPos2, yPos2).stroke({ width: strokeWidth, dasharray: '0,' + lineLength });

      line.addClass(className);

      if (animationSpeed !== false) {
        line.animate(animationSpeed, '>').stroke({ dasharray: lineLength + ',' + lineLength });
      } else {
        line.stroke({ dasharray: lineLength * -1 + ',' + lineLength * -1 });
      }
      return line;
    }
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChart_vue__ = __webpack_require__(139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cf57ce2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChart_vue__ = __webpack_require__(392);
function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9cf57ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cf57ce2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//

// import Vue from 'vue'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circlechart',
  props: {
    value: {
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      hasBeenAnimated: false,
      animationSpeed: 750,
      canvas: false,
      canvasSize: [100, 100],
      widthHeight: [40, 40],
      lineWidth: 15,
      groups: []
    };
  },

  watch: {
    value: function value() {
      this.reset();
      this.drawChart();
    }
  },
  mounted: function mounted() {
    this.drawCanvas();
    this.drawChart();
  },

  methods: {
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.groups, function (group) {
        group.remove();
      });
      this.hasBeenAnimated = false;
    },
    valueExists: function valueExists() {
      return this.value !== undefined && !isNaN(this.value);
    },
    drawChart: function drawChart() {
      var group = this.canvas.group();

      group.add(this.drawCircle(1, 'svg-stroke--gray-lightest'));

      if (this.valueExists()) {
        group.add(this.drawCircle(parseFloat(this.value), 'svg-stroke--' + this.color, this.animationSpeed));
      }

      this.groups.push(group);
    },


    /**
     * Initialize the SVG convas
     */
    drawCanvas: function drawCanvas() {
      this.canvas = __WEBPACK_IMPORTED_MODULE_0_svg_js___default()('circlechart--' + this._uid).size(this.widthHeight[0] + 'px', this.widthHeight[1] + 'px');
      this.canvas.viewbox(0, 0, this.canvasSize[0], this.canvasSize[1]);
      this.canvas.style({ width: this.widthHeight[0] + 'px', height: this.widthHeight[1] + 'px' });
    },


    /**
     * Draws a circle
     * @param  {Float}  value           The value
     * @param  {String}  className      ClassName
     * @param  {Boolean/Integer} speed  The animation speed - or false if no animatino
     * @return {Object}                 The svgjs circle object
     */
    drawCircle: function drawCircle(value, className) {
      var _this = this;

      var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var d = this.canvasSize[0] - this.lineWidth;
      var r = d / 2;
      var circleLength = 2 * Math.PI * r;

      var circle = this.canvas.circle(d).fill('none').stroke({ width: this.lineWidth, dasharray: '0,' + circleLength }).rotate(-90, this.canvasSize[0] / 2, this.canvasSize[0] / 2).move(this.lineWidth / 2, this.lineWidth / 2).addClass(className);

      var animateTo = circleLength * value;

      if (this.hasBeenAnimated === false && speed !== false) {
        // Animate - but only the first time
        circle.animate(speed, '>').stroke({ dasharray: animateTo + ',' + circleLength }).afterAll(function () {
          _this.hasBeenAnimated = true;
        });
      } else {
        circle.stroke({ dasharray: animateTo + ',' + circleLength });
      }

      return circle;
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrameworkWheel_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1126c2bd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrameworkWheel_vue__ = __webpack_require__(401);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1126c2bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrameworkWheel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1126c2bd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrameworkWheel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_filter_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_filter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_filter_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CircleCalculations_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StrSplitter_js__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__covid19_FrameworkWheelMixins_js__ = __webpack_require__(119);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'frameworkwheel',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__covid19_FrameworkWheelMixins_js__["a" /* Covid19icons */], __WEBPACK_IMPORTED_MODULE_6__covid19_FrameworkWheelMixins_js__["b" /* FrameworkWheelMixins */]],
  props: {
    dataset: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      CircleCalculations: false,
      hasBeenAnimated: false,
      groups: [],
      canvas: false,
      canvasSize: [500, 500],
      widthHeight: [500, 500],
      attributeLabels: {
        A_01: ['SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04'],
        A_02: ['SA_02_01', 'SA_02_02', 'SA_02_03'],
        A_03: ['SA_03_01', 'SA_03_02', 'SA_03_03'],
        A_04: ['SA_04_01', 'SA_04_02'],
        A_05: ['SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04']
      }
    };
  },

  watch: {
    dataset: function dataset() {
      this.reset();
      this.drawChart();
      this.setCovid19AttributeIcons();
    },
    canvasSize: function canvasSize() {
      this.CircleCalculations.setCircleDimensions(this.canvasSize[0], this.canvasSize[1]);
    }
  },
  mounted: function mounted() {
    this.CircleCalculations = new __WEBPACK_IMPORTED_MODULE_4__CircleCalculations_js__["a" /* default */]();
    this.CircleCalculations.setCircleDimensions(this.canvasSize[0], this.canvasSize[1]);

    this.drawCanvas();
    this.drawChart();
    this.setCovid19AttributeIcons();
  },

  computed: {
    firstCountry: function firstCountry() {
      return this.$store.getters['rsc/firstSelected'];
    }
  },
  methods: {
    hasDataset: function hasDataset() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.dataset).length > 0;
    },

    /**
     * Reset the SVG
     *
     * @return  {void}
     */
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.groups, function (group) {
        group.remove();
      });
      this.hasBeenAnimated = false;
    },
    rotateCircle: function rotateCircle(circleObj, rotation) {
      var newRotation = -90 + rotation;
      circleObj.rotate(newRotation, this.canvasSize[0] / 2, this.canvasSize[0] / 2);
    },


    /**
     * Draws a circle
     * @param  {Float}  value           The value
     * @param  {String}  className      ClassName
     * @param  {Boolean/Integer} speed  The animation speed - or false if no animatino
     * @return {Object}                 The svgjs circle object
     */
    drawCircle: function drawCircle(value, className) {
      var _this = this;

      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var speed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var c = void 0;

      if (position === 1) {
        c = this.CircleCalculations.getAttributeCircleInformation();
      } else {
        c = this.CircleCalculations.getSubAttributeCircleInformation();
      }

      var circle = this.canvas.circle(c.d).fill('none').stroke({ width: c.linewidth, dasharray: '0,' + c.l }).rotate(-90, this.canvasSize[0] / 2, this.canvasSize[0] / 2).move(c.x, c.y).addClass(className);

      var animateTo = c.l * value;

      if (this.hasBeenAnimated === false && speed !== false) {
        // Animate - but only the first time
        circle.animate(speed, '>').stroke({ dasharray: animateTo + ',' + c.l }).afterAll(function () {
          _this.hasBeenAnimated = true;
        });
      } else {
        circle.stroke({ dasharray: animateTo + ',' + c.l });
      }

      return circle;
    },
    addCenterCircle: function addCenterCircle() {
      var c = this.CircleCalculations.getCenterCircleXY();
      var year = this.dataset['ID_year'] ? this.dataset['ID_year'] : 'N/A';
      var dem = this.$store.getters['rsc/getRegimeById'](this.dataset['dem']);
      // let demperf = this.$store.getters['rsc/getRegimePerformanceById'](this.dataset['demperf'])
      var textgroup = this.canvas.group();

      if (this.firstCountry && this.firstCountry.name) {
        textgroup = this.addGroupTextLine(this.firstCountry.name, textgroup);
        textgroup = this.addGroupTextLine(year, textgroup, 'default', 15, 8);
      }

      if (dem && dem.name) {
        // if (parseInt(this.dataset['dem']) === 3 && demperf && demperf.name) {
        //   textgroup = this.addGroupTextLine(demperf.name, textgroup, 'default', 13, 5)
        // }
        textgroup = this.addGroupTextLine(dem.name, textgroup, 'default', 15, 5);
      }

      var circle = this.canvas.circle(c.d).stroke({ width: 0 }).move(c.x, c.y).addClass('svg-fill--white').attr('style', 'filter:url(#dropshadow)');

      var dimensions = textgroup.bbox();
      if (dimensions && dimensions.h && dimensions.w) {
        textgroup.move(this.canvasSize[0] / 2, this.canvasSize[0] / 2 - dimensions.h / 2);
      }

      this.groups.push(textgroup);

      return circle;
    },
    addGroupTextLine: function addGroupTextLine(text, group) {
      var textWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
      var fontsize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 18;
      var push = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

      var fontstack = 'Yrsa';

      var textBits = Object(__WEBPACK_IMPORTED_MODULE_5__StrSplitter_js__["a" /* default */])(text, textWidth);
      var textObj = this.canvas.text(function (add) {
        textBits.forEach(function (val) {
          add.tspan(val).newLine();
        });
      });

      textObj.font({
        fill: '#151c2b',
        anchor: 'middle',
        size: fontsize,
        family: fontstack,
        weight: 500
      });

      var dimensions = group.bbox();
      if (dimensions && dimensions.h && dimensions.w) {
        textObj.move(0, dimensions.h + push);
      }

      group.add(textObj);

      return group;
    },
    addText: function addText(x, y, text) {
      var textWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
      var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var fontsize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 18;

      var fontstack = 'Yrsa';

      var textBits = Object(__WEBPACK_IMPORTED_MODULE_5__StrSplitter_js__["a" /* default */])(text, textWidth);
      var textObj = this.canvas.text(function (add) {
        textBits.forEach(function (val) {
          add.tspan(val).newLine();
        });
      });

      textObj.font({
        fill: '#151c2b',
        anchor: 'middle',
        size: fontsize,
        family: fontstack,
        weight: 500
      });

      var dimensions = textObj.bbox();
      if (dimensions && dimensions.h) {
        y -= dimensions.h / 2;
        y += fontsize / 2;
      }

      textObj.move(x, y - fontsize / 2).rotate(rotation);

      return textObj;
    },
    addSliceText: function addSliceText(text, degree) {
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var c = this.CircleCalculations.getLabelInfo(degree, position);

      // Don't write text if there isn't a dataset
      text = this.hasDataset() ? text : '';

      return this.addText(c.x, c.y, text, 'default', c.rotation, 11);
    },
    addCircleLine: function addCircleLine(degree) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var c = this.CircleCalculations.getCircleLineInfo(degree, position);

      return this.canvas.line(c.x, c.y, c.lx, c.ly).stroke({ width: 2 }).addClass('svg-stroke--white');
    },
    getValueColorInfo: function getValueColorInfo(val) {
      if (val === undefined || val === false || val === '') {
        return {
          color: 'gray-lightest',
          category: false
        };
      }

      if (val >= 0.4 && val <= 0.7) {
        return {
          color: 'valueyellow',
          category: 'medium'
        };
      }

      if (val > 0.7) {
        return {
          color: 'valuegreen',
          category: 'high'
        };
      }

      return {
        color: 'valuered',
        category: 'low'
      };
    },
    getColorFromPE: function getColorFromPE() {
      var _this2 = this;

      if (!this.hasDataset()) return 'gray-lightest';
      var values = [];

      this.attributeLabels['A_05'].forEach(function (attr) {
        if (_this2.dataset[attr]) {
          values.push(_this2.dataset[attr]);
        } else {
          console.log('Dataset does not contain a value for ' + attr);
        }
      });

      var minimumValues = values.filter(function (val) {
        return val < 0.4;
      }).length;

      var highValues = values.filter(function (val) {
        return val > 0.7;
      }).length;

      if (minimumValues === 2 && highValues === 2) {
        return 'valuegreen';
      }

      if (minimumValues > 1) {
        return 'valuered';
      }

      if (highValues > 1) {
        return 'valuegreen';
      }

      return 'valueyellow';
    },
    getColorFromValue: function getColorFromValue(val) {
      return this.getValueColorInfo(val).color;
    },


    /**
     * Draws the chart object
     *
     * @return  {void}
     */
    drawChart: function drawChart() {
      var _this3 = this;

      var group = this.canvas.group();

      // Background circles
      group.add(this.drawCircle(1, 'svg-stroke--gray-lightest', 2));
      group.add(this.drawCircle(1, 'svg-stroke--gray-lightest', 1));

      var attributes1Size = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.attributeLabels).length;
      var current1position = 0;
      var current2position = 0;
      __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.attributeLabels, function (attr, key) {
        var size1Percentage = 1 / attributes1Size;
        var color1 = key === 'A_05' ? _this3.getColorFromPE() : _this3.getColorFromValue(_this3.dataset[key]);
        var circle = _this3.drawCircle(size1Percentage, 'svg-stroke--' + color1, 2, 500);
        var attribute2Size = attr.length;
        var label = _this3.$store.getters['attributes/getLabelFromKey'](key);

        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(attr, function (subattr) {
          var size2Percentage = size1Percentage / attribute2Size;
          var circle = _this3.drawCircle(size2Percentage, 'svg-stroke--' + _this3.getColorFromValue(_this3.dataset[subattr]), 1, 500);
          var label2 = _this3.$store.getters['attributes/getLabelFromKey'](subattr);
          _this3.rotateCircle(circle, current2position);
          group.add(_this3.addCircleLine(current2position - 90, 2));
          group.add(_this3.addCircleLine(current2position - 90, 2));
          group.add(circle);

          if (label2) {
            var nextdegree = current2position + 360 * size2Percentage;
            var labeldegree = (nextdegree + current2position) / 2;
            var text2 = _this3.addSliceText(label2.name, labeldegree - 90, 2);
            group.add(text2);
          }

          current2position += 360 * size2Percentage;
        });

        _this3.rotateCircle(circle, current1position);
        group.add(_this3.addCircleLine(current1position - 90, 1));
        group.add(circle);

        if (label) {
          var next1degree = current1position + 360 * size1Percentage;
          var label1degree = (next1degree + current1position) / 2;
          var text1 = _this3.addSliceText(label.name, label1degree - 90, 1);
          group.add(text1);
        }

        current1position += 360 * size1Percentage;
      });

      group.add(this.addCircleLine(-90, 2));

      group.add(this.addCenterCircle());

      this.groups.push(group);
    },


    /**
     * Initializes the canvas
     *
     * @return  {void}
     */
    drawCanvas: function drawCanvas() {
      this.canvas = __WEBPACK_IMPORTED_MODULE_1_svg_js___default()('frameworkwheel-svg--' + this._uid).size(this.widthHeight[0] + 'px', this.widthHeight[1] + 'px');
      this.canvas.viewbox(0, 0, this.canvasSize[0], this.canvasSize[1]);
      this.canvas.style({ width: this.widthHeight[0] + 'px', height: this.widthHeight[1] + 'px' });
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintIcon_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_092a879b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintIcon_vue__ = __webpack_require__(402);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_092a879b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'PrintIcon',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareIcon_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f13174_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareIcon_vue__ = __webpack_require__(405);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21f13174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f13174_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_click_outside__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'ShareIcon',
  'directives': { ClickOutside: __WEBPACK_IMPORTED_MODULE_0_vue_click_outside___default.a },
  'props': {
    size: {
      type: Number,
      default: 40
    },
    country: {
      type: String
    }
  },
  data: function data() {
    return {
      isVisibleDelay: false,
      tooltipVisible: false,
      copied: false
    };
  },

  computed: {
    profileUrl: function profileUrl() {
      return "https://www.idea.int/gsod-indices/" + 'profile/' + (this.$store.state.covid19.is_enabled ? 'covid19/' : '') + this.country.toLowerCase().replace(/[^a-zA-Z0-9._-]+/g, '-');
    }
  },
  methods: {
    copyToClipboard: function copyToClipboard() {
      var _this = this;

      var el = document.createElement('textarea');
      el.value = this.profileUrl;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.copied = true;
      setTimeout(function () {
        _this.copied = false;
      }, 500);
    },
    show: function show() {
      var _this2 = this;

      if (this.tooltipVisible === false && this.isVisibleDelay === false) {
        this.tooltipVisible = true;
        setTimeout(function () {
          _this2.isVisibleDelay = true;
        }, 500);
      } else {
        this.hide();
      }
    },
    hide: function hide() {
      if (this.isVisibleDelay === true) {
        this.tooltipVisible = false;
        this.isVisibleDelay = false;
      }
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadIcon_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76cb78f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadIcon_vue__ = __webpack_require__(406);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76cb78f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'DownloadIcon',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_charts_BarLine_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_misc_Checkbox_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_charts_CircleChart_vue__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_charts_FrameworkWheel_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_misc_HelpTooltip_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_misc_HighMediumLowExplainer_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfiletableRow_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProfiletableHeader_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProfiletableAttributeHeader_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SourceLinksSection_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_icons_DevelopmentsToWatch_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_icons_ConcerningDevelopments_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_icons_AttributeIcon_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_icons_PrintIcon_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shared_icons_ShareIcon_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_icons_DownloadIcon_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__event_bus_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__MiniSourceLink_vue__ = __webpack_require__(180);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'covid19-profile',
  components: {
    AttributeIcon: __WEBPACK_IMPORTED_MODULE_14__shared_icons_AttributeIcon_vue__["a" /* default */],
    ConcerningDevelopments: __WEBPACK_IMPORTED_MODULE_13__shared_icons_ConcerningDevelopments_vue__["a" /* default */],
    DevelopmentsToWatch: __WEBPACK_IMPORTED_MODULE_12__shared_icons_DevelopmentsToWatch_vue__["a" /* default */],
    SourceLinksSection: __WEBPACK_IMPORTED_MODULE_11__SourceLinksSection_vue__["a" /* default */],
    ProfiletableAttributeHeader: __WEBPACK_IMPORTED_MODULE_10__ProfiletableAttributeHeader_vue__["a" /* default */],
    ProfiletableHeader: __WEBPACK_IMPORTED_MODULE_9__ProfiletableHeader_vue__["a" /* default */],
    ProfiletableRow: __WEBPACK_IMPORTED_MODULE_8__ProfiletableRow_vue__["a" /* default */],
    BarLine: __WEBPACK_IMPORTED_MODULE_2__shared_charts_BarLine_vue__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_3__shared_misc_Checkbox_vue__["a" /* default */],
    CircleChart: __WEBPACK_IMPORTED_MODULE_4__shared_charts_CircleChart_vue__["a" /* default */],
    FrameworkWheel: __WEBPACK_IMPORTED_MODULE_5__shared_charts_FrameworkWheel_vue__["a" /* default */],
    PrintIcon: __WEBPACK_IMPORTED_MODULE_15__shared_icons_PrintIcon_vue__["a" /* default */],
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_17__shared_icons_DownloadIcon_vue__["a" /* default */],
    ShareIcon: __WEBPACK_IMPORTED_MODULE_16__shared_icons_ShareIcon_vue__["a" /* default */],
    HelpTooltip: __WEBPACK_IMPORTED_MODULE_6__shared_misc_HelpTooltip_vue__["a" /* default */],
    HighMediumLowExplainer: __WEBPACK_IMPORTED_MODULE_7__shared_misc_HighMediumLowExplainer_vue__["a" /* default */],
    MiniSourceLink: __WEBPACK_IMPORTED_MODULE_19__MiniSourceLink_vue__["a" /* default */]
  },
  props: ['currentCountryDataset', 'firstCountry', 'subattributeData', 'subcomponentData', 'worldData'],
  data: function data() {
    return {
      CancelToken: __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken,
      countryData: false,
      sourcelinkNum: 0
    };
  },
  metaInfo: function metaInfo() {
    var title = 'The Global State of Democracy initiative';
    if (this.firstCountry && this.firstCountry.name) {
      title += ' ' + this.firstCountry.name;
    }
    return {
      title: title,
      meta: [{ name: 'description', content: 'Global Monitor of COVID-19´s impact on Democracy and Human Rights.' }, { property: 'og:title', content: title }, { property: 'og:site_name', content: 'The Global State of Democracy initiative' }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: this.profileUrl }, { name: 'robots', content: 'index,follow' }]
    };
  },

  computed: {
    profileUrl: function profileUrl() {
      if (this.firstCountry && this.firstCountry.name) {
        return "https://www.idea.int/gsod-indices/" + 'profile/' + (this.$store.state.covid19.is_enabled ? 'covid19/' : '') + this.firstCountry.name.toLowerCase().replace(/[^a-zA-Z0-9._-]+/g, '-');
      }
      return '';
    },
    maplink: function maplink() {
      return "https://www.idea.int/gsod-indices/" + '#/indices/world-map?covid19=1';
    },
    VDemLogo: function VDemLogo() {
      return "https://www.idea.int/gsod-indices/" + 'themes/custom/gsodi/img/vdem-logo.png';
    },
    downloadUrl: function downloadUrl() {
      return "https://www.idea.int/gsod-indices/" + 'gsodi-pdf/download';
    },
    downloadAttr: function downloadAttr() {
      return 'rsc=[' + this.firstCountry.id + ']&covid19=1';
    }
  },
  mounted: function mounted() {
    this.fetchCountryInfo();
  },
  destroyed: function destroyed() {
    this.$store.state.covid19.last_updated = false;
  },

  watch: {
    'firstCountry': function firstCountry() {
      this.countryData = false;
      this.fetchCountryInfo();
    },
    'countryData': function countryData() {
      this.$store.state.covid19.last_updated = this.countryData['last_updated'];
    }
  },
  methods: {
    fetchCountryInfo: function fetchCountryInfo() {
      var _this = this;

      if (!this.firstCountry || !this.firstCountry.id) {
        return false;
      }

      this.$store.dispatch('startFetching', 'covid19profile');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://covid19api.idea.int/api/" + 'covid19/country/' + this.firstCountry.id + '?t=' + this.apiRefreshToken(), {
        cancelToken: new this.CancelToken(function (c) {
          _this.cancel = c;
        })
      }).then(function (response) {
        _this.$store.dispatch('stopFetching', 'covid19profile');
        if (response.data.country_code) {
          _this.countryData = response.data;
        }
      }).catch(function (error) {
        _this.$store.dispatch('stopFetching', 'covid19profile');
        if (!__WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error)) {
          __WEBPACK_IMPORTED_MODULE_18__event_bus_js__["a" /* EventBus */].$emit('popup.open', _this.$Strings('json_error_title'), _this.$Strings('json_error_body'));
          console.log(error);
        }
      });
    },
    printImage: function printImage() {
      window.print();
    },
    getEmptyRowData: function getEmptyRowData(countryname, columnKey) {
      var rowData = { range: [] };
      rowData.columnKey = false;
      rowData.range[0] = false;
      rowData.range[1] = false;
      rowData.value = false;
      rowData.country = countryname;
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name');
      rowData.color = 'gray-lighter';
      rowData.description = false;
      return rowData;
    },
    getRowData: function getRowData(row, columnKey) {
      var rowData = { range: [] };
      rowData.columnKey = columnKey;
      rowData.range[0] = row[columnKey + '_L'] ? row[columnKey + '_L'] : false;
      rowData.range[1] = row[columnKey + '_U'] ? row[columnKey + '_U'] : false;
      rowData.value = row[columnKey] || false;
      rowData.country = row['ID_country_name'];
      rowData.label = this.$store.getters['attributes/labelInfo'](columnKey, 'name');
      rowData.color = this.$store.getters['attributes/labelInfo'](columnKey, 'color');
      rowData.description = this.$store.getters['attributes/labelInfo'](columnKey, 'description');
      return rowData;
    },
    getAttributeValue: function getAttributeValue(columnKey, value) {
      var row = this.currentCountryDataset();
      var data = !row ? this.getEmptyRowData('', columnKey) : this.getRowData(row, columnKey);
      return data[value] ? data[value] : undefined;
    },
    getWorldDataValue: function getWorldDataValue(columnKey) {
      var worldrow = this.worldData;
      if (!columnKey || !worldrow) return undefined;
      var result = this.getRowData(worldrow, columnKey);
      return result && result.value ? parseFloat(result.value) : undefined;
    },
    hasIncidents: function hasIncidents(columnKeys) {
      var _this2 = this;

      var result = false;

      if (!this.countryData.incident_reports) {
        return result;
      }

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(columnKeys, function (key) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this2.countryData.incident_reports, function (incident) {
          if (incident.attribute_code === key) {
            result = true;
          }
        });
      });

      return result;
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_icons_AttributeIcon_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_icons_DevelopmentsToWatch_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_icons_ConcerningDevelopments_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MiniSourceLink_vue__ = __webpack_require__(180);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'profile-table-row',
  components: {
    AttributeIcon: __WEBPACK_IMPORTED_MODULE_3__shared_icons_AttributeIcon_vue__["a" /* default */],
    DevelopmentsToWatch: __WEBPACK_IMPORTED_MODULE_4__shared_icons_DevelopmentsToWatch_vue__["a" /* default */],
    ConcerningDevelopments: __WEBPACK_IMPORTED_MODULE_5__shared_icons_ConcerningDevelopments_vue__["a" /* default */],
    MiniSourceLink: __WEBPACK_IMPORTED_MODULE_6__MiniSourceLink_vue__["a" /* default */]
  },
  'props': {
    'attribute-key': {
      type: String,
      required: false
    },
    dataset: {
      required: true
    },
    covid19dataset: {
      required: true
    },
    country: {
      required: true
    }
  },
  data: function data() {
    return {
      openCategories: []
    };
  },

  computed: {
    bgColor: function bgColor() {
      var color = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('valueColor')(this.attributeValue);
      return ['bg--' + color];
    },
    incidents: function incidents() {
      var _this = this;

      var result = [];

      if (!this.covid19dataset || !this.covid19dataset.incident_reports) {
        return result;
      }

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.covid19dataset.incident_reports, function (item) {
        if (item.attribute_code === _this.attributeKey) {
          result.push(item);
        }
      });

      return result;
    },
    attributeValue: function attributeValue() {
      return this.dataset && this.dataset[this.attributeKey] ? Math.round(this.dataset[this.attributeKey] * 100) / 100 : '';
    },
    attributeTitle: function attributeTitle() {
      var label = this.$store.getters['attributes/getLabelFromKey'](this.attributeKey);
      return label ? label.name : '';
    }
  },
  methods: {
    /**
     * Check if a list of incident has any reports not attached to a category
     *
     * @param   {array}  incidents
     *
     * @return  {boolean}
     */
    hasEmptyCategories: function hasEmptyCategories(incidents) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(incidents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var incident = _step.value;

          if (!incident.category || !incident.category.title) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },


    /**
     * Return all categories available in an array of inicident reports
     *
     * @param   {array}  incidents
     *
     * @return  {array}
     */
    incidentCategories: function incidentCategories(incidents) {
      var result = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(incidents), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var incident = _step2.value;

          if (incident.category && incident.category.title && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(result, { 'id': incident.category.id })) {
            result.push(incident.category);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.hasEmptyCategories(incidents)) {
        result.push('');
      }

      return result;
    },


    /**
     * Return the incidents from a category
     *
     * @param   {obj}  category   The category
     * @param   {array}  incidents  Array of all incidents
     *
     * @return  {array}
     */
    incidentsInCategory: function incidentsInCategory(category, incidents) {
      var result = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(incidents), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var incident = _step3.value;

          if (incident.category && incident.category.title && incident.category.id === category.id) {
            result.push(incident);
          } else if (!incident.category || !incident.category.title && category === '') {
            result.push(incident);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      result.sort(function (a, b) {
        if (a.weight < b.weight) {
          return -1;
        } else if (a.weight > b.weight) {
          return 1;
        }return 0;
      });
      return result;
    },


    /**
     * Toggle a category open/clised
     *
     * @param   {obj}  category
     *
     * @return  {void}
     */
    toggleCategory: function toggleCategory(category) {
      if (this.categoryIsOpen(category)) {
        var index = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(this.openCategories, function (cat) {
          return parseInt(cat.id) === parseInt(category.id);
        });
        this.openCategories.splice(index, 1);
      } else {
        this.openCategories.push(category);
      }
    },


    /**
     * Check if the category is open
     *
     * @param   {obj}  category  The category
     *
     * @return  {boolean}
     */
    categoryIsOpen: function categoryIsOpen(category) {
      if (category === '' || !category.id) {
        return true;
      }

      return !!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.openCategories, { 'id': category.id });
    },


    /**
     * Get an excerpt incident from a category
     *
     * @param   {obj}  category
     * @param   {array}  incidents  Incidents
     *
     * @return  {string}
     */
    categoryExcerptIncident: function categoryExcerptIncident(category, incidents) {
      var items = this.incidentsInCategory(category, incidents);
      var incident = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.first(items);

      if (incident && incident.incident_report) {
        return incident;
      }
    },


    /**
     * Get the excerpt from a category
     *
     * @param   {obj}  category
     * @param   {array}  incidents  Incidents
     *
     * @return  {string}
     */
    categoryExcerpt: function categoryExcerpt(category, incidents) {
      var txt = '';
      var incident = this.categoryExcerptIncident(category, incidents);

      if (incident) {
        txt += incident.incident_report;
        if (this.incidentsInCategory(category, incidents).length > 1) {
          txt += ' ...';
        }
      }

      return txt;
    },


    /**
     * Get the excerpt sources from a category
     *
     * @param   {obj}  category
     * @param   {array}  incidents  Incidents
     *
     * @return  {obj}
     */
    categoryExcerptSources: function categoryExcerptSources(category, incidents) {
      var incident = this.categoryExcerptIncident(category, incidents);

      if (incident && incident.sources) {
        return incident.sources;
      }
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attributes_A_01_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attributes_A_02_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attributes_A_03_vue__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__attributes_A_04_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__attributes_A_05_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__attributes_SA_01_01_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__attributes_SA_01_02_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__attributes_SA_01_03_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__attributes_SA_01_04_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__attributes_SA_02_01_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__attributes_SA_02_02_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__attributes_SA_02_03_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__attributes_SA_03_01_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__attributes_SA_03_02_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__attributes_SA_03_03_vue__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__attributes_SA_04_01_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__attributes_SA_04_02_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__attributes_SC_02_02_a_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__attributes_SC_02_02_b_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__attributes_SC_02_02_c_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__attributes_SC_02_02_d_vue__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__attributes_SC_02_02_e_vue__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__attributes_SC_02_03_a_vue__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__attributes_SC_02_03_b_vue__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__attributes_SC_02_03_c_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__attributes_SA_05_01_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__attributes_SA_05_02_vue__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__attributes_SA_05_03_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__attributes_SA_05_04_vue__ = __webpack_require__(468);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//































/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'AttributeIcon',
  components: {
    A01: __WEBPACK_IMPORTED_MODULE_0__attributes_A_01_vue__["a" /* default */],
    SA0101: __WEBPACK_IMPORTED_MODULE_5__attributes_SA_01_01_vue__["a" /* default */],
    SA0102: __WEBPACK_IMPORTED_MODULE_6__attributes_SA_01_02_vue__["a" /* default */],
    SA0103: __WEBPACK_IMPORTED_MODULE_7__attributes_SA_01_03_vue__["a" /* default */],
    SA0104: __WEBPACK_IMPORTED_MODULE_8__attributes_SA_01_04_vue__["a" /* default */],
    A02: __WEBPACK_IMPORTED_MODULE_1__attributes_A_02_vue__["a" /* default */],
    SA0201: __WEBPACK_IMPORTED_MODULE_9__attributes_SA_02_01_vue__["a" /* default */],
    SA0202: __WEBPACK_IMPORTED_MODULE_10__attributes_SA_02_02_vue__["a" /* default */],
    SA0203: __WEBPACK_IMPORTED_MODULE_11__attributes_SA_02_03_vue__["a" /* default */],
    SC0202a: __WEBPACK_IMPORTED_MODULE_17__attributes_SC_02_02_a_vue__["a" /* default */],
    SC0202b: __WEBPACK_IMPORTED_MODULE_18__attributes_SC_02_02_b_vue__["a" /* default */],
    SC0202c: __WEBPACK_IMPORTED_MODULE_19__attributes_SC_02_02_c_vue__["a" /* default */],
    SC0202d: __WEBPACK_IMPORTED_MODULE_20__attributes_SC_02_02_d_vue__["a" /* default */],
    SC0202e: __WEBPACK_IMPORTED_MODULE_21__attributes_SC_02_02_e_vue__["a" /* default */],
    SC0203a: __WEBPACK_IMPORTED_MODULE_22__attributes_SC_02_03_a_vue__["a" /* default */],
    SC0203b: __WEBPACK_IMPORTED_MODULE_23__attributes_SC_02_03_b_vue__["a" /* default */],
    SC0203c: __WEBPACK_IMPORTED_MODULE_24__attributes_SC_02_03_c_vue__["a" /* default */],
    A03: __WEBPACK_IMPORTED_MODULE_2__attributes_A_03_vue__["a" /* default */],
    SA0301: __WEBPACK_IMPORTED_MODULE_12__attributes_SA_03_01_vue__["a" /* default */],
    SA0302: __WEBPACK_IMPORTED_MODULE_13__attributes_SA_03_02_vue__["a" /* default */],
    SA0303: __WEBPACK_IMPORTED_MODULE_14__attributes_SA_03_03_vue__["a" /* default */],
    A04: __WEBPACK_IMPORTED_MODULE_3__attributes_A_04_vue__["a" /* default */],
    SA0401: __WEBPACK_IMPORTED_MODULE_15__attributes_SA_04_01_vue__["a" /* default */],
    SA0402: __WEBPACK_IMPORTED_MODULE_16__attributes_SA_04_02_vue__["a" /* default */],
    A05: __WEBPACK_IMPORTED_MODULE_4__attributes_A_05_vue__["a" /* default */],
    SA0501: __WEBPACK_IMPORTED_MODULE_25__attributes_SA_05_01_vue__["a" /* default */],
    SA0502: __WEBPACK_IMPORTED_MODULE_26__attributes_SA_05_02_vue__["a" /* default */],
    SA0503: __WEBPACK_IMPORTED_MODULE_27__attributes_SA_05_03_vue__["a" /* default */],
    SA0504: __WEBPACK_IMPORTED_MODULE_28__attributes_SA_05_04_vue__["a" /* default */]
  },
  'props': {
    'size': {
      type: Number,
      default: 40
    },
    'attributeKey': {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'A_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'A_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'A_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'A_04',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'A_05',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_01_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_01_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_01_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_01_04',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_03_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_03_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_03_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_04_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_04_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_02_a',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_02_b',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_02_c',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_02_d',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_02_e',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_03_a',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_03_b',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_02_03_c',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_05_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_05_02',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_05_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'SA_05_04',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiniSourceLink_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de76c92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MiniSourceLink_vue__ = __webpack_require__(472);
function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2de76c92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MiniSourceLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2de76c92_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MiniSourceLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'mini-source',
  props: ['sources'],
  methods: {
    gotoSource: function gotoSource(source) {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('source:click', source);
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'profile-table-header'
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_icons_AttributeIcon_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AttributeIcon: __WEBPACK_IMPORTED_MODULE_0__shared_icons_AttributeIcon_vue__["a" /* default */]
  },
  'name': 'profile-table-row',
  'props': {
    'attribute-key': {
      type: String,
      required: false
    },
    dataset: {
      required: true
    }
  },
  computed: {
    bgColor: function bgColor() {
      var color = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('valueColor')(this.attributeValue);
      return ['bg--' + color];
    },
    typeIcon: function typeIcon() {
      return 'impact';
    },
    incidents: function incidents() {
      return ['Lorem ipsum', 'dolor sit amet'];
    },
    attributeValue: function attributeValue() {
      return this.dataset && this.dataset[this.attributeKey] ? Math.round(this.dataset[this.attributeKey] * 100) / 100 : '';
    },
    attributeTitle: function attributeTitle() {
      var label = this.$store.getters['attributes/getLabelFromKey'](this.attributeKey);
      return label ? label.name : '';
    }
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  'name': 'source-links-section',
  props: ['sourceLinks'],
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$on('source:click', function (source) {
      _this.sourceClicked(source);
    });
  },

  computed: {
    groupedSources: function groupedSources() {
      var groups = [];

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.sourceLinks, function (link) {
        if (groups[groups.length - 1] && !groups[groups.length - 1].icon && !link.icon) {
          groups[groups.length - 1].links.push(link);
        } else {
          groups.push({
            title: link.title,
            icon: link.icon,
            links: [link]
          });
        }
      });
      return groups;
    }
  },
  methods: {
    sourceClicked: function sourceClicked(source) {
      var sourceId = source.source_id;
      var el = this.$refs['source-' + sourceId][0];
      this.resetHighlights();
      if (this.$refs['source-' + sourceId] && el) {
        this.highlight(el);
        this.$refs['source-' + sourceId][0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    resetHighlights: function resetHighlights() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.sourceLinks, function (source) {
        var sourceId = source.source_id;
        if (_this2.$refs['source-' + sourceId] && _this2.$refs['source-' + sourceId][0]) {
          _this2.deactivateHighlight(_this2.$refs['source-' + sourceId][0]);
        }
      });
    },
    deactivateHighlight: function deactivateHighlight($ref) {
      $ref.classList.remove('isHighlighted');
    },
    highlight: function highlight($ref) {
      $ref.classList.add('isHighlighted');
    }
  }

});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_bus_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_sliders_RangeYearSlider_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_misc_Checkbox_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_misc_HelpTooltip_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_misc_ButtonGroup_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_charts_BarLine_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_misc_HighMediumLowExplainer_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_navigation_AttributesNavigation_assets_ChecksOnGovernmentIcon__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_shared_navigation_AttributesNavigation_assets_ParticipatoryEngagementIcon__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_shared_navigation_AttributesNavigation_assets_RepresentativeGovernmentIcon__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_shared_navigation_AttributesNavigation_assets_FundamentalRightsIcon__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_navigation_AttributesNavigation_assets_ImpartialAdministrationIcon__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
















/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['subattributeData', 'attributeData'],
  components: {
    HighMediumLowExplainer: __WEBPACK_IMPORTED_MODULE_7__shared_misc_HighMediumLowExplainer_vue__["a" /* default */],
    BarLine: __WEBPACK_IMPORTED_MODULE_6__shared_charts_BarLine_vue__["a" /* default */],
    RangeYearSlider: __WEBPACK_IMPORTED_MODULE_2__shared_sliders_RangeYearSlider_vue__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_3__shared_misc_Checkbox_vue__["a" /* default */],
    HelpTooltip: __WEBPACK_IMPORTED_MODULE_4__shared_misc_HelpTooltip_vue__["a" /* default */],
    ButtonGroup: __WEBPACK_IMPORTED_MODULE_5__shared_misc_ButtonGroup_vue__["a" /* default */],
    ChecksOnGovernmentIcon: __WEBPACK_IMPORTED_MODULE_8__components_shared_navigation_AttributesNavigation_assets_ChecksOnGovernmentIcon__["a" /* default */],
    ParticipatoryEngagementIcon: __WEBPACK_IMPORTED_MODULE_9__components_shared_navigation_AttributesNavigation_assets_ParticipatoryEngagementIcon__["a" /* default */],
    RepresentativeGovernmentIcon: __WEBPACK_IMPORTED_MODULE_10__components_shared_navigation_AttributesNavigation_assets_RepresentativeGovernmentIcon__["a" /* default */],
    FundamentalRightsIcon: __WEBPACK_IMPORTED_MODULE_11__components_shared_navigation_AttributesNavigation_assets_FundamentalRightsIcon__["a" /* default */],
    ImpartialAdministrationIcon: __WEBPACK_IMPORTED_MODULE_12__components_shared_navigation_AttributesNavigation_assets_ImpartialAdministrationIcon__["a" /* default */]
  },
  data: function data() {
    return {
      attrSub: 'attributes'
    };
  },

  watch: {
    attributeData: function attributeData() {
      __WEBPACK_IMPORTED_MODULE_1__event_bus_js__["a" /* EventBus */].$emit('slider.refresh');
    }
  },
  methods: {
    toggleAttrSub: function toggleAttrSub() {
      if (this.attrSub === 'subattributes') {
        this.attrSub = 'attributes';
      } else {
        this.attrSub = 'subattributes';
      }
    }
  }
}));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
// import {EventBus} from '@/event-bus.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'buttongroup',
  props: {
    values: {
      type: Object,
      required: true
    },
    selectedKey: {
      required: true
    }
  },
  methods: {
    select: function select() {
      this.$emit('click');
    },
    isActive: function isActive(key) {
      return this.selectedKey === key;
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFound',
  beforeCreate: function beforeCreate() {
    this.$parent.notFound = true;
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__strings_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_meta__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookie__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import VueSync from 'vue-sync'









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_cookie___default.a);
// Vue.use(VueSync)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__strings_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_meta__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_7__store_js__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417e2232_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417e2232_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleMap_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a50a9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleMap_vue__ = __webpack_require__(215);
function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a50a9d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f00b2da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__ = __webpack_require__(288);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Nav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f00b2da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Nav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorldMap_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f10a26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorldMap_vue__ = __webpack_require__(273);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorldMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88f10a26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorldMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-arrow",on:{"click":function($event){return _vm.clicked()}}},[_c('svg',{staticClass:"toggle-arrow__svg",attrs:{"id":'toggler_' + this._uid,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 60 40"}},[_c('polygon',{staticClass:"arrow svg-fill--gray-darkest",attrs:{"points":"30 0 60 40 0 40"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"togglelabel",class:{ 'isOpen': _vm.open, 'isToggleable': _vm.toggleable }},[(_vm.toggleable === false)?_c('div',{staticClass:"attributes__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.toggleable === true)?_c('div',{staticClass:"attributes__title attributes__title--toggleable",on:{"click":function($event){return _vm.toggleOpen()}}},[(_vm.selected === false)?_c('div',{staticClass:"label label--none"},[_vm._v("Choose "+_vm._s(_vm.title.toLowerCase()))]):_vm._e(),_vm._v(" "),(_vm.selected !== false)?_c('div',{staticClass:"label label--selected"},[_vm._v(_vm._s(_vm.selected))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.toggleable)?_c('div',{staticClass:"countries-nav__header__toggle",on:{"click":function($event){return _vm.toggleOpen()}}},[_c('ToggleArrow',{attrs:{"width":8,"closed":!_vm.open}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip hide-for-print"},[_c('svg',{attrs:{"width":"12","height":"12","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 11.32 11.32"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.clickTooltip()}}},[_c('path',{staticClass:"cls-2",attrs:{"d":"M5.66,10.82a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,5.66,10.82Z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M5.48,7.25a.59.59,0,1,0,.57.6A.57.57,0,0,0,5.48,7.25Z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M5.59,3a2.07,2.07,0,0,0-1.14.32l-.08.06.27.72L4.78,4a1.2,1.2,0,0,1,.68-.21c.27,0,.59.1.59.52a1.55,1.55,0,0,1-.49.94,1.83,1.83,0,0,0-.49,1.38l0,.31h.83V6.6a1.36,1.36,0,0,1,.4-1A2.13,2.13,0,0,0,7,4.21,1.23,1.23,0,0,0,5.59,3Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('svg',{staticClass:"icon_svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_320","data-name":"Group 320","transform":"translate(-174.561 -96.788)"}},[_c('circle',{class:['svg-fill--' + _vm.color],attrs:{"id":"Ellipse_86","data-name":"Ellipse 86","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(174.561 96.788)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_319","data-name":"Group 319","transform":"translate(0 -850.394)"}},[_c('path',{attrs:{"id":"Path_233","data-name":"Path 233","d":"M220.5,974.37A15.107,15.107,0,1,1,205.4,959.263,15.108,15.108,0,0,1,220.5,974.37","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_21","data-name":"Line 21","x2":"13.61","y2":"13.61","transform":"translate(215.221 985.45)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_22","data-name":"Line 22","x2":"9.849","y2":"9.849","transform":"translate(218.982 989.211)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"9"}}),_vm._v(" "),_c('path',{class:['svg-fill--' + _vm.color],attrs:{"id":"Path_234","data-name":"Path 234","d":"M202.039,986.454a8.048,8.048,0,1,1-8.048-8.048,8.048,8.048,0,0,1,8.048,8.048","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_235","data-name":"Path 235","d":"M222.026,986.327","fill":"#fff","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_134","data-name":"Group 134"}},[_c('path',{attrs:{"id":"Path_236","data-name":"Path 236","d":"M207.222,972.312a3.544,3.544,0,0,0,.419-.247c.054-.035.1-.075.156-.113.089-.066.174-.137.255-.21a4,4,0,1,0-5.689-.521c.041.052.083.1.127.155.084.093.168.183.26.268a4.026,4.026,0,0,0,.37.306c.053.038.1.078.157.114a3.971,3.971,0,0,0,.423.248,6.111,6.111,0,0,0-4.188,3.9,7.588,7.588,0,0,1,4.65,5.181h8.1C212.267,975.831,210.128,973.063,207.222,972.312Z","fill":"#fff"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_237","data-name":"Path 237","d":"M204.19,985.28","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_238","data-name":"Path 238","d":"M190.154,986.064,193,988.913l5.171-5.171","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('svg',{staticClass:"icon_svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_322","data-name":"Group 322","transform":"translate(-454.795 -96.788)"}},[_c('circle',{class:['svg-fill--' + _vm.color],attrs:{"id":"Ellipse_40","data-name":"Ellipse 40","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(454.795 96.788)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_512","data-name":"Path 512","d":"M2754.849,993.853a20.983,20.983,0,0,0-1.659-8.9c3.612-6.922,3.4-16.941,3.483-19.251a2.94,2.94,0,0,0-.368-1.718.7.7,0,0,0-1.286.248c-.883,4.616-1.2,9.512-3.814,13.608a3.54,3.54,0,0,1-1.853,1.442,7.371,7.371,0,0,1-2.46.235,6.077,6.077,0,0,0,.66-.4,2.509,2.509,0,0,0,.248-.183,4.926,4.926,0,0,0,.586-.477c.147-.137.284-.275.413-.421.073-.083.137-.165.2-.248a6.228,6.228,0,0,0,1.421-3.917,6.393,6.393,0,0,0-6.272-6.35,6.295,6.295,0,0,0-4.132,11.092c.128.11.265.22.4.33.083.055.165.119.247.174a6,6,0,0,0,.661.4c-4.584,1.182-7.957,5.555-7.957,14.337Z","transform":"translate(-2267.717 -850.394)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_513","data-name":"Path 513","d":"M2761.263,993.853a20.981,20.981,0,0,1,1.66-8.9c-3.612-6.922-3.332-15.069-3.415-17.379a2.942,2.942,0,0,1,.368-1.718.7.7,0,0,1,1.286.248c.883,4.616,1.128,7.64,3.746,11.736a3.535,3.535,0,0,0,1.853,1.442,7.368,7.368,0,0,0,2.459.235,6.077,6.077,0,0,1-.66-.4,2.616,2.616,0,0,1-.247-.183,4.917,4.917,0,0,1-.587-.477c-.146-.137-.284-.275-.412-.421-.074-.083-.138-.165-.2-.248a6.241,6.241,0,0,1-1.421-3.917,6.4,6.4,0,0,1,6.272-6.35,6.3,6.3,0,0,1,4.133,11.092c-.128.11-.266.22-.4.33-.082.055-.164.119-.247.174a6.1,6.1,0,0,1-.66.4c4.584,1.182,7.957,5.555,7.957,14.337Z","transform":"translate(-2267.717 -850.394)","fill":"#fff"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('svg',{staticClass:"icon_svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_315","data-name":"Group 315","transform":"translate(-454.795 -96.788)"}},[_c('circle',{class:['svg-fill--' + _vm.color],attrs:{"id":"Ellipse_234","data-name":"Ellipse 234","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(454.795 96.788)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_314","data-name":"Group 314"}},[_c('path',{attrs:{"id":"Path_478","data-name":"Path 478","d":"M491.713,138.162a5.547,5.547,0,0,0,.617-.363c.079-.052.153-.111.23-.167.131-.1.255-.2.375-.309a5.9,5.9,0,1,0-8.38-.768c.062.077.123.154.188.228.123.137.247.27.382.395a6.048,6.048,0,0,0,.546.451c.078.056.151.115.231.168a5.768,5.768,0,0,0,.623.365c-4.279,1.106-7.431,5.184-7.431,13.379h20.05C499.144,143.346,495.992,139.268,491.713,138.162Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_479","data-name":"Path 479","d":"M505.4,130.767a5.612,5.612,0,0,0,.6-.353c.085-.055.164-.116.245-.176.139-.1.27-.212.4-.326a5.9,5.9,0,1,0-8.352-.682c.031.038.061.075.093.112a6.247,6.247,0,0,0,.459.476c.105.1.218.182.329.271a5.762,5.762,0,0,0,.559.4c.157.1.312.2.479.281a8.636,8.636,0,0,0-2.322.99,7.521,7.521,0,0,1,.119.928,7.944,7.944,0,0,1-1.524,4.923,12.105,12.105,0,0,1,4.671,6.538h11.675C512.835,135.951,509.683,131.873,505.4,130.767Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_480","data-name":"Path 480","d":"M480.22,132.685a7.721,7.721,0,0,1,.12-.928,8.637,8.637,0,0,0-2.322-.99c.084-.042.161-.1.242-.142a5.882,5.882,0,0,0,1.046-.733l.034-.028a5.9,5.9,0,1,0-7.588.2c.035.029.069.058.1.086.149.115.3.226.458.326a5.611,5.611,0,0,0,.515.291c-4.279,1.106-7.431,5.184-7.431,13.379h11.675a12.105,12.105,0,0,1,4.671-6.538A7.951,7.951,0,0,1,480.22,132.685Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_481","data-name":"Path 481","d":"M491.713,119.9c.132-.065.252-.147.378-.222a5.755,5.755,0,0,0,.752-.531c.082-.068.168-.13.245-.2a5.982,5.982,0,0,0,.478-.5l.1-.127a5.892,5.892,0,1,0-9.022.107l.012.015a6.069,6.069,0,0,0,.529.547c.039.035.081.065.121.1a5.853,5.853,0,0,0,.891.627c.108.063.21.134.323.189a8.538,8.538,0,0,0-2.887,1.379,7.619,7.619,0,0,1,.584,4.417,7.8,7.8,0,0,1,4.9-1.741c.123,0,.248,0,.372.008a7.767,7.767,0,0,1,4.516,1.741,8.052,8.052,0,0,1-.1-1.218,7.859,7.859,0,0,1,.691-3.205A8.506,8.506,0,0,0,491.713,119.9Z","fill":"#fff"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('svg',{staticClass:"icon_svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_318","data-name":"Group 318","transform":"translate(-2441.849 -97.306)"}},[_c('circle',{class:['svg-fill--' + _vm.color],attrs:{"id":"Ellipse_207","data-name":"Ellipse 207","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(2441.849 97.306)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_317","data-name":"Group 317"}},[_c('path',{attrs:{"id":"Path_366","data-name":"Path 366","d":"M2480.247,119.388l-4-.051a.233.233,0,0,1-.2-.15,4.553,4.553,0,0,0-3.905-3.168c-.519-.065-8.759-.082-8.759-.082a1.235,1.235,0,0,0-.032,2.469l2.04.026h.052a.331.331,0,0,1,.173.333.327.327,0,0,1-.234.269l-2.956-.038a1.341,1.341,0,0,0-1.369,1.135,1.282,1.282,0,0,0,1.26,1.43l2.766.036a.29.29,0,0,1-.037.556l-3.2-.04a1.3,1.3,0,0,0-1.329,1.1c0,.031,0,.061,0,.093s-.008.046-.008.07a.7.7,0,0,0,.007.079c0,.018,0,.035,0,.053a1.206,1.206,0,0,0,1.18,1.092l3.446.05a.355.355,0,0,1,.035.707l-2.744-.01a1.174,1.174,0,0,0-1.1.791c-.008.02-.014.041-.02.062a1.229,1.229,0,0,0-.031.135c0,.018-.009.034-.011.052s0,.036,0,.054-.007.043-.007.065.005.048.007.073a.886.886,0,0,0,.01.117,1.061,1.061,0,0,0,.024.114,1.205,1.205,0,0,0,.036.123c.012.031.026.059.039.088a1.34,1.34,0,0,0,.067.126c.013.022.029.041.044.062a1.167,1.167,0,0,0,.1.124c.012.013.026.024.039.036a1.1,1.1,0,0,0,.138.116l.019.012a1.172,1.172,0,0,0,.642.205s8.928.041,9.418.041c.584,0,.853.261.853.88l.014,1.138a1.883,1.883,0,0,0,.247.006c1.17,0,2.173-1.2,2.617-2.349.159-.41.255-.864.727-.885.129-.005,3.588.046,3.944.051Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_367","data-name":"Path 367","d":"M2464.905,109.264l-.066,5.128h7.2c0-.131.045-3.549.065-5.128Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_368","data-name":"Path 368","d":"M2463.929,129.316l-.051,4a.233.233,0,0,1-.15.2,4.551,4.551,0,0,0-3.168,3.9c-.065.52-.082,8.76-.082,8.76a1.235,1.235,0,0,0,2.469.031l.026-2.04v-.051a.333.333,0,0,1,.333-.174.329.329,0,0,1,.269.235l-.038,2.955a1.34,1.34,0,0,0,1.135,1.369,1.281,1.281,0,0,0,1.43-1.259l.036-2.767a.29.29,0,0,1,.556.038l-.04,3.2a1.3,1.3,0,0,0,1.1,1.329c.031,0,.061,0,.093,0s.046.008.07.008.053-.005.079-.007l.053,0a1.205,1.205,0,0,0,1.092-1.179l.05-3.446a.355.355,0,0,1,.707-.035l-.01,2.744a1.174,1.174,0,0,0,.791,1.1l.062.02a1.061,1.061,0,0,0,.135.03c.018,0,.034.01.052.012s.036,0,.054,0,.043.007.065.008.048-.006.073-.007.079-.005.117-.01.076-.015.114-.024a1.254,1.254,0,0,0,.123-.037.875.875,0,0,0,.088-.039,1.165,1.165,0,0,0,.126-.066c.022-.014.041-.03.062-.044a1.334,1.334,0,0,0,.124-.1c.013-.013.024-.027.036-.04a1.091,1.091,0,0,0,.117-.137l.011-.019a1.173,1.173,0,0,0,.205-.643s.041-8.927.041-9.417c0-.585.261-.853.88-.853l1.138-.014a1.878,1.878,0,0,0,.006-.248c0-1.169-1.2-2.172-2.349-2.617-.41-.158-.864-.255-.885-.727,0-.128.046-3.587.051-3.943Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_369","data-name":"Path 369","d":"M2453.8,144.658l5.128.065v-7.2l-5.128-.066Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_370","data-name":"Path 370","d":"M2473.86,145.629l4,.051a.23.23,0,0,1,.2.15,4.555,4.555,0,0,0,3.905,3.168c.52.065,8.76.082,8.76.082a1.235,1.235,0,0,0,.031-2.469l-2.04-.026h-.052a.332.332,0,0,1-.173-.333.328.328,0,0,1,.235-.269l2.955.037a1.339,1.339,0,0,0,1.369-1.135,1.283,1.283,0,0,0-1.259-1.43l-2.767-.035a.291.291,0,0,1,.037-.557l3.2.041a1.3,1.3,0,0,0,1.329-1.1c0-.032,0-.062,0-.093s.007-.046.008-.07-.006-.053-.007-.08,0-.035,0-.052a1.206,1.206,0,0,0-1.18-1.092l-3.446-.051a.355.355,0,0,1-.034-.706l2.744.01a1.172,1.172,0,0,0,1.1-.791c.008-.021.014-.042.021-.063a1.331,1.331,0,0,0,.03-.134c0-.018.009-.034.012-.052s0-.036,0-.055.007-.042.007-.064,0-.048-.006-.073a1.177,1.177,0,0,0-.011-.118.853.853,0,0,0-.024-.113,1.119,1.119,0,0,0-.036-.124c-.012-.03-.025-.058-.039-.087a1.2,1.2,0,0,0-.067-.127c-.013-.021-.029-.04-.044-.061a1.1,1.1,0,0,0-.1-.124c-.012-.013-.026-.024-.039-.036a1.251,1.251,0,0,0-.137-.117l-.02-.011a1.164,1.164,0,0,0-.642-.205s-8.927-.042-9.418-.042c-.584,0-.853-.26-.853-.879l-.014-1.139a2.132,2.132,0,0,0-.247-.005c-1.17,0-2.172,1.2-2.617,2.348-.158.411-.255.864-.727.885-.128.006-3.587-.045-3.944-.05Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_371","data-name":"Path 371","d":"M2489.2,155.752l.065-5.127h-7.2c0,.13-.045,3.549-.065,5.127Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_372","data-name":"Path 372","d":"M2490.17,135.691l.051-4a.234.234,0,0,1,.15-.2,4.552,4.552,0,0,0,3.168-3.9c.065-.52.082-8.76.082-8.76a1.235,1.235,0,0,0-2.469-.031l-.026,2.04v.051a.334.334,0,0,1-.333.174.329.329,0,0,1-.269-.235l.038-2.955a1.341,1.341,0,0,0-1.136-1.369,1.282,1.282,0,0,0-1.43,1.259l-.035,2.767a.29.29,0,0,1-.556-.038l.04-3.2a1.3,1.3,0,0,0-1.1-1.329c-.031,0-.062,0-.093,0s-.046-.008-.07-.008-.053.006-.079.007l-.053,0a1.205,1.205,0,0,0-1.092,1.179l-.051,3.446a.355.355,0,0,1-.706.035l.01-2.744a1.174,1.174,0,0,0-.791-1.1l-.063-.02a.994.994,0,0,0-.134-.03c-.018,0-.034-.01-.052-.012s-.036,0-.054,0-.043-.007-.065-.008-.048.006-.073.007c-.04,0-.079.005-.118.01s-.075.015-.113.024-.083.022-.124.037-.058.025-.087.039a1.166,1.166,0,0,0-.126.066c-.022.014-.041.03-.062.045a1.18,1.18,0,0,0-.124.1c-.013.013-.024.027-.036.04a1.167,1.167,0,0,0-.117.137l-.011.019a1.171,1.171,0,0,0-.205.643s-.041,8.927-.041,9.417c0,.585-.261.854-.88.854l-1.139.013a2.15,2.15,0,0,0,0,.248c0,1.169,1.195,2.172,2.348,2.617.411.158.865.255.885.727.006.128-.045,3.587-.05,3.943Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_373","data-name":"Path 373","d":"M2500.294,120.349l-5.128-.065v7.2l5.128.066Z","fill":"#fff"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('svg',{staticClass:"icon_svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_321","data-name":"Group 321","transform":"translate(-1588.653 -947.181)"}},[_c('circle',{class:['svg-fill--' + _vm.color],attrs:{"id":"Ellipse_74","data-name":"Ellipse 74","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(1588.653 947.181)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_91","data-name":"Group 91"}},[_c('path',{attrs:{"id":"Path_217","data-name":"Path 217","d":"M1640.421,1000.106h-2.82V966.263h1.41v-4.231h-31.023v4.231h1.41v33.843h-2.115a.7.7,0,0,0,0,1.41h17.627V986.005h9.871v15.511h5.64a.7.7,0,0,0,0-1.41Zm-18.331-14.1v5.64h-9.871v-5.64Zm0-8.461v5.64h-9.871v-5.64Zm0-8.461v5.641h-9.871v-5.641Zm12.691,8.461v5.64h-9.871v-5.64Zm0-8.461v5.641h-9.871v-5.641Z","fill":"#fff"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attribute-label",class:_vm.classes},[_c('div',{staticClass:"attribute-label__icon",on:{"click":function($event){return _vm.toggleSelect()}}},[_c(_vm.iconComponent,{tag:"component",staticClass:"svg",attrs:{"color":_vm.getColor}})],1),_vm._v(" "),_c('div',{staticClass:"attribute-label__title",class:['color--' + _vm.getColor],on:{"click":function($event){return _vm.toggleSelect()}}},[_c('div',{staticClass:"attribute-label__title__wrap"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),(_vm.tooltip !== false)?_c('HelpTooltip',{staticClass:"attribute-label__title__help",attrs:{"followMouse":false,"link":_vm.link,"description":_vm.tooltip}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"attribute-label__toggle",on:{"click":function($event){return _vm.toggleOpen()}}},[_c('ToggleArrow',{attrs:{"width":8,"closed":!_vm.open}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attribute",class:['color--' + _vm.getColor, { isActive: (_vm.currentlySelected === true) }],on:{"click":function($event){return _vm.clicked()}}},[_vm._v("\n  "+_vm._s(_vm.attr.name)+" "),(_vm.tooltip !== false)?_c('helptooltip',{staticClass:"attribute__help",attrs:{"followMouse":false,"link":_vm.link,"description":_vm.tooltip}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected)?_c('div',{staticClass:"selectionmarker"},[(_vm.type == 'check')?_c('svg',{staticClass:"check",class:'svg-stroke--' + _vm.color,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 6.46 5.08"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('polyline',{staticClass:"cls-1",attrs:{"points":"0.35 2.31 2.46 4.36 6.08 0.33"}})])])]):_c('div',{staticClass:"dot",class:['bg--' + _vm.color]})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 40 40"}},[_c('g',{attrs:{"id":"Group_24","data-name":"Group 24","transform":"translate(8.361 7.293)"}},[_c('circle',{attrs:{"id":"Ellipse_41","data-name":"Ellipse 41","cx":"20","cy":"20","r":"20","transform":"translate(-8.361 -7.293)","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_32","data-name":"Path 32","d":"M2052.531-475.3a11.619,11.619,0,0,0-10.859-7.653,11.619,11.619,0,0,0-10.86,7.653h-.778v2.209h23.276V-475.3Zm-10.859-5.737a9.7,9.7,0,0,1,8.758,5.631h-17.516A9.7,9.7,0,0,1,2041.671-481.036Z","transform":"translate(-2030.033 482.952)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_33","data-name":"Path 33","d":"M2050.428-464.4h-1.969v9.421h-3.2V-464.4h-1.968v9.421h-3.2V-464.4h-1.969v9.421h-3.2V-464.4h-1.969v9.421h-2.93v2.086h23.276v-2.086h-2.881Z","transform":"translate(-2030.033 475.279)","fill":"#fff"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regime_nav flex flex-nowrap p20 items-center bg-gray",class:{
    'isSelected': _vm.isRegimeEnabled,
    'color--gray-darkest': _vm.isRegimeEnabled,
    'color--gray': !_vm.isRegimeEnabled
  },on:{"click":function($event){return _vm.toggle()}}},[(_vm.isRegimeEnabled)?_c('SelectionMarker',{staticClass:"regime_nav__marker",attrs:{"color":"gray-darkest","selected":true,"type":'check'}}):_vm._e(),_vm._v(" "),_c('RegimeIcon',{staticClass:"regime_nav__icon flex-none",attrs:{"size":30}}),_vm._v(" "),_c('div',{staticClass:"regime_nav__label flex-auto pr-10 pl-10 color--gray-darkest"},[_vm._v("\n    Regime type "),_c('helptooltip',{staticClass:"regime_nav__label flex-none",attrs:{"followMouse":false,"description":_vm.$Strings('regime_nav_tooltip')}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attributes",attrs:{"id":"attribute-nav"}},[(_vm.$store.state.regime_nav_enabled)?_c('Regime'):_vm._e(),_vm._v(" "),(!this.selectMultiple)?_c('ToggleLabel',{attrs:{"toggleable":_vm.toggleable,"closed":!_vm.open,"title":"Attributes","selected":_vm.firstSelectedAttribute,"callback":_vm.toggleOpen}}):_c('ToggleLabel',{attrs:{"toggleable":_vm.toggleable,"closed":!_vm.open,"title":"Attributes","selected":false,"callback":_vm.toggleOpen}}),_vm._v(" "),_vm._l((_vm.attributeHeaders),function(attribute){return (_vm.open === true && attribute.section === '')?_c('ul',{key:attribute.id,staticClass:"attributes__list"},[_c('li',{staticClass:"attributes__list__item "},[_c('SelectionMarker',{staticClass:"attributes__list__item__selectionmarker",attrs:{"color":"gray-darkest","selected":_vm.attributeIsSelected(attribute.id),"type":"check"}}),_vm._v(" "),_c('AttributeLabel',{attrs:{"open":(_vm.currentSection == attribute.id),"selected":_vm.attributeIsSelected(attribute.id),"color":"gray-darkest","identifier":attribute.id,"title":attribute.name,"tooltip":attribute.description,"link":attribute.link},on:{"toggleOpen":function($event){return _vm.toggleSectionOpen(attribute.id)},"toggleSelect":function($event){return _vm.toggleAttribute(attribute.id, attribute.id, attribute.selectable)}}}),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[((_vm.currentSection == attribute.id))?_c('ul',{staticClass:"attributes__list__item__list"},_vm._l((_vm.attributeHeaders),function(subattribute){return (subattribute.section === attribute.id)?_c('li',{staticClass:"attributes__list__item__list__item"},[_c('SelectionMarker',{staticClass:"selectionmarker",attrs:{"color":"gray-darkest","selected":_vm.attributeIsSelected(subattribute.id),"type":"check"}}),_vm._v(" "),_c('Attribute',{attrs:{"attr":subattribute,"color":"gray-darkest","selected":_vm.attributeIsSelected(subattribute.id),"tooltip":subattribute.description,"link":subattribute.link},on:{"selected":function($event){return _vm.toggleAttribute(subattribute.id, attribute.id)}}}),_vm._v(" "),(_vm.hasSubattributes(subattribute))?_c('ul',{staticClass:"subattributes__list__item__list"},_vm._l((_vm.attributeHeaders),function(subsubattribute){return (subsubattribute.section === subattribute.id)?_c('li',{staticClass:"subattributes__list__item__list__item"},[_c('SelectionMarker',{staticClass:"selectionmarker selectionmarker--on-line",attrs:{"color":"gray-darkest","selected":_vm.attributeIsSelected(subsubattribute.id),"type":"check"}}),_vm._v(" "),_c('Attribute',{attrs:{"attr":subsubattribute,"color":"gray-darkest","selected":_vm.attributeIsSelected(subsubattribute.id),"tooltip":subsubattribute.description,"link":subattribute.link},on:{"selected":function($event){return _vm.toggleAttribute(subsubattribute.id, attribute.id)}}})],1):_vm._e()}),0):_vm._e()],1):_vm._e()}),0):_vm._e()])],1)]):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountriesRegime_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cf07e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountriesRegime_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06cf07e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountriesRegime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cf07e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountriesRegime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countries-regime",attrs:{"id":"countries-regime"}},[_c('div',{staticClass:"regime_nav flex flex-nowrap p20 items-center bg-gray color--gray-darkest"},[_c('RegimeIcon',{staticClass:"regime_nav__icon flex-none",attrs:{"size":30}}),_vm._v(" "),_c('div',{staticClass:"regime_nav__label flex-auto pr-10 pl-10 color--gray-darkest"},[_vm._v("\n      Countries\n    ")])],1),_vm._v(" "),_vm._l((_vm.countriesRegime),function(attribute){return _c('ul',{key:attribute.id,staticClass:"attributes__list"},[_c('li',{staticClass:"attributes__list__item"},[_c('div',{staticClass:"label-wrapper",class:attribute.class},[_c('AttributeLabel',{attrs:{"open":(_vm.currentSection == attribute.id),"selected":_vm.attributeIsSelected(attribute.id),"identifier":attribute.id,"title":attribute.name},on:{"toggleOpen":function($event){return _vm.toggleSectionOpen(attribute.id)},"toggleSelect":function($event){return _vm.toggleSectionOpen(attribute.id)}}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[((_vm.currentSection == attribute.id))?_c('ul',{staticClass:"attributes__list__item__list"},_vm._l((attribute.countries),function(subattribute){return _c('router-link',{staticClass:"attributes__list__item__list__item link-item",attrs:{"tag":"li","to":{ path: '/countries-regions-profile?rsc=[' + subattribute.id + ']' + _vm.covidQuery  }}},[_vm._v(" "+_vm._s(subattribute.name)+"\n          ")])}),1):_vm._e()])],1)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worldmap-nav",attrs:{"id":"worldmap-nav"}},[_c('attribute-nav',{attrs:{"selectMultiple":false,"closeOnSelect":false,"toggleable":false,"closed":false}}),_vm._v(" "),_c('CountriesRegime')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareAttributes_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718b384a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareAttributes_vue__ = __webpack_require__(282);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-718b384a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareAttributes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718b384a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareAttributes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */,
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapseLabel_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369930e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapseLabel_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-369930e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollapseLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_369930e6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollapseLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-label"},[_c('div',{staticClass:"collapse-label__label",on:{"click":function($event){return _vm.toggleClick()}}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.canOpen)?_c('div',{staticClass:"collapse-label__toggle",on:{"click":function($event){return _vm.toggleOpen()}}},[_c('ToggleArrow',{attrs:{"width":8,"closed":!_vm.open}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countries-nav",attrs:{"id":"countries-nav"}},[_c('header',{staticClass:"countries-nav__header"},[_c('ToggleLabel',{attrs:{"toggleable":_vm.toggleable,"closed":!_vm.open,"title":"Country, region","selected":_vm.selectedLabel,"callback":_vm.toggleCountryList}})],1),_vm._v(" "),((_vm.open === true))?_c('div',{staticClass:"countries-nav__search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchstring),expression:"searchstring"}],attrs:{"type":"text","id":"countries-nav__search__input","placeholder":"Search"},domProps:{"value":(_vm.searchstring)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchstring=$event.target.value}}}),_vm._v(" "),_c('transition',{attrs:{"name":"quickfade"}},[(_vm.selectMultiple && (_vm.selectedCountries.length > 0))?_c('ul',{staticClass:"countries-nav__selected"},[_vm._l((_vm.selectedCountries),function(country,index){return _c('li',{staticClass:"countries-nav__selected__item",class:'color--' + _vm.getCountryColor(country.id),on:{"click":function($event){return _vm.toggleCountry(country.id, country.name, country.type)}}},[_c('SelectionMarker',{staticClass:"countries-nav__selected__item__selectionmarker",attrs:{"color":_vm.getCountryColor(country.id),"selected":true,"type":"check"}}),_vm._v("\n          "+_vm._s(country.name)+"\n        ")],1)}),_vm._v(" "),(_vm.selectedCountries && _vm.selectedCountries.length === 1)?_c('li',{staticClass:"countries-nav__selected__item countries-nav__selected__item--unclickable color--gray-light"},[_vm._v("\n          "+_vm._s(this.$Strings('addMoreToCompare'))+"\n        ")]):_vm._e()],2):_vm._e()])],1):_vm._e(),_vm._v(" "),((_vm.open === true))?_c('ul',{staticClass:"countries-nav__list regions"},_vm._l((_vm.sortByName(_vm.visibleRegions)),function(region){return (_vm.rscIsVisible(region.id))?_c('li',{key:region.id,staticClass:"countries-nav__list__item regions__item",class:{ isActive : _vm.countryIsActive(region.id, region.name, 'region') }},[_c('SelectionMarker',{staticClass:"regions__item__selectionmarker",attrs:{"color":'gray-darkest',"selected":_vm.countryIsActive(region.id, region.name, 'region'),"type":_vm.selectMultiple ? 'check' : 'dot'}}),_vm._v(" "),_c('CollapseLabel',{staticClass:"regions__item__name",attrs:{"title":region.name,"closed":true,"canOpen":_vm.hasSubregions(region)},on:{"toggleClick":function($event){return _vm.toggleCountry(region.id, region.name, 'region')},"toggleOpen":function($event){return _vm.toggleCountryRegion(region.id,'region')}}}),_vm._v(" "),(_vm.subregionExists(region.id))?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.countryRegionIsOpen(region.id, 'region')),expression:"countryRegionIsOpen(region.id, 'region')"}],staticClass:"subregions"},_vm._l((_vm.sortByName(region.subregions)),function(subregion){return (_vm.rscIsVisible(subregion.id))?_c('li',{key:subregion.id,staticClass:"subregions__item",class:{ isActive : _vm.countryIsActive(subregion.id, subregion.name, 'subregion') }},[_c('SelectionMarker',{staticClass:"subregions__item__selectionmarker",attrs:{"color":'gray-darkest',"selected":_vm.countryIsActive(subregion.id, subregion.name, 'subregion'),"type":_vm.selectMultiple ? 'check' : 'dot'}}),_vm._v(" "),_c('CollapseLabel',{staticClass:"subregions__item__name",attrs:{"title":subregion.name,"closed":true,"canOpen":_vm.hasCountries(subregion)},on:{"toggleClick":function($event){return _vm.toggleCountry(subregion.id, subregion.name, 'subregion')},"toggleOpen":function($event){return _vm.toggleCountryRegion(subregion.id, 'subregion')}}}),_vm._v(" "),_vm._l((_vm.sortByName(subregion.countries)),function(country){return (_vm.rscIsVisible(country.id) && subregion.id != country.id)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.countryRegionIsOpen(subregion.id, 'subregion')),expression:"countryRegionIsOpen(subregion.id, 'subregion')"}],key:country.id,staticClass:"countries"},[_c('li',{staticClass:"countries__name",class:{ isActive : _vm.countryIsActive(country.id, country.name, 'country') },on:{"click":function($event){return _vm.toggleCountry(country.id, country.name, 'country')}}},[_c('SelectionMarker',{staticClass:"countries__name__selectionmarker",attrs:{"color":'gray-darkest',"selected":_vm.countryIsActive(country.id, country.name, 'country'),"type":_vm.selectMultiple ? 'check' : 'dot'}}),_vm._v("\n              "+_vm._s(country.name)+"\n            ")],1)]):_vm._e()})],2):_vm._e()}),0):_vm._e(),_vm._v(" "),_vm._l((_vm.sortByName(region.subregions)),function(subregion){return (_vm.subregionExists(region.id) === false)?_c('div',{staticClass:"no-subregion",class:{ isActive : _vm.countryIsActive(subregion.id, subregion.name, 'subregion') }},_vm._l((_vm.sortByName(subregion.countries)),function(country){return _c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.countryRegionIsOpen(region.id, 'region')),expression:"countryRegionIsOpen(region.id, 'region')"}],staticClass:"countries"},[_c('li',{staticClass:"countries__name",class:{ isActive : _vm.countryIsActive(country.id, country.name, 'country') },on:{"click":function($event){return _vm.toggleCountry(country.id, country.name, 'country')}}},[_c('SelectionMarker',{staticClass:"countries__name__selectionmarker",attrs:{"color":'gray-darkest',"selected":_vm.countryIsActive(country.id, country.name, 'country'),"type":_vm.selectMultiple ? 'check' : 'dot'}}),_vm._v("\n            "+_vm._s(country.name)+"\n          ")],1)])}),0):_vm._e()})],2):_vm._e()}),0):_vm._e(),_vm._v(" "),(_vm.showNoSearchResultsText())?_c('div',{staticClass:"countries-nav__list__noresult"},[_vm._v(_vm._s(this.$Strings('noResults')))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-attributes-nav"},[_c('countries-nav',{staticClass:"compare-attributes-nav__countries",class:{ isOpen: (_vm.currentNav === 'country') },attrs:{"selectMultiple":false,"closeOnSelect":true,"countries":_vm.countries,"toggleable":true,"closed":(_vm.currentNav !== 'country')},on:{"toggleClosed":_vm.toggleCountryNavigation}}),_vm._v(" "),_c('attribute-nav',{staticClass:"compare-attributes-nav__attributes",class:{ isOpen: (_vm.currentNav === 'attribute') },attrs:{"selectMultiple":true,"closeOnSelect":false,"toggleable":true,"useRandomColors":true,"closed":(_vm.currentNav !== 'attribute')},on:{"toggleClosed":_vm.toggleAttributeNavigation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareCountriesRegions_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf7d632e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareCountriesRegions_vue__ = __webpack_require__(285);
function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bf7d632e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareCountriesRegions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf7d632e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareCountriesRegions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-countries-regions-nav"},[_c('attribute-nav',{staticClass:"compare-countries-regions-nav__attributes",class:{ isOpen: (_vm.currentNav === 'attribute') },attrs:{"selectMultiple":false,"closeOnSelect":true,"toggleable":true,"closed":(_vm.currentNav !== 'attribute')},on:{"toggleClosed":_vm.toggleAttributeNavigation}}),_vm._v(" "),_c('countries-nav',{staticClass:"compare-countries-regions-nav__countries",class:{ isOpen: (_vm.currentNav === 'country') },attrs:{"selectMultiple":true,"closeOnSelect":false,"countries":_vm.countries,"toggleable":true,"closed":(_vm.currentNav !== 'country')},on:{"toggleClosed":_vm.toggleCountryNavigation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryRegionProfile_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd5d57e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryRegionProfile_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryRegionProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd5d57e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryRegionProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country-region-profile-nav"},[_c('countries-nav',{attrs:{"selectMultiple":!_vm.$store.state.covid19.is_enabled || this.countries.length > 0,"closeOnSelect":false,"countries":_vm.countries,"toggleable":false,"closed":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current)?_c('div',{staticClass:"page-sidebar-nav hide-for-print"},[_c(_vm.current,{tag:"component",attrs:{"countriesRegime":this.countriesRegime}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LevelNavigation_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dfa4908_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LevelNavigation_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dfa4908"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LevelNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dfa4908_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LevelNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level-navigation hide-for-print",attrs:{"id":"level-navigation"}},[_c('nav',{staticClass:"nav level-navigation__nav"},[(!_vm.isFetching)?_c('ul',{staticClass:"nav__navigation"},[_c('li',{staticClass:"nav__navigation__item first"},[_c('router-link',{attrs:{"to":{ name: this.rout ? 'covid-19-monitor' : 'democracy-indices' }}},[_vm._v(_vm._s(this.$Strings('worldmap')))])],1),_vm._v(" "),(!_vm.$store.state.covid19.is_enabled)?_c('li',{staticClass:"nav__navigation__item"},[_c('router-link',{attrs:{"to":{ name: 'compare-attributes' }}},[_vm._v(_vm._s(this.$Strings('compareAttributes')))])],1):_vm._e(),_vm._v(" "),(!_vm.$store.state.covid19.is_enabled)?_c('li',{staticClass:"nav__navigation__item"},[_c('router-link',{attrs:{"to":{ name: 'compare-countries-regions' }}},[_vm._v(_vm._s(this.$Strings('compareCountryRegions')))])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav__navigation__item last"},[_c('router-link',{attrs:{"to":{ name: 'countries-regions-profile', query:{ 'covid19': _vm.$store.state.covid19.is_enabled ? '1' : '0' } }}},[_vm._v(_vm._s(this.$Strings('countryProfile')))])],1)]):_c('ul',{staticClass:"nav__navigation"},[_c('li',{staticClass:"nav__navigation__item first"},[_c('a',{staticClass:"not-active",attrs:{"href":"#"}},[_vm._v(_vm._s(this.$Strings('worldmap')))])]),_vm._v(" "),(!_vm.$store.state.covid19.is_enabled)?_c('li',{staticClass:"nav__navigation__item"},[_c('a',{staticClass:"not-active",attrs:{"href":"#"}},[_vm._v(_vm._s(this.$Strings('compareAttributes')))])]):_vm._e(),_vm._v(" "),(!_vm.$store.state.covid19.is_enabled)?_c('li',{staticClass:"nav__navigation__item"},[_c('a',{staticClass:"not-active",attrs:{"href":"#"}},[_vm._v(_vm._s(this.$Strings('compareCountryRegions')))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav__navigation__item last"},[_c('a',{staticClass:"not-active",attrs:{"href":"#"}},[_vm._v(_vm._s(this.$Strings('countryProfile')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpToolbar_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4ee760e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpToolbar_vue__ = __webpack_require__(294);
function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4ee760e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4ee760e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helptoolbar-wrap hide-for-print"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible())?_c('div',{staticClass:"helptoolbar"},[_c('div',{staticClass:"helptoolbar__info"},[_c('svg',{attrs:{"width":"12","height":"12","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 11.32 11.32"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M5.66,10.82a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,5.66,10.82Z"}}),_c('line',{staticClass:"cls-1",attrs:{"x1":"5.66","y1":"4.99","x2":"5.66","y2":"8.58"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"5.66","cy":"3.39","r":"0.79"}})])]),_vm._v(" "),_c('div',{staticClass:"helptoolbar__content"},[_vm._v("\n        "+_vm._s(_vm.description)+"\n        "),(_vm.popupContent)?_c('span',{staticClass:"helptoolbar__content__readmore",on:{"click":function($event){return _vm.openPopup()}}},[_vm._v(_vm._s(this.$Strings('readmore')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"helptoolbar__close",on:{"click":function($event){return _vm.closeToolbar()}}},[_c('svg',{staticClass:"helptoolbar__close__times",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.6 9.6"}},[_c('title',[_vm._v("times_small")]),_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('line',{staticClass:"cls-1",attrs:{"x1":"0.35","y1":"0.35","x2":"9.25","y2":"9.25"}}),_c('line',{staticClass:"cls-1",attrs:{"x1":"9.25","y1":"0.35","x2":"0.35","y2":"9.25"}})])])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CovidToolbar_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108ebb6f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CovidToolbar_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-108ebb6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CovidToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108ebb6f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CovidToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.size,"height":_vm.size,"viewBox":"0 0 47 47"},on:{"mouseover":_vm.openTooltip,"mouseout":_vm.closeTooltip}},[_c('defs',[_c('filter',{attrs:{"id":"Path_3","x":"0","y":"0","width":"47","height":"47","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3","input":"SourceAlpha"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_vm._v(" "),_c('feFlood',{attrs:{"flood-opacity":"0.161"}}),_vm._v(" "),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"SourceGraphic"}})],1)]),_vm._v(" "),_c('g',{attrs:{"id":"Component_19_63","data-name":"Component 19 – 63","transform":"translate(9 6)"}},[(_vm.shadow)?_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, -9, -6)","filter":"url(#Path_3)"}},[_c('path',{attrs:{"id":"Path_3-2","data-name":"Path 3","d":"M14.5,0A14.5,14.5,0,1,1,0,14.5,14.5,14.5,0,0,1,14.5,0Z","transform":"translate(9 6)","fill":"#fff"}})]):_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, -9, -6)"}},[_c('path',{attrs:{"id":"Path_3-2","data-name":"Path 3","d":"M14.5,0A14.5,14.5,0,1,1,0,14.5,14.5,14.5,0,0,1,14.5,0Z","transform":"translate(9 6)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Ellipse_78","data-name":"Ellipse 78","transform":"translate(4.247 12.525) rotate(-45)","fill":"none","stroke":"#004c64","stroke-width":"2"}},[_c('circle',{attrs:{"cx":"5.5","cy":"5.5","r":"5.5","stroke":"none"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"5.5","cy":"5.5","r":"4.5","fill":"none"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Rectangle_253","data-name":"Rectangle 253","transform":"translate(13.439 16.061) rotate(-45)","fill":"none","stroke":"#004c64","stroke-linecap":"round","stroke-width":"2"}},[_c('rect',{attrs:{"width":"3","height":"9","rx":"1.5","stroke":"none"}}),_vm._v(" "),_c('rect',{attrs:{"x":"1","y":"1","width":"1","height":"7","rx":"0.5","fill":"none"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":_vm.size,"height":_vm.size,"viewBox":"0 0 47 47"},on:{"mouseover":_vm.openTooltip,"mouseout":_vm.closeTooltip}},[_c('defs',[_c('filter',{attrs:{"id":"Ellipse_6","x":"0","y":"0","width":"47","height":"47","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3","input":"SourceAlpha"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_vm._v(" "),_c('feFlood',{attrs:{"flood-opacity":"0.161"}}),_vm._v(" "),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_vm._v(" "),_c('feComposite',{attrs:{"in":"SourceGraphic"}})],1)]),_vm._v(" "),_c('g',{attrs:{"id":"Component_25_7","data-name":"Component 25 – 7","transform":"translate(9 6)"}},[(_vm.shadow)?_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, -9, -6)","filter":"url(#Ellipse_6)"}},[_c('circle',{attrs:{"id":"Ellipse_6-2","data-name":"Ellipse 6","cx":"14.5","cy":"14.5","r":"14.5","transform":"translate(9 6)","fill":"#f23411"}})]):_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, -9, -6)"}},[_c('circle',{attrs:{"id":"Ellipse_6-2","data-name":"Ellipse 6","cx":"14.5","cy":"14.5","r":"14.5","transform":"translate(9 6)","fill":"#f23411"}})]),_vm._v(" "),_c('text',{attrs:{"id":"_","data-name":"!","transform":"translate(3 1.6)","fill":"#fff","font-size":"21","font-family":"Yrsa-Bold, Yrsa","font-weight":"700"}},[_c('tspan',{attrs:{"x":"8.791","y":"20"}},[_vm._v("!")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-toolbar c-toolbar--warning hide-for-print"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.covid19.filter_available)?_c('div',{staticClass:"inner"},[_c('div',{staticClass:"inner-wrapper"},[_c('div',{staticClass:"c-toolbar__content"},[_vm._v("\n          Global Monitor of COVID-19´s impact on Democracy and Human Rights "),_c('a',{staticClass:"pl-10",attrs:{"href":_vm.aboutUrl}},[_vm._v("read more")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.covid19.is_enabled)?_c('div',{staticClass:"c-toolbar__explainer"},[_c('div',{staticClass:"c-toolbar__explainer__item"},[_c('ConcerningDevelopments',{staticStyle:{"margin-bottom":"-4px"},attrs:{"size":35}}),_vm._v(" "),_c('div',[_vm._v("\n                Concerning developments\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"c-toolbar__explainer__item"},[_c('DevelopmentsToWatch',{staticStyle:{"margin-bottom":"-4px"},attrs:{"size":35}}),_vm._v(" "),_c('div',[_vm._v("\n                Developments to watch\n              ")])],1)]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"alert-application",staticStyle:{"background-color":"#10637e","color":"white","padding":"15px 20px"}},[_c('p',{staticStyle:{"margin":"0","line-height":"1.5"}},[_vm._v("\n          Thank you for visiting International IDEA’s Global Monitor of Covid-19’s Impact on Democracy and Human Rights. We are currently developing a new Global Monitor space, and the February 2022 updates mark the end of the current tool. Please watch this space for a new and improved resource in the near future!\n        ")])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tutorials_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688f4779_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tutorials_vue__ = __webpack_require__(302);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tutorials_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_688f4779_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tutorials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentView !== false)?_c('div',{staticClass:"tutorials",style:(_vm.styleObject),on:{"click":function($event){return _vm.remove()}}},[_c('transition',{attrs:{"name":"fade"}},[_c(_vm.currentView,{tag:"component"})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseTooltip_vue__ = __webpack_require__(106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b9073e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MouseTooltip_vue__ = __webpack_require__(305);
function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b9073e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MouseTooltip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b9073e7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MouseTooltip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.style)?_c('div',{staticClass:"mouse-tooltip hide-for-print"},[_c('transition',{attrs:{"name":"fade"}},[((_vm.visible !== false))?_c('div',{staticClass:"mouse-tooltip__tooltip",style:(_vm.positionStyle),attrs:{"id":"mousetooltip"}},[(_vm.data.style === 'linechart')?_c('div',{staticClass:"linetooltip"},_vm._l((_vm.data.data.dataarr),function(info){return _c('div',{staticClass:"inner"},[_c('div',{staticClass:"linetooltip__label",domProps:{"innerHTML":_vm._s(info.label)}}),_vm._v(" "),_c('div',{staticClass:"linetooltip__row"},[_c('div',{staticClass:"col6 linetooltip__year",domProps:{"innerHTML":_vm._s(info.year)}}),_vm._v(" "),_c('div',{staticClass:"col6 linetooltip__value",domProps:{"innerHTML":_vm._s(_vm.getFixedValue(info.value))}})])])}),0):_vm._e(),_vm._v(" "),(_vm.data.style === 'germany')?_c('div',{staticClass:"germany"},[(_vm.data.values['Germany'])?_c('div',{staticClass:"linetooltip__row"},[_c('div',{staticClass:"col6 linetooltip__year"},[_vm._v("Germany")]),_vm._v(" "),_c('div',{staticClass:"col6 linetooltip__value",domProps:{"innerHTML":_vm._s(_vm.getFixedValue(_vm.data.values['Germany']))}})]):_vm._e(),_vm._v(" "),(_vm.data.values['German Democratic Republic'])?_c('div',{staticClass:"linetooltip__row"},[_c('div',{staticClass:"col6 linetooltip__year"},[_vm._v("German Democratic Republic")]),_vm._v(" "),_c('div',{staticClass:"col6 linetooltip__value",domProps:{"innerHTML":_vm._s(_vm.getFixedValue(_vm.data.values['German Democratic Republic']))}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.data.style === 'map')?_c('div',{staticClass:"map"},[_c('div',{staticClass:"map__wrap"},[_c('div',{staticClass:"map__wrap__label",domProps:{"innerHTML":_vm._s(_vm.data.label)}}),_vm._v(" "),_c('div',{staticClass:"map__wrap__value",domProps:{"innerHTML":_vm._s(_vm.getFixedValue(_vm.data.value))}})]),_vm._v(" "),(_vm.data.sublabel)?_c('div',{staticClass:"map__sublabel",domProps:{"innerHTML":_vm._s(_vm.data.sublabel)}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.data.style === 'multiline')?_c('div',{staticClass:"multiline"},[(_vm.data.label)?_c('div',{staticClass:"multiline__label",domProps:{"innerHTML":_vm._s(_vm.data.label)}}):_vm._e(),_vm._v(" "),(_vm.data.sublabel)?_c('div',{staticClass:"multiline__sublabel",domProps:{"innerHTML":_vm._s(_vm.data.sublabel)}}):_vm._e(),_vm._v(" "),(_vm.data.value)?_c('div',{staticClass:"multiline__values"},_vm._l((_vm.data.value),function(val,i){return _c('div',{key:i,staticClass:"multiline__values__value",domProps:{"innerHTML":_vm._s(val)}})}),0):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.data.style === 'country-info')?_c('div',{staticClass:"multiline country-info"},[(_vm.data.label)?_c('div',{staticClass:"multiline__label",domProps:{"innerHTML":_vm._s(_vm.data.label)}}):_vm._e(),_vm._v(" "),(_vm.data.sublabel)?_c('div',{staticClass:"multiline__sublabel",domProps:{"innerHTML":_vm._s(_vm.data.sublabel)}}):_vm._e(),_vm._v(" "),(_vm.data.value)?_c('div',{staticClass:"multiline__values"},_vm._l((_vm.data.value),function(val,i){return _c('div',{key:i,staticClass:"multiline__values__value"},[_c('span',{domProps:{"innerHTML":_vm._s(val.label)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(val.value)}})])}),0):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.data.style === 'single')?_c('div',{staticClass:"single"},[_c('div',{staticClass:"single__label",domProps:{"innerHTML":_vm._s(_vm.data.label)}}),_vm._v(" "),(_vm.data.link && _vm.data.link !== '')?_c('a',{staticClass:"single__link",attrs:{"target":"_blank","href":_vm.data.link}},[_vm._v(_vm._s(this.$Strings('tooltip_readmore')))]):_vm._e()]):_vm._e()]):_vm._e()])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8acdfe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c8acdfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Popup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c8acdfe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Popup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup hide-for-print"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible === true)?_c('div',{staticClass:"popup__wrap",on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_c('div',{staticClass:"popup-bg"},[_c('div',{staticClass:"popup__wrap__close",on:{"click":function($event){$event.stopPropagation();return _vm.close()}}},[_c('svg',{attrs:{"width":"25","height":"25","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}},[_c('line',{staticClass:"cls-1",attrs:{"x1":"0","y1":"0","x2":"25","y2":"25"}}),_c('line',{staticClass:"cls-1",attrs:{"x1":"25","y1":"0","x2":"0","y2":"25"}})])]),_vm._v(" "),_c('div',{staticClass:"popup__wrap__content"},[(_vm.title !== '')?_c('h3',{staticClass:"popup__wrap__content__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup__wrap__content__body",domProps:{"innerHTML":_vm._s(_vm.content)}})])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewSelector_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e54a42_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewSelector_vue__ = __webpack_require__(311);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36e54a42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36e54a42_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-selector hide-for-print",class:{ 'isFetching': (this.$store.state.fetching.length > 0) },attrs:{"id":"view-selector"}},[(!_vm.$store.state.covid19.is_enabled)?_c('ul',{staticClass:"options"},[_c('li',{staticClass:"options__item",class:{ isActive: (_vm.viewMode == 'chart') },on:{"click":function($event){return _vm.setViewmode('chart')}}},[_c('div',{staticClass:"inner"},[_vm._v("\n        Visualization\n      ")])]),_vm._v(" "),_c('li',{staticClass:"options__item",class:{ isActive: (_vm.viewMode == 'table') },on:{"click":function($event){return _vm.setViewmode('table')}}},[_c('div',{staticClass:"inner"},[_vm._v("\n        Data\n      ")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8251f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__(314);
function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8251f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-footer"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.showIndicesNavigation)?_c('ToggleMap',{attrs:{"show":!this.$store.state.selections.covid19}}):_vm._e(),_vm._v(" "),_c('main',{staticClass:"l-mainwrap"},[(_vm.showIndicesNavigation)?_c('PageSidebarNavigation',{staticClass:"l-mainwrap__sidebar"}):_vm._e(),_vm._v(" "),_c('div',{class:{
      'l-mainwrap__main': _vm.showIndicesNavigation,
      'l-mainwrap__main-full': !_vm.showIndicesNavigation
    }},[(_vm.showIndicesNavigation)?_c('level-navigation',{staticClass:"l-mainwrap__main__navigation",attrs:{"rout":_vm.$store.state.covid19.is_enabled}}):_vm._e(),_vm._v(" "),(_vm.showIndicesNavigation)?_c('ViewSelector',{staticClass:"level-navigation__selector"}):_vm._e(),_vm._v(" "),(_vm.$store.state.covid19.is_enabled)?_c('CovidToolbar'):_vm._e(),_vm._v(" "),_c('tutorials'),_vm._v(" "),_c('router-view')],1)],1),_vm._v(" "),_c('tooltip'),_vm._v(" "),_c('popup'),_vm._v(" "),_c('theFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Welcome__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Map__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_MapTable__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_CompareAttributes__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_CompareCountriesRegions__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_CountriesRegionsProfile__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_NotFound__ = __webpack_require__(488);




// import CovidMap from '@/components/pages/CovidMap'






// import Covid19PDF from '@/components/pdf/Covid19PDF'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: '/gsod-indices/',
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/welcome'
  }, {
    path: '/world-map',
    redirect: '/democracy-indices'
  }, {
    path: '/indices/world-map ',
    redirect: '/democracy-indices'
  }, {
    path: '/covid-19-monitor',
    redirect: '/covid19globalmonitor'
  }, {
    path: '/welcome',
    name: 'welcome',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Welcome__["a" /* default */]
  }, {
    path: '/covid19globalmonitor',
    name: 'covid-19-monitor',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Map__["a" /* default */],
    props: { covidEnable: true }
  }, {
    path: '/democracy-indices',
    name: 'democracy-indices',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Map__["a" /* default */],
    props: { covidEnable: false }
  }, {
    path: '/world-map',
    name: 'world-map',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Map__["a" /* default */]
  }, {
    path: '/world-map-table',
    name: 'world-map-table',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_MapTable__["a" /* default */]
  }, {
    path: '/compare-attributes',
    name: 'compare-attributes',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_CompareAttributes__["a" /* default */]
  }, {
    path: '/compare-countries-regions',
    name: 'compare-countries-regions',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_CompareCountriesRegions__["a" /* default */]
  }, {
    path: '/countries-regions-profile',
    name: 'countries-regions-profile',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_CountriesRegionsProfile__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_NotFound__["a" /* default */]
    // {
    //   path: '/pdf/covid19/profile',
    //   name: 'COVID19 profile PDF',
    //   component: Covid19PDF
    // }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

if (location.hash) {
  var democracyUrl = location.origin + '/gsod-indices/democracy-indices';
  var covidUrl = location.origin + '/gsod-indices/covid19globalmonitor';
  location.replace(location.hash.replace('#/indices/world-map', democracyUrl));
  location.replace(location.hash.replace('#/indices/countries-regions-profile?rsc=%5B625%5D&covid19=1', democracyUrl));
  location.replace(location.hash.replace('#/covid-19-monitor', covidUrl));
}

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f6580a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__(323);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f6580a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowRightIcon_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1faa2b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowRightIcon_vue__ = __webpack_require__(322);
function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1faa2b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArrowRightIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1faa2b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArrowRightIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"welcome__navigation"},[_c('li',{staticClass:"welcome__navigation__item"},[_c('router-link',{attrs:{"to":{ name: 'democracy-indices' }}},[_c('h2',[_vm._v("Global State of "),_c('br'),_vm._v(" Democracy Indices")]),_vm._v(" "),_c('div',{staticClass:"item-bottom"},[_c('p',[_vm._v("\n          The Global State of Democracy Indices depict democratic trends at the country, regional and global levels for 165 countries across 29 aspects of democracy from 1975-2021, updated annually.\n        ")]),_vm._v(" "),_c('div',{staticClass:"icon"},[_c('ArrowRightIcon',{attrs:{"size":15}})],1)])])],1),_vm._v(" "),_c('li',{staticClass:"welcome__navigation__item revert"},[_c('router-link',{attrs:{"to":{ name: 'covid-19-monitor' }}},[_c('h2',[_vm._v("Global Monitor of "),_c('br'),_vm._v("COVID-19's Impact "),_c('br'),_vm._v("on Democracy and "),_c('br'),_vm._v("Human Rights")]),_vm._v(" "),_c('div',{staticClass:"item-bottom"},[_c('p',[_vm._v("\n            The Global Monitor of COVID-19’s Impact on Democracy and Human Rights is a qualitative monitor and a “one-stop-shop” online global monitoring tool/of the democracy and human rights implications of measures adopted by governments around the world in the context of the COVID-19 crisis.\n          ")]),_vm._v(" "),_c('div',{staticClass:"icon"},[_c('ArrowRightIcon',{attrs:{"size":15}})],1)])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome__header"},[_c('h1',[_vm._v("Welcome to the Global State of Democracy!")]),_vm._v(" "),_c('p',[_vm._v("Please select a dataset:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60de014_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60de014_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CountryClass_js__ = __webpack_require__(338);





var _class = function () {
  /**
   * Constructor
   */
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.countries = [];
  }

  /**
   * Return ID
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'addCountry',
    value: function addCountry(dataRow, $el, $store) {
      this.countries.push(new __WEBPACK_IMPORTED_MODULE_3__CountryClass_js__["a" /* default */](dataRow, $el, $store));
    }

    /**
     * Return all
     */

  }, {
    key: 'all',
    value: function all() {
      return this.countries;
    }

    /**
     * Return first result by name
     */

  }, {
    key: 'firstByName',
    value: function firstByName(name) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.countries, { name: name });
    }

    /**
     * Return first result by year and name
     */

  }, {
    key: 'firstByYearName',
    value: function firstByYearName(year, name) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.countries, function (c) {
        return parseInt(c.year) === parseInt(year) && c.name === name;
      });
    }

    /**
     * Reset the collection
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.countries = [];
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);





var _class = function () {
  /**
   * Constructor
   */
  function _class(data, $el, $store) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.data = data;
    this.$el = $el;
    this.$store = $store;

    this.id = this.data.ID_country_code;
    this.year = this.data.ID_year;
    this.name = __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].filter('fixedName')(this.data.ID_country_name);
  }

  /**
   * Return regime name
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'regimeName',
    value: function regimeName() {
      var dem = parseInt(this.data.dem);
      var demperf = parseInt(this.data.demperf);
      var demObj = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.rsc.dem, { dem: dem });

      if (!dem || !demObj) {
        return false;
      }

      if (!demperf) {
        return dem < 3 ? demObj.name : demPerfObj.name + ' ' + demObj.name;
      }

      var demPerfObj = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.rsc.demperf, { demperf: demperf });
      return dem < 3 ? demObj.name : demPerfObj.name + ' ' + demObj.name;
    }

    /**
     * Return the color of a regime
     */

  }, {
    key: 'attributeColor',
    value: function attributeColor(attr) {
      var val = this.attributeValue(attr);
      return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].filter('valueColor')(val);
    }

    /**
     * Return the hex value of a attribute color
     */

  }, {
    key: 'attributeHexColor',
    value: function attributeHexColor(attr) {
      var color = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.colors, { name: this.attributeColor(attr) });
      return color && color.hex ? color.hex : '';
    }

    /**
     * Return the color of a regime
     */

  }, {
    key: 'regimeColor',
    value: function regimeColor() {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].filter('regimeColor')(this.data);
    }

    /**
     * Return the hex value of a regime color
     */

  }, {
    key: 'regimeHexColor',
    value: function regimeHexColor() {
      var color = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.colors, { name: this.regimeColor() });
      return color && color.hex ? color.hex : '';
    }

    /**
     * Returns the value of an attribute
     */

  }, {
    key: 'attributeValue',
    value: function attributeValue(key) {
      return this.data[key];
    }

    /**
     * Return the high/watch indication of the entire country
     */

  }, {
    key: 'incidentType',
    value: function incidentType() {
      return this.$store.getters['covid19/countryType'](this.id);
    }

    /**
     * Return the high/watch indication for an attribute
     */

  }, {
    key: 'countryAttributeType',
    value: function countryAttributeType(attr) {
      return this.$store.getters['covid19/countryAttributeType'](this.id, attr);
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegimeExplainer_vue__ = __webpack_require__(113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49aa3d70_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegimeExplainer_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49aa3d70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegimeExplainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49aa3d70_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegimeExplainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regime-explainer"},[(_vm.$store.state.covid19.is_enabled)?_c('div',{staticClass:"regime-explainer__title"},[_vm._v("GSoD Indices 2021")]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"regime-explainer__notice"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":35,"height":35,"viewBox":"0 -3 47 47"}},[_c('g',{attrs:{"id":"Component_25_7","data-name":"Component 25 – 7","transform":"translate(9 6)"}},[(_vm.shadow)?_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, -9, -6)","filter":"url(#Ellipse_6)"}},[_c('circle',{attrs:{"id":"Ellipse_6-2","data-name":"Ellipse 6","cx":"14.5","cy":"14.5","r":"14.5","transform":"translate(9 6)","fill":"#004c65"}})]):_c('g',{attrs:{"transform":"matrix(1, 0, 0, 1, -9, -6)"}},[_c('circle',{attrs:{"id":"Ellipse_6-2","data-name":"Ellipse 6","cx":"14.5","cy":"14.5","r":"14.5","transform":"translate(9 6)","fill":"#004c65"}})]),_vm._v(" "),_c('text',{attrs:{"id":"_","data-name":"!","transform":"translate(3 1.6)","fill":"#fff","font-size":"21","font-family":"Yrsa-Bold, Yrsa","font-weight":"700"}},[_c('tspan',{attrs:{"x":"8.791","y":"20"}},[_vm._v("!")])])])]),_vm._v(" "),_c('div',[_vm._v("\n      Current version includes data up to 31 December, 2021\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regime-explainer__content flex flex-nowrap"},[_c('div',{staticClass:"flex-auto"},[_c('div',{staticClass:"mb-10"},[_c('strong',[_vm._v("Regime types as of 31 December 2021")])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_vm._v("Democracy")]),_vm._v(" "),_c('div',{staticClass:"flex flex-nowrap items-center pt-2"},[_c('div',{staticClass:"swatch bg--regime-dem-low flex-none"}),_vm._v(" "),_c('div',{staticClass:"flex-auto pl-10"},[_vm._v("\n          Weak/Low performance\n        ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-nowrap items-center pt-2"},[_c('div',{staticClass:"swatch bg--regime-dem-mid flex-none"}),_vm._v(" "),_c('div',{staticClass:"flex-auto pl-10"},[_vm._v("\n          Mid-range performance\n        ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-nowrap items-center pt-2"},[_c('div',{staticClass:"swatch bg--regime-dem-high flex-none"}),_vm._v(" "),_c('div',{staticClass:"flex-auto pl-10"},[_vm._v("\n          High performance\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"flex-auto mt-45"},[_c('div',{staticClass:"flex flex-nowrap items-center pt-2"},[_c('div',{staticClass:"swatch bg--regime-purple flex-none"}),_vm._v(" "),_c('div',{staticClass:"flex-auto pl-10"},[_vm._v("\n          Hybrid regime\n        ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-nowrap items-center pt-2"},[_c('div',{staticClass:"swatch bg--regime-orange flex-none"}),_vm._v(" "),_c('div',{staticClass:"flex-auto pl-10"},[_vm._v("\n          Authoritarian regime\n        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-explainer",class:{ 'color-explainer--bg' : _vm.bg }},[_c('div',{staticClass:"color-explainer__item"},[_c('span',{staticClass:"color-explainer__item__color bg--valuered"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(this.$Strings('valueColorRedExplainer'))}})]),_vm._v(" "),_c('div',{staticClass:"color-explainer__item"},[_c('span',{staticClass:"color-explainer__item__color bg--valueyellow"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(this.$Strings('valueColorYellowExplainer'))}})]),_vm._v(" "),_c('div',{staticClass:"color-explainer__item"},[_c('span',{staticClass:"color-explainer__item__color bg--valuegreen"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(this.$Strings('valueColorGreenExplainer'))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader-overlay hide-for-print"},[_c('div',{staticClass:"inner"},[_c('svg',{staticClass:"preloader__svg",attrs:{"id":'preloader_' + this._uid,"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 60 40"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */,
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range-year-slider hide-for-print",class:{ 'isRangeSameYear' : (_vm.isRangeSameYear() === true), 'isRange' : (_vm.isRangeSlider() === true) },attrs:{"id":"range-year-slider"}},[_c('vue-slider',{ref:"slider",staticClass:"range-year-slider__slider",attrs:{"lazy":true,"max":_vm.maxYear,"min":_vm.minYear,"piecewise":true,"piecewise-label":true,"piecewiseStyle":{
        "backgroundColor": "#2F3E5E",
        "width": "4px",
        "height": "4px"
      },"tooltipStyle":[
        {
          "backgroundColor": "#F1F3F7",
          "borderColor": "#F1F3F7",
          "boxShadow": "0 0 10px 0 RGBA(0,0,0,0.1)",
          "color": "#2F3E5E",
          "font-size": "14px",
          "border-radius": "3px"
        },
        {
          "backgroundColor": "#F1F3F7",
          "borderColor": "#F1F3F7",
          "color": "#2F3E5E",
          "font-size": "14px",
          "border-radius": "3px"
        }
      ],"tooltip":"hover","tooltip-dir":"top"},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-overlay hide-for-print"},[_c('div',{staticClass:"inner",domProps:{"innerHTML":_vm._s(_vm.description)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-button-wrap hide-for-print"},[_c('div',{staticClass:"tour-button",on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v("i")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.showTourTooltip)?_c('div',{staticClass:"tour-button__help"},[_vm._v(_vm._s(_vm.$Strings('tour_tooltip')))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worldmap"},[_c('div',{staticClass:"header-area flex flex-nowrap items-center"},[(_vm.$store.state.covid19.all['last_updated'] && _vm.$store.state.covid19.is_enabled)?_c('div',{staticClass:"last-updated flex-auto text-sm"},[_vm._v("Updated "+_vm._s(this.$store.state.covid19.all['last_updated']))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"viewmode-chart"},[_c('transition',{staticStyle:{}},[(_vm.$store.state.fetching.length)?_c('PreloaderOverlay'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"zoomnav hide-for-print",class:{
      'translate-top': !_vm.$store.state.covid19.is_enabled
      }},[_c('div',{staticClass:"zoomnav__item zoomnav__item--in",class:{ isDisabled: (_vm.canZoomIn() === false) },on:{"click":function($event){$event.preventDefault();return _vm.zoomIn()}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 20 20"},attrs:{"width":"20","height":"20","version":"1.1","id":"zoomIn","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","xml:space":"preserve"}},[_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"9.5","y":"5","width":"1","height":"10"}}),_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"5","y":"10","width":"10","height":"1"}})])]),_vm._v(" "),_c('div',{staticClass:"zoomnav__item zoomnav__item--out",class:{ isDisabled: (_vm.canZoomOut() === false) },on:{"click":function($event){$event.preventDefault();return _vm.zoomOut()}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 20 20"},attrs:{"width":"20","height":"20","version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","xml:space":"preserve"}},[_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"5","y":"10","width":"10","height":"1"}})])]),_vm._v(" "),_c('div',{staticClass:"zoomnav__item zoomnav__item--reset",class:{ isDisabled: (_vm.canReset() === false) },on:{"click":function($event){$event.preventDefault();return _vm.zoomReset()}}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 20 20"},attrs:{"width":"20","height":"20","version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 20 20","xml:space":"preserve"}},[_c('g',[_c('g',[_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"2","y":"3","width":"1","height":"4"}}),_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"4","transform":"matrix(-1.836970e-16 1 -1 -1.836970e-16 7 -2)","width":"1","height":"5"}})]),_c('g',[_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"14.5","y":"0.5","transform":"matrix(-1.836970e-16 1 -1 -1.836970e-16 17.5 -12.5)","width":"1","height":"4"}}),_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"17","y":"2","transform":"matrix(-1 -1.224647e-16 1.224647e-16 -1 35 9)","width":"1","height":"5"}})]),_c('g',[_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"2","y":"13","width":"1","height":"4"}}),_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"4","y":"15","transform":"matrix(6.123234e-17 -1 1 6.123234e-17 -13 22)","width":"1","height":"5"}})]),_c('g',[_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"14.5","y":"15.5","transform":"matrix(6.123234e-17 -1 1 6.123234e-17 -2.5 32.5)","width":"1","height":"4"}}),_c('rect',{staticClass:"zoomnav__item__fill",attrs:{"x":"17","y":"13","transform":"matrix(-1 -1.224647e-16 1.224647e-16 -1 35 31)","width":"1","height":"5"}})])])])])]),_vm._v(" "),_c('section',{staticClass:"maparea"},[_c('div',{style:({ height: _vm.mapHeight + 'px'}),attrs:{"id":"worldmap"}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.isRegimeEnabled)?_c('RegimeExplainer',{class:'explainerstyle--bottom'}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(!_vm.isRegimeEnabled)?_c('div',{class:'explainerstyle--bottom'},[(_vm.$store.state.covid19.is_enabled)?_c('div',{staticClass:"text-bold mb-10 text-sm"},[_vm._v("\n          Pre-pandemic GSoD Indices 2019\n        ")]):_vm._e(),_vm._v(" "),_c('HighMediumLowExplainer',{attrs:{"bg":false}})],1):_vm._e()]),_vm._v(" "),(!_vm.$store.state.covid19.is_enabled)?_c('range-year-slider',{staticClass:"rangeSlider",attrs:{"years":_vm.$store.state.defaultYears,"startSelection":_vm.$store.state.yearSliderCurrent}}):_vm._e(),_vm._v(" "),(_vm.$store.state.covid19.is_enabled)?_c('div',{staticClass:"bottom-push"}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapTable_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b602026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapTable_vue__ = __webpack_require__(361);
function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b602026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableChart_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a064d1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableChart_vue__ = __webpack_require__(359);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a064d1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a064d1a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tablechart"},[_c('div',{staticClass:"table-wrap"},[_c('table',{staticClass:"table"},[_c('tr',_vm._l((_vm.headerNames),function(headerKey){return _c('th',{class:{ isSelected: (_vm.currentSorting === headerKey) },style:({ 'cursor': _vm.isSortable(headerKey) ? 'pointer' : '' }),on:{"click":function($event){return _vm.changeSorting(headerKey)}}},[_c('div',{staticClass:"rowheader"},[(_vm.isSortable(headerKey))?_c('ToggleArrow',{staticClass:"rowheader__arrow",attrs:{"closed":(_vm.currentSorting === headerKey && _vm.currentSortingOrder === 'asc')}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rowheader__key"},[_vm._v(_vm._s(_vm.getHeaderName(headerKey)))])],1)])}),0),_vm._v(" "),_c('tr'),_vm._v(" "),_vm._l((_vm.rows),function(row){return _c('tr',_vm._l((_vm.headerNames),function(key){return (row[key])?_c('td',[(key !== 'ID_country_name' && key !== 'ID_year')?_c('span',[_vm._v(_vm._s(_vm.getFixedValue(row[key])))]):_c('span',[_vm._v(_vm._s(row[key]))])]):_c('td',[_c('em',[_vm._v("N/A")])])}),0)})],2),_vm._v(" "),(_vm.rows.length === 0)?_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewmode-table"},[_c('header',{staticClass:"viewmode-table__header"},[_c('div',{staticClass:"left"},[_c('h1',[_vm._v(_vm._s(this.$Strings('tableTitle')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$Strings('tableDescription')))])]),_vm._v(" "),(_vm.downloadUrl)?_c('div',{staticClass:"right download"},[_c('a',{staticClass:"btn",attrs:{"href":_vm.downloadUrl,"target":"_blank"}},[_vm._v("Download displayed data")]),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":this.$Strings('tableFullDatasetUrl'),"target":"_blank"}},[_vm._v("Download dataset")])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"table"},[_c('range-year-slider',{attrs:{"years":_vm.$store.state.defaultYears,"startSelection":_vm.dateRange}}),_vm._v(" "),(_vm.data)?_c('TableChart',{attrs:{"sortingKey":_vm.sortingKey,"showAttributes":_vm.showAttributes,"data":_vm.data,"showConfidenceInterval":true}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maptable"},[_c('div',{staticClass:"main-wrap"},[_c('transition',{staticStyle:{}},[(_vm.$store.state.fetching.length > 0)?_c('PreloaderOverlay'):_vm._e()],1),_vm._v(" "),_c('ViewModeTable',{attrs:{"showAttributes":[_vm.selectedAttribute],"data":_vm.tableData,"dateRange":_vm.year}}),_vm._v(" "),(!_vm.selectedAttribute)?_c('InfoOverlay',{staticClass:"infoOverlay",attrs:{"description":this.$Strings('mapChooseAttribute')}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareAttributes_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af7d83c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareAttributes_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af7d83c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareAttributes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af7d83c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareAttributes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linechart",on:{"mousemove":function($event){return _vm.onMouseMove($event)}}},[_c('div',{staticClass:"linechart__svg",attrs:{"id":'linechart--' + this._uid}},[_c('svg',{attrs:{"id":'linechart__svg--' + this._uid,"xmlns":"http://www.w3.org/2000/svg","version":"1.1","xmlns:xlink":"http://www.w3.org/1999/xlink","xmlns:svgjs":"http://svgjs.com/svgjs","viewBox":"0 0 740 285"}},[_c('g',{staticClass:"questionmark"},[_c('path',{staticClass:"cls-2",attrs:{"d":"M5.66,10.82a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,5.66,10.82Z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M5.48,7.25a.59.59,0,1,0,.57.6A.57.57,0,0,0,5.48,7.25Z"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M5.59,3a2.07,2.07,0,0,0-1.14.32l-.08.06.27.72L4.78,4a1.2,1.2,0,0,1,.68-.21c.27,0,.59.1.59.52a1.55,1.55,0,0,1-.49.94,1.83,1.83,0,0,0-.49,1.38l0,.31h.83V6.6a1.36,1.36,0,0,1,.4-1A2.13,2.13,0,0,0,7,4.21,1.23,1.23,0,0,0,5.59,3Z"}})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[((_vm.tooltipCurrent !== false))?_c('div',{staticClass:"linechart__tooltip",style:({
          left: _vm.tooltipX + 'px',
          top: _vm.tooltipY + 'px'
        })},[_c('span',{staticClass:"linechart__tooltip__name"},[_vm._v(_vm._s(_vm.tooltipCurrent.name))]),_vm._v(" "),_c('span',{staticClass:"linechart__tooltip__val"},[_vm._v(_vm._s(_vm.tooltipCurrent.value))])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareAttributesTutorial_vue__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dc876d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareAttributesTutorial_vue__ = __webpack_require__(368);
function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareAttributesTutorial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15dc876d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareAttributesTutorial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-attributes-tutorials"},[_vm._v("\n  Her er tekst for compare attributes tutorial\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downloadshare hide-for-print"},[_c('div',{staticClass:"downloadshare__actions btn-group"},[_c('div',{staticClass:"downloadshare__actions__link btn",on:{"click":function($event){return _vm.download()}}},[_c('div',{staticClass:"btn-content"},[_c('div',{staticClass:"btn-content__icon"},[_c('svg',{staticClass:"btn-content__icon__svg btn__icon downloadshare__actions__link__icon downloadshare__actions__link__icon--download",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 10.5"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"downloadshare"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M9.66,5,6.56,7.54a.09.09,0,0,1-.11,0L3.34,5"}}),_c('line',{staticClass:"cls-1",attrs:{"x1":"6.5","y1":"7.77","x2":"6.5"}}),_c('line',{staticClass:"cls-1",attrs:{"y1":"10","x2":"13","y2":"10"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"btn-content__value"},[_vm._v(_vm._s(this.$Strings('downloadTxt')))])])]),_vm._v(" "),_c('div',{staticClass:"downloadshare__actions__link btn",on:{"click":function($event){_vm.showShareOptions = !_vm.showShareOptions}}},[_c('div',{staticClass:"btn-content"},[_c('div',{staticClass:"btn-content__icon"},[_c('svg',{staticClass:"btn-content__icon__svg btn-icon downloadshare__actions__link__icon downloadshare__actions__link__icon--share",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"downloadshare"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M10.58,6.46v4.93a.11.11,0,0,1-.11.11H.61a.11.11,0,0,1-.11-.11V1.53a.11.11,0,0,1,.11-.11H5.54"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M7.38.5h4.05a.07.07,0,0,1,.07.07V4.62"}}),_c('line',{staticClass:"cls-1",attrs:{"x1":"11.5","y1":"0.5","x2":"5.08","y2":"6.92"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"btn-content__value"},[_vm._v(_vm._s(this.$Strings('shareTxt')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showShareOptions),expression:"showShareOptions"}],staticClass:"shareoptions"},[_c('div',{staticClass:"shareoptions__item shareoptions__item--facebook"},[_c('a',{attrs:{"target":"_blank","href":_vm.facebookLink}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.02 16.02"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Icons"}},[_c('g',{attrs:{"id":"Black"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Facebook","d":"M8.56,16H.88A.88.88,0,0,1,0,15.14V.88A.88.88,0,0,1,.88,0H15.14A.88.88,0,0,1,16,.88V15.14a.88.88,0,0,1-.88.88H11.05V9.82h2.08l.31-2.42H11.05V5.85c0-.7.19-1.18,1.2-1.18h1.28V2.51a17.11,17.11,0,0,0-1.87-.1,2.91,2.91,0,0,0-3.11,3.2V7.4H6.47V9.82H8.56V16Z"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"shareoptions__item shareoptions__item--twitter"},[_c('a',{attrs:{"target":"_blank","href":_vm.twitterLink}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.02 13.35"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Icons"}},[_c('g',{attrs:{"id":"Black"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Twitter","d":"M16,1.58a6.42,6.42,0,0,1-1.89.53A3.36,3.36,0,0,0,15.58.25a6.47,6.47,0,0,1-2.09.82A3.24,3.24,0,0,0,11.09,0,3.33,3.33,0,0,0,7.81,3.37a3.44,3.44,0,0,0,.08.77A9.25,9.25,0,0,1,1.12.62a3.43,3.43,0,0,0-.44,1.7A3.39,3.39,0,0,0,2.13,5.12,3.23,3.23,0,0,1,.64,4.7v0A3.35,3.35,0,0,0,3.28,8a3.13,3.13,0,0,1-.87.12A3.19,3.19,0,0,1,1.8,8.1a3.3,3.3,0,0,0,3.07,2.34A6.49,6.49,0,0,1,.78,11.88a6.58,6.58,0,0,1-.78,0,9.15,9.15,0,0,0,5,1.51,9.41,9.41,0,0,0,9.35-9.59c0-.15,0-.29,0-.44A6.75,6.75,0,0,0,16,1.58"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"shareoptions__item shareoptions__item--linkedin"},[_c('a',{attrs:{"target":"_blank","href":_vm.linkedInLink}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.69 13.35"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Icons"}},[_c('g',{attrs:{"id":"Black"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"LinkedIn","d":"M14.69,13.35H11.44V8.66c0-1.23-.51-2.07-1.62-2.07A1.64,1.64,0,0,0,8.27,7.7a2.07,2.07,0,0,0-.07.74v4.91H5S5,5,5,4.28H8.2V5.7a2.94,2.94,0,0,1,2.86-1.51c2,0,3.63,1.3,3.63,4.11v5Zm-13-10.2h0A1.58,1.58,0,0,1,0,1.57,1.6,1.6,0,0,1,1.75,0,1.59,1.59,0,0,1,3.47,1.57,1.6,1.6,0,0,1,1.73,3.15ZM.37,4.28H3.23v9.07H.37V4.28Z"}})])])])])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox hide-for-print",class:_vm.checkboxClasses,on:{"click":function($event){$event.stopPropagation();return _vm.toggle()}}},[(_vm.reverse)?_c('span',{staticClass:"checkbox__label"},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.active === false)?_c('svg',{staticClass:"checkbox__off",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M9,1V9H1V1H9m.2-1H.8A.8.8,0,0,0,0,.8V9.2a.8.8,0,0,0,.8.8H9.2a.8.8,0,0,0,.8-.8V.8A.8.8,0,0,0,9.2,0Z"}})])])]):_c('svg',{staticClass:"checkbox__on",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('rect',{staticClass:"cls-1",attrs:{"width":"10","height":"10","rx":"0.8","ry":"0.8"}}),_c('polyline',{staticClass:"cls-2",attrs:{"points":"2.15 4.96 4.27 7.01 7.89 2.98"}})])])]),_vm._v(" "),(!_vm.reverse)?_c('span',{staticClass:"checkbox__label"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confidenceintervals hide-for-print"},[_c('div',{staticClass:"confidenceintervals__confidence"},[_c('Checkbox',{staticClass:"confidenceintervals__confidence__checkbox",attrs:{"active":_vm.showConfidenceIntervals},on:{"toggle":function($event){return _vm.toggleConfidenceInterval()}}},[_vm._v(_vm._s(this.$Strings('confidenceIntervals')))]),_vm._v(" "),_c('HelpTooltip',{staticClass:"confidenceintervals__confidence__tooltip",attrs:{"description":this.$Strings('confidenceIntervalsDescription')}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linechartSelectedLabels"},[_c('ul',{staticClass:"labels"},_vm._l((_vm.data),function(attr){return _c('li',{staticClass:"labels__item"},[_c('span',{staticClass:"labels__item__color"},[_c('svg',{attrs:{"width":"8px","height":"9px","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 10 10"}},[_c('circle',{staticClass:"cls-3",class:['svg-fill--' + attr.color],attrs:{"cx":"5","cy":"5","r":"5"}})])]),_vm._v(" "),_c('span',{staticClass:"labels__item__name",class:['color--' + attr.color]},[_vm._v(_vm._s(attr.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-attributes main-wrap"},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.selectedCountry && _vm.selectedAttributes.length === 0)?_c('InfoOverlay',{attrs:{"description":this.$Strings('compareAttributesInfoCountryAttrMissing')}}):(!_vm.selectedCountry)?_c('InfoOverlay',{attrs:{"description":this.$Strings('compareAttributesInfoCountryMissing')}}):(_vm.selectedAttributes.length === 0)?_c('InfoOverlay',{attrs:{"description":this.$Strings('compareAttributesInfoAttrMissing')}}):_vm._e()],1),_vm._v(" "),(_vm.viewmode === 'chart')?_c('div',{staticClass:"viewmode-chart"},[(_vm.$store.state.fetching.length > 0)?_c('PreloaderOverlay'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"compare-linechart"},[_c('header',{staticClass:"compare-attributes__header clearfix"},[(_vm.selectedCountry)?_c('div',{staticClass:"inner"},[_c('h1',{staticClass:"compare-attributes__header__title page-title"},[_vm._v(_vm._s(_vm.selectedCountry.name))]),_vm._v(" "),_c('DownloadShare',{staticClass:"compare-attributes__header__downloadshare",attrs:{"page":"CompareAttributes"}})],1):_c('div',{staticClass:"inner"},[_c('h1',{staticClass:"compare-attributes__header__title page-title"},[_vm._v(" ")]),_vm._v(" "),_c('DownloadShare',{staticClass:"compare-attributes__header__downloadshare",attrs:{"page":"CompareAttributes"}})],1)]),_vm._v(" "),_c('section',{staticClass:"comparison-chart"},[_c('header',{staticClass:"comparison-chart__header"},[_c('LinechartSelectedLabels',{staticClass:"comparison-chart__header__labels",attrs:{"data":_vm.formattedChartData}}),_vm._v(" "),_c('ConfidenceIntervals',{staticClass:"comparison-chart__header__ci",attrs:{"showConfidenceIntervals":this.$store.state.confidenceIntervals},on:{"toggleInterval":_vm.toggleInterval}})],1),_vm._v(" "),_c('LineChart',{attrs:{"data":_vm.formattedChartData,"visibleRange":_vm.dateRange,"showConfidenceInterval":this.$store.state.confidenceIntervals}})],1),_vm._v(" "),_c('range-year-slider',{style:({ 'margin-top': '40px' }),attrs:{"years":_vm.$store.state.defaultYears}})],1)],1):_vm._e(),_vm._v(" "),(_vm.viewmode === 'table')?_c('ViewModeTable',{attrs:{"showAttributes":this.$store.state.attributes.selected,"sortingKey":'ID_year',"data":_vm.tableData,"dateRange":_vm.dateRange}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareCountriesRegions_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbb5b388_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareCountriesRegions_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbb5b388"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompareCountriesRegions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbb5b388_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompareCountriesRegions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-countries-regions main-wrap"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.selectedAttributes.length === 0 && _vm.selectedCountries.length === 0)?_c('InfoOverlay',{attrs:{"description":this.$Strings('compareCountriesRegionsInfoCountryAttrMissing')}}):(_vm.selectedCountries.length === 0)?_c('InfoOverlay',{attrs:{"description":this.$Strings('compareCountriesRegionsInfoCountryMissing')}}):(_vm.selectedAttributes.length === 0)?_c('InfoOverlay',{attrs:{"description":this.$Strings('compareCountriesRegionsInfoAttrMissing')}}):_vm._e()],1),_vm._v(" "),(_vm.viewmode === 'chart')?_c('div',{staticClass:"viewmode-chart"},[(_vm.$store.state.fetching.length > 0)?_c('PreloaderOverlay'):_vm._e(),_vm._v(" "),_c('header',{staticClass:"compare-attributes__header clearfix"},[(_vm.firstSelectedAttributeName)?_c('div',{staticClass:"inner"},[_c('h1',{staticClass:"compare-attributes__header__title page-title"},[_vm._v(_vm._s(_vm.firstSelectedAttributeName))]),_vm._v(" "),_c('DownloadShare',{staticClass:"compare-attributes__header__downloadshare"})],1):_c('div',{staticClass:"inner"},[_c('h1',{staticClass:"compare-attributes__header__title page-title"},[_vm._v(" ")]),_vm._v(" "),_c('DownloadShare',{staticClass:"compare-attributes__header__downloadshare"})],1)]),_vm._v(" "),_c('section',{staticClass:"comparison-chart"},[_c('header',{staticClass:"comparison-chart__header"},[_c('LinechartSelectedLabels',{staticClass:"comparison-chart__header__labels",attrs:{"data":_vm.selectedLabelsData}}),_vm._v(" "),_c('ConfidenceIntervals',{staticClass:"comparison-chart__header__ci",attrs:{"showConfidenceIntervals":this.$store.state.confidenceIntervals},on:{"toggleInterval":_vm.toggleInterval}})],1),_vm._v(" "),_c('LineChart',{attrs:{"data":_vm.convertedChartData,"visibleRange":_vm.dateRange,"showConfidenceInterval":this.$store.state.confidenceIntervals}})],1),_vm._v(" "),_c('range-year-slider',{style:({ 'margin-top': '40px' }),attrs:{"years":_vm.$store.state.defaultYears}})],1):_vm._e(),_vm._v(" "),(_vm.viewmode === 'table')?_c('ViewModeTable',{attrs:{"sortingKey":'ID_year',"showAttributes":this.$store.state.attributes.selected,"data":_vm.tableData,"dateRange":_vm.dateRange}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountriesRegionsProfile_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5de7dda_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountriesRegionsProfile_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5de7dda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountriesRegionsProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5de7dda_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountriesRegionsProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleCountry_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7773f63b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleCountry_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7773f63b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleCountry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7773f63b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleCountry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barline",class:{ 'hasVerticalValues': _vm.showValues }},[_c('div',{staticClass:"barline_svg__wrap"},[_c('div',{staticClass:"barline_svg",attrs:{"id":'barline_svg--' + this._uid}}),_vm._v(" "),(_vm.showInLineValue)?_c('div',{staticClass:"barline__single_value"},[_vm._v(_vm._s(_vm.getFixedValue(_vm.value)))]):_vm._e()]),_vm._v(" "),(_vm.showValues)?_c('div',{staticClass:"barline_values"},[_c('div',{staticClass:"barline__value"},[(_vm.getFixedValue(_vm.value))?_c('span',[_vm._v(_vm._s(_vm.getFixedValue(_vm.value)))]):_c('span',[_vm._v(" ")])]),_vm._v(" "),(_vm.tooltip)?_c('div',{staticClass:"barline__tooltip"},[_c('HelpTooltip',{attrs:{"description":_vm.tooltip}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"barline__label",class:{ 'isDisabled': !_vm.valueExists() }},[_c('span',{staticClass:"barline__label__value"},[_vm._v(_vm._s(_vm.label))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circlechart"},[_c('div',{staticClass:"circlechart__svg",attrs:{"id":'circlechart--' + this._uid}}),_vm._v(" "),(_vm.valueExists())?_c('div',{staticClass:"circlechart__value"},[_vm._v(_vm._s(_vm.getFixedValue(_vm.value)))]):_c('div',{staticClass:"circlechart__value"},[_vm._v("N/A")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var CircleCalculations = function () {
  /**
   * Constructor
   *
   * @return  {void}
   */
  function CircleCalculations() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CircleCalculations);

    this.circleDimensions = [0, 0];
  }

  /**
   * setCircleDimensions
   *
   * @param   {integer}  height  The height of the circle
   * @param   {integer}  width   The width of the circle
   *
   * @return  {void}
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CircleCalculations, [{
    key: "setCircleDimensions",
    value: function setCircleDimensions(width, height) {
      this.circleDimensions = [width, height];
    }

    /**
     * Returns the main circle information
     *
     * @return  {object} An object with dimensions, x and y position
     */

  }, {
    key: "getSubAttributeCircleInformation",
    value: function getSubAttributeCircleInformation() {
      var lw = this.circleDimensions[0] / 6 - 2;
      var d = this.circleDimensions[0] / 2;
      var r = d / 2;
      var l = 2 * Math.PI * r;

      return {
        x: d / 2,
        y: d / 2,
        d: d,
        r: r,
        l: l,
        linewidth: lw
      };
    }

    /**
     * Returns the main circle information
     *
     * @return  {object} An object with dimensions, x and y position
     */

  }, {
    key: "getAttributeCircleInformation",
    value: function getAttributeCircleInformation() {
      var lw = this.circleDimensions[0] / 6;
      var d = this.circleDimensions[0] - lw;
      var r = d / 2;
      var l = 2 * Math.PI * r;

      return {
        x: lw / 2,
        y: lw / 2,
        d: d,
        r: r,
        l: l,
        linewidth: lw
      };
    }

    /**
     * The the circle line info
     *
     * @return  {object}
     */

  }, {
    key: "getCircleLineInfo",
    value: function getCircleLineInfo(degree, position) {
      var x = this.circleDimensions[0] / 2;
      var y = this.circleDimensions[1] / 2;
      var r = position !== 1 ? this.circleDimensions[0] / 2 : this.circleDimensions[0] / 4;
      var a = degree * Math.PI / 180;
      var lx = x + r * Math.cos(a);
      var ly = y + r * Math.sin(a);

      return {
        x: x,
        y: y,
        lx: lx,
        ly: ly
      };
    }

    /**
     * Return the center circle X and y
     *
     * @return  {object} An object with dimensions, x and y position
     */

  }, {
    key: "getCenterCircleXY",
    value: function getCenterCircleXY() {
      var d = this.circleDimensions[0] / 3;
      var x = this.circleDimensions[0] / 2 - d / 2;
      var y = this.circleDimensions[1] / 2 - d / 2;

      return { d: d, x: x, y: y };
    }

    /**
     * Return the X and Y position for an attribute slice
     * based on
     *
     * @return  {object} An object with the XY positions
     */

  }, {
    key: "getAttributeXY",
    value: function getAttributeXY(degree, position) {
      var x = this.circleDimensions[0] / 2;
      var y = this.circleDimensions[1] / 2;
      var r = position !== 1 ? this.circleDimensions[0] / 2 : this.circleDimensions[0] / 4;
      var a = degree * Math.PI / 180;
      var lx = x + r * Math.cos(a);
      var ly = y + r * Math.sin(a);

      return { x: lx, y: ly };
    }
  }, {
    key: "getLabelInfo",
    value: function getLabelInfo(degree, position) {
      var x = this.circleDimensions[0] / 2;
      var y = this.circleDimensions[1] / 2;
      var r = position !== 1 ? this.circleDimensions[0] / 2.4 : this.circleDimensions[0] / 4.2;
      var rotation = position === 1 ? degree + 90 : degree;
      var a = degree * Math.PI / 180;
      var lx = x + r * Math.cos(a);
      var ly = y + r * Math.sin(a);

      if (rotation > 90 && rotation < 270) {
        rotation = rotation - 180;
      }

      return { x: lx, y: ly, rotation: rotation };
    }
  }]);

  return CircleCalculations;
}();

/* harmony default export */ __webpack_exports__["a"] = (CircleCalculations);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (str) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

  var charlen = size === 'large' ? 20 : 13;
  var result = str.replace(new RegExp('(?![^\\n]{1,' + charlen + '}$)([^\\n]{1,' + charlen + '})\\s', 'g'), '$1::newline::');

  if (result) {
    return result.split('::newline::');
  } else {
    return [];
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frameworkwheel"},[_c('center',{staticClass:"frameworkwheel__svg",attrs:{"id":'frameworkwheel--' + this._uid}},[_c('svg',{attrs:{"id":'frameworkwheel-svg--' + this._uid}},[_c('filter',{attrs:{"id":"dropshadow","height":"130%"}},[_c('feGaussianBlur',{attrs:{"in":"SourceAlpha","stdDeviation":"3"}}),_vm._v(" "),_c('feOffset',{attrs:{"dx":"0","dy":"5","result":"offsetblur"}}),_vm._v(" "),_c('feComponentTransfer',[_c('feFuncA',{attrs:{"type":"linear","slope":"0.15"}})],1),_vm._v(" "),_c('feMerge',[_c('feMergeNode'),_vm._v(" "),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"feather feather-printer",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polyline',{attrs:{"points":"6 9 6 2 18 2 18 9"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"}}),_vm._v(" "),_c('rect',{attrs:{"x":"6","y":"14","width":"12","height":"8"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */,
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}],staticClass:"wrap"},[_c('div',{staticClass:"clickarea",on:{"click":_vm.show}}),_vm._v(" "),_c('svg',{staticClass:"icon icon-tabler icon-tabler-share",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"6","cy":"12","r":"3"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"18","cy":"6","r":"3"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"18","cy":"18","r":"3"}}),_vm._v(" "),_c('line',{attrs:{"x1":"8.7","y1":"10.7","x2":"15.3","y2":"7.3"}}),_vm._v(" "),_c('line',{attrs:{"x1":"8.7","y1":"13.3","x2":"15.3","y2":"16.7"}})]),_vm._v(" "),(_vm.tooltipVisible)?_c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"sharelink"},[_c('div',{staticClass:"sharelink__link"},[_vm._v("\n        "+_vm._s(_vm.profileUrl)+"\n      ")]),_vm._v(" "),_c('svg',{staticClass:"sharelink__icon",class:{ 'isHighlight' : this.copied },attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 24 24","stroke-width":"2","stroke":"currentColor","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"},on:{"click":_vm.copyToClipboard}},[_c('path',{attrs:{"stroke":"none","d":"M0 0h24v24H0z"}}),_vm._v(" "),_c('rect',{attrs:{"x":"8","y":"8","width":"12","height":"12","rx":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"}})])]),_vm._v(" "),_c('div',{staticClass:"sharebuttons"},[_c('a',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"href":'http://www.facebook.com/sharer.php?u=' + _vm.profileUrl,"target":"_blank"}},[_c('svg',{attrs:{"width":"30","height":"30","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('title',[_vm._v("Facebook icon")]),_c('path',{attrs:{"fill":"currentColor","d":"M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"}})])]),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"href":'https://www.linkedin.com/shareArticle?mini=true&url='  + _vm.profileUrl + '&title=&summary=The Global State of Democracy Indices&source=',"target":"_blank"}},[_c('svg',{attrs:{"width":"30","height":"30","role":"img","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_vm._v("LinkedIn icon")]),_c('path',{attrs:{"fill":"currentColor","d":"M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"}})])]),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"href":'https://twitter.com/share?url=' + _vm.profileUrl,"target":"_blank"}},[_c('svg',{attrs:{"width":"30","height":"30","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('title',[_vm._v("Twitter icon")]),_c('path',{attrs:{"fill":"currentColor","d":"M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"}})])]),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"none","color":"white"},attrs:{"href":'mailto:info@example.com?&subject=&body=' + _vm.profileUrl,"target":"_blank"}},[_c('svg',{attrs:{"width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","aria-hidden":"true","focusable":"false","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 15 15"}},[_c('path',{attrs:{"d":"M14 6.5V12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6.5a.5.5 0 0 1 .5-.5a.49.49 0 0 1 .21 0l5.79 4l5.8-4a.488.488 0 0 1 .2 0a.5.5 0 0 1 .5.5zM1.25 3.92l.08.08L7.5 8l6.19-4h.06a.49.49 0 0 0 .25-.5a.5.5 0 0 0-.5-.5h-12a.5.5 0 0 0-.5.5a.49.49 0 0 0 .25.42z","fill":"currentColor"}})])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M16 11h5l-9 10-9-10h5v-11h8v11zm3 8v3h-14v-3h-2v5h18v-5h-2z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-country"},[_c('section',{staticClass:"single-country__main"},[(_vm.countryData)?_c('div',{staticClass:"country-print-wrap hide-for-print"},[(this.firstCountry && this.firstCountry.id)?_c('div',{staticClass:"country-print"},[_c('form',{attrs:{"action":_vm.downloadUrl,"target":"_blank","method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"args"},domProps:{"value":_vm.downloadAttr}}),_vm._v(" "),_c('label',{staticStyle:{"cursor":"pointer"}},[_c('DownloadIcon',{attrs:{"size":15}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"submit","value":"Download PDF"}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"country-print",on:{"click":function($event){return _vm.printImage()}}},[_c('PrintIcon',{attrs:{"size":15}})],1),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.name)?_c('ShareIcon',{staticClass:"country-print",attrs:{"country":_vm.firstCountry.name,"size":15}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('range-year-slider',{staticClass:"rangeSlider",attrs:{"years":_vm.$store.state.defaultYears,"startSelection":_vm.$store.state.yearSliderCurrent}}),_vm._v(" "),_c('FrameworkWheel',{attrs:{"dataset":_vm.currentCountryDataset()}}),_vm._v(" "),_c('div',{staticClass:"main-attribute-charts"},[_vm._l((['A_01', 'A_02', 'A_03', 'A_04']),function(key){return _c('div',{key:key,staticClass:"main-attribute-charts__item"},[_c('CircleChart',{staticClass:"main-attribute-charts__item__svg",attrs:{"value":_vm.getAttributeValue(key, 'value'),"color":_vm._f("valueColor")(_vm.getAttributeValue(key, 'value'))}}),_vm._v(" "),_c('div',{staticClass:"main-attribute-charts__item__label"},[_vm._v(_vm._s(_vm.getAttributeValue(key, 'label'))),_c('br'),_vm._v(" "),(_vm.getAttributeValue(key, 'description'))?_c('HelpTooltip',{staticClass:"mt5",attrs:{"description":_vm.getAttributeValue(key, 'description')}}):_vm._e()],1)],1)}),_vm._v(" "),_c('div',{staticClass:"main-attribute-charts__item"},[_c('div',{staticClass:"main-attribute-charts__item__svg"},[_vm._v(" ")]),_vm._v(" "),(_vm.getAttributeValue('A_01', 'value'))?_c('div',{staticClass:"main-attribute-charts__item__label"},[_vm._v(_vm._s(this.$Strings('popularParticipation')))]):_c('div',{staticClass:"main-attribute-charts__item__label"},[_vm._v(_vm._s(this.$Strings('popularParticipation')))]),_vm._v(" "),(_vm.getAttributeValue('A_01', 'description'))?_c('HelpTooltip',{attrs:{"description":this.$Strings('popularParticipationTooltip')}}):_vm._e()],1)],2),_vm._v(" "),_c('div',{staticClass:"actions--bar flex justify-end mb-10"},[_c('div',{staticClass:"confidence-actions"},[_c('Checkbox',{staticClass:"confidence-actions__checkbox",attrs:{"reverse":true,"active":_vm.$store.state.confidenceIntervals},on:{"toggle":function($event){_vm.$store.state.confidenceIntervals = !_vm.$store.state.confidenceIntervals}}},[_vm._v(_vm._s(this.$Strings('confidenceIntervals')))]),_vm._v(" "),_c('HelpTooltip',{staticClass:"confidence-actions__tooltip",attrs:{"description":this.$Strings('confidenceIntervalsDescription')}})],1),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.id !== '999')?_c('div',{staticClass:"confidence-actions"},[_c('Checkbox',{staticClass:"confidence-actions__checkbox",attrs:{"reverse":true,"active":_vm.$store.state.isWorldAverageEnabled},on:{"toggle":function($event){_vm.$store.state.isWorldAverageEnabled = !_vm.$store.state.isWorldAverageEnabled}}},[_vm._v(_vm._s(this.$Strings('worldAverageCheckbox')))]),_vm._v(" "),_c('HelpTooltip',{staticClass:"confidence-actions__tooltip",attrs:{"description":this.$Strings('worldAverageCheckboxDescription')}})],1):_vm._e()]),_vm._v(" "),(_vm.subattributeData[0] && _vm.subcomponentData[0])?_c('HighMediumLowExplainer',{staticClass:"explainer mb-10",attrs:{"bg":true}}):_vm._e(),_vm._v(" "),(_vm.subattributeData[0] && _vm.subcomponentData[0])?_c('div',{staticClass:"barchart"},[_c('div',{staticClass:"barchart__wrap--dark"},_vm._l((_vm.subattributeData[0]),function(row,i){return _c('div',{key:'country_' + i,staticClass:"barchart__line"},[_c('BarLine',{attrs:{"annotation-value":_vm.$store.state.isWorldAverageEnabled && _vm.firstCountry && _vm.firstCountry.id !== '999' ? _vm.getWorldDataValue(row.columnKey) : undefined,"confInt":row.range,"color":_vm._f("valueColor")(row.value),"value":parseFloat(row.value),"tooltip":row.description,"label":row.label,"showValues":true,"showRange":_vm.$store.state.confidenceIntervals,"mini":true}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"barchart__wrap--light"},_vm._l((_vm.subcomponentData[0]),function(row,i){return _c('div',{key:'sub_country_' + i,staticClass:"barchart__line"},[_c('BarLine',{attrs:{"annotation-value":_vm.$store.state.isWorldAverageEnabled && _vm.firstCountry && _vm.firstCountry.id !== '999' ? _vm.getWorldDataValue(row.columnKey) : undefined,"confInt":row.range,"color":_vm._f("valueColor")(row.value),"value":parseFloat(row.value),"tooltip":row.description,"label":row.label,"showValues":true,"showRange":_vm.$store.state.confidenceIntervals,"mini":true}})],1)}),0)]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Covid19Profile_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c97f9664_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Covid19Profile_vue__ = __webpack_require__(480);
function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c97f9664"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Covid19Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c97f9664_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Covid19Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfiletableRow_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a011605_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfiletableRow_vue__ = __webpack_require__(473);
function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a011605"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfiletableRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a011605_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfiletableRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_01_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9e109c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_01_vue__ = __webpack_require__(413);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9e109c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_311","data-name":"Group 311","transform":"translate(-315.731 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_237","data-name":"Ellipse 237","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.731 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_306","data-name":"Group 306"}},[_c('path',{attrs:{"id":"Path_482","data-name":"Path 482","d":"M353.907,322.033a5.538,5.538,0,0,0,.616-.363c.08-.052.153-.111.23-.167q.2-.147.376-.309a5.9,5.9,0,1,0-8.38-.768c.061.077.123.154.188.228.123.137.247.27.382.4a5.917,5.917,0,0,0,.546.451c.077.056.15.115.231.168a5.852,5.852,0,0,0,.622.365c-4.279,1.106-7.431,5.184-7.431,13.379h20.05C361.337,327.217,358.186,323.139,353.907,322.033Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_483","data-name":"Path 483","d":"M367.6,314.638a5.516,5.516,0,0,0,.6-.353c.085-.055.164-.117.246-.176q.207-.154.4-.327a5.9,5.9,0,1,0-8.352-.681l.092.112a6.075,6.075,0,0,0,.46.476c.1.1.218.182.329.271a5.752,5.752,0,0,0,.558.4c.157.1.313.2.479.281a8.644,8.644,0,0,0-2.321.99,7.721,7.721,0,0,1,.119.928,7.944,7.944,0,0,1-1.525,4.923,12.105,12.105,0,0,1,4.671,6.538h11.675C375.029,319.822,371.877,315.744,367.6,314.638Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_484","data-name":"Path 484","d":"M342.414,316.556a7.721,7.721,0,0,1,.119-.928,8.644,8.644,0,0,0-2.321-.99c.084-.042.16-.1.242-.142a5.882,5.882,0,0,0,1.046-.733l.033-.028a5.9,5.9,0,1,0-7.588.2l.1.086c.15.115.3.226.459.326a5.6,5.6,0,0,0,.515.291c-4.28,1.106-7.432,5.184-7.431,13.379h11.675a12.105,12.105,0,0,1,4.671-6.538A7.938,7.938,0,0,1,342.414,316.556Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_485","data-name":"Path 485","d":"M353.906,303.773c.132-.065.253-.147.379-.222a5.821,5.821,0,0,0,.752-.531c.081-.068.167-.13.245-.2a5.811,5.811,0,0,0,.477-.5c.036-.042.071-.084.105-.127a5.893,5.893,0,1,0-9.021.107l.012.015a5.934,5.934,0,0,0,.529.547c.038.035.081.065.12.1a5.854,5.854,0,0,0,.891.627c.108.063.211.134.323.189a8.524,8.524,0,0,0-2.886,1.379,7.644,7.644,0,0,1,.584,4.417,7.8,7.8,0,0,1,4.9-1.741c.123,0,.247,0,.371.008a7.772,7.772,0,0,1,4.517,1.741,8.051,8.051,0,0,1-.1-1.218,7.843,7.843,0,0,1,.691-3.205A8.519,8.519,0,0,0,353.906,303.773Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_02_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6984f065_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_02_vue__ = __webpack_require__(415);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6984f065_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_316","data-name":"Group 316","transform":"translate(-34.261 -279.266)"}},[_c('circle',{attrs:{"id":"Ellipse_205","data-name":"Ellipse 205","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(34.261 279.266)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_282","data-name":"Group 282","transform":"translate(-2267.717)"}},[_c('path',{attrs:{"id":"Path_390","data-name":"Path 390","d":"M2340.376,301.347l-4-.051a.235.235,0,0,1-.2-.15,4.556,4.556,0,0,0-3.905-3.169c-.519-.065-8.759-.081-8.759-.081a1.235,1.235,0,0,0-.032,2.469l2.04.026h.052a.334.334,0,0,1,.173.334.326.326,0,0,1-.234.268l-2.955-.037a1.34,1.34,0,0,0-1.37,1.135,1.283,1.283,0,0,0,1.26,1.43l2.766.035a.29.29,0,0,1-.037.557l-3.2-.041a1.3,1.3,0,0,0-1.329,1.1c0,.032,0,.062,0,.093s-.008.046-.008.07a.715.715,0,0,0,.007.08c0,.018,0,.035,0,.052a1.206,1.206,0,0,0,1.18,1.093l3.446.05a.355.355,0,0,1,.035.706l-2.744-.01a1.174,1.174,0,0,0-1.1.791c-.008.021-.014.042-.02.063a1,1,0,0,0-.03.135.446.446,0,0,0-.012.052c0,.018,0,.036,0,.054s-.007.042-.007.064,0,.049.007.073a1.176,1.176,0,0,0,.01.118,1.113,1.113,0,0,0,.024.113,1.063,1.063,0,0,0,.037.124.935.935,0,0,0,.039.088,1.181,1.181,0,0,0,.066.126c.013.021.029.041.044.061a1.2,1.2,0,0,0,.1.125c.012.013.026.023.039.036a1.271,1.271,0,0,0,.138.116l.019.012a1.17,1.17,0,0,0,.642.2s8.928.042,9.418.042c.584,0,.853.261.853.88l.014,1.138a1.932,1.932,0,0,0,.248.005c1.169,0,2.172-1.194,2.616-2.348.159-.41.255-.864.727-.885.129-.006,3.588.046,3.944.05Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_391","data-name":"Path 391","d":"M2325.034,291.223l-.066,5.127h7.2c0-.13.045-3.548.065-5.127Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_392","data-name":"Path 392","d":"M2324.058,311.274l-.051,4a.234.234,0,0,1-.15.2,4.552,4.552,0,0,0-3.168,3.9c-.065.52-.082,8.76-.082,8.76a1.235,1.235,0,0,0,2.469.031l.026-2.04v-.051a.325.325,0,0,1,.6.061l-.038,2.955a1.341,1.341,0,0,0,1.136,1.369,1.282,1.282,0,0,0,1.43-1.259l.035-2.767a.29.29,0,0,1,.556.037l-.04,3.2a1.3,1.3,0,0,0,1.1,1.329c.031,0,.062,0,.093,0s.046.007.07.008.053-.006.079-.007l.053-.005a1.206,1.206,0,0,0,1.092-1.18l.051-3.446a.355.355,0,0,1,.706-.034l-.01,2.744a1.173,1.173,0,0,0,.791,1.1c.02.008.041.014.062.021.045.012.089.022.135.03.018,0,.034.009.052.012s.036,0,.054,0,.043.007.065.007.048-.005.073-.006a1.154,1.154,0,0,0,.118-.011,1.128,1.128,0,0,0,.113-.023c.042-.011.083-.022.124-.037s.058-.025.087-.039a1.172,1.172,0,0,0,.126-.067c.022-.013.041-.029.062-.044a1.192,1.192,0,0,0,.124-.1c.013-.012.024-.026.036-.039a1.169,1.169,0,0,0,.117-.137l.011-.019a1.177,1.177,0,0,0,.205-.643s.041-8.927.041-9.418c0-.584.261-.853.88-.853l1.138-.014a1.878,1.878,0,0,0,.006-.247c0-1.17-1.195-2.172-2.348-2.617-.411-.158-.865-.255-.885-.727-.006-.128.045-3.587.05-3.944Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_393","data-name":"Path 393","d":"M2313.934,326.617l5.128.065v-7.2l-5.128-.065Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_394","data-name":"Path 394","d":"M2333.99,327.587l4,.051a.233.233,0,0,1,.2.15,4.553,4.553,0,0,0,3.9,3.169c.52.064,8.76.081,8.76.081a1.235,1.235,0,0,0,.031-2.469l-2.04-.026h-.051a.331.331,0,0,1-.174-.333.327.327,0,0,1,.235-.268l2.955.037a1.34,1.34,0,0,0,1.369-1.135,1.282,1.282,0,0,0-1.259-1.43l-2.767-.035a.29.29,0,0,1,.038-.557l3.2.041a1.3,1.3,0,0,0,1.329-1.1c0-.032,0-.062,0-.093s.007-.046.008-.071-.006-.052-.007-.079,0-.035,0-.053a1.206,1.206,0,0,0-1.18-1.092l-3.446-.05a.355.355,0,0,1-.034-.706l2.744.01a1.173,1.173,0,0,0,1.1-.791c.008-.021.014-.042.021-.063q.018-.066.03-.135c0-.017.009-.034.012-.052s0-.036,0-.054.007-.042.007-.065-.005-.048-.006-.072a1.176,1.176,0,0,0-.011-.118,1.05,1.05,0,0,0-.023-.113,1.229,1.229,0,0,0-.037-.124.938.938,0,0,0-.039-.088,1.185,1.185,0,0,0-.067-.126c-.013-.021-.029-.041-.044-.061a1.085,1.085,0,0,0-.1-.125c-.012-.013-.026-.024-.039-.036a1.159,1.159,0,0,0-.137-.116l-.019-.012a1.175,1.175,0,0,0-.643-.2s-8.927-.042-9.418-.042c-.584,0-.853-.261-.853-.88l-.014-1.138a1.874,1.874,0,0,0-.247-.006c-1.17,0-2.172,1.2-2.617,2.349-.158.41-.255.864-.727.885-.128.006-3.587-.046-3.943-.05Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M2349.332,337.711l.065-5.128h-7.2c0,.131-.045,3.549-.065,5.128Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M2350.3,317.65l.051-4a.233.233,0,0,1,.15-.2,4.554,4.554,0,0,0,3.168-3.9c.065-.519.082-8.759.082-8.759a1.235,1.235,0,0,0-2.469-.032l-.026,2.04v.052a.331.331,0,0,1-.333.173.326.326,0,0,1-.269-.234l.038-2.956a1.341,1.341,0,0,0-1.136-1.369,1.281,1.281,0,0,0-1.429,1.259l-.036,2.767a.29.29,0,0,1-.556-.037l.04-3.2a1.3,1.3,0,0,0-1.1-1.329c-.031,0-.061,0-.093,0s-.046-.008-.07-.008a.682.682,0,0,0-.079.007l-.053,0a1.206,1.206,0,0,0-1.092,1.18l-.051,3.446a.355.355,0,0,1-.706.035l.01-2.744a1.174,1.174,0,0,0-.791-1.1.647.647,0,0,0-.062-.02,1.252,1.252,0,0,0-.135-.031c-.018,0-.034-.009-.052-.011s-.036,0-.054,0-.043-.007-.065-.007-.048.005-.073.007a.9.9,0,0,0-.117.01,1.1,1.1,0,0,0-.114.024c-.042.01-.083.022-.124.036s-.058.026-.087.039a1.353,1.353,0,0,0-.126.067c-.022.013-.041.029-.062.044a1.139,1.139,0,0,0-.124.1c-.013.012-.024.026-.036.039a1.176,1.176,0,0,0-.117.138l-.011.019a1.173,1.173,0,0,0-.205.642s-.041,8.928-.041,9.418c0,.584-.261.853-.88.853l-1.138.014a1.868,1.868,0,0,0-.006.247c0,1.17,1.2,2.173,2.348,2.617.411.159.865.255.886.727.005.129-.046,3.588-.051,3.944Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_397","data-name":"Path 397","d":"M2360.423,302.308l-5.128-.066v7.2l5.128.065Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_03_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9345d15c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_03_vue__ = __webpack_require__(417);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9345d15c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_321","data-name":"Group 321","transform":"translate(-35.496 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_90","data-name":"Ellipse 90","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(35.496 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_137","data-name":"Group 137","transform":"translate(0 -850.394)"}},[_c('path',{attrs:{"id":"Path_239","data-name":"Path 239","d":"M81.148,1158.241a15.107,15.107,0,1,1-15.106-15.107,15.108,15.108,0,0,1,15.106,15.107","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_23","data-name":"Line 23","x2":"13.61","y2":"13.61","transform":"translate(75.866 1169.321)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_24","data-name":"Line 24","x2":"9.849","y2":"9.849","transform":"translate(79.627 1173.082)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"9"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_240","data-name":"Path 240","d":"M62.684,1170.325a8.048,8.048,0,1,1-8.047-8.048,8.048,8.048,0,0,1,8.047,8.048","fill":"#fff","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_241","data-name":"Path 241","d":"M82.671,1170.2","fill":"#fff","stroke":"#73c19d","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_136","data-name":"Group 136"}},[_c('path',{attrs:{"id":"Path_242","data-name":"Path 242","d":"M67.868,1156.183a3.62,3.62,0,0,0,.418-.247c.054-.035.1-.075.156-.113.089-.066.174-.137.256-.21a4.005,4.005,0,1,0-5.69-.521c.041.052.083.1.127.154.084.094.168.184.26.269a4.187,4.187,0,0,0,.37.306c.053.038.1.078.157.114a3.97,3.97,0,0,0,.423.248,6.113,6.113,0,0,0-4.188,3.9,7.588,7.588,0,0,1,4.65,5.181h8.106C72.913,1159.7,70.773,1156.934,67.868,1156.183Z","fill":"#1a1818"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_243","data-name":"Path 243","d":"M64.835,1169.151","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_244","data-name":"Path 244","d":"M50.8,1169.935l2.849,2.849,5.171-5.171","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_04_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e214386_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_04_vue__ = __webpack_require__(419);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_04_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e214386_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_04_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_97","data-name":"Group 97","transform":"translate(-1449.588 -1130.68)"}},[_c('circle',{attrs:{"id":"Ellipse_77","data-name":"Ellipse 77","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(1449.588 1130.68)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_96","data-name":"Group 96"}},[_c('path',{attrs:{"id":"Path_220","data-name":"Path 220","d":"M1501.357,1183.6h-2.82v-33.843h1.41v-4.231h-31.023v4.231h1.41V1183.6h-2.115a.705.705,0,0,0,0,1.41h17.626V1169.5h9.871v15.512h5.641a.705.705,0,0,0,0-1.41Zm-18.332-14.1v5.641h-9.871V1169.5Zm0-8.46v5.64h-9.871v-5.64Zm0-8.461v5.64h-9.871v-5.64Zm12.691,8.461v5.64h-9.871v-5.64Zm0-8.461v5.64h-9.871v-5.64Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_05_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df9e5062_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_05_vue__ = __webpack_require__(421);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_A_05_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df9e5062_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_A_05_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_327","data-name":"Group 327","transform":"translate(-315.731 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_44","data-name":"Ellipse 44","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.731 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_100","data-name":"Path 100","d":"M2615.688,1177.337a20.97,20.97,0,0,0-1.66-8.9c3.612-6.922,3.4-16.941,3.484-19.251a2.942,2.942,0,0,0-.368-1.718.7.7,0,0,0-1.286.248c-.883,4.616-1.2,9.512-3.815,13.608a3.532,3.532,0,0,1-1.853,1.442,7.342,7.342,0,0,1-2.459.234,5.952,5.952,0,0,0,.66-.394,2.522,2.522,0,0,0,.247-.183,4.932,4.932,0,0,0,.587-.477,5.8,5.8,0,0,0,.412-.421c.074-.083.138-.165.2-.248a6.237,6.237,0,0,0,1.421-3.917,6.394,6.394,0,0,0-6.272-6.35,6.3,6.3,0,0,0-4.133,11.092c.129.11.266.22.4.33.082.055.165.119.247.174a5.926,5.926,0,0,0,.66.394c-4.583,1.183-7.957,5.556-7.957,14.338Z","transform":"translate(-2267.717 -850.394)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_101","data-name":"Path 101","d":"M2622.1,1177.337a20.986,20.986,0,0,1,1.659-8.9c-3.611-6.922-3.332-15.069-3.414-17.379a2.94,2.94,0,0,1,.368-1.718.7.7,0,0,1,1.286.248c.883,4.616,1.128,7.64,3.746,11.736a3.532,3.532,0,0,0,1.853,1.442,7.342,7.342,0,0,0,2.459.234,5.952,5.952,0,0,1-.66-.394,2.493,2.493,0,0,1-.247-.183,4.932,4.932,0,0,1-.587-.477c-.147-.137-.284-.275-.413-.421-.073-.083-.137-.165-.2-.248a6.23,6.23,0,0,1-1.421-3.917,6.393,6.393,0,0,1,6.272-6.35,6.295,6.295,0,0,1,4.132,11.092c-.128.11-.265.22-.4.33-.082.055-.165.119-.247.174a5.926,5.926,0,0,1-.66.394c4.583,1.183,7.957,5.556,7.957,14.338Z","transform":"translate(-2267.717 -850.394)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_01_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f87c2c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_01_vue__ = __webpack_require__(423);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f87c2c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_312","data-name":"Group 312","transform":"translate(-594.989 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_243","data-name":"Ellipse 243","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.989 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_502","data-name":"Path 502","d":"M644.8,311.962v21.632H615.583V311.962","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_226","data-name":"Rectangle 226","width":"12.563","height":"8.067","transform":"translate(624.501 299.074) rotate(-45)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_503","data-name":"Path 503","d":"M641.979,302.445h-5.206l-2.34,2.34h2.387l.921,2.973H622.647l.937-2.973H626l-2.34-2.34h-5.253l-4.324,9.519H646.3Z","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_02_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b667cac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_02_vue__ = __webpack_require__(425);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b667cac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_313","data-name":"Group 313","transform":"translate(-35.342 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_220","data-name":"Ellipse 220","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(35.342 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_444","data-name":"Path 444","d":"M1201.838,299.174v15.515a9.385,9.385,0,0,1-4.487,8.005v15.118h-8.732V323.247a9.381,9.381,0,0,1-5.54-8.558V304.8a1.529,1.529,0,1,1,3.059,0v7.647h.574v.005a6.872,6.872,0,0,1,6.694,6.651h.8a7.687,7.687,0,0,0-7.036-7.425l-.169-.016V294.9a1.533,1.533,0,0,1,3.065,0v13.045a.43.43,0,1,0,.859,0V293.6a1.532,1.532,0,0,1,3.065,0v14.351a.429.429,0,1,0,.858,0V294.9a1.532,1.532,0,0,1,3.065,0v13.05a.432.432,0,1,0,.864,0v-8.774a1.53,1.53,0,1,1,3.06,0Z","transform":"translate(-1133.858)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_445","data-name":"Path 445","d":"M1211.281,320.882v7.99a4.83,4.83,0,0,1-2.31,4.122v8.361h-4.5v-8.076a4.83,4.83,0,0,1-2.853-4.407v-5.091a.788.788,0,1,1,1.575,0v3.938h.3v0a3.539,3.539,0,0,1,3.447,3.425h.412a3.958,3.958,0,0,0-3.623-3.824l-.087-.008v-8.633a.789.789,0,0,1,1.579,0V325.4a.221.221,0,1,0,.442,0v-7.391a.789.789,0,1,1,1.578,0V325.4a.221.221,0,1,0,.442,0v-6.721a.789.789,0,0,1,1.579,0V325.4a.223.223,0,1,0,.445,0v-4.518a.787.787,0,1,1,1.575,0Z","transform":"translate(-1133.858)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_446","data-name":"Path 446","d":"M1212.92,304.312v10.514a6.358,6.358,0,0,0,3.04,5.424v16.588h5.917V320.625a6.359,6.359,0,0,0,3.754-5.8v-6.7a1.037,1.037,0,1,0-2.073,0v5.182h-.389v0a4.657,4.657,0,0,0-4.536,4.508h-.542a5.208,5.208,0,0,1,4.767-5.032l.114-.011V301.418a1.039,1.039,0,0,0-2.077,0v8.84a.291.291,0,1,1-.581,0v-9.725a1.038,1.038,0,0,0-2.077,0v9.725a.291.291,0,1,1-.582,0v-8.843a1.039,1.039,0,0,0-2.077,0v8.843a.292.292,0,0,1-.585,0v-5.946a1.037,1.037,0,1,0-2.073,0Z","transform":"translate(-1133.858)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_03_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ed0a8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_03_vue__ = __webpack_require__(427);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23ed0a8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_314","data-name":"Group 314","transform":"translate(-315.731 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_231","data-name":"Ellipse 231","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.731 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_293","data-name":"Group 293","transform":"translate(-1133.858)"}},[_c('path',{attrs:{"id":"Path_465","data-name":"Path 465","d":"M1488.715,324.813c1.877-2.634,2.674-6.5.6-8.888a2.719,2.719,0,0,0-.514-3.1l-4.01-4.01a2.725,2.725,0,0,0-3.844,0l-.061.06a2.726,2.726,0,0,0,0,3.844l4.01,4.011a2.719,2.719,0,0,0,2.839.626c1.686,1.967.35,5.346-1.67,7.456H1461.8v3.874h45.934v-3.874Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_466","data-name":"Path 466","d":"M1481.63,316.522l-2.236-2.261-.045-.045-.157-.159.015-.014a5.015,5.015,0,0,1-1.069-1.935,9.03,9.03,0,0,0-2.884-1.316,5.853,5.853,0,0,0,.653-.384c.085-.055.163-.118.244-.177.139-.1.271-.213.4-.328a6.246,6.246,0,1,0-8.875-.813c.065.082.131.163.2.242.13.145.261.286.4.419a6.151,6.151,0,0,0,.578.476c.082.06.16.123.245.179a6.276,6.276,0,0,0,.659.386c-4.083,1.056-7.188,4.678-7.764,11.729h21.03A18.805,18.805,0,0,0,1481.63,316.522Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_467","data-name":"Path 467","d":"M1492.467,309.332c.13.145.261.286.4.419a6.135,6.135,0,0,0,.578.476c.082.06.16.123.245.179a6.276,6.276,0,0,0,.659.386,9.018,9.018,0,0,0-3.122,1.475,4.954,4.954,0,0,1,.885,2.481,9.441,9.441,0,0,1,.656,7.773h14.84c-.577-7.051-3.682-10.673-7.764-11.729a5.84,5.84,0,0,0,.652-.384c.085-.055.163-.118.244-.177.139-.1.271-.213.4-.328a6.246,6.246,0,1,0-8.875-.813C1492.332,309.172,1492.4,309.253,1492.467,309.332Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_04_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf400b9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_04_vue__ = __webpack_require__(429);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_01_04_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf400b9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_01_04_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_315","data-name":"Group 315","transform":"translate(-594.989 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_214","data-name":"Ellipse 214","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.989 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_422","data-name":"Path 422","d":"M1780.287,312.021a5.779,5.779,0,0,0,.6-.353c.085-.055.164-.117.246-.176.138-.1.269-.212.4-.327a5.9,5.9,0,1,0-8.352-.681c.031.037.061.075.093.111a5.888,5.888,0,0,0,.459.476c.1.1.218.183.329.272a5.751,5.751,0,0,0,.559.4c.157.1.312.2.479.281a14.671,14.671,0,0,0-3.018,1.334c.047.307.806.266.816.584a7.952,7.952,0,0,1-1.525,4.923,12.1,12.1,0,0,1,4.671,6.538h11.675C1787.718,317.2,1784.566,313.127,1780.287,312.021Z","transform":"translate(-1133.858)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_423","data-name":"Path 423","d":"M1768.835,306.658a8.808,8.808,0,0,1,.963-4,8.493,8.493,0,0,0-3.139-1.546,5.607,5.607,0,0,0,.616-.363c.08-.053.153-.111.231-.167.13-.1.255-.2.375-.31a5.9,5.9,0,1,0-8.38-.768c.061.078.123.154.188.228.123.138.247.271.382.4a5.756,5.756,0,0,0,.546.45c.077.056.151.116.231.168a5.778,5.778,0,0,0,.623.366,8.49,8.49,0,0,0-3.209,1.6,8.833,8.833,0,0,1-3.789,11.774h19.086A8.853,8.853,0,0,1,1768.835,306.658Z","transform":"translate(-1133.858)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_424","data-name":"Path 424","d":"M1755.1,313.939c.009-.318,1.107-.083,1.154-.391a18.323,18.323,0,0,0-3.357-1.527c.084-.042.161-.1.242-.142a5.829,5.829,0,0,0,1.046-.734c.011-.009.023-.017.034-.027a5.9,5.9,0,1,0-7.588.2c.035.029.069.059.1.087a5.515,5.515,0,0,0,.459.326,5.7,5.7,0,0,0,.514.291c-4.279,1.106-7.431,5.184-7.431,13.379h11.675a12.1,12.1,0,0,1,4.671-6.538A7.945,7.945,0,0,1,1755.1,313.939Z","transform":"translate(-1133.858)","fill":"#1a1818"}}),_vm._v(" "),_c('circle',{attrs:{"id":"Ellipse_224","data-name":"Ellipse 224","cx":"13.335","cy":"13.335","r":"13.335","transform":"translate(616.968 312.226)","fill":"#fff","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_425","data-name":"Path 425","d":"M1757.4,326.383l4.384,4.384,9.134-10.413","transform":"translate(-1133.858)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_02_01_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e4feab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_02_01_vue__ = __webpack_require__(431);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_02_01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e4feab_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_02_01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_317","data-name":"Group 317","transform":"translate(-315.731 -280.254)"}},[_c('circle',{attrs:{"id":"Ellipse_197","data-name":"Ellipse 197","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.731 280.254)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_318","data-name":"Path 318","d":"M2640.284,300.58h-5.434l-.324-1.259h0a2.377,2.377,0,0,0-2.35-1.79h-.022a2.376,2.376,0,0,0-2.339,1.827l-.293,1.222h-7.4v-2.366h-6.957v2.366h-7.548l-.324-1.259h0a2.379,2.379,0,0,0-2.35-1.79h-.022a2.376,2.376,0,0,0-2.339,1.827l-.293,1.222h-5.281v2.609h4.656l-4.249,17.73h15.434l-4.561-17.73h6.877v10.424h1.739V331.8h-10.7v2.609h24.877V331.8h-10.7V313.613h1.739V303.189h6.77l-4.249,17.73h15.435l-4.561-17.73h4.762Zm-8.285-.609h0Zm-27.228,0h0Zm4.718,18.339h-8.76l3.623-15.121h1.247Zm27.229,0h-8.761l3.623-15.121h1.247Z","transform":"translate(-2267.717)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_02_02_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055d4001_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_02_02_vue__ = __webpack_require__(433);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_02_02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_055d4001_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_02_02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_318","data-name":"Group 318","transform":"translate(-594.989 -280.254)"}},[_c('circle',{attrs:{"id":"Ellipse_196","data-name":"Ellipse 196","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.989 280.254)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_274","data-name":"Group 274","transform":"translate(-2267.717)"}},[_c('path',{attrs:{"id":"Path_350","data-name":"Path 350","d":"M2906.632,299.658v2.455a2.778,2.778,0,0,0,5.556,0V296.09a2.778,2.778,0,0,0-5.556,0Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_351","data-name":"Path 351","d":"M2885.7,299.161h5.288v-4.937a2.644,2.644,0,0,0-5.288.039Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_352","data-name":"Path 352","d":"M2892.644,294.119c0,.012,0,.025,0,.039v5.031h5.431v-6.644a2.718,2.718,0,0,0-5.435,0Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_353","data-name":"Path 353","d":"M2905.276,294.026v7.793a.854.854,0,0,1-.013.187v.133a2.876,2.876,0,0,1-3.181,2.727,2.992,2.992,0,0,1-2.58-3.034v-7.98a2.886,2.886,0,0,1,3.181-2.874A3.015,3.015,0,0,1,2905.276,294.026Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_354","data-name":"Path 354","d":"M2898.249,292.8v7.564a.8.8,0,0,1-.013.182v.13a2.792,2.792,0,0,1-3.088,2.646,2.9,2.9,0,0,1-2.5-2.945v-7.746a2.8,2.8,0,0,1,3.088-2.789A2.927,2.927,0,0,1,2898.249,292.8Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_355","data-name":"Path 355","d":"M2891,294.435V301.6a.757.757,0,0,1-.012.172v.123a2.645,2.645,0,0,1-2.925,2.507,2.75,2.75,0,0,1-2.371-2.789v-7.336a2.652,2.652,0,0,1,2.924-2.642A2.772,2.772,0,0,1,2891,294.435Z","fill":"#1a1818"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_273","data-name":"Group 273"}},[_c('path',{attrs:{"id":"Path_356","data-name":"Path 356","d":"M2898.423,303.409c-.1.1-.2.2-.31.293a4.053,4.053,0,0,1-2.647.978,4.324,4.324,0,0,1-.466-.026,2.046,2.046,0,0,0-4.087.156,3.916,3.916,0,0,1-2.553.944,4.243,4.243,0,0,1-.449-.025,4.1,4.1,0,0,1-3.561-4.119v-.9h-1.179v13.726a.408.408,0,0,1,.026.107c.253,2.166,2.074,4.708,3.919,6.621a17.46,17.46,0,0,0,2.709,2.343c.009.005.008.018.017.027a.149.149,0,0,1,.023.015.554.554,0,0,1,.245.457V341.08h17.532V324.03a.535.535,0,0,1,.183-.4,13.453,13.453,0,0,0,4.491-8.894,3.438,3.438,0,0,0,.061-.578v-9.091a8.364,8.364,0,0,0-9.992,1.308,3.987,3.987,0,0,1-2.7-1.068,8.335,8.335,0,0,1-4.964,3.136,6.063,6.063,0,0,1-1.1.1l-3.381.019.022,1.248a12.458,12.458,0,0,1,11.795,12.653v1.516c.019.019-1.439.01-1.449,0v-1.516a11.312,11.312,0,0,0-11.3-11.3.546.546,0,0,1-.546-.544v-2.976a.541.541,0,0,1,.16-.383.547.547,0,0,1,.386-.161l4.234,0c.034,0,.079-.01.115-.011a5.229,5.229,0,0,0,.808-.082,6.938,6.938,0,0,0,4.513-2.587Z","fill":"#1a1818"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_02_03_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f82f32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_02_03_vue__ = __webpack_require__(435);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_02_03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f82f32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_02_03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_72","data-name":"Group 72","transform":"translate(-34.26 -279.299)"}},[_c('circle',{attrs:{"id":"Ellipse_33","data-name":"Ellipse 33","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(34.26 279.299)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_157","data-name":"Path 157","d":"M87,304.756A19.232,19.232,0,0,0,78.761,293.5l.973-1.67-1.683-.981-3.6,6.173A14.134,14.134,0,0,0,60.267,321.36l-3.861,6.626,1.683.981,1.185-2.034a19.269,19.269,0,0,0,8.024,2.206v2.1l-5.8.968v4.7H75.059v-4.7l-5.814-.969v-2.1a19.47,19.47,0,0,0,4.044-.635A19.385,19.385,0,0,0,87,304.756Zm-25.109.177h12.97v3.328H61.889Zm0,6.335h12.97V314.6H61.889Zm21.486,7.225a17.4,17.4,0,0,1-23.114,6.746l1.681-2.883a14.126,14.126,0,0,0,14.205-24.375l1.633-2.8a17.4,17.4,0,0,1,5.6,23.314Z","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_03_01_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca95144_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_03_01_vue__ = __webpack_require__(437);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_03_01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca95144_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_03_01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_164","data-name":"Group 164","transform":"translate(-315.885 -1130.68)"}},[_c('g',{attrs:{"id":"Group_322","data-name":"Group 322"}},[_c('circle',{attrs:{"id":"Ellipse_116","data-name":"Ellipse 116","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.885 1130.68)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_163","data-name":"Group 163"}},[_c('g',{attrs:{"id":"Group_150","data-name":"Group 150"}},[_c('circle',{attrs:{"id":"Ellipse_117","data-name":"Ellipse 117","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(363.868 1175.156)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_151","data-name":"Group 151"}},[_c('path',{attrs:{"id":"Path_263","data-name":"Path 263","d":"M368.525,1179.936h-1a16.473,16.473,0,1,0-32.945,0h-1a17.473,17.473,0,1,1,34.945,0Z","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_152","data-name":"Group 152"}},[_c('path',{attrs:{"id":"Path_264","data-name":"Path 264","d":"M379.21,1173.464h-1a27.157,27.157,0,0,0-54.314,0h-1a28.157,28.157,0,0,1,56.314,0Z","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_153","data-name":"Group 153"}},[_c('circle',{attrs:{"id":"Ellipse_118","data-name":"Ellipse 118","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(346.988 1158.818)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_154","data-name":"Group 154"}},[_c('circle',{attrs:{"id":"Ellipse_119","data-name":"Ellipse 119","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(341.786 1142.611)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_155","data-name":"Group 155"}},[_c('circle',{attrs:{"id":"Ellipse_120","data-name":"Ellipse 120","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(328.276 1149.45)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_156","data-name":"Group 156"}},[_c('circle',{attrs:{"id":"Ellipse_121","data-name":"Ellipse 121","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(330.174 1175.156)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_157","data-name":"Group 157"}},[_c('circle',{attrs:{"id":"Ellipse_122","data-name":"Ellipse 122","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(358.686 1163.775)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_158","data-name":"Group 158"}},[_c('circle',{attrs:{"id":"Ellipse_123","data-name":"Ellipse 123","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(353.075 1142.611)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_159","data-name":"Group 159"}},[_c('circle',{attrs:{"id":"Ellipse_124","data-name":"Ellipse 124","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(366.697 1149.45)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_160","data-name":"Group 160"}},[_c('circle',{attrs:{"id":"Ellipse_125","data-name":"Ellipse 125","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(322.043 1158.818)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_161","data-name":"Group 161"}},[_c('circle',{attrs:{"id":"Ellipse_126","data-name":"Ellipse 126","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(371.999 1158.897)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_162","data-name":"Group 162"}},[_c('circle',{attrs:{"id":"Ellipse_127","data-name":"Ellipse 127","cx":"4.065","cy":"4.065","r":"4.065","transform":"translate(335.289 1163.775)","fill":"#1a1818"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_03_02_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ea7da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_03_02_vue__ = __webpack_require__(439);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_03_02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ea7da6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_03_02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_323","data-name":"Group 323","transform":"translate(-595.143 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_84","data-name":"Ellipse 84","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(595.143 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_146","data-name":"Group 146","transform":"translate(0 -850.394)"}},[_c('rect',{attrs:{"id":"Rectangle_103","data-name":"Rectangle 103","width":"9.32","height":"11.73","transform":"matrix(0.867, 0.498, -0.498, 0.867, 624.325, 1149.552)","fill":"#1a1818"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_41","data-name":"Line 41","x2":"12.198","y2":"7.009","transform":"translate(614.61 1161.692)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_42","data-name":"Line 42","x2":"12.198","y2":"7.009","transform":"translate(624.07 1145.23)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_43","data-name":"Line 43","x2":"23.921","y2":"13.746","transform":"translate(631.466 1160.172)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_44","data-name":"Line 44","x2":"25.627","transform":"translate(605.839 1179.565)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_45","data-name":"Line 45","x2":"21.279","transform":"translate(608.013 1174.696)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_03_03_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564979fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_03_03_vue__ = __webpack_require__(441);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_03_03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_564979fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_03_03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_324","data-name":"Group 324","transform":"translate(-35.341 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_65","data-name":"Ellipse 65","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(35.341 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_143","data-name":"Path 143","d":"M1189.745,1146.2h32.376v35.373a3,3,0,0,1-3,3h-31.176l-.216-.006a4.256,4.256,0,0,1-3.981-4.191V1152.8h5.995Zm0,8.993h-3.6v25.752a.71.71,0,0,0,.206.509c1.549,1.495,3.391.422,3.391-1.08Zm13.19,22.183h-7.194a1.2,1.2,0,1,0,0,2.4h7.194a1.2,1.2,0,1,0,0-2.4Zm13.191-5.4h-8.394v7.794h9.593v-6.595a1.2,1.2,0,0,0-1.2-1.2Zm-13.191.6h-7.194a1.2,1.2,0,0,0,0,2.4h7.194a1.2,1.2,0,1,0,0-2.4Zm13.191-6h-20.385a1.2,1.2,0,1,0,0,2.4h20.385a1.2,1.2,0,1,0,0-2.4Zm-21.584-16.188v13.19h11.991V1150.4h-11.991Zm21.584,10.193h-4.8a1.2,1.2,0,0,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4Zm0-4.8h-4.8a1.2,1.2,0,0,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4Zm0-4.8h-4.8a1.2,1.2,0,1,0,0,2.4h4.8a1.2,1.2,0,0,0,0-2.4Zm0,0","transform":"translate(-1133.858 -850.394)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_04_01_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb011a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_04_01_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_04_01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb011a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_04_01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_325","data-name":"Group 325","transform":"translate(-594.988 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_70","data-name":"Ellipse 70","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.988 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_78","data-name":"Group 78","transform":"translate(-1133.858 -850.394)"}},[_c('path',{attrs:{"id":"Path_177","data-name":"Path 177","d":"M1765.672,1176.5c-5.7,0-10.32-1.484-10.32-3.583v3.049c0,2.1,4.621,3.8,10.32,3.8s10.32-1.7,10.32-3.8v-3.049C1775.992,1175.018,1771.372,1176.5,1765.672,1176.5Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_178","data-name":"Path 178","d":"M1765.672,1182.246c-5.7,0-10.32-1.484-10.32-3.583v3.049c0,2.1,4.621,3.8,10.32,3.8s10.32-1.7,10.32-3.8v-3.049C1775.992,1180.762,1771.372,1182.246,1765.672,1182.246Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_179","data-name":"Path 179","d":"M1765.672,1187.99c-5.7,0-10.32-1.484-10.32-3.583v3.049c0,2.1,4.621,3.8,10.32,3.8s10.32-1.7,10.32-3.8v-3.049C1775.992,1186.506,1771.372,1187.99,1765.672,1187.99Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_180","data-name":"Path 180","d":"M1765.672,1174.046c5.7,0,10.32-1.7,10.32-3.8s-4.62-3.8-10.32-3.8-10.32,1.7-10.32,3.8S1759.973,1174.046,1765.672,1174.046Z","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_79","data-name":"Group 79","transform":"translate(-1133.858 -850.394)"}},[_c('path',{attrs:{"id":"Path_181","data-name":"Path 181","d":"M1754.393,1169.285c-5.7,0-10.319-1.484-10.319-3.583v3.049c0,2.1,4.621,3.8,10.319,3.8h0v-3.268Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_182","data-name":"Path 182","d":"M1754.393,1166.5c5.7,0,10.32-1.7,10.32-3.8v-3.049c0,2.1-4.62,3.583-10.32,3.583s-10.319-1.484-10.319-3.583v3.049C1744.074,1164.8,1748.695,1166.5,1754.393,1166.5Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_183","data-name":"Path 183","d":"M1754.393,1175.029c-5.7,0-10.319-1.484-10.319-3.583v3.049c0,2.1,4.621,3.8,10.319,3.8h0v-3.268Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_184","data-name":"Path 184","d":"M1754.393,1180.773c-5.7,0-10.319-1.484-10.319-3.583v3.049c0,2.1,4.621,3.8,10.319,3.8h0v-3.268Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_185","data-name":"Path 185","d":"M1754.393,1160.476c5.7,0,10.32-1.7,10.32-3.8s-4.62-3.8-10.32-3.8-10.319,1.7-10.319,3.8S1748.695,1160.476,1754.393,1160.476Z","fill":"#1a1818"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_186","data-name":"Path 186","d":"M1771.176,1141.881a11.049,11.049,0,1,0,11.048,11.048A11.048,11.048,0,0,0,1771.176,1141.881Zm6.485,15.773-1.761,1.761-4.724-4.724-4.724,4.724-1.761-1.761,4.724-4.725-4.724-4.724,1.761-1.761,4.724,4.724,4.724-4.724,1.761,1.761-4.724,4.724Z","transform":"translate(-1133.858 -850.394)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_04_02_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b1abea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_04_02_vue__ = __webpack_require__(445);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_04_02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b1abea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_04_02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_326","data-name":"Group 326","transform":"translate(-35.342 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_50","data-name":"Ellipse 50","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(35.342 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_84","data-name":"Path 84","d":"M2362.176,1171.164a13.288,13.288,0,1,1-13.288-13.289,13.29,13.29,0,0,1,13.288,13.289","transform":"translate(-2267.717 -850.394)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_85","data-name":"Path 85","d":"M2340.751,1171.3l5.781,5.781,10.492-10.492","transform":"translate(-2267.717 -850.394)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_86","data-name":"Path 86","d":"M2334.153,1164.025l-4.757-4.939-5.9,5.68-2.082-2.16,5.9-5.681-5.68-5.9,2.16-2.08,5.68,5.9,5.9-5.679,2.082,2.16-5.9,5.68,4.209,4.371a16.422,16.422,0,0,1,6.9-5.371,13.278,13.278,0,1,0-13.232,14.249,13.12,13.12,0,0,0,3.129-.393A16.247,16.247,0,0,1,2334.153,1164.025Z","transform":"translate(-2267.717 -850.394)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_a_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b86edc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_a_vue__ = __webpack_require__(447);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_a_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b86edc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_a_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_73","data-name":"Group 73","transform":"translate(-315.73 -280.287)"}},[_c('circle',{attrs:{"id":"Ellipse_26","data-name":"Ellipse 26","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.73 280.287)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_35","data-name":"Group 35"}},[_c('g',{attrs:{"id":"Group_33","data-name":"Group 33"}},[_c('path',{attrs:{"id":"Path_115","data-name":"Path 115","d":"M366.868,303.7h0s-4.082,2.95-5.054,3.57c-2.4,1.527-7.861,1.973-10.234,2.131a1.58,1.58,0,0,0-1.354,1.557v.077a1.581,1.581,0,0,0,1.354,1.558c.708.047,1.669.126,2.761.25,0,.715-.18,5.5-.18,5.5-.424-.165-1.823-.708-2.252-.87-.787-.3-6.243-2.09-8.967-2.756a7.092,7.092,0,0,0,.771-.454c.1-.065.192-.139.289-.209.164-.123.32-.253.471-.389a7.4,7.4,0,1,0-10.513-.963c.076.1.154.193.235.286.155.172.31.339.48.5a7.169,7.169,0,0,0,.685.565c.1.071.189.145.289.211a7.25,7.25,0,0,0,.781.458c-5.148,2.99-4.779,6.5-4.779,16.784h20.611a27.3,27.3,0,0,0-1.169-8.42c1.546.489,3.111,1.009,4.649,1.533l.167.057a2.526,2.526,0,0,0,.9.132,2.568,2.568,0,0,0,2.485-2.65l-.275-8.5a8.806,8.806,0,0,1,2.793,1.069c.606.434,5.054,3.545,5.054,3.545Z","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_34","data-name":"Group 34"}},[_c('path',{attrs:{"id":"Path_116","data-name":"Path 116","d":"M373.544,318.052l-.7-.485a11.366,11.366,0,0,0-.183-13.208l.687-.5a12.137,12.137,0,0,1,1.843,10.79A12.333,12.333,0,0,1,373.544,318.052Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_117","data-name":"Path 117","d":"M371.624,316.674l-.7-.482a9.026,9.026,0,0,0-.178-10.449l.687-.5a9.866,9.866,0,0,1,.191,11.435Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_118","data-name":"Path 118","d":"M369.706,315.294l-.706-.477a6.656,6.656,0,0,0-.167-7.694l.684-.5a7.45,7.45,0,0,1,1.152,6.654A7.57,7.57,0,0,1,369.706,315.294Z","fill":"#1a1818"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_b_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a492f74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_b_vue__ = __webpack_require__(449);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_b_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a492f74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_b_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_74","data-name":"Group 74","transform":"translate(-594.988 -280.287)"}},[_c('circle',{attrs:{"id":"Ellipse_25","data-name":"Ellipse 25","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.988 280.287)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_56","data-name":"Group 56"}},[_c('path',{attrs:{"id":"Path_139","data-name":"Path 139","d":"M637.42,329.429l0-.021q-.051-.473-.124-.914l-.006-.037a11.481,11.481,0,0,0-.887-2.99c2.453-4.7,2.263-10.232,2.319-11.8a1.988,1.988,0,0,0-.25-1.166.475.475,0,0,0-.725-.1V297.456H622.552v14.873a.454.454,0,0,0-.576.171,1.988,1.988,0,0,0-.25,1.166c.056,1.569-.134,7.1,2.318,11.8a11.519,11.519,0,0,0-.887,2.99l-.006.037q-.072.441-.123.914l0,.021a19.68,19.68,0,0,0-.108,2.082l0,0v.013h14.6v-.013l0,0A19.96,19.96,0,0,0,637.42,329.429Zm-3.625-7.813a5,5,0,0,1-1.67.16,4.205,4.205,0,0,0,.448-.268,1.144,1.144,0,0,0,.136-.1l.022-.016.006-.005,0,0c.039-.028.072-.061.109-.089l.017-.012c.047-.038.092-.077.139-.114s.092-.07.134-.109c.1-.094.193-.187.28-.286.05-.057.093-.113.137-.168.018-.023.031-.049.048-.072a4.159,4.159,0,0,0,.3-.438c.043-.071.079-.145.118-.219.055-.105.1-.212.152-.322s.08-.192.114-.292a4.347,4.347,0,0,0,.122-.441c.022-.1.036-.2.051-.3a3.93,3.93,0,0,0,.039-.395,1.4,1.4,0,0,0,.017-.184,4.041,4.041,0,0,0-.082-.8c-.016-.089-.04-.174-.062-.261s-.031-.156-.055-.23-.057-.143-.083-.215c-.036-.1-.07-.194-.112-.287a4.271,4.271,0,0,0-.3-.549c-.056-.087-.12-.166-.182-.249a4.111,4.111,0,0,0-.292-.354c-.075-.081-.153-.156-.234-.23-.1-.093-.208-.179-.318-.262-.085-.065-.166-.132-.256-.19a4.3,4.3,0,0,0-.575-.311c-.1-.045-.2-.076-.3-.113a4.137,4.137,0,0,0-.4-.124c-.11-.028-.221-.052-.335-.071-.042-.007-.082-.021-.124-.026s-.085-.016-.129-.02c-.095-.01-.191-.013-.287-.017-.044,0-.087-.007-.131-.007h-.079c-.044,0-.087.005-.13.007-.1,0-.193.007-.287.017-.044,0-.086.014-.129.02s-.083.019-.125.026c-.114.019-.224.043-.335.071a4.123,4.123,0,0,0-.4.124c-.1.037-.206.068-.3.113a4.36,4.36,0,0,0-.575.311c-.089.058-.17.125-.255.189-.11.084-.217.17-.319.263-.08.074-.158.149-.233.229a4.531,4.531,0,0,0-.293.355c-.062.083-.126.163-.182.249a4.273,4.273,0,0,0-.3.549c-.043.093-.076.19-.112.287-.027.072-.061.141-.083.215s-.035.154-.055.23-.046.172-.062.261a4.111,4.111,0,0,0-.083.8,1.588,1.588,0,0,0,.018.184,3.9,3.9,0,0,0,.039.395c.014.1.029.2.051.3a4.343,4.343,0,0,0,.121.441c.034.1.074.2.115.292s.1.217.151.322c.039.074.076.148.119.219a4.3,4.3,0,0,0,.3.438c.018.023.031.049.049.072.044.055.087.111.137.168.087.1.181.192.28.286.042.039.091.072.134.109s.092.076.138.114l.017.012c.038.028.07.061.11.089l0,0,.005.005.023.016a1.07,1.07,0,0,0,.136.1,4.11,4.11,0,0,0,.448.268,5.007,5.007,0,0,1-1.671-.16,2.4,2.4,0,0,1-1.258-.979,16.166,16.166,0,0,1-2.306-6.683h1.028v-5.709h12.069v5.709h1.177a16.168,16.168,0,0,1-2.307,6.683A2.4,2.4,0,0,1,633.795,321.616Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_140","data-name":"Path 140","d":"M653.431,316.6l1.519-.961-4.342-6.866,4.07-2.574-3.9-6.173-9.659,6.109,3.9,6.173,4.07-2.574,2.4,3.79c-.484,2.662-.777,4.59-2.385,7.106a2.4,2.4,0,0,1-1.26.98,4.959,4.959,0,0,1-1.672.16,3.956,3.956,0,0,0,.448-.268,1.508,1.508,0,0,0,.169-.125,3.481,3.481,0,0,0,.4-.324,3.983,3.983,0,0,0,.28-.287c.05-.056.094-.112.137-.168a4.235,4.235,0,0,0,.966-2.663,4.347,4.347,0,0,0-4.264-4.318,4.281,4.281,0,0,0-2.81,7.542c.087.075.181.15.274.225.056.037.112.081.169.118a3.956,3.956,0,0,0,.448.268,6.285,6.285,0,0,0-3.931,3.042,15.466,15.466,0,0,1,1.074,3.719l.008.05c.065.39.119.792.164,1.209l0,.028c.056.542.091,1.114.115,1.7h11.761a14.263,14.263,0,0,0-1.128-6.052,23.734,23.734,0,0,0,2.28-9.973Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_141","data-name":"Path 141","d":"M617.992,321.772a3.969,3.969,0,0,0,.449-.268c.056-.037.112-.081.168-.118.094-.075.187-.15.274-.225a4.28,4.28,0,0,0-2.809-7.542,4.348,4.348,0,0,0-4.265,4.318,4.24,4.24,0,0,0,.966,2.663c.044.056.087.112.137.168a4,4,0,0,0,.281.287,3.32,3.32,0,0,0,.4.324,1.591,1.591,0,0,0,.168.125,3.969,3.969,0,0,0,.449.268,4.968,4.968,0,0,1-1.673-.16,2.406,2.406,0,0,1-1.26-.98c-1.607-2.516-1.9-4.444-2.385-7.106l2.4-3.79,4.071,2.574,3.9-6.173-9.66-6.109-3.9,6.173,4.071,2.574-4.343,6.866,1.519.961.7-1.107a23.734,23.734,0,0,0,2.281,9.973,14.263,14.263,0,0,0-1.128,6.052h11.749c.023-.586.058-1.158.115-1.7l0-.028c.044-.417.1-.819.163-1.209l.008-.05a15.443,15.443,0,0,1,1.08-3.732A6.283,6.283,0,0,0,617.992,321.772Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_c_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cffbc27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_c_vue__ = __webpack_require__(451);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_c_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cffbc27_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_c_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_76","data-name":"Group 76","transform":"translate(-315.73 -280.287)"}},[_c('circle',{attrs:{"id":"Ellipse_6","data-name":"Ellipse 6","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.73 280.287)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_5","data-name":"Group 5","transform":"translate(-1133.858)"}},[_c('path',{attrs:{"id":"Path_9","data-name":"Path 9","d":"M1495.546,324.158a3.291,3.291,0,0,1-.674-2v-5.25a37.248,37.248,0,0,0-2.487-13.415l-4.681-12.138a1.143,1.143,0,0,0-.622-.647,1.121,1.121,0,0,0-.882,0,1.168,1.168,0,0,0-.7,1.2l-.011,12.749a2.6,2.6,0,0,1,3.491-.237,3.354,3.354,0,0,1,1.129,2.735l.18,10.45h-1.243l-.227-10.467a1.853,1.853,0,0,0-.964-1.679,1.7,1.7,0,0,0-1.84.339c-.411.529-.517,1.4-.515,3.337l-.006,15.9a11.394,11.394,0,0,0,2.225,6.752l7.917,7.717,6.889-5.38Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_10","data-name":"Path 10","d":"M1474.034,324.158a3.292,3.292,0,0,0,.675-2v-5.25a37.271,37.271,0,0,1,2.486-13.415l4.682-12.138a1.139,1.139,0,0,1,.621-.647,1.123,1.123,0,0,1,.883,0,1.167,1.167,0,0,1,.7,1.2l.012,12.749a2.6,2.6,0,0,0-3.491-.237,3.355,3.355,0,0,0-1.13,2.735l-.18,10.45h1.243l.227-10.467a1.852,1.852,0,0,1,.965-1.679,1.7,1.7,0,0,1,1.839.339c.411.529.518,1.4.515,3.337l.007,15.9a11.405,11.405,0,0,1-2.225,6.752l-7.918,7.717-6.888-5.38Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_d_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b39c9af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_d_vue__ = __webpack_require__(453);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_d_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b39c9af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_d_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_75","data-name":"Group 75","transform":"translate(-34.26 -279.299)"}},[_c('circle',{attrs:{"id":"Ellipse_12","data-name":"Ellipse 12","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(34.26 279.299)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_18","data-name":"Group 18","transform":"translate(-1133.858)"}},[_c('g',{attrs:{"id":"Group_17","data-name":"Group 17"}},[_c('path',{attrs:{"id":"Path_21","data-name":"Path 21","d":"M1225.144,308.556l-1.414,1.414,3.568,3.568h-10.407v1.435a13.582,13.582,0,0,1-.508,3.255l1.921.551a15.514,15.514,0,0,0,.568-3.241h8.352l-3.494,3.494,1.414,1.414,5.946-5.945Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_22","data-name":"Path 22","d":"M1189.733,315.538v-1.214a13.624,13.624,0,0,1,.515-3.594l-1.924-.549a15.594,15.594,0,0,0-.564,3.357h-8.421l3.568-3.568-1.414-1.414-5.945,5.945,5.945,5.945,1.414-1.414-3.494-3.494Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_23","data-name":"Path 23","d":"M1202.356,290.62v8.293a15.683,15.683,0,0,0-2.551.36l.45,1.949a13.824,13.824,0,0,1,2.538-.33h1.139c.035,0,.072,0,.107,0v0h.317v-10.2l3.493,3.494,1.414-1.414-5.944-5.945-5.945,5.945,1.414,1.414Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_24","data-name":"Path 24","d":"M1193.162,305.435l-1.494-1.33a15.613,15.613,0,0,0-2.414,3.626l1.8.865A13.609,13.609,0,0,1,1193.162,305.435Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_25","data-name":"Path 25","d":"M1206.74,299.252l-.438,1.951a13.5,13.5,0,0,1,3.552,1.343l.963-1.752A15.471,15.471,0,0,0,1206.74,299.252Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M1198.083,301.921l-.772-1.846a15.608,15.608,0,0,0-3.744,2.226l1.252,1.56A13.564,13.564,0,0,1,1198.083,301.921Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_27","data-name":"Path 27","d":"M1216.711,312.135l1.97-.34a15.514,15.514,0,0,0-1.338-4.148l-1.8.875A13.524,13.524,0,0,1,1216.711,312.135Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_28","data-name":"Path 28","d":"M1200.308,327.721a13.5,13.5,0,0,1-3.549-1.35l-.966,1.752a15.581,15.581,0,0,0,4.074,1.55Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_29","data-name":"Path 29","d":"M1216,305.4a15.679,15.679,0,0,0-3-3.154l-1.242,1.566a13.666,13.666,0,0,1,2.619,2.752Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_30","data-name":"Path 30","d":"M1189.923,316.77l-1.971.336a15.425,15.425,0,0,0,1.33,4.151l1.8-.873A13.475,13.475,0,0,1,1189.923,316.77Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_31","data-name":"Path 31","d":"M1208.53,327.021l.768,1.848a15.632,15.632,0,0,0,3.749-2.219l-1.25-1.562A13.524,13.524,0,0,1,1208.53,327.021Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_32","data-name":"Path 32","d":"M1213.456,323.517l1.492,1.332a15.6,15.6,0,0,0,2.421-3.621l-1.8-.869A13.629,13.629,0,0,1,1213.456,323.517Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_33","data-name":"Path 33","d":"M1192.245,322.346l-1.629,1.163a15.656,15.656,0,0,0,3,3.16l1.246-1.565A13.628,13.628,0,0,1,1192.245,322.346Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_34","data-name":"Path 34","d":"M1204.356,338.308V330a15.522,15.522,0,0,0,2.445-.332l-.446-1.949a13.607,13.607,0,0,1-2.465.307h-1.534v10.358l-3.568-3.569-1.414,1.414,5.945,5.946,5.944-5.946-1.414-1.414Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_35","data-name":"Path 35","d":"M1196.739,321.949H1209.9c0-5.378-2.068-8.054-4.876-8.78a3.767,3.767,0,0,0,.4-.238c.053-.034.1-.073.151-.11.086-.064.168-.132.247-.2a3.871,3.871,0,1,0-5.5-.5q.06.076.123.15c.081.09.162.177.251.259a3.756,3.756,0,0,0,.358.3c.051.037.1.076.152.11a3.964,3.964,0,0,0,.408.24C1198.808,313.895,1196.74,316.571,1196.739,321.949Z"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_e_vue__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_354d731a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_e_vue__ = __webpack_require__(455);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_02_e_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_354d731a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_02_e_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_77","data-name":"Group 77","transform":"translate(-594.988 -280.287)"}},[_c('circle',{attrs:{"id":"Ellipse_1","data-name":"Ellipse 1","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.988 280.287)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_1","data-name":"Group 1","transform":"translate(-1133.858)"}},[_c('path',{attrs:{"id":"Path_1","data-name":"Path 1","d":"M1773.949,297.522a46.951,46.951,0,0,1-9.9-4.471,46.917,46.917,0,0,1-9.9,4.471,55.057,55.057,0,0,1-9.382,1.625V317.2c0,17.223,19.282,23.077,19.282,23.077s19.282-5.854,19.282-23.077V299.147A55.038,55.038,0,0,1,1773.949,297.522Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2","data-name":"Path 2","d":"M1766.143,314.036a4.336,4.336,0,0,0,.5-.294c.065-.042.124-.09.187-.135.106-.08.207-.164.305-.252a4.786,4.786,0,1,0-6.8-.623c.05.063.1.125.152.185.1.112.2.22.31.321a4.849,4.849,0,0,0,.443.366c.063.045.123.094.188.136a4.546,4.546,0,0,0,.505.3c-3.472.9-6.029,4.206-6.029,10.854h16.267C1772.172,318.242,1769.615,314.934,1766.143,314.036Z","fill":"#fff"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_03_a_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fe210a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_03_a_vue__ = __webpack_require__(457);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_03_a_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59fe210a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_03_a_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_319","data-name":"Group 319","transform":"translate(-35.342 -280.254)"}},[_c('circle',{attrs:{"id":"Ellipse_178","data-name":"Ellipse 178","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(35.342 280.254)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_277","data-name":"Path 277","d":"M3495.356,316.813h-21.027l-.288-1.119h0a2.113,2.113,0,0,0-2.088-1.591h-.02a2.111,2.111,0,0,0-2.079,1.624l-.26,1.086h-20.715v2.319h20.159l-3.776,15.758h-4.521v2.319h22.109V334.89h-3.87l-4.054-15.758h20.43Zm-23.561-.542h0Zm4.194,16.3H3468.2l3.22-13.439h1.108Z","transform":"translate(-3401.575)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_278","data-name":"Path 278","d":"M3457.557,305.877a3.9,3.9,0,0,0,.435-.256c.056-.037.108-.078.162-.118.092-.069.18-.142.265-.218a4.162,4.162,0,1,0-5.913-.542c.043.055.087.109.133.161.087.1.174.191.269.279a4.339,4.339,0,0,0,.385.318c.055.039.107.081.164.118a3.985,3.985,0,0,0,.439.258c-2.9,1.681-2.688,3.657-2.688,9.44H3462.8C3462.8,309.535,3460.576,306.658,3457.557,305.877Z","transform":"translate(-3401.575)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_279","data-name":"Path 279","d":"M3486.679,305.877a3.834,3.834,0,0,1-.435-.256c-.057-.037-.108-.078-.163-.118-.092-.069-.18-.142-.265-.218a4.162,4.162,0,1,1,5.913-.542c-.043.055-.087.109-.132.161-.087.1-.175.191-.27.279a4.17,4.17,0,0,1-.385.318c-.055.039-.107.081-.163.118a4.045,4.045,0,0,1-.44.258c2.9,1.681,2.688,3.657,2.689,9.44h-11.593C3481.435,309.535,3483.659,306.658,3486.679,305.877Z","transform":"translate(-3401.575)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_03_b_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cedd7bac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_03_b_vue__ = __webpack_require__(459);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_03_b_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cedd7bac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_03_b_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_248","data-name":"Group 248","transform":"translate(-3996.564 -280.254)"}},[_c('circle',{attrs:{"id":"Ellipse_187","data-name":"Ellipse 187","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(3996.564 280.254)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_247","data-name":"Group 247"}},[_c('g',{attrs:{"id":"Group_246","data-name":"Group 246"}},[_c('path',{attrs:{"id":"Path_304","data-name":"Path 304","d":"M4026.1,312.838a3.443,3.443,0,1,0,0-6.886h0a3.438,3.438,0,0,0-3.438,3.438v0A3.442,3.442,0,0,0,4026.1,312.838Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_305","data-name":"Path 305","d":"M4034.85,323.212a1.659,1.659,0,0,0-.544-2.283l-3.931-2.417a1.66,1.66,0,0,0-1.384-.164l-1.958.638.6-2.91,4.531,1a1.7,1.7,0,0,0,.359.039,1.66,1.66,0,0,0,.357-3.281l-7.469-1.65a1.639,1.639,0,0,0-.607-.019,3.079,3.079,0,0,0-3.165,2.453l-1.058,5.135a3.085,3.085,0,0,0,3.022,3.7c.1,0,.208-.007.31-.017a1.666,1.666,0,0,0,.184-.025,3.087,3.087,0,0,0,.793-.242l4.4-1.434,3.277,2.015a1.659,1.659,0,0,0,2.283-.545Z","fill":"#1a1818"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_306","data-name":"Path 306","d":"M4055.448,310.688c0-.165,0-.329,0-.494-.007-.289-.025-.577-.051-.865-.017-.2-.032-.408-.06-.611-.03-.222-.077-.441-.119-.661a12.62,12.62,0,0,0-.444-1.712c-.018-.05-.029-.1-.047-.151-.115-.324-.252-.64-.394-.956-.043-.094-.083-.188-.128-.281-.152-.315-.317-.623-.5-.928-.045-.076-.094-.151-.141-.227a12.37,12.37,0,0,0-1.446-1.934,13.523,13.523,0,0,0-19.279-.456l-1.079.986-1.075-.986a13.524,13.524,0,0,0-19.28.456,12.4,12.4,0,0,0-1.446,1.934c-.047.076-.1.151-.141.228-.179.3-.346.612-.5.926-.045.094-.087.189-.129.284-.142.315-.279.63-.393.954-.019.051-.031.1-.048.154a12.706,12.706,0,0,0-.444,1.705c-.042.221-.088.442-.119.665-.027.2-.042.407-.06.611-.026.288-.044.576-.05.865,0,.165-.005.33,0,.5,0,.367.028.734.065,1.1.01.094.014.188.026.282a13.514,13.514,0,0,0,3.969,8.027l16.371,15.125-.007.015,3.248,3,.011-.011.013.011,3.248-3-.008-.015,16.37-15.125a13.517,13.517,0,0,0,3.971-8.028c.011-.093.016-.187.026-.28C4055.42,311.424,4055.443,311.057,4055.448,310.688Z","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_134","data-name":"Rectangle 134","width":"5.058","height":"5.058","transform":"translate(4037.922 317.686)","fill":"#1a1818"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_135","data-name":"Rectangle 135","width":"5.058","height":"5.058","transform":"translate(4039.91 312.627)","fill":"#1a1818"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_136","data-name":"Rectangle 136","width":"5.058","height":"5.058","transform":"translate(4036.252 307.563)","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_03_c_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b8dad55_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_03_c_vue__ = __webpack_require__(461);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SC_02_03_c_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b8dad55_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SC_02_03_c_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_227","data-name":"Group 227","transform":"translate(-3717.306 -280.254)"}},[_c('g',{attrs:{"id":"Group_320","data-name":"Group 320"}},[_c('circle',{attrs:{"id":"Ellipse_174","data-name":"Ellipse 174","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(3717.306 280.254)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_226","data-name":"Group 226"}},[_c('circle',{attrs:{"id":"Ellipse_175","data-name":"Ellipse 175","cx":"13.039","cy":"13.039","r":"13.039","transform":"translate(3737.719 302.065)","fill":"#1a1818"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_84","data-name":"Line 84","y2":"11.694","transform":"translate(3750.759 328.032)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_85","data-name":"Line 85","x2":"11.694","transform":"translate(3744.912 333.879)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_225","data-name":"Group 225"}},[_c('line',{attrs:{"id":"Line_86","data-name":"Line 86","x2":"11.694","transform":"translate(3744.912 312.249)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_87","data-name":"Line 87","x2":"11.694","transform":"translate(3744.912 317.961)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}})]),_vm._v(" "),_c('line',{attrs:{"id":"Line_88","data-name":"Line 88","x1":"8.269","y2":"8.269","transform":"translate(3759.671 297.669)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_275","data-name":"Path 275","d":"M3760.773,296.985h7.8v7.8","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_01_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb412c5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_01_vue__ = __webpack_require__(463);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_01_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb412c5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_01_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_328","data-name":"Group 328","transform":"translate(-594.989 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_57","data-name":"Ellipse 57","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.989 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_56","data-name":"Group 56","transform":"translate(-2267.717 -850.394)"}},[_c('g',{attrs:{"id":"Group_55","data-name":"Group 55"}},[_c('path',{attrs:{"id":"Path_129","data-name":"Path 129","d":"M2889.578,1182.363a17.338,17.338,0,0,1,1.373-7.36c-2.987-5.724-2.756-12.461-2.824-14.371a2.437,2.437,0,0,1,.3-1.421.582.582,0,0,1,1.064.206c.73,3.817.933,6.317,3.1,9.7a2.92,2.92,0,0,0,1.532,1.192,6.053,6.053,0,0,0,2.034.194,4.757,4.757,0,0,1-.545-.326,1.964,1.964,0,0,1-.205-.151,4.006,4.006,0,0,1-.485-.394,4.846,4.846,0,0,1-.341-.349c-.061-.068-.114-.136-.167-.2a5.156,5.156,0,0,1-1.175-3.239,5.287,5.287,0,0,1,5.186-5.251,5.207,5.207,0,0,1,3.418,9.173c-.106.091-.22.182-.334.272-.068.046-.136.1-.2.144a4.834,4.834,0,0,1-.546.326c3.79.978,6.58,4.594,6.58,11.856Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_130","data-name":"Path 130","d":"M2888.929,1175.661a5.559,5.559,0,0,0-3.087-2.062,3.786,3.786,0,0,0,.4-.238c.052-.034.1-.073.151-.109.085-.065.167-.132.246-.2a3.908,3.908,0,0,0,1.13-1.627,30.557,30.557,0,0,1-.85-3.96,3.848,3.848,0,0,0-5.77,5.084c.04.05.08.1.123.149.081.09.162.177.25.259a3.9,3.9,0,0,0,.358.3c.051.037.1.076.151.11a3.866,3.866,0,0,0,.408.24c-2.8.724-4.868,3.4-4.868,8.764h10.35A20.607,20.607,0,0,1,2888.929,1175.661Z","fill":"#1a1818"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_57","data-name":"Rectangle 57","width":"15.774","height":"10.081","transform":"matrix(0.845, 0.535, -0.535, 0.845, 2891.063, 1141.989)","fill":"#1a1818"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_53","data-name":"Group 53"}},[_c('rect',{attrs:{"id":"Rectangle_58","data-name":"Rectangle 58","width":"14.884","height":"2.481","transform":"translate(2885.299 1163.538) rotate(-57.686)","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_54","data-name":"Group 54"}},[_c('path',{attrs:{"id":"Path_131","data-name":"Path 131","d":"M2913.371,1173.6a3.758,3.758,0,0,0,.4-.238c.052-.034.1-.073.15-.109.086-.065.168-.132.247-.2a3.863,3.863,0,1,0-5.491-.5c.041.05.081.1.124.149.08.09.161.177.25.259a3.769,3.769,0,0,0,.358.3c.05.037.1.076.151.11a3.887,3.887,0,0,0,.408.24,5.533,5.533,0,0,0-2.282,1.2,19.482,19.482,0,0,1,1.3,7.565h9.246C2918.239,1176.994,2916.174,1174.323,2913.371,1173.6Z","fill":"#1a1818"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_02_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2d9bbc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_02_vue__ = __webpack_require__(465);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_02_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2d9bbc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_02_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_329","data-name":"Group 329","transform":"translate(-35.342 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_17","data-name":"Ellipse 17","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(35.342 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_3","data-name":"Group 3","transform":"translate(-3401.575 -850.394)"}},[_c('rect',{attrs:{"id":"Rectangle_21","data-name":"Rectangle 21","width":"36","height":"6.871","transform":"translate(3453.968 1177.742)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_9","data-name":"Path 9","d":"M3481.4,1183.016l6.816-12.7-17.18-9.337-11.858,21.849Z","fill":"#fff","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_10","data-name":"Path 10","d":"M3468.142,1169.871l-2.713-8.312-10.768-7.9,1.773-2.42,11.547,8.469,3.012,9.229Z","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_11","data-name":"Path 11","d":"M3465.429,1161.558l-3.481-2.553-1.743,1.244a3.145,3.145,0,0,0,.531,5.428l-2.07,1.477a3.146,3.146,0,1,0,3.654,5.123l1.476-1.053,3.955-2.551Z","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_12","data-name":"Path 12","d":"M3484.983,1152.906s-10.785-7.484-17.467-10.519c-5-2.272-3.581-1.742-3.581-1.742l-8.575,8.551s4.427,3.823,6.29,5.42c.838.718,5.758,4.677,5.758,4.677a1.031,1.031,0,0,1,.371.49c.122.337,3.836,10.623,4.08,11.235a2.406,2.406,0,0,0,1.223,1.153,3,3,0,0,0,4.268-3.507l-2.9-9.987c.118-.246,4.459,8.025,4.459,8.025l4.953-.46,2.61-9.185A4.055,4.055,0,0,0,3484.983,1152.906Z","fill":"#1a1818"}}),_vm._v(" "),_c('line',{attrs:{"id":"Line_6","data-name":"Line 6","x1":"4.007","y1":"11.535","transform":"translate(3475.194 1157.419)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_03_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d0fe3ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_03_vue__ = __webpack_require__(467);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_03_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d0fe3ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_03_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_330","data-name":"Group 330","transform":"translate(-315.731 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_5","data-name":"Ellipse 5","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(315.731 280.286)","fill":"#fff"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_15","data-name":"Group 15","transform":"translate(-3401.575 -850.394)"}},[_c('g',{attrs:{"id":"Group_13","data-name":"Group 13"}},[_c('path',{attrs:{"id":"Path_31","data-name":"Path 31","d":"M3772,1163.173a5.04,5.04,0,0,0,.544-.321c.071-.046.136-.1.2-.147.115-.087.225-.178.332-.274a5.21,5.21,0,1,0-7.4-.678c.054.068.108.136.166.2.108.121.218.238.337.349a5.112,5.112,0,0,0,.483.4c.068.049.133.1.2.148a4.989,4.989,0,0,0,.55.323,7.462,7.462,0,0,0-3.586,2.095,8.038,8.038,0,0,0-.637.757,9.208,9.208,0,0,0-.786,1.258c-.019.036-.035.077-.054.113a14.128,14.128,0,0,1,2.671,7.595h13.539C3778.569,1167.752,3775.785,1164.15,3772,1163.173Z","fill":"#1a1818"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_14","data-name":"Group 14"}},[_c('path',{attrs:{"id":"Path_32","data-name":"Path 32","d":"M3742.673,1170.162a25.978,25.978,0,0,1-1.9-6.16,7.617,7.617,0,0,0-2-.829,4.935,4.935,0,0,0,.545-.321c.07-.046.135-.1.2-.147.116-.087.226-.178.332-.274a5.348,5.348,0,0,0,.574-.583,58.62,58.62,0,0,1-.455-6.821c0-.144,0-.273-.007-.391a5.189,5.189,0,0,0-7.515,7.117c.055.068.109.136.166.2.109.121.219.238.338.349a5.262,5.262,0,0,0,.482.4c.069.049.133.1.2.148a5.2,5.2,0,0,0,.55.323,7.463,7.463,0,0,0-3.585,2.095,8.2,8.2,0,0,0-.638.757,9.181,9.181,0,0,0-.785,1.258,16.64,16.64,0,0,0-1.556,7.708h13.96A17.52,17.52,0,0,1,3742.673,1170.162Z","fill":"#1a1818"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_33","data-name":"Path 33","d":"M3744.529,1177.388a17.2,17.2,0,0,1,1.359-7.293c-2.959-5.671-2.786-13.881-2.854-15.774a2.4,2.4,0,0,1,.3-1.407.576.576,0,0,1,1.053.2c.724,3.782.981,7.794,3.126,11.15a2.892,2.892,0,0,0,1.518,1.181,6,6,0,0,0,2.016.193,4.975,4.975,0,0,1-.541-.323,2.2,2.2,0,0,1-.2-.15,4.157,4.157,0,0,1-.481-.391c-.12-.113-.233-.225-.338-.345-.06-.068-.112-.136-.165-.2a5.11,5.11,0,0,1-1.164-3.21,5.239,5.239,0,0,1,5.139-5.2,5.158,5.158,0,0,1,3.386,9.089c-.1.09-.218.18-.33.27-.068.045-.136.1-.2.143a4.975,4.975,0,0,1-.541.323c3.756.969,6.52,4.552,6.52,11.747Z","fill":"#1a1818"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_04_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d82302_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_04_vue__ = __webpack_require__(469);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SA_05_04_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d82302_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SA_05_04_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 70.402 70.402"}},[_c('g',{attrs:{"id":"Group_331","data-name":"Group 331","transform":"translate(-594.989 -280.286)"}},[_c('circle',{attrs:{"id":"Ellipse_11","data-name":"Ellipse 11","cx":"35.201","cy":"35.201","r":"35.201","transform":"translate(594.989 280.286)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_53","data-name":"Path 53","d":"M4051.379,1164.816a4.529,4.529,0,0,1-.51-.3c-.066-.043-.127-.092-.191-.138-.108-.081-.212-.167-.311-.257a4.885,4.885,0,1,1,6.942-.636c-.051.064-.1.128-.156.189-.1.114-.2.224-.316.328a5.161,5.161,0,0,1-.452.373c-.065.046-.125.1-.192.139a4.744,4.744,0,0,1-.516.3c3.4,1.974,3.156,4.295,3.156,11.083h-13.609C4045.224,1169.111,4047.835,1165.733,4051.379,1164.816Z","transform":"translate(-3401.575 -850.394)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_54","data-name":"Path 54","d":"M4033.66,1152.993a4.033,4.033,0,0,0,.451-.266c.059-.038.112-.081.169-.121.095-.072.186-.148.274-.227a4.311,4.311,0,1,0-6.127-.561c.045.056.09.112.138.166.09.1.18.2.279.29a4.523,4.523,0,0,0,.4.329c.057.041.11.084.169.123a4.311,4.311,0,0,0,.455.267c-3.128.809-5.432,3.789-5.433,9.781h14.659C4039.093,1156.783,4036.789,1153.8,4033.66,1152.993Z","transform":"translate(-3401.575 -850.394)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_55","data-name":"Path 55","d":"M4012.52,1164.816a4.543,4.543,0,0,0,.511-.3c.066-.043.127-.092.191-.138.108-.081.211-.167.311-.257a4.886,4.886,0,1,0-6.943-.636c.051.064.1.128.156.189.1.114.2.224.317.328a4.921,4.921,0,0,0,.452.373c.064.046.125.1.191.139a4.835,4.835,0,0,0,.516.3c-3.4,1.974-3.156,4.295-3.156,11.083h13.61C4018.676,1169.111,4016.065,1165.733,4012.52,1164.816Z","transform":"translate(-3401.575 -850.394)","fill":"#1a1818"}}),_vm._v(" "),_c('ellipse',{attrs:{"id":"Ellipse_25","data-name":"Ellipse 25","cx":"18.681","cy":"11.395","rx":"18.681","ry":"11.395","transform":"translate(611.474 309.203)","fill":"#fff"}}),_vm._v(" "),_c('ellipse',{attrs:{"id":"Ellipse_26","data-name":"Ellipse 26","cx":"14.203","cy":"7.534","rx":"14.203","ry":"7.534","transform":"translate(615.986 313.066)","fill":"none","stroke":"#1a1818","stroke-miterlimit":"10","stroke-width":"3"}}),_vm._v(" "),_c('circle',{attrs:{"id":"Ellipse_27","data-name":"Ellipse 27","cx":"8.316","cy":"8.316","r":"8.316","transform":"translate(621.873 309.207)","fill":"#fff"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_57","data-name":"Path 57","d":"M4034.232,1173.007a5.232,5.232,0,0,0,.586-.346c.076-.049.146-.1.219-.158.125-.093.243-.192.358-.3a5.611,5.611,0,1,0-7.972-.73c.058.073.116.146.178.217.117.13.235.257.364.376a5.468,5.468,0,0,0,.519.428c.074.054.144.11.22.16a5.465,5.465,0,0,0,.592.348c-4.07,1.052-7.069,4.931-7.069,12.726H4041.3C4041.3,1177.938,4038.3,1174.059,4034.232,1173.007Z","transform":"translate(-3401.575 -850.394)","fill":"#1a1818"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attribute-icon"},[(_vm.attributeKey === 'A_01')?_c('A01',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_01_01')?_c('SA0101',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_01_02')?_c('SA0102',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_01_03')?_c('SA0103',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_01_04')?_c('SA0104',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'A_02')?_c('A02',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_02_01')?_c('SA0201',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_02_02')?_c('SA0202',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_02_03')?_c('SA0203',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_02_a')?_c('SC0202a',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_02_b')?_c('SC0202b',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_02_c')?_c('SC0202c',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_02_d')?_c('SC0202d',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_02_e')?_c('SC0202e',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_03_a')?_c('SC0203a',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_03_b')?_c('SC0203b',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SC_02_03_c')?_c('SC0203c',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'A_03')?_c('A03',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_03_01')?_c('SA0301',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_03_02')?_c('SA0302',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_03_03')?_c('SA0303',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'A_04')?_c('A04',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_04_01')?_c('SA0401',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_04_02')?_c('SA0402',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'A_05')?_c('A05',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_05_01')?_c('SA0501',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_05_02')?_c('SA0502',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_05_03')?_c('SA0503',{attrs:{"size":_vm.size}}):_vm._e(),_vm._v(" "),(_vm.attributeKey === 'SA_05_04')?_c('SA0504',{attrs:{"size":_vm.size}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.sources),function(source,source_i){return (_vm.sources)?_c('sup',{key:source_i,staticClass:"cursor-pointer text-xs pl-2 pr-2 mini-source",staticStyle:{"text-decoration":"underline","padding":"0 3px"},on:{"click":function($event){$event.preventDefault();return _vm.gotoSource(source)}}},[_vm._v(_vm._s(source.source_id))]):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150",class:_vm.bgColor},[_c('AttributeIcon',{attrs:{"size":25,"attributeKey":_vm.attributeKey}}),_vm._v(" "),_c('div',{staticClass:"font-serif text-lg leading-snug"},[_vm._v(_vm._s(_vm.attributeTitle))]),_vm._v(" "),_c('div',{staticClass:"font-sans-serif text-sm"},[_vm._v(_vm._s(_vm.attributeValue))])],1),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data flex-auto w-full bg--gray-200"},_vm._l((_vm.incidentCategories(_vm.incidents)),function(category,c_key){return _c('div',{key:c_key},[_c('div',{class:{ isOpen : _vm.categoryIsOpen(category) && category !== '', isClosed : !_vm.categoryIsOpen(category) }},[(category !== '')?_c('div',[_c('span',{staticClass:"mt-0 cursor-pointer mb-10 text-bold"},[_vm._v("\n            "+_vm._s(category.title)+":\n          ")]),_vm._v(" "),_c('span',[(!_vm.categoryIsOpen(category))?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.categoryExcerpt(category, _vm.incidents))}}),_vm._v(" "),_c('MiniSourceLink',{attrs:{"sources":_vm.categoryExcerptSources(category, _vm.incidents)}})],1):_vm._e(),_vm._v(" "),(_vm.incidentsInCategory(category, _vm.incidents).length > 1 && category !== '')?_c('span',{on:{"click":function($event){return _vm.toggleCategory(category)}}},[_c('span',{staticClass:"cursor-pointer"},[_vm._v("\n                  ("),(!_vm.categoryIsOpen(category))?_c('span',{staticClass:"underline text-bold color--blue"},[_vm._v("Read More")]):_c('span',{staticClass:"underline text-bold color--blue"},[_vm._v("...")]),_vm._v(")\n                ")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.categoryIsOpen(category))?_c('ul',{staticClass:"pl-20 mt-0 mb-20"},_vm._l((_vm.incidentsInCategory(category, _vm.incidents)),function(incident){return _c('li',{key:incident.id},[_c('span',{domProps:{"innerHTML":_vm._s(incident.incident_report)}}),_c('br'),_vm._v(" "),_c('MiniSourceLink',{attrs:{"sources":incident.sources}})],1)}),0):_vm._e()])])}),0),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data bg--gray-lightest flex-none w-100 text-center"},[(_vm.$store.getters['covid19/countryAttributeType'](_vm.country.id, _vm.attributeKey) === 'watch')?_c('DevelopmentsToWatch',{staticClass:"barchart__line__icon flex-none",attrs:{"shadow":false,"size":45}}):_vm._e(),_vm._v(" "),(_vm.$store.getters['covid19/countryAttributeType'](_vm.country.id, _vm.attributeKey) === 'high')?_c('ConcerningDevelopments',{staticClass:"barchart__line__icon flex-none",attrs:{"shadow":false,"size":45}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfiletableHeader_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a10a40f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfiletableHeader_vue__ = __webpack_require__(475);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfiletableHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a10a40f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfiletableHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profiletable__row flex w-full text-bold"},[_c('div',{staticClass:"profiletable__row__data bg--gray-lightest flex-none w-150"},[_vm._v("\n    GSoD Indices 2021\n  ")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data bg--gray-lightest flex-auto"},[_vm._v("\n    COVID-19 related measures/developments with an impact on Democracy and Human Rights\n  ")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data bg--gray-lightest flex-none w-100 text-center"},[_vm._v("\n    Impact\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfiletableAttributeHeader_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba0d34c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfiletableAttributeHeader_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfiletableAttributeHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba0d34c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfiletableAttributeHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profiletable__row flex"},[_c('div',{staticClass:"profiletable__row__data flex-auto flex flex-nowrap items-center w-full",class:_vm.bgColor},[_c('AttributeIcon',{attrs:{"size":40,"attributeKey":_vm.attributeKey}}),_vm._v(" "),_c('div',{staticClass:"flex-auto pl-20"},[_c('span',{staticClass:"font-serif text-lg leading-snug"},[_vm._v(_vm._s(_vm.attributeTitle))]),_vm._v(" "),_c('span',{staticClass:"pl-10 text-sm",domProps:{"innerHTML":_vm._s(_vm.attributeValue)}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourceLinksSection_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5ba1f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourceLinksSection_vue__ = __webpack_require__(479);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SourceLinksSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5ba1f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SourceLinksSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.groupedSources && _vm.groupedSources.length > 0)?_c('div',{staticClass:"profiletable mt-20 pt-40 mb-20",attrs:{"id":"sourceLinksSection"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.groupedSources),function(group,i){return _c('div',{key:i,staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data profiletable__row__data--sm flex-auto max-w-150 min-w-150 bg--gray-lightest flex justify-center items-center"},[(group.icon)?_c('div',{staticClass:"text-center"},[(group.icon)?_c('img',{staticClass:"max-w-full w-auto h-3",attrs:{"src":group.icon,"alt":group.title}}):_vm._e(),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(group.title))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data profiletable__row__data--sm flex-auto w-full bg--gray-200 overflow-hidden"},_vm._l((group.links),function(link,li){return _c('div',{key:li,ref:'source-' + link.source_id,refInFor:true,staticClass:"truncate"},[_vm._v("\n        "+_vm._s(link.source_id)+". "),_c('a',{attrs:{"target":"_blank","href":link.url}},[_vm._v(_vm._s(link.url))])])}),0)])})],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-auto w-full bg--gray-lightest flex items-center"},[_vm._v("\n      Links\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-country"},[_c('section',{staticClass:"single-country__main",staticStyle:{"min-height":"600px"}},[(_vm.countryData)?_c('div',{staticClass:"country-print-wrap hide-for-print"},[(this.firstCountry && this.firstCountry.id)?_c('div',{staticClass:"country-print"},[_c('form',{attrs:{"action":_vm.downloadUrl,"target":"_blank","method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"args"},domProps:{"value":_vm.downloadAttr}}),_vm._v(" "),_c('label',{staticStyle:{"cursor":"pointer"}},[_c('DownloadIcon',{attrs:{"size":15}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"submit","value":"Download PDF"}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"country-print",on:{"click":function($event){return _vm.printImage()}}},[_c('PrintIcon',{attrs:{"size":15}})],1),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.name)?_c('ShareIcon',{staticClass:"country-print",attrs:{"country":_vm.firstCountry.name,"size":15}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(!_vm.countryData && _vm.firstCountry && _vm.$store.state.fetching.length === 0)?_c('div',[_c('p',{staticClass:"mb-40 pb-20 pt-20 bg--gray-lighter pl-20 pr-20 mt-40"},[_c('em',[_vm._v("For COVID-19 information, "),_c('a',{staticClass:"color--gray-darkest",attrs:{"href":_vm.maplink}},[_vm._v("click here")])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.countryData)?_c('div',[(_vm.$store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(_vm.firstCountry.id)) === -1)?_c('HighMediumLowExplainer',{staticClass:"explainer mt-40 mb-20",attrs:{"bg":true}}):_vm._e(),_vm._v(" "),(_vm.$store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(_vm.firstCountry.id)) === -1)?_c('FrameworkWheel',{staticClass:"mb-40 pt-40",attrs:{"dataset":_vm.currentCountryDataset()}}):_vm._e(),_vm._v(" "),(_vm.countryData['regime_type'] || _vm.countryData['state_of_emergency'] || _vm.countryData['summary'])?_c('div',{staticClass:"profiletable mt-20"},[(_vm.countryData['regime_type'] && _vm.countryData['regime_type'] !== '')?_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150 bg--gray-200 text-bold"},[_vm._v("Regime Type")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data flex-auto w-full bg--gray-200",domProps:{"innerHTML":_vm._s(_vm.countryData['regime_type'])}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.countryData['regime_type'])}})])]):_vm._e(),_vm._v(" "),(_vm.countryData['state_of_emergency'] && _vm.countryData['state_of_emergency'] !== '')?_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150 bg--gray-200 text-bold"},[_vm._v("State of emergency")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data flex-auto w-full bg--gray-200"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.countryData['state_of_emergency'])}}),_vm._v(" "),_c('MiniSourceLink',{attrs:{"sources":_vm.countryData['state_of_emergency_sources']}})],1)]):_vm._e(),_vm._v(" "),(_vm.countryData['summary'] && _vm.countryData['summary'] !== '')?_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150 bg--gray-200 text-bold"},[_vm._v("COVID-19 Democracy & Human Rights Impact Summary")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data flex-auto w-full bg--gray-200"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.countryData['summary'])}}),_vm._v(" "),_c('MiniSourceLink',{attrs:{"sources":_vm.countryData['summary_sources']}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.countryData && _vm.countryData.incident_reports && _vm.$store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(_vm.firstCountry.id)) === -1)?_c('div',[_c('p',{staticClass:"font-small mb-10 mt-40 text-bold"},[_vm._v("GSoD Indices 2021")]),_vm._v(" "),_c('HighMediumLowExplainer',{staticClass:"explainer mt-0 mb-40",attrs:{"bg":true}})],1):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['A_01', 'SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04']))?_c('div',{staticClass:"profiletable mt-40"},[_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"A_01"}}),_vm._v(" "),_c('ProfiletableHeader'),_vm._v(" "),(_vm.hasIncidents(['SA_01_01']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_01_01"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_01_02']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_01_02"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_01_03']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_01_03"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_01_04']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_01_04"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['A_02', 'SA_02_01', 'SA_02_02', 'SA_02_03', 'SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c']))?_c('div',{staticClass:"profiletable mt-40"},[_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"A_02"}}),_vm._v(" "),_c('ProfiletableHeader'),_vm._v(" "),(_vm.hasIncidents(['SA_02_01']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_02_01"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e']))?_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_02_02"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_02_a']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_02_a"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_02_b']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_02_b"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_02_c']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_02_c"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_02_d']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_02_d"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_02_e']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_02_e"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c']))?_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_02_03"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_03_a']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_03_a"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_03_b']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_03_b"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SC_02_03_c']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SC_02_03_c"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['A_03', 'SA_03_01', 'SA_03_02', 'SA_03_03']))?_c('div',{staticClass:"profiletable mt-40"},[_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"A_03"}}),_vm._v(" "),_c('ProfiletableHeader'),_vm._v(" "),(_vm.hasIncidents(['SA_03_01']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_03_01"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_03_02']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_03_02"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_03_03']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_03_03"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['A_04', 'SA_04_01', 'SA_04_02']))?_c('div',{staticClass:"profiletable mt-40"},[_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"A_04"}}),_vm._v(" "),_c('ProfiletableHeader'),_vm._v(" "),(_vm.hasIncidents(['SA_04_01']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_04_01"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_04_02']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_04_02"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['A_05', 'SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04']))?_c('div',{staticClass:"profiletable mt-40"},[_c('ProfiletableAttributeHeader',{attrs:{"dataset":_vm.currentCountryDataset(),"attribute-key":"A_05"}}),_vm._v(" "),_c('ProfiletableHeader'),_vm._v(" "),(_vm.hasIncidents(['SA_05_01']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_05_01"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_05_02']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_05_02"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_05_03']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_05_03"}}):_vm._e(),_vm._v(" "),(_vm.hasIncidents(['SA_05_04']))?_c('ProfiletableRow',{attrs:{"country":_vm.firstCountry,"covid19dataset":_vm.countryData,"dataset":_vm.currentCountryDataset(),"attribute-key":"SA_05_04"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.countryData && _vm.countryData.additional_information)?_c('div',{staticClass:"profiletable mt-20 pt-40 mb-20"},[_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-full bg--gray-lightest flex items-center text-bold"},[_vm._v("\n              Additional information\n            ")])]),_vm._v(" "),_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-full bg--gray-200 pb-40 pt-40 pl-60 pr-60"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.countryData['additional_information'])}}),_vm._v(" "),_c('MiniSourceLink',{attrs:{"sources":_vm.countryData['additional_information_sources']}})],1)])]):_vm._e(),_vm._v(" "),(_vm.countryData.democratic_violations_inde || _vm.countryData.pandemic_backsliding_index)?_c('div',{staticClass:"profiletable mt-20 pt-40 mb-20"},[_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150 bg--gray-lightest flex justify-center items-center"},[_c('a',{staticClass:"block",attrs:{"href":"https://www.v-dem.net/en/analysis/PanDem/","target":"_blank"}},[_c('img',{staticClass:"img-responsive w-full",attrs:{"src":_vm.VDemLogo,"alt":"V-Dem Institute"}})])]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data flex-auto w-full profiletable__row__data--no-padding"},[(_vm.countryData.democratic_violations_inde)?_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150 bg--gray-lightest text-bold"},[_vm._v("\n                  "+_vm._s(_vm.$Strings('vdem_pandem'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data bg--gray-200 flex-auto w-full"},[_vm._v("\n                  "+_vm._s(_vm.countryData.democratic_violations_inde)+"\n                ")])]):_vm._e(),_vm._v(" "),(_vm.countryData.pandemic_backsliding_index)?_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-150 bg--gray-lightest text-bold"},[_vm._v("\n                  "+_vm._s(_vm.$Strings('vdem_panback'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"profiletable__row__data bg--gray-200 flex-auto w-full"},[_vm._v("\n                  "+_vm._s(_vm.countryData.pandemic_backsliding_index)+"\n                ")])]):_vm._e()])])]):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.firstCountry && _vm.$store.state.rsc.countriesCovidProfileOnly.indexOf(parseInt(_vm.firstCountry.id)) === -1)?_c('div',[(_vm.countryData)?_c('div',{staticClass:"main-attribute-charts"},[_vm._l((['A_01', 'A_02', 'A_03', 'A_04']),function(key){return _c('div',{key:key,staticClass:"main-attribute-charts__item"},[_c('CircleChart',{staticClass:"main-attribute-charts__item__svg",attrs:{"value":_vm.getAttributeValue(key, 'value'),"color":_vm._f("valueColor")(_vm.getAttributeValue(key, 'value'))}}),_vm._v(" "),_c('div',{staticClass:"main-attribute-charts__item__label"},[_vm._v(_vm._s(_vm.getAttributeValue(key, 'label'))),_c('br'),_vm._v(" "),(_vm.getAttributeValue(key, 'description'))?_c('HelpTooltip',{staticClass:"mt5",attrs:{"description":_vm.getAttributeValue(key, 'description')}}):_vm._e()],1)],1)}),_vm._v(" "),_c('div',{staticClass:"main-attribute-charts__item"},[_c('div',{staticClass:"main-attribute-charts__item__svg"},[_vm._v(" ")]),_vm._v(" "),(_vm.getAttributeValue('A_01', 'value'))?_c('div',{staticClass:"main-attribute-charts__item__label"},[_vm._v(_vm._s(this.$Strings('popularParticipation')))]):_c('div',{staticClass:"main-attribute-charts__item__label"},[_vm._v(_vm._s(this.$Strings('popularParticipation')))]),_vm._v(" "),(_vm.getAttributeValue('A_01', 'description'))?_c('HelpTooltip',{attrs:{"description":this.$Strings('popularParticipationTooltip')}}):_vm._e()],1)],2):_vm._e(),_vm._v(" "),(_vm.countryData)?_c('div',{staticClass:"actions--bar flex justify-end mb-10"},[_c('div',{staticClass:"confidence-actions"},[_c('Checkbox',{staticClass:"confidence-actions__checkbox",attrs:{"reverse":true,"active":_vm.$store.state.confidenceIntervals},on:{"toggle":function($event){_vm.$store.state.confidenceIntervals = !_vm.$store.state.confidenceIntervals}}},[_vm._v(_vm._s(this.$Strings('confidenceIntervals')))]),_vm._v(" "),_c('HelpTooltip',{staticClass:"confidence-actions__tooltip",attrs:{"description":this.$Strings('confidenceIntervalsDescription')}})],1),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.id !== '999')?_c('div',{staticClass:"confidence-actions"},[_c('Checkbox',{staticClass:"confidence-actions__checkbox",attrs:{"reverse":true,"active":_vm.$store.state.isWorldAverageEnabled},on:{"toggle":function($event){_vm.$store.state.isWorldAverageEnabled = !_vm.$store.state.isWorldAverageEnabled}}},[_vm._v(_vm._s(this.$Strings('worldAverageCheckbox')))]),_vm._v(" "),_c('HelpTooltip',{staticClass:"confidence-actions__tooltip",attrs:{"description":this.$Strings('worldAverageCheckboxDescription')}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.countryData && _vm.subattributeData[0] && _vm.subcomponentData[0])?_c('HighMediumLowExplainer',{staticClass:"explainer mb-10",attrs:{"bg":true}}):_vm._e(),_vm._v(" "),(_vm.countryData && _vm.subattributeData[0] && _vm.subcomponentData[0])?_c('div',{staticClass:"barchart"},[_c('div',{staticClass:"barchart__wrap--dark"},_vm._l((_vm.subattributeData[0]),function(row,i){return _c('div',{key:'country_' + i,staticClass:"barchart__line"},[_c('BarLine',{attrs:{"annotation-value":_vm.$store.state.isWorldAverageEnabled && _vm.firstCountry && _vm.firstCountry.id !== '999' ? _vm.getWorldDataValue(row.columnKey) : undefined,"confInt":row.range,"color":_vm._f("valueColor")(row.value),"value":parseFloat(row.value),"tooltip":row.description,"label":row.label,"showValues":true,"showRange":_vm.$store.state.confidenceIntervals,"mini":true}}),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.id && _vm.$store.getters['covid19/countryAttributeType'](_vm.firstCountry.id, row.columnKey) === 'watch')?_c('DevelopmentsToWatch',{staticClass:"barchart__line__icon",attrs:{"size":30}}):_vm._e(),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.id && _vm.$store.getters['covid19/countryAttributeType'](_vm.firstCountry.id, row.columnKey) === 'high')?_c('ConcerningDevelopments',{staticClass:"barchart__line__icon",attrs:{"size":30}}):_vm._e()],1)}),0),_vm._v(" "),_c('div',{staticClass:"barchart__wrap--light"},_vm._l((_vm.subcomponentData[0]),function(row,i){return _c('div',{key:'sub_country_' + i,staticClass:"barchart__line"},[_c('BarLine',{attrs:{"annotation-value":_vm.$store.state.isWorldAverageEnabled && _vm.firstCountry && _vm.firstCountry.id !== '999' ? _vm.getWorldDataValue(row.columnKey) : undefined,"confInt":row.range,"color":_vm._f("valueColor")(row.value),"value":parseFloat(row.value),"tooltip":row.description,"label":row.label,"showValues":true,"showRange":_vm.$store.state.confidenceIntervals,"mini":true}}),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.id && _vm.$store.getters['covid19/countryAttributeType'](_vm.firstCountry.id, row.columnKey) === 'watch')?_c('DevelopmentsToWatch',{staticClass:"barchart__line__icon",attrs:{"size":30}}):_vm._e(),_vm._v(" "),(_vm.firstCountry && _vm.firstCountry.id && _vm.$store.getters['covid19/countryAttributeType'](_vm.firstCountry.id, row.columnKey) === 'high')?_c('ConcerningDevelopments',{staticClass:"barchart__line__icon",attrs:{"size":30}}):_vm._e()],1)}),0)]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.countryData && _vm.countryData['source_links'])?_c('SourceLinksSection',{attrs:{"sourceLinks":_vm.countryData['source_links']}}):_vm._e(),_vm._v(" "),(_vm.countryData && _vm.countryData.incident_reports)?_c('div',{staticClass:"profiletable mt-20 pt-40 mb-20"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-full bg--gray-200 pb-40 pt-40 pl-60 pr-60",domProps:{"innerHTML":_vm._s(this.$Strings('covid19_disclaimer'))}})])]):_vm._e(),_vm._v(" "),_c('a',{ref:"downloadLink"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profiletable__row flex w-full"},[_c('div',{staticClass:"profiletable__row__data flex-none w-full bg--gray-lightest flex items-center text-bold"},[_vm._v("\n          Disclaimer\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleCountries_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61155924_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleCountries_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61155924"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultipleCountries_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61155924_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultipleCountries_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGroup_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fff4a99_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGroup_vue__ = __webpack_require__(485);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fff4a99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fff4a99_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttongroup hide-for-print"},_vm._l((_vm.values),function(val,key){return _c('div',{staticClass:"btn",class:{ isActive: _vm.isActive(key) },domProps:{"innerHTML":_vm._s(val)},on:{"click":function($event){return _vm.select()}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"multiple-countries"},[_c('header',{staticClass:"header"},[_c('div',{staticClass:"header__left"},[_c('range-year-slider',{staticClass:"rangeSlider",attrs:{"years":_vm.$store.state.defaultYears,"startSelection":"2021"}}),_vm._v(" "),_c('div',{staticClass:"confidence-actions"},[_c('Checkbox',{staticClass:"confidence-actions__checkbox",attrs:{"active":_vm.$store.state.confidenceIntervals},on:{"toggle":function($event){_vm.$store.state.confidenceIntervals = !_vm.$store.state.confidenceIntervals}}},[_vm._v(_vm._s(this.$Strings('confidenceIntervals')))]),_vm._v(" "),_c('HelpTooltip',{staticClass:"confidence-actions__tooltip",attrs:{"description":this.$Strings('confidenceIntervalsDescription')}})],1)],1),_vm._v(" "),_c('div',{staticClass:"header__right"},[_c('div',{staticClass:"multiple-countries__btngroup"},[_c('ButtonGroup',{staticClass:"multiple-countries__btngroup__group",attrs:{"values":{'attributes': this.$Strings('attributes'), 'subattributes': this.$Strings('subattributes') },"selectedKey":_vm.attrSub},on:{"click":function($event){return _vm.toggleAttrSub()}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"country-minified--sub"},[(_vm.attrSub === 'attributes')?_c('div',{staticClass:"country-minified__item-wrapper"},_vm._l((_vm.attributeData),function(row,index){return _c('div',{key:index,staticClass:"country-minified__item"},[_c('div',{staticClass:"barchart"},_vm._l((row),function(ar,i){return _c('BarLine',{key:'attribute' + i,staticClass:"barchart__line",attrs:{"confInt":ar.range,"color":_vm._f("valueColor")(ar.value),"value":parseFloat(ar.value),"tooltip":row.description,"label":ar.label,"showValues":false,"canvasSize":[30,100],"strokeWidth":20,"showRange":_vm.$store.state.confidenceIntervals,"showInLineValue":true}})}),1),_vm._v(" "),(row[0].country)?_c('div',{staticClass:"country-minified__item__name"},[_vm._v(_vm._s(row[0].country))]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.attrSub === 'subattributes')?_c('div',{staticClass:"country-minified__item-wrapper"},_vm._l((_vm.subattributeData),function(row,index){return _c('div',{key:index,staticClass:"country-minified__item"},[_c('div',{staticClass:"barchart"},_vm._l((row),function(ar,i){return _c('BarLine',{key:'subattribute_' + i,staticClass:"barchart__line",attrs:{"confInt":ar.range,"color":_vm._f("valueColor")(ar.value),"value":parseFloat(ar.value),"tooltip":row.description,"label":ar.label,"showValues":false,"showRange":_vm.$store.state.confidenceIntervals}})}),1),_vm._v(" "),(row[0].country)?_c('div',{staticClass:"country-minified__item__name"},[_vm._v(_vm._s(row[0].country))]):_vm._e()])}),0):_vm._e(),_vm._v(" "),_c('HighMediumLowExplainer',{staticClass:"mt-20 explainer",attrs:{"bg":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countries-regions-profile main-wrap full-width"},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.firstCountry)?_c('InfoOverlay',{staticClass:"infoOverlay",attrs:{"description":this.$Strings('chooseACountry')}}):_vm._e()],1),_vm._v(" "),(_vm.viewmode === 'chart')?_c('div',{staticClass:"viewmode-chart"},[(_vm.$store.state.fetching.length > 0)?_c('PreloaderOverlay'):_vm._e(),_vm._v(" "),_c('header',{staticClass:"page-title__header",class:{ isSmall : _vm.$store.state.covid19.is_enabled }},[(_vm.countries.length < 2 || _vm.$store.state.covid19.is_enabled)?_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.firstCountry ? _vm.firstCountry.name : ' ')),(_vm.$store.state.covid19.is_enabled && _vm.firstCountry)?_c('span',{staticClass:"font-small font-sans-serif"},[_vm._v(" (COVID-19)")]):_vm._e()]):_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(this.$Strings('countryComparisons')))]),_vm._v(" "),(!_vm.$store.state.covid19.is_enabled)?_c('div',{staticClass:"actions-wrap hide-for-print"},[(_vm.countries && _vm.countries.length <= 1)?_c('div',{staticClass:"actions btn-group mt-10"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.firstCountry && _vm.firstCountry.name === 'World') && !(_vm.firstCountry && _vm.firstCountry.name === 'German Democratic Republic')),expression:"!(firstCountry && firstCountry.name === 'World') && !(firstCountry && firstCountry.name === 'German Democratic Republic')"}],staticClass:"btn btn--fluid",attrs:{"href":_vm.downloadProfileUrl,"target":"_blank","id":"download-btn"}},[_c('span',{staticClass:"btn-content"},[_c('span',{staticClass:"btn-content__icon"},[_c('svg',{staticClass:"btn-content__icon__svg download-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 10.5"}},[_c('g',{attrs:{"id":"Lag_2","data-name":"Lag 2"}},[_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"downloadshare"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M9.66,5,6.56,7.54a.09.09,0,0,1-.11,0L3.34,5"}}),_c('line',{staticClass:"cls-1",attrs:{"x1":"6.5","y1":"7.77","x2":"6.5"}}),_c('line',{staticClass:"cls-1",attrs:{"y1":"10","x2":"13","y2":"10"}})])])])])]),_vm._v(" "),_c('span',{staticClass:"btn-content__value"},[_vm._v(_vm._s(this.$Strings('downloadProfile')))])])]),_vm._v(" "),_c('div',{staticClass:"btn btn--fluid",attrs:{"target":"_blank","id":"global-performance-btn"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.gotoGlobalPerformance()}}},[_c('span',{staticClass:"btn-content"},[_c('span',{staticClass:"btn-content__icon"},[_c('svg',{staticClass:"btn-content__icon__svg global-performance-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.57 15.57"}},[_c('circle',{staticClass:"cls-1",attrs:{"cx":"7.79","cy":"7.79","r":"7.29"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M15.13,8h-7a1.72,1.72,0,0,0-1.58,1h0A1.72,1.72,0,0,0,8.12,11.5h.63v3.83","transform":"translate(-0.05 -0.26)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.94.84v3a1.59,1.59,0,0,0,1.59,1.59h4.11","transform":"translate(-0.05 -0.26)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M3.48,2.22V5.14A1.88,1.88,0,0,1,1.6,7h-1","transform":"translate(-0.05 -0.26)"}})])]),_vm._v(" "),_c('span',{staticClass:"btn-content__value"},[_vm._v(_vm._s(this.$Strings('compareToRegion')))])])]),_vm._v(" "),_c('div',{staticClass:"btn btn--fluid",attrs:{"target":"_blank","id":"key-attributes-btn"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.gotoKeyAttributesOverTime()}}},[_c('span',{staticClass:"btn-content"},[_c('span',{staticClass:"btn-content__icon"},[_c('svg',{staticClass:"btn-content__icon__svg key-attributes-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.8 12.02"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M3.6,8.37,6.9,6a1,1,0,0,1,.87-.15l3.74,1.11a.72.72,0,0,0,.62-.09l4.73-3.1","transform":"translate(-0.33 -0.18)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M17.07,11.69h-16a.28.28,0,0,1-.28-.28V.18","transform":"translate(-0.33 -0.18)"}})])]),_vm._v(" "),_c('span',{staticClass:"btn-content__value"},[_vm._v(_vm._s(this.$Strings('keyAttributesOverTime')))])])])]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.subattributeData && _vm.$store.state.covid19.is_enabled)?_c('covid19-profile',{attrs:{"subattributeData":_vm.subattributeData,"subcomponentData":_vm.subcomponentData,"currentCountryDataset":_vm.currentCountryDataset,"firstCountry":_vm.firstCountry,"worldData":_vm.worldData}}):_vm._e(),_vm._v(" "),(_vm.subattributeData && _vm.subattributeData.length === 1 && !_vm.$store.state.covid19.is_enabled)?_c('single-country',{attrs:{"subattributeData":_vm.subattributeData,"subcomponentData":_vm.subcomponentData,"currentCountryDataset":_vm.currentCountryDataset,"firstCountry":_vm.firstCountry,"worldData":_vm.worldData}}):_vm._e(),_vm._v(" "),(_vm.subattributeData && _vm.subattributeData.length > 1 && !_vm.$store.state.covid19.is_enabled)?_c('multiple-countries',{attrs:{"subattributeData":_vm.subattributeData,"attributeData":_vm.attributeData}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.viewmode === 'table')?_c('ViewModeTable',{attrs:{"showAttributes":_vm.mainAttributeKeys.concat(_vm.subAttributeKeys),"data":_vm.tableData,"dateRange":this.year}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7323f18e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7323f18e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7323f18e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"region region-content"},[_c('section',{staticClass:"block"},[_c('div',{staticClass:"block__content"},[_c('h1',[_vm._v("Page not found")])])]),_vm._v(" "),_c('section',{staticClass:"block"},[_c('div',{staticClass:"block__content"},[_vm._v("\n        The requested page could not be found.\n      ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Strings = {
  install: function install(Vue, options) {
    Vue.prototype.$Strings = function (key) {
      if (window.drupalSettings && window.drupalSettings.gsoidstrings && window.drupalSettings.gsoidstrings[key]) {
        return window.drupalSettings.gsoidstrings[key];
      } else {
        return key;
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Strings);

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


// Global stuff
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    getFixedValue: function getFixedValue(val) {
      val = parseFloat(val);
      var fixedval = val.toFixed(2);

      if (fixedval === '0.70' && val > 0.7) {
        fixedval = 0.701;
      }

      if (fixedval === '0.40' && val < 0.40) {
        fixedval = 0.399;
      }

      return fixedval;
    },
    apiRefreshToken: function apiRefreshToken() {
      var date = new Date();
      var token = date.getFullYear() + '-' + date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getHours();

      return token;
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('fixedName', function (name) {
  if (name === 'Latin America/Caribbean') {
    name = 'Latin America and the Caribbean';
  }
  if (name === 'Asia/Pacific') {
    name = 'Asia and the Pacific';
  }
  if (name === 'Viet Nam') {
    name = 'Vietnam';
  }
  if (name === 'Cape Verde') {
    name = 'Cabo Verde';
  }
  return name;
});

// returns a color name based on a 0-1 value
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('valueColor', function (value) {
  var result = 'gray-lighter';

  if (parseFloat(value) > 0.7) {
    result = 'valuegreen';
  }
  if (parseFloat(value) <= 0.7 && parseFloat(value) >= 0.4) {
    result = 'valueyellow';
  }
  if (parseFloat(value) < 0.4) {
    result = 'valuered';
  }

  return result;
});

// Returns a regime color name based on country data
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('regimeColor', function (countryData) {
  if (parseInt(countryData.dem) === 1) {
    return 'regime-orange';
  } else if (parseInt(countryData.dem) === 2) {
    return 'regime-purple';
  } else if (parseInt(countryData.dem) === 3) {
    if (parseInt(countryData.demperf) === 1) {
      return 'regime-dem-low';
    } else if (parseInt(countryData.demperf) === 2) {
      return 'regime-dem-mid';
    } else if (parseInt(countryData.demperf) === 3) {
      return 'regime-dem-high';
    }
  }

  return 'gray-light';
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_rscStore_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_attributesStore_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stores_userSelectionStore_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stores_covid19Store_js__ = __webpack_require__(502);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

  modules: {
    rsc: __WEBPACK_IMPORTED_MODULE_3__stores_rscStore_js__["a" /* rscStore */],
    attributes: __WEBPACK_IMPORTED_MODULE_4__stores_attributesStore_js__["a" /* attributesStore */],
    selections: __WEBPACK_IMPORTED_MODULE_5__stores_userSelectionStore_js__["a" /* userSelectionStore */],
    covid19: __WEBPACK_IMPORTED_MODULE_6__stores_covid19Store_js__["a" /* covid19Store */]
  },

  state: {
    /**
     * Tells if the regime navigation is available on the current page
     */
    regime_nav_enabled: false,

    /**
     * Is the regime selected by the user
     * We default to yes!
     */
    regime_enabled: true,

    showTourTooltip: false,

    image_download_path: 'https://www.idea.int/nodejs',
    pathSelection: {},

    mousePosition: { x: 0, y: 0 },

    windowSize: { width: 0, height: 0 },
    contentSize: { width: 0, height: 0 },

    /**
     * Use to tell if the application is fetching something or not
     * @type {Boolean}
     */
    fetching: [],

    /**
     * Current slider value
     * @type {Array}
     */
    defaultYears: [1975, 2021],

    /**
     * Current slider value
     * @type {Array}
     */
    yearSliderCurrent: 2021,

    /**
     * Current slider value
     * @type {Array}
     */
    rangeYearSliderCurrent: [1975, 2021],

    /**
     * Currently displayed page tutorial
     * @type {Boolean|String}
     */
    pagetutorial: false,

    /**
     * The colors to be used in charts
     * @type {Array}
     */
    colors: [{
      'name': 'blue',
      'hex': '#00ADE4'
    }, {
      'name': 'orange',
      'hex': '#EF5214'
    }, {
      'name': 'red',
      'hex': '#E21F55'
    }, {
      'name': 'green',
      'hex': '#85BC4F'
    }, {
      'name': 'palegreen',
      'hex': '#74C19D'
    }, {
      'name': 'pink',
      'hex': '#ea6cae'
    }, {
      'name': 'purple',
      'hex': '#50479E'
    }, {
      'name': 'yellow',
      'hex': '#f3d139'
    }, {
      'name': 'gray-lightest',
      'hex': '#F1F3F7'
    }, {
      'name': 'gray-lighter',
      'hex': '#DCE1E5'
    }, {
      'name': 'gray-light',
      'hex': '#BEC4CC'
    }, {
      'name': 'gray',
      'hex': '#9AA1A8'
    }, {
      'name': 'gray-darker',
      'hex': '#7E8489'
    }, {
      'name': 'gray-darkest',
      'hex': '#2F3E5E'
    }, {
      'name': 'white',
      'hex': '#FFF'
    }, {
      'name': 'disabled',
      'hex': '#989da3'
    }, {
      'name': 'valuered',
      'hex': '#E21F55'
    }, {
      'name': 'valueyellow',
      'hex': '#f3d139'
    }, {
      'name': 'valuegreen',
      'hex': '#85BC4F'
    }, {
      'name': 'regime-purple',
      'hex': '#A78AC2'
    }, {
      'name': 'regime-orange',
      'hex': '#F79C32'
    }, {
      'name': 'regime-dem-high',
      'hex': '#2BCBA8'
    }, {
      'name': 'regime-dem-mid',
      'hex': '#7FE0CB'
    }, {
      'name': 'regime-dem-low',
      'hex': '#BFEFE5'
    }],

    /**
     * The user selected viewmode
     * @type {String}
     */
    viewMode: 'chart',

    /**
     * The user selected confidenceInterval
     * @type {Boolean}
     */
    confidenceIntervals: true,

    /**
     * world average
     * @type {Boolean}
     */
    isWorldAverageEnabled: true,

    colorMapping: [],

    helptoolbars: [{
      'path': '/indices/compare-attributes',
      'description': 'Lorem ipsum dolor sit amet, consectetur.',
      'popupTitle': 'Nam voluptatibus',
      'popupContent': 'Officiis, est, quas veniam repellendus error quasi assumenda dicta at nesciunt sunt, reprehenderit odio consequuntur magni laborum ipsam aliquid, accusantium delectus. Atque.'
    }, {
      'path': '/indices/countries-regions-profile',
      'description': 'Lorem ipsum dolor sit amet, consectetur adipisicing.',
      'popupTitle': 'Wuas veniam repellendus',
      'popupContent': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam voluptatibus animi totam aperiam necessitatibus iste minus veniam obcaecati nemo porro repellendus tenetur assumenda tempore doloribus dicta, magni rem. Officiis, est, quas veniam repellendus error quasi assumenda dicta at nesciunt sunt, reprehenderit odio consequuntur magni laborum ipsam aliquid, accusantium delectus. Atque.'
    }]
  },

  getters: {
    /**
     * Maps a key to a color
     * @param  {obj} state    The Vuex state
     * @param  {obj} getters) The Vuex getters
     * @return {string}       Color name
     */
    getSelectionColor: function getSelectionColor(state, getters) {
      return function (key) {
        key = String(key);
        var alreadyAvailable = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(state.colorMapping, { key: key });

        if (alreadyAvailable) {
          return alreadyAvailable.color;
        }

        var usedColors = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(state.colorMapping, 'color');

        // Get unique color from color array
        var availableColors = state.colors.slice(0, 7);
        var color = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(availableColors, function (color) {
          return usedColors.indexOf(color.name) === -1;
        });

        // If no color - return a default
        if (!color) {
          color = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.first(availableColors);
        }

        state.colorMapping.push({
          key: key,
          color: color.name
        });

        return color.name;
      };
    }
  },

  mutations: {
    /**
     * Resets color section
     * @param  {obj} state    The Vuex state
     * @param  {obj} getters) The Vuex getters
     * @return {string}       Color name
     */
    resetSelectionColor: function resetSelectionColor(state) {
      state.colorMapping = [];
    }
  },

  actions: {
    /**
     * Select or unselect a country
     * @param  {obj} options.state     Vuex state
     * @param  {obj} options.commit    Vuex commit
     * @param  {obj} options.rootState Vuex rootState
     * @param  {string} key            A key for the fetching
     * @return {void}
     */
    startFetching: function startFetching(_ref, key) {
      var state = _ref.state,
          commit = _ref.commit,
          rootState = _ref.rootState;

      state.fetching.push({ id: key });
    },


    /**
     * Select or unselect a country
     * @param  {obj} options.state     Vuex state
     * @param  {obj} options.commit    Vuex commit
     * @param  {obj} options.rootState Vuex rootState
     * @param  {string} key            A key for the fetching
     * @return {void}
     */
    stopFetching: function stopFetching(_ref2, key) {
      var state = _ref2.state,
          commit = _ref2.commit,
          rootState = _ref2.rootState;

      var i = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(state.fetching, ['id', key]);
      if (i !== -1) {
        state.fetching.splice(i, 1);
      }
    }
  }
});

/***/ }),
/* 497 */,
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rscStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var rscStore = {
  namespaced: true,
  state: {
    /**
     * The selected country/region/subregion from the country dropdown
     * @type {Array}
     */
    selected: [],

    /**
     * Regime lookup object
     * @type {Object}
     */
    dem: [{
      dem: 1,
      name: 'Authoritarian regime'
    }, {
      dem: 2,
      name: 'Hybrid regime'
    }, {
      dem: 3,
      name: 'Democracy'
    }],

    /**
     * Democracy performance lookip
     */
    demperf: [{
      demperf: 1,
      name: 'Weak/Low performance'
    }, {
      demperf: 2,
      name: 'Mid-range performance'
    }, {
      demperf: 3,
      name: 'High performance'
    }],

    /**
     * All countries/regions/subregions
     * @type {Object}
     */
    all: {},

    /**
     * Some regions do not have subregions.
     * This is a list of ids
     * @type {Array}
     */
    regionsWithoutSubregions: [993, 995, 6000, 999999],

    /**
     * List of regions/subregion/countries that should only be visible on the
     * Covid19 profiles
     * @type {Array}
     */
    rscCovidProfileOnly: [6000, 6004, 6005, 6006],

    /**
     * List of countries that should only be visible on the
     * Covid19 profiles
     * @type {Array}
     */
    countriesCovidProfileOnly: [6004, 6005, 6006],

    /**
     * Regions that are not selectable for comparison
     * @type {Array}
     */
    notSelectableRegions: [999999]
  },

  getters: {

    /**
     * Checks if a r/s/c is selected
     * @param  {obj}  state The Vuex state
     * @param  {object} obj   The selected country object
     * @return {Boolean}
     */
    isSelected: function isSelected(state, getters) {
      return function (obj) {
        var result = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.selected, function (rsc) {
          return rsc.id === obj.id;
        });
        return !!result;
      };
    },

    /**
     * Returns the first selected
     * @param  {Object} state rscStore.state
     * @return {undefined|obj} The selected country object
     */
    firstSelected: function firstSelected(state) {
      return state.selected[0];
    },


    /**
     * Return a r/s/c based on id
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {obj}  r/s/c object
     */
    getFromId: function getFromId(state, getters) {
      return function (id) {
        var result = false;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.all.regions, function (region, rI) {
          if (parseInt(region.id) === parseInt(id)) result = region;
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(region.subregions, function (subregion, srI) {
            if (parseInt(subregion.id) === parseInt(id)) result = subregion;
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(subregion.countries, function (country, cI) {
              if (parseInt(country.id) === parseInt(id)) result = country;
            });
          });
        });
        return result;
      };
    },

    /**
     * Return global object
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {obj}  r/s/c object
     */
    getGlobal: function getGlobal(state, getters) {
      if (state.all.regions && state.all.regions[999]) {
        return state.all.regions[999];
      }
    },

    /**
     * Return the regime object by country data row
     */
    getRegimenameByDataRow: function getRegimenameByDataRow(state) {
      return function (row) {
        var dem = parseInt(row.dem);
        var demperf = parseInt(row.demperf);

        if (!dem || !demperf) {
          return false;
        }

        var demObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.dem, function (d) {
          return d.dem === dem;
        });

        if (dem === 3) {
          var demPerfObj = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.demperf, function (d) {
            return d.demperf === demperf;
          });

          return demPerfObj.name + ' ' + demObj.name;
        }

        return demObj.name;
      };
    },

    /**
     * Return a regime based on id
     * @param  {obj}  state The Vuex state
     * @return {obj}  r/s/c object
     */
    getRegimeById: function getRegimeById(state) {
      return function (id) {
        var result = void 0;

        if (id && id > 0) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.dem, function (regime) {
            if (id && parseInt(regime.dem) === parseInt(id)) {
              result = regime;
            }
          });
        }

        return result;
      };
    },

    /**
     * Return a regime performance based on id
     * @param  {obj}  state The Vuex state
     * @return {obj}  r/s/c object
     */
    getRegimePerformanceById: function getRegimePerformanceById(state) {
      return function (id) {
        var result = void 0;

        if (id && id > 0) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.demperf, function (regime) {
            if (id && parseInt(regime.demperf) === parseInt(id)) {
              result = regime;
            }
          });
        }

        return result;
      };
    },

    /**
     * Return a country based on id
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {obj}  r/s/c object
     */
    getCountry: function getCountry(state, getters) {
      return function (id) {
        var result = false;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.all.regions, function (region, rI) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(region.subregions, function (subregion, srI) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(subregion.countries, function (country, cI) {
              if (country.id === id) result = country;
            });
          });
        });
        return result;
      };
    },

    /**
     * Return the subregion of a country
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {obj}  r/s/c object
     */
    getCountrySubregion: function getCountrySubregion(state, getters) {
      return function (id) {
        var result = false;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.all.regions, function (region, rI) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(region.subregions, function (subregion, srI) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(subregion.countries, function (country, cI) {
              if (country.id === id) result = subregion;
            });
          });
        });
        return result;
      };
    },

    /**
     * Return the region of a country
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {obj}  r/s/c object
     */
    getCountryRegion: function getCountryRegion(state, getters) {
      return function (id) {
        var result = false;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.all.regions, function (region, rI) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(region.subregions, function (subregion, srI) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(subregion.countries, function (country, cI) {
              if (country.id === id) result = region;
            });
          });
        });
        return result;
      };
    },

    /**
     * Check if this is a region
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {Boolean}
     */
    isRegion: function isRegion(state, getters) {
      return function (id) {
        return !!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.all.regions, ['id', id]);
      };
    },

    /**
     * Check if this is a region
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {Boolean}
     */
    isSubregion: function isSubregion(state, getters) {
      return function (id) {
        var result = false;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.all.regions, function (region, rI) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(region.subregions, function (subregion, srI) {
            if (subregion.id === id) result = true;
          });
        });
        return result;
      };
    },

    /**
     * Check if this is a region
     * @param  {obj}  state The Vuex state
     * @param  {obj}  getters The Vuex getters
     * @return {Boolean}
     */
    isCountry: function isCountry(state, getters) {
      return function (id) {
        var result = false;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.all.regions, function (region, rI) {
          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(region.subregions, function (subregion, srI) {
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(subregion.countries, function (country, cI) {
              if (country.id === id) result = true;
            });
          });
        });
        return result;
      };
    }
  },

  mutations: {
    /**
     * Add or remove a selected rsc
     * @param  {obj} state Vuex state
     * @param  {object} obj   The selected country object
     * @return {void}
     */
    select: function select(state, obj) {
      state.selected.push(obj);
    },


    /**
     * Unselect a rsc
     * @param  {object} state Vuex state
     * @param  {object} obj   The selected country object
     * @return {void}
     */
    unselect: function unselect(state, obj) {
      state.selected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.reject(state.selected, function (rsc) {
        return rsc.id === obj.id;
      });
    },


    /**
     * Resets the selected countries
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    resetAllSelected: function resetAllSelected(state) {
      state.selected = [];
    }
  },

  actions: {
    /**
     * Select or unselect a country
     * @param  {obj} options.state     Vuex state
     * @param  {obj} options.commit    Vuex commit
     * @param  {obj} options.rootState Vuex rootState
     * @param  {obj} obj               The country select object
     * @return {void}
     */
    toggleSelect: function toggleSelect(_ref, obj) {
      var state = _ref.state,
          commit = _ref.commit,
          rootState = _ref.rootState;

      var exists = !!__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.selected, function (rsc) {
        return rsc.id === obj.id;
      });
      if (exists) {
        commit('unselect', obj);
      } else {
        commit('select', obj);
      }
    }
  }
};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var attributesStore = {
  namespaced: true,
  state: {
    /**
     * The selected attributes
     * @type {Array}
     */
    selected: [],

    /**
     * The attributes label
     * @type {Object}
     */
    labels: {},

    /**
     * All attributes
     * @type {Object}
     */
    all: {}
  },

  getters: {
    /**
     * Checks if an attribute is selected
     * @param  {obj} state Vuex state
     * @param  {obj} state Vuex getters
     * @param  {string} key   Country identifier
     * @return {Boolean}
     */
    getLabelFromKey: function getLabelFromKey(state, getters) {
      return function (key) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.labels, ['id', key]);
      };
    },

    /**
     * Returns the first selected attribute
     * @param  {Object} state attributesStore.state
     * @return {undefined|obj} The selected country object
     */
    firstSelected: function firstSelected(state) {
      return state.selected[0];
    },


    /**
     * Checks if an attribute is selected
     * @param  {obj} state Vuex state
     * @param  {obj} state Vuex getters
     * @param  {string} key   Country identifier
     * @return {Boolean}
     */
    isSelected: function isSelected(state, getters) {
      return function (key) {
        var exists = state.selected.indexOf(key) !== -1;
        return exists;
      };
    },

    /**
     * Checks if this attribute is selected
     * or if it contains a selected attribute
     *
     * @param  {obj} state Vuex state
     * @param  {obj} state Vuex getters
     * @param  {string} key   Country identifier
     * @return {Boolean}
     */
    isOrContainsSelected: function isOrContainsSelected(state, getters) {
      return function (key) {
        var result = false;
        if (getters.isSelected(key)) return true;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.selected, function (selectedKey) {
          var section = getters.labelInfo(selectedKey, 'section');
          if (section === key) {
            result = true;
          }
        });
        return result;
      };
    },

    /**
     * Return the name of a attributes
     * @param  {integer} id   The id
     * @param  {string} type The type: country,region or subregion
     * @return {undefined|String} The name of the value if found
     */
    labelInfo: function labelInfo(state, getters) {
      return function (key, info) {
        var result = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.labels, ['id', key]);
        if (!result || !result[info]) {
          return undefined;
        } else {
          return result[info];
        }
      };
    }
  },

  mutations: {
    /**
     * Add or remove a selected attributes
     * @param  {obj} state Vuex state
     * @param  {string} key   Country identifier
     * @return {void}
     */
    select: function select(state, key) {
      state.selected.push(key);
    },


    /**
     * Unselect a attributes
     * @param  {obj} state Vuex state
     * @param  {string} key   Country identifier
     * @return {void}
     */
    unselect: function unselect(state, key) {
      var index = state.selected.indexOf(key);
      state.selected.splice(index, 1);
    },


    /**
     * Resets the selected countries
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    resetAllSelected: function resetAllSelected(state) {
      state.selected = [];
    }
  },

  actions: {
    /**
     * Toggels an attribute on/off
     * @param  {obj} options.state
     * @param  {obj} options.commit
     * @param  {obj} options.rootState
     * @param  {string} key
     * @return {void}
     */
    toggleSelect: function toggleSelect(_ref, key) {
      var state = _ref.state,
          commit = _ref.commit,
          rootState = _ref.rootState;

      var exists = state.selected.indexOf(key) !== -1;
      if (exists) {
        commit('unselect', key);
      } else {
        commit('select', key);
      }
    }
  }
};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userSelectionStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_persistedstate__ = __webpack_require__(501);
// import _ from 'lodash'


var userSelectionStore = {
  namespaced: true,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_vuex_persistedstate__["a" /* default */])()],

  state: {
    'rsc': [],
    'attr': [],
    'view': 'chart',
    'ci': true,
    'date': [1975, 2020], // TODO: store this one too
    'covid19': true
  }
};

/***/ }),
/* 501 */,
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return covid19Store; });
// import _ from 'lodash'

var covid19Store = {
  namespaced: true,
  state: {
    countrymapIconOffset: {
      'United States': [{ x: 80, y: -70 }, { x: 50, y: 50 }],
      'Chile': [{ x: 40, y: 0 }],
      'Ecuador': [{ x: 10, y: 0 }],
      'Portugal': [{ x: 27, y: -10 }],
      'Netherlands': [{ x: 95, y: -61 }],
      'France': [{ x: -60, y: -86 }],
      'Spain': [{ x: 10, y: -10 }],
      'South Africa': [{ x: -10, y: -10 }],
      'Norway': [{ x: -10, y: 75 }],
      'Canada': [{ x: -40, y: 75 }],
      'New Zealand': [{ x: 0, y: -10 }, { x: -26, y: 34 }],
      'Australia': [{ x: 0, y: -30 }]
    },
    attribute_map: {
      'A_01': ['A_01', 'SA_01_01', 'SA_01_02', 'SA_01_03', 'SA_01_04'],
      'SA_01_01': ['SA_01_01'],
      'SA_01_02': ['SA_01_02'],
      'SA_01_03': ['SA_01_03'],
      'SA_01_04': ['SA_01_04'],
      'A_02': ['SA_02_01', 'SA_02_02', 'SA_02_03', 'SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c'],
      'SA_02_01': ['SA_02_01'],
      'SA_02_02': ['SA_02_02', 'SC_02_02_a', 'SC_02_02_b', 'SC_02_02_c', 'SC_02_02_d', 'SC_02_02_e'],
      'SA_02_03': ['SA_02_03', 'SC_02_03_a', 'SC_02_03_b', 'SC_02_03_c'],
      'SC_02_02_a': ['SC_02_02_a'],
      'SC_02_02_b': ['SC_02_02_b'],
      'SC_02_02_c': ['SC_02_02_c'],
      'SC_02_02_d': ['SC_02_02_d'],
      'SC_02_02_e': ['SC_02_02_e'],
      'SC_02_03_a': ['SC_02_03_a'],
      'SC_02_03_b': ['SC_02_03_b'],
      'SC_02_03_c': ['SC_02_03_c'],
      'A_03': ['A_03', 'SA_03_01', 'SA_03_02', 'SA_03_03'],
      'SA_03_01': ['SA_03_01'],
      'SA_03_02': ['SA_03_02'],
      'SA_03_03': ['SA_03_03'],
      'A_04': ['A_04', 'SA_04_01', 'SA_04_02'],
      'SA_04_01': ['SA_04_01'],
      'SA_04_02': ['SA_04_02'],
      'A_05': ['A_05', 'SA_05_01', 'SA_05_02', 'SA_05_03', 'SA_05_04'],
      'SA_05_01': ['SA_05_01'],
      'SA_05_02': ['SA_05_02'],
      'SA_05_03': ['SA_05_03'],
      'SA_05_04': ['SA_05_04']
    },

    /**
     * Has user set the covid19 filter on/off
     */
    is_enabled: true,

    /**
     * The countries information
     * @type {Obj}
     */
    all: {},

    /**
     * Country information
     * @type {Obj}
     */
    countries: {},

    /**
     * The last time this information was updated
     */
    last_updated: false,

    /**
     * Tells if the filter is available for the current page or not
     */
    filter_available: false
  },

  getters: {
    /**
     * Return a countries information by country_code
     * @param  {object} country_code   The country code
     * @return {Boolean}
     */
    getCountry: function getCountry(state, getters) {
      return function (countryCode) {
        return state.all[countryCode];
      };
    },
    /**
     * Return the last updated date
     * @param  {object} country_code   The country code
     * @return {Boolean}
     */
    getLastUpdated: function getLastUpdated(state, getters) {
      return function (countryCode) {
        if (countryCode !== undefined) {
          var country = getters.getCountry(countryCode);
          if (country && country.last_updated) {
            return country.last_updated;
          }
        }
        return state.all.last_updated;
      };
    },

    countryType: function countryType(state, getters) {
      return function (countryCode) {
        var country = getters.getCountry(countryCode);
        return country && country.country_type ? country.country_type : false;
      };
    },

    countryAttributeType: function countryAttributeType(state, getters) {
      return function (countryCode, attributeKey) {
        var country = getters.getCountry(countryCode);
        return country && country.attr && country.attr[attributeKey] ? country.attr[attributeKey] : false;
      };
    }
  },
  mutations: {},
  actions: {}
};

/***/ })
],[188]);


// WEBPACK FOOTER //
// static/js/app.js